export const examples =  {
    1: `AHCTF1\tT1808
AHCTF1\tS2222
AHCTF1\tS2226
AHNAK\tS41
AHNAK\tS511
ANLN\tS449
ANLN\tS323
APBB2\tS123
ASPM\tS425
ATF7\tT53
CAMSAP2\tS862
CAVIN1\tT302
CAVIN2\tS288
CCNE2\tS21
CENPF\tS3119
CENPF\tS1747
CRYBG1\tS75
DMAP1\tT445
DYNC1LI1\tS510
DYNC1LI1\tS516
DYNC1LI1\tS421
EIF2B4\tT86
EIF3J\tT109
ELAVL1\tS202
EXOC4\tT237
FTSJ3\tS688
FUBP1\tS140
GIGYF2\tS19
GIGYF2\tS26
H1-4\tT18
HMGA1\tS36
HNRNPAB\tS242
HOMER3\tT243
HSPB1\tS15
JPT1\tT54
JPT2\tS97
JUN\tS73
JUND\tS100
KIF20B\tS1740
KIF4A\tS801
KIFAP3\tS60
KLC2\tS445
KRT6B\tS37
LAD1\tS121
LARP1\tS766
LARP1\tS766
LASP1\tT104
LEMD3\tS187
LIG1\tT233
LMNA\tS22
LMNB1\tS23
LRBA\tS1488
MAP3K20\tS727
MAP3K20\tT628
MAP4\tT571
MAST4\tS1822
MAVS\tS222
MBD2\tS181
MKI67\tT1315
MKI67\tT1801
MKI67\tT1923
MKI67\tS1937
MKI67\tS1329
MKI67\tT2406
MTA1\tS576
MTDH\tT143
MTDH\tS308
MYO9B\tS1267
NAV1\tS1000
NCAPD2\tT1339
NCL\tT121
NCOA3\tS551
NOLC1\tT607
NOLC1\tT607
NOP56\tS563
NUP153\tS529
NUP35\tS66
NUP98\tS608
PAICS\tS27
PAK2\tS58
PCM1\tS110
PDLIM1\tS90
PDLIM2\tS197
PDLIM5\tS313
PELP1\tS1033
PHIP\tS1315
PNN\tS66
PNN\tS66
POLR1G\tS172
PPP1R12A\tS299
PPP1R12A\tS299
PSMA5\tS56
RAD51AP1\tS120
RANBP2\tT1144
RB1\tS807
RB1\tS249
RBL1\tT385
RBM7\tS136
RIPK1\tS320
RPL12\tS38
RPRD2\tS1099
RPS6KA4\tS343
SACS\tS1779
SCEL\tS312
SFPQ\tT687
SFPQ\tS33
SLAIN2\tS48
SLAIN2\tS147
SMNDC1\tS201
SMTN\tT373
SMTN\tS357
SMTN\tS304
SNX2\tS277
SRCAP\tS3148
SRRM2\tS1326
SRRM2\tS377
SUPT5H\tS671
TASOR2\tS2009
TASOR2\tS340
TJAP1\tS345
TJP2\tT1027
TMPO\tS424
TRIM28\tS473
TRIM28\tS473
TRIM29\tS104
TRRAP\tS2051
TRRAP\tS2077
UBAP2L\tS416
UTP14A\tS52
VIM\tS56
ZC3HAV1\tS387
ZFP36\tS186
ZFP36\tS60
ZFYVE16\tS939
ZYX\tS281
ANLN\tT320
CAVIN2\tS293
CRYBG1\tS81
DYNC1LI1\tS516
GIGYF2\tS26
GIGYF2\tS30
HMGA1\tT53
LAD1\tS123
LARP1\tS774
LMNA\tT19
LMNB1\tT20
MYO9B\tT1271
NOLC1\tT610
NOLC1\tT610
NUP35\tS73
NUP98\tS612
RB1\tT252
RPS6KA4\tS347
SMTN\tT360
SRRM2\tS387
ZC3HAV1\tT393
SRRM2\tS398`,
    2: `AAK1\tS14\t0.8076023
AAK1\tS18\t0.3131298
AAK1\tS637\t-0.7441971
AAK1\tS846\t-2.1192595
AAK1\tT389\t0.7850064
AAK1\tT606\t0.09437123
AAK1\tT620\t0.158854
AARS\tS484\t-0.2927226
AARS\tS555\t0.2149951
AATF\tS203\t0.111432
AATF\tS316\t0.0610158
AATF\tS320\t-0.007396555
AATF\tS321\t-0.007396555
ABCA2\tS1327\t-0.93388515
ABCA2\tT2412\t-0.0168259
ABCB6\tS410\t0.128540785
ABCC4\tS629\t0.03689012
ABCC4\tS655\t-0.4030208
ABCC4\tT646\t0.1102295
ABCC5\tS509\t-0.067119405
ABCC5\tS558\t-0.3049148
ABCF1\tS105\t-0.09580494
ABCF1\tS109\t-0.07363613
ABCF1\tS166\t-0.6906841
ABCF1\tS22\t-0.1794167
ABCF1\tS228\t-0.04281345
ABCF1\tS595\t-0.06523222
ABCF1\tS621\t-0.12304355
ABCF1\tT108\t-0.06193259
ABHD10\tS233\t-0.123098935
ABI2\tS221\t0.06901471
ABI2\tS301\t-0.1493126
ABL1\tS16\t-0.4262183
ABL1\tS588\t0.01834928
ABL1\tS678\t-0.02745442
ABL1\tS828\t-0.6968678
ABL1\tS874\t-1.165046
ABL1\tT833\t0.03365203
ABL1\tT871\t-1.287536
ABL2\tS566\t-0.4925554
ABL2\tS584\t0.0219326
ABL2\tS595\t0.03773361
ABL2\tS619\t0.01792198
ABL2\tS781\t-0.8054842
ABL2\tS879\t0.5289713
ABL2\tS900\t-1.29846
ABLIM3\tS311\t0.09518178
ABLIM3\tS392\t0.4066455
ABLIM3\tS393\t0.355129
ABLIM3\tS456\t0.607795875
ABR\tS18\t-0.69762695
ABR\tS26\t0.1837088
ACACA\tS23\t-0.86975845
ACACA\tS25\t-1.0647438
ACACA\tS29\t-0.9619208
ACAP2\tS379\t-0.08937474
ACAP2\tS384\t0.06281248
ACAP2\tS521\t0.1025909
ACBD3\tS316\t0.062061695
ACBD3\tS43\t-1.565503
ACBD5\tS152\t-0.07730507
ACBD5\tS156\t-0.01824965
ACBD5\tS218\t-0.2169876
ACD\tS111\t0.07107621
ACIN1\tS158\t0.01906128
ACIN1\tS182\t-0.839186825
ACIN1\tS185\t-0.7735259
ACIN1\tS270\t-0.1186486
ACIN1\tS307\t0.02361021
ACIN1\tS342\t-0.1293235
ACIN1\tS352\t-0.016167197
ACIN1\tS420\t0.0494913
ACIN1\tS432\t0.009060428
ACIN1\tS503\t-0.4064271
ACIN1\tS597\t0.06073913
ACIN1\tS599\t0.06073913
ACIN1\tS652\t-1.368998
ACIN1\tS780\t0.1106305
ACIN1\tS840\t-0.01754852
ACIN1\tS885\t-0.01754852
ACIN1\tT196\t0.4279279
ACIN1\tT350\t0.035901995
ACIN1\tT356\t-0.030459335
ACIN1\tT624\t0.03097168
ACLY\tS451\t0.45895975
ACLY\tS455\t0.441271
ACLY\tS478\t-0.2485082
ACLY\tS481\t-0.2013605
ACO2\tS559\t0.121546
ACOT1\tT56\t0.06970215
ACOX3\tS64\t-0.078837065
ACOX3\tT281\t0.3123756
ACSL3\tS353\t0.07519039
ACSL3\tS683\t-0.04308099
ACSL3\tT688\t-0.04492527
ACSL4\tS633\t-0.03436718
ACSL4\tT638\t-0.0764324
ACSS2\tS265\t-0.010816978
ACSS2\tS267\t-0.09898444
ACSS2\tS30\t0.01392662
ACTL6A\tS233\t0.08229379
ACTN1\tS763\t0.0425042
ACTN1\tT230\t-0.1363787
ACTN1\tT765\t0.1978653
ACTN2\tS140\t-0.0382742
ACTN4\tS404\t-0.3290295
ACTR8\tS21\t0.1857398
ADAM10\tT719\t0.0292761
ADAM15\tS783\t-0.4250816
ADAM17\tS767\t-0.2948006
ADAM17\tS770\t-0.2948006
ADAM17\tS785\t-2.990468
ADAM17\tS791\t0.04753833
ADAM17\tS819\t-2.7040745
ADAM17\tT735\t-1.742941
ADAM17\tT768\t-0.2948006
ADAM22\tS798\t-0.33866825
ADAM22\tS821\t0.88015925
ADAM9\tS758\t-0.3549311
ADAM9\tT761\t-0.2757611
ADAR\tS304\t-0.0450488
ADAR\tT306\t-1.549873
ADAR\tT308\t-1.515728
ADAT1\tS42\t-0.5979327
ADAT3\tS34\t-0.6569696
ADCK2\tS109\t0.6164518
ADCY3\tS158\t-0.2490493
ADCY6\tS54\t-0.56126
ADCY6\tS576\t0.02899346
ADCY9\tS138\t0.17625195
ADCY9\tS235\t0.2435951
ADCY9\tS238\t0.0495054
ADCY9\tT233\t-0.05906227
ADD1\tS12\t-0.3290872
ADD1\tS355\t0.37306735
ADD1\tS358\t-0.2777089
ADD1\tS465\t0.07765318
ADD1\tS532\t-0.09899992
ADD1\tS586\t0.3283769
ADD3\tS42\t0.3101074
ADD3\tS478\t0.3352546
ADD3\tS641\t0.0729976
ADD3\tS645\t0.1790014
ADD3\tS647\t0.102754243
ADD3\tS649\t0.0729976
ADD3\tT12\t-1.323335
ADH5\tS351\t-0.08069719
ADNP\tS709\t0.3361692
ADNP\tS921\t-0.04374997
ADNP\tS953\t0.038728051
ADNP\tS955\t0.006635256
ADNP\tS98\t0.1863738
ADRBK1\tS670\t-0.7834977
ADRM1\tS211\t0.1098286
ADRM1\tS405\t0.01906128
ADSL\tS15\t0.1047392
ADSL\tS9\t0.1613072
AEBP2\tS141\t0.1499097
AEBP2\tS18\t0.05158086
AEBP2\tS206\t-0.24404552
AEBP2\tS211\t-0.23730616
AEBP2\tS24\t0.05158086
AEBP2\tS390\t0.15835458
AES\tS196\t-0.45680685
AFAP1\tS265\t-1.409546
AFAP1\tS283\t0.09153062
AFAP1L1\tS104\t-0.45638645
AFAP1L1\tS329\t0.1989969
AFAP1L1\tS98\t-0.081920125
AFAP1L2\tS484\t-1.29739165
AFAP1L2\tS640\t0.1012467
AFAP1L2\tT345\t-1.916691
AFF1\tS199\t0.095916885
AFF1\tS206\t-0.01874676
AFF1\tS588\t-0.2235659
AFF1\tT697\t-1.16582945
AFF4\tS1043\t-0.3083547
AFF4\tS1055\t-0.256195675
AFF4\tS1058\t-0.11859399
AFF4\tS222\t0.07983892
AFF4\tS32\t-0.2907446
AFF4\tS392\t-0.58541025
AFF4\tS487\t0.11246775
AFF4\tS671\t0.03647721
AFF4\tS694\t-0.04626543
AFF4\tS703\t0.153027
AFF4\tS706\t-0.02854292
AFF4\tS814\t-0.2571142
AFF4\tT674\t0.02247432
AFTPH\tS411\t0.341561275
AFTPH\tS902\t-0.44123035
AFTPH\tT617\t-1.067334
AGAP1\tT303\t0.4328525
AGAP1\tT783\t0.0542234
AGAP3\tS443\t0.3596336
AGAP3\tS450\t0.2504765
AGAP3\tT324\t0.704872
AGFG1\tS181\t0.260924035
AGFG1\tT177\t0.6498454
AGGF1\tS11\t-0.01521381
AGGF1\tS7\t-0.07388363
AGK\tS322\t0.1191569
AGPAT9\tS77\t-0.2108018
AGPS\tS149\t0.2006298
AGPS\tS65\t0.3042774
AGPS\tS80\t0.03322923
AGPS\tT155\t-0.32481295
AGPS\tT68\t0.1388075
AGPS\tT74\t0.2407417
AGPS\tT82\t0.02417773
AHCTF1\tS1142\t0.1851053
AHCTF1\tS1214\t0.733528
AHCTF1\tS1216\t0.27282164
AHCTF1\tS1222\t0.32256784
AHCTF1\tS1232\t-0.8210241
AHCTF1\tS1283\t0.07765318
AHCTF1\tS1295\t0.1863738
AHCTF1\tS1297\t0.05394543
AHCTF1\tS1513\t-0.03086245
AHCTF1\tS1533\t-0.05110017
AHCTF1\tS1541\t0.1164979
AHCTF1\tS1629\t0.1670031
AHCTF1\tS1946\t0.05130255
AHCTF1\tS2065\t-0.93418285
AHCTF1\tS2181\t0.3328511
AHCTF1\tS2212\t0.1691554
AHCTF1\tS2222\t0.501186925
AHCTF1\tS2226\t0.27412303
AHCTF1\tS528\t-0.08508344
AHCTF1\tT1175\t0.3955016
AHCTF1\tT1369\t0.2162376
AHCTF1\tT1897\t-0.7090427
AHDC1\tS1549\t-0.628997
AHDC1\tS596\t0.02672926
AHDC1\tS896\t0.1406477
AHI1\tS1123\t0.09207205
AHNAK\tS135\t-5.161989
AHNAK\tS177\t-0.02195085
AHNAK\tS210\t-1.03914525
AHNAK\tS212\t-0.2518823
AHNAK\tS216\t0.01340805
AHNAK\tS220\t0.1992933
AHNAK\tS2397\t-2.440342
AHNAK\tS3412\t-0.0783961
AHNAK\tS3426\t-2.262434
AHNAK\tS41\t-0.5759379
AHNAK\tS4516\t0.32112
AHNAK\tS4908\t-0.7558679
AHNAK\tS511\t-1.33228
AHNAK\tS5110\t-4.048663
AHNAK\tS5293\t-0.1114301
AHNAK\tS5448\t0.0610158
AHNAK\tS5552\t0.02573757
AHNAK\tS570\t-0.2241487
AHNAK\tS572\t-0.3362637
AHNAK\tS5731\t1.488258
AHNAK\tS5735\t1.0464913
AHNAK\tS5737\t1.419053
AHNAK\tS5739\t1.488258
AHNAK\tS5745\t0.652707
AHNAK\tS5746\t0.7393296
AHNAK\tS5749\t0.5315686
AHNAK\tS5752\t0.2439128
AHNAK\tS5763\t-0.4359243
AHNAK\tS5780\t-2.9950105
AHNAK\tS5782\t-0.97472725
AHNAK\tS5790\t-0.43886005
AHNAK\tS5841\t0.1483484
AHNAK\tS5851\t0.71292225
AHNAK\tS5854\t0.58030865
AHNAK\tS5857\t0.2046285
AHNAK\tS819\t-0.00699962
AHNAK\tS93\t-0.4754749
AHNAK\tT3716\t0.2691962
AHNAK\tT4100\t-0.40058629
AHNAK\tT4564\t0.06170706
AHNAK\tT4766\t0.1708224
AHNAK\tT4877\t-0.08574162
AHNAK\tT490\t-0.1243457
AHNAK\tT5798\t-0.291659875
AHNAK\tT5824\t1.011567
AHNAK\tT590\t-0.01356724
AHRR\tS97\t0.00878305
AIDA\tS162\t-0.1214865
AIFM1\tS116\t-0.4106009
AIFM1\tS268\t0.19131
AIM1\tS533\t-0.09742468
AIM1\tS75\t0.261591
AIM1\tT524\t-0.5978673
AIM1\tT525\t-0.5195695
AJUBA\tS104\t-0.139599405
AJUBA\tS119\t-0.05246097
AJUBA\tS230\t0.2389091
AKAP1\tS105\t0.1523782
AKAP1\tS107\t0.35456225
AKAP1\tS150\t-3.007563
AKAP1\tT533\t-0.1187739
AKAP10\tS187\t-1.04118565
AKAP10\tS202\t-0.0875034
AKAP11\tS1242\t-0.11441
AKAP11\tS1487\t-0.09589748
AKAP11\tS1580\t0.1370589
AKAP11\tS18\t-1.9020675
AKAP11\tS422\t0.52013555
AKAP11\tS433\t-0.4310729
AKAP11\tS448\t-1.309788
AKAP11\tS456\t-0.04556546
AKAP11\tS985\t-0.9350345
AKAP11\tT1100\t-0.6786029
AKAP11\tT981\t0.5691022
AKAP12\tS1331\t-0.1213453
AKAP12\tS1395\t-0.31493
AKAP12\tS1674\t-0.0885462
AKAP12\tS219\t-0.4611043
AKAP12\tS283\t-0.8132966
AKAP12\tS286\t-1.576046
AKAP12\tS353\t-0.6532003
AKAP12\tS371\t-0.7273079
AKAP12\tS381\t-0.4599926
AKAP12\tS483\t-0.2486253
AKAP12\tS505\t0.04222413
AKAP12\tS598\t0.000721115
AKAP12\tS612\t-0.704136
AKAP12\tS627\t-0.103119875
AKAP12\tS629\t-0.064295875
AKAP12\tS696\t-0.285056
AKAP12\tS697\t-0.0761515
AKAP12\tS698\t-0.0761515
AKAP12\tT1116\t-0.2361975
AKAP12\tT1760\t-0.6594948
AKAP12\tT351\t-0.469980465
AKAP12\tT608\t-0.6257339
AKAP13\tS1411\t-0.04616119
AKAP13\tS1507\t-1.0488559
AKAP13\tS1584\t-0.066925183
AKAP13\tS1629\t-0.26313185
AKAP13\tS1858\t-0.1587031
AKAP13\tS1911\t0.08133958
AKAP13\tS2325\t-0.08456324
AKAP13\tS2378\t-0.51798935
AKAP13\tS2689\t-1.802185
AKAP13\tS2708\t-0.1417007
AKAP13\tS983\t-0.1714659
AKAP13\tT953\t-0.3393817
AKAP17A\tS537\t-0.06343934
AKAP2\tS1009\t-0.9219095
AKAP2\tS1016\t-0.8424646
AKAP2\tS22\t-0.228182
AKAP2\tS226\t-0.28358105
AKAP2\tS351\t-0.1764463
AKAP2\tS352\t-0.05772194
AKAP2\tS383\t-1.210463
AKAP2\tS606\t-2.1361575
AKAP2\tS624\t-0.4975268
AKAP2\tS862\t-0.2051142
AKAP2\tS951\t-0.3616759
AKAP2\tS979\t-2.829511
AKAP2\tT1011\t-0.8335162
AKAP2\tT400\t0.3198492
AKAP2\tT403\t-0.3938041
AKAP5\tS178\t0.03407487
AKAP5\tT179\t0.14702455
AKAP6\tS1073\t-0.1234496
AKAP6\tS1644\t0.010702842
AKAP6\tS1655\t0.155150355
AKAP8\tS112\t-0.06635671
AKAP8\tS323\t0.001874253
AKAP8\tS328\t0.041265962
AKAP8\tS339\t-0.06205306
AKAP8\tS685\t-0.05932957
AKAP8L\tS283\t0.53240075
AKAP8L\tS552\t-0.11328285
AKAP9\tS1327\t0.04236425
AKAP9\tS3568\t-1.03475855
AKAP9\tS3575\t0.011301255
AKAP9\tS3682\t-0.5523044
AKAP9\tS3834\t-0.6027581
AKIRIN1\tS22\t-0.1008399
AKIRIN2\tS21\t-0.05433238
AKIRIN2\tS57\t-0.09669945
AKNA\tS153\t-0.0533051
AKR7A2\tS210\t0.08542464
AKT1\tS122\t-0.180579412
AKT1\tS124\t-0.198362805
AKT1\tS126\t0.003458378
AKT1\tS129\t-0.06919455
AKT1S1\tS108\t-0.2750354
AKT1S1\tS112\t-0.2459847
AKT1S1\tS2\t-0.1820984
AKT1S1\tS203\t-0.06392186
AKT1S1\tS222\t-0.2357649
AKT1S1\tS223\t-0.15600215
AKT1S1\tS231\t0.046119945
AKT1S1\tS232\t-0.08532838
AKT1S1\tT266\t0.338567
AKT2\tS126\t-0.33215495
AKT2\tT451\t-0.04333369
AKT3\tS120\t-0.2301098
AKT3\tS34\t0.2542312
AKT3\tT122\t-0.2463955
AKT3\tT447\t-0.05136925
ALDH4A1\tS44\t0.1134338
ALDH7A1\tS56\t0.05743005
ALDOA\tS36\t-0.1852937
ALDOA\tS39\t-0.007695645
ALDOA\tS46\t-0.2423623
ALDOA\tT37\t-0.02454593
ALDOA\tT49\t-0.1359823
ALDOA\tT9\t-0.2607048
ALG3\tS12\t0.02517066
ALKBH5\tS350\t-0.03215265
ALKBH5\tS352\t-0.176134565
ALKBH5\tS373\t0.1971105
ALKBH5\tS53\t-0.156017545
ALKBH5\tS58\t-0.04175865
ALKBH5\tS85\t-0.4034018
ALKBH5\tY60\t-0.1758106
ALMS1\tS1218\t-0.2720545
ALMS1\tS2804\t0.15831824
ALMS1\tS2946\t0.44053665
ALMS1\tS464\t0.3327366
ALS2\tS466\t0.1750454
ALS2\tS483\t0.1416943
ALS2\tS492\t-0.017213
AMFR\tS523\t-0.13616355
AMFR\tS542\t-2.756136
AMIGO1\tS477\t-0.2158813
AMMECR1L\tS74\t-0.3398929
AMOT\tS305\t0.06695026
AMOT\tS414\t0.1811662
AMOTL1\tS219\t0.1592417
AMOTL1\tS272\t-1.904872
AMOTL1\tS435\t0.2013335
AMOTL1\tS670\t0.01106615
AMOTL1\tS743\t0.113351715
AMOTL1\tS755\t0.2490205
AMOTL1\tS759\t0.3619929
AMOTL1\tS778\t0.2097652
AMOTL1\tS842\t0.1011122
AMOTL1\tS856\t1.031748
AMOTL1\tT852\t1.058455
AMOTL2\tS667\t0.1560082
AMOTL2\tS759\t0.5505067
AMPD2\tS87\t-1.7981765
ANAPC1\tS355\t0.442834
ANAPC1\tS377\t-0.27584465
ANAPC1\tS688\t-0.6456608
ANAPC1\tS731\t-0.07693452
ANAPC1\tT530\t-0.01251903
ANAPC10\tT3\t0.2113849
ANAPC2\tS218\t0.140103665
ANAPC2\tS314\t0.01792198
ANAPC2\tS729\t-0.09749127
ANAPC5\tS195\t-0.05189259
ANK2\tS1722\t-0.55567735
ANK2\tS2801\t-0.1989076
ANK2\tS31\t-0.1054733
ANK2\tS3760\t-0.2580455
ANK2\tS3762\t-0.1253997
ANK2\tS3785\t0.0311129
ANK2\tS3790\t0.03856156
ANK2\tS3812\t0.1130337
ANK2\tS3914\t-1.810612
ANK2\tT3764\t0.076368615
ANK2\tT3781\t-0.102221425
ANK2\tT3811\t-0.050655
ANK3\tS1466\t-2.366084
ANK3\tS1625\t-0.07368135
ANK3\tS1834\t0.7212759
ANK3\tS951\t0.02029024
ANK3\tS953\t0.4003373
ANKHD1\tT1653\t0.026821355
ANKHD1-EIF4EBP3\tS2539\t0.3330801
ANKIB1\tS443\t-0.10082737
ANKIB1\tS737\t0.01178193
ANKIB1\tS891\t-0.41413075
ANKRD11\tS276\t0.1576905
ANKRD11\tS609\t-0.2165893
ANKRD11\tS834\t0.1182268
ANKRD12\tS126\t0.03815525
ANKRD12\tS545\t-0.1562895
ANKRD13D\tS202\t-0.7403117
ANKRD13D\tT206\t-0.7403117
ANKRD17\tS19\t-0.034547615
ANKRD17\tS1939\t1.27185465
ANKRD17\tS2040\t0.2522945
ANKRD17\tS2041\t0.1861201
ANKRD17\tS2044\t-0.3597187
ANKRD17\tS2046\t-0.0262517
ANKRD17\tS2058\t-0.011457635
ANKRD17\tS2066\t0.05792547
ANKRD17\tS2400\t0.108491
ANKRD26\tS489\t0.4380799
ANKRD26\tS530\t-0.1146131
ANKRD26\tS630\t0.1326427
ANKRD27\tS962\t-1.1468727
ANKRD27\tT1023\t-0.599025
ANKRD28\tS1011\t-0.5963178
ANKRD30BL\tS159\t0.3671771
ANKRD34A\tS247\t-0.776372
ANKRD34A\tS392\t0.068475657
ANKRD50\tS1163\t-0.3576058
ANKRD50\tS1167\t-0.2167859
ANKRD50\tS253\t-0.1370448
ANKRD52\tS1028\t-0.1700692
ANKRD52\tS1033\t-0.04666772
ANKRD54\tS63\t0.1346153
ANKS1A\tS579\t0.4056657
ANKS1A\tS626\t0.01392662
ANKS1A\tS628\t0.07860982
ANKS1A\tS634\t0.0259093
ANKS1A\tS647\t0.194042165
ANKS1A\tS649\t0.384501735
ANKS1A\tS652\t0.3025237
ANKS1A\tS661\t-0.1325146
ANKS1A\tS663\t0.070512555
ANKS1A\tS666\t0.1870075
ANKS1A\tS677\t0.0182068
ANKS1A\tS858\t0.5794698
ANKS1A\tS870\t0.3952649
ANKS1A\tS887\t-0.2299068
ANKS1A\tS895\t-0.41476295
ANKS1A\tT318\t-0.09750187
ANKS1B\tS19\t-0.09097198
ANKS3\tS114\t0.07683272
ANKS6\tS126\t-0.1702316
ANKS6\tS129\t0.2403754
ANKUB1\tS68\t2.138786
ANKUB1\tS71\t2.138786
ANKZF1\tS361\t-0.16775365
ANKZF1\tS398\t-0.01243177
ANKZF1\tS533\t-0.02902857
ANKZF1\tS675\t-0.8970329
ANKZF1\tT607\t-0.2680174
ANLN\tS323\t0.1063484
ANLN\tS449\t0.6672109
ANLN\tS54\t0.08420031
ANLN\tS562\t0.4672795
ANLN\tS661\t-0.1176934
ANLN\tS72\t0.5104556
ANLN\tT75\t-0.01892185
ANO6\tS256\t0.115566
ANO8\tS641\t-1.396005
ANP32A\tS27\t-0.1495046
ANP32B\tT244\t-0.05562126
ANTXR1\tS362\t-0.1334639
ANXA1\tS173\t-0.030204575
ANXA1\tS37\t-0.42762395
ANXA2\tS12\t-0.06874056
ANXA2\tS164\t0.2980718
ANXA2\tS184\t0.503759035
ANXA2\tS2\t0.1852855
ANXA2\tS26\t-0.097688185
ANXA2\tT163\t0.1306673
ANXA2\tY24\t-0.40930305
ANXA4\tS12\t-0.1892032
AP1AR\tT195\t0.06653696
AP1M1\tS47\t-0.2943848
AP1S1\tS147\t-0.2035351
AP1S2\tT146\t-0.5695435
AP2A1\tS655\t0.1232689
AP2A1\tT814\t-1.1678675
AP2M1\tT154\t0.588037
AP3B1\tS227\t0.05241581
AP3B1\tS560\t0.00805652
AP3D1\tS658\t-2.160298
AP3D1\tS827\t-0.05205715
AP3D1\tS829\t0.03477915
AP4E1\tS601\t0.3258469
AP5Z1\tS776\t0.3245128
APAF1\tS238\t0.06322686
APAF1\tS248\t0.06322686
APBA2\tS468\t-0.271026
APBA3\tS9\t-0.4514845
APBB2\tS123\t-0.8565805
APBB2\tS325\t-0.400485205
APBB2\tS330\t-0.5411561
APBB2\tS334\t0.5497184
APC\tS1921\t-0.005825792
APC\tS2024\t0.1571731
APC\tS2159\t0.4704067
APC\tS2182\t0.09734114
APC\tS2573\t-0.2608604
APEH\tS187\t-0.009538838
API5\tS464\t-0.042858
APIP\tS87\t-0.07351469
APLF\tS107\t-0.2195219
APMAP\tT19\t-0.33346785
APOB\tS3778\t-0.268782
APOB\tT3785\t-0.268782
APOBEC3B\tS397\t-0.1577371
APOOL\tS203\t0.2244108
APPL1\tS401\t-0.01438299
APPL1\tS403\t-0.061421755
APRT\tS15\t0.019126775
APRT\tS30\t0.0615688
APRT\tS66\t0.105678
APTX\tS132\t-0.2079014
APTX\tS135\t-0.00010595
ARAF\tS186\t1.02839225
ARAF\tS257\t0.0382896
ARAP1\tS229\t-0.06470624
ARAP3\tS1380\t0.1881477
ARAP3\tS1444\t-0.2785136
ARAP3\tS1480\t0.038596545
ARAP3\tT1348\t0.2492632
ARAP3\tT1369\t0.1575611
ARCN1\tS493\t-0.04771118
ARF4\tS147\t-0.00185158
ARFGAP1\tS150\t0.777026
ARFGAP1\tS343\t0.120352
ARFGAP1\tS361\t-0.6758345
ARFGAP1\tT135\t0.16221
ARFGAP1\tT189\t0.007051912
ARFGAP2\tS146\t-0.3176604
ARFGAP2\tS238\t0.384492
ARFGAP2\tS368\t-0.3467381
ARFGAP2\tS432\t-0.3375575
ARFGAP3\tS143\t-0.6619807
ARFGAP3\tS212\t0.2571068
ARFGAP3\tS274\t0.3823906
ARFGAP3\tS331\t0.4389213
ARFGEF1\tS1555\t-1.8041715
ARFGEF1\tS1566\t0.37478155
ARFGEF1\tS1569\t-0.64850365
ARFGEF1\tS394\t-0.58403365
ARFGEF1\tS397\t-0.28723081
ARFGEF2\tS1499\t-0.242635285
ARFGEF2\tS1525\t0.15847302
ARFGEF2\tS1528\t0.16938194
ARFGEF2\tS218\t-0.4170202
ARFGEF2\tS227\t-0.17931428
ARFGEF2\tS346\t-0.1849165
ARFGEF3\tS1991\t0.03083044
ARFIP1\tS69\t-0.224351
ARHGAP1\tS51\t-0.3862609
ARHGAP10\tS591\t0.18221875
ARHGAP11A\tS129\t0.48656
ARHGAP11A\tS486\t0.5154096
ARHGAP11A\tS679\t0.5524754
ARHGAP11A\tS96\t-0.461005
ARHGAP11A\tT134\t0.252312155
ARHGAP11A\tT319\t0.6638456
ARHGAP11A\tT378\t0.0871912
ARHGAP12\tS165\t-0.145365219
ARHGAP12\tS176\t-0.6136304
ARHGAP12\tS201\t0.1854624
ARHGAP12\tS213\t0.01300246
ARHGAP12\tS215\t0.061496375
ARHGAP12\tS240\t0.002450562
ARHGAP12\tS423\t0.4590119
ARHGAP12\tS451\t-2.393652
ARHGAP12\tT230\t0.059047295
ARHGAP12\tT231\t0.016402975
ARHGAP12\tY243\t0.03280595
ARHGAP17\tS575\t-0.06665395
ARHGAP17\tT793\t0.202825895
ARHGAP18\tT158\t0.07052668
ARHGAP21\tS1503\t-0.0872888
ARHGAP21\tS1604\t-0.06642739
ARHGAP21\tS1668\t-1.226442
ARHGAP21\tS1712\t-1.246087
ARHGAP21\tS923\t-0.8802056
ARHGAP21\tT1701\t0.797179
ARHGAP22\tS191\t0.1712069
ARHGAP23\tS1136\t-0.08468067
ARHGAP23\tS267\t-0.2104461
ARHGAP23\tS278\t0.02361021
ARHGAP23\tS529\t0.111320625
ARHGAP23\tS583\t-0.02082342
ARHGAP28\tS21\t-0.1054888
ARHGAP29\tS589\t-0.74304635
ARHGAP31\tS1036\t-0.6084522
ARHGAP31\tS1080\t-1.0426673
ARHGAP31\tS346\t0.1110314
ARHGAP31\tS387\t0.29236235
ARHGAP31\tS476\t0.117163
ARHGAP31\tS629\t-0.1334006
ARHGAP32\tS1203\t-0.04278369
ARHGAP32\tS1234\t-1.4239995
ARHGAP32\tS706\t-0.07751287
ARHGAP32\tS856\t-1.343788
ARHGAP32\tS952\t0.3358043
ARHGAP32\tT1236\t-0.60661065
ARHGAP35\tS1134\t0.1569143
ARHGAP35\tS1150\t-1.092186
ARHGAP35\tS1179\t0.1818022
ARHGAP35\tS975\t0.04711958
ARHGAP35\tS985\t0.1304037
ARHGAP35\tY1105\t-0.41328415
ARHGAP39\tS286\t-0.01330512
ARHGAP39\tS407\t0.2017593
ARHGAP4\tS860\t-0.6300814
ARHGAP4\tS930\t-0.6123066
ARHGAP5\tS1124\t-1.977554
ARHGAP5\tS1173\t-0.17540975
ARHGAP5\tS1176\t-0.5766693
ARHGAP5\tS1195\t-1.8864919
ARHGAP5\tS1202\t-1.8949742
ARHGAP5\tS1218\t-0.01313042
ARHGAP5\tS590\t-3.28736
ARHGAP5\tS765\t-0.68204455
ARHGAP5\tS968\t-1.96016
ARHGAP5\tT1171\t-0.6834686
ARHGEF1\tS410\t-0.1721322
ARHGEF1\tS919\t-1.141335
ARHGEF1\tT430\t0.0311129
ARHGEF1\tT751\t-1.019463
ARHGEF10\tS1221\t0.131214235
ARHGEF10\tS1222\t0.131214235
ARHGEF10\tS35\t-0.2023395
ARHGEF11\tS1335\t0.1245928
ARHGEF11\tS14\t-2.8679365
ARHGEF11\tS1497\t-1.49574225
ARHGEF11\tS1498\t-1.503977
ARHGEF11\tS150\t-0.2540313
ARHGEF11\tS1518\t-0.121505223
ARHGEF11\tS1520\t-0.042234123
ARHGEF11\tS16\t-0.71963465
ARHGEF11\tS256\t-1.91082435
ARHGEF11\tS272\t-1.793094
ARHGEF11\tS282\t0.07847318
ARHGEF11\tS285\t-0.1402609
ARHGEF11\tS291\t0.2577348
ARHGEF11\tS295\t0.2127561
ARHGEF11\tS311\t-0.3173548
ARHGEF11\tS317\t-0.27636005
ARHGEF11\tS35\t-0.5429837
ARHGEF11\tS596\t-1.8268275
ARHGEF11\tS675\t0.2419622
ARHGEF11\tS698\t-0.21921385
ARHGEF11\tS703\t0.1382902
ARHGEF11\tT1332\t0.1501697
ARHGEF11\tT1501\t-1.503977
ARHGEF11\tT1502\t-1.36135675
ARHGEF11\tT294\t0.20629755
ARHGEF11\tT708\t0.166587
ARHGEF11\tT712\t0.20563425
ARHGEF12\tS1157\t-0.3935389
ARHGEF12\tS1269\t0.00707445
ARHGEF12\tS1370\t0.182016485
ARHGEF12\tS322\t-1.704583
ARHGEF12\tS41\t-2.064193
ARHGEF12\tS618\t-0.7411796
ARHGEF12\tT1267\t-0.06763636
ARHGEF12\tT684\t-3.696078
ARHGEF12\tT713\t-0.3906284
ARHGEF12\tT717\t0.2200823
ARHGEF17\tS1002\t-0.04391361
ARHGEF17\tS142\t-1.388507
ARHGEF17\tS395\t0.1245928
ARHGEF17\tS418\t0.2292427
ARHGEF17\tS507\t0.5506052
ARHGEF17\tS509\t0.54076585
ARHGEF17\tS527\t-1.223177
ARHGEF17\tS619\t-0.7708305
ARHGEF17\tS735\t-0.03330375
ARHGEF17\tS914\t0.8594514
ARHGEF17\tS946\t0.682408
ARHGEF17\tS961\t-0.1632033
ARHGEF17\tT702\t0.006477609
ARHGEF18\tS378\t0.2967804
ARHGEF18\tS742\t-0.02269806
ARHGEF18\tS763\t-1.920134
ARHGEF18\tS799\t-2.690591
ARHGEF2\tS124\t0.04963072
ARHGEF2\tS136\t0.5172253
ARHGEF2\tS145\t-0.1745563
ARHGEF2\tS147\t0.27163225
ARHGEF2\tS150\t0.34667955
ARHGEF2\tS617\t-0.09904625
ARHGEF2\tS620\t0.03815525
ARHGEF2\tS668\t-0.6289653
ARHGEF2\tS858\t-0.8092209
ARHGEF2\tS904\t-0.2787061
ARHGEF2\tS912\t-0.3132978
ARHGEF2\tS913\t0.1923955
ARHGEF2\tS919\t0.18954
ARHGEF2\tS928\t-0.76961845
ARHGEF2\tS932\t-1.596231
ARHGEF2\tS94\t0.3188085
ARHGEF2\tS948\t-0.0296175
ARHGEF2\tS95\t0.306379
ARHGEF2\tT917\t0.2698593
ARHGEF26\tS222\t-0.8638611
ARHGEF26\tS392\t-0.01200978
ARHGEF26\tS98\t-0.2025279
ARHGEF35\tS184\t-0.1170518
ARHGEF35\tS445\t-2.105504
ARHGEF35\tS450\t-3.392591
ARHGEF40\tS1438\t-1.236062
ARHGEF40\tS1443\t-0.0329642
ARHGEF40\tS1474\t-1.375759
ARHGEF40\tS1480\t0.8536139
ARHGEF40\tS255\t0.04121267
ARHGEF40\tS262\t0.3653566
ARHGEF40\tS401\t-1.144042
ARHGEF40\tS419\t-1.446109
ARHGEF40\tS421\t-1.2656895
ARHGEF40\tS931\t0.4119685
ARHGEF40\tS961\t0.2125071
ARHGEF40\tS997\t-0.98705165
ARHGEF40\tT1074\t0.7287477
ARHGEF40\tT257\t0.83030075
ARHGEF40\tT371\t0.6967763
ARHGEF5\tS1044\t0.0462499
ARHGEF5\tS11\t-0.162414245
ARHGEF5\tS1126\t0.05088473
ARHGEF5\tS1405\t-0.1597503
ARHGEF5\tS15\t-0.21873607
ARHGEF5\tS445\t-1.609553
ARHGEF5\tS450\t-2.451662
ARHGEF6\tS530\t-0.2711827
ARHGEF7\tS340\t0.1336951
ARHGEF7\tS516\t-1.705194
ARHGEF7\tS525\t0.09423606
ARHGEF7\tS560\t-0.3865815
ARID1A\tS1182\t0.3531904
ARID1A\tS1755\t-0.1506572
ARID1A\tS301\t0.024036
ARID1A\tS382\t-0.09400225
ARID1A\tS604\t0.0729532
ARID1A\tS696\t-0.328718807
ARID1A\tS705\t-0.6575819
ARID1A\tS772\t-0.2059793
ARID1A\tT1206\t0.3464442
ARID1A\tT1888\t-0.1254627
ARID1B\tS1744\t-0.009451673
ARID1B\tS429\t0.3328543
ARID4B\tS296\t-0.02764558
ARID4B\tS483\t-0.02311752
ARID4B\tS675\t0.1066163
ARID4B\tS790\t-0.004696399
ARID4B\tS912\t2.1351885
ARID4B\tT133\t0.3972554
ARID4B\tT481\t-0.011249085
ARID4B\tT793\t-0.004696399
ARID4B\tY795\t0.165314468
ARID5B\tS789\t0.08256635
ARID5B\tT296\t0.09895846
ARIH1\tS517\t-0.02867537
ARL13B\tT282\t0.3912178
ARL6IP4\tS178\t-0.005521651
ARL6IP4\tS180\t0.169215565
ARL6IP4\tS271\t-0.1370766
ARL6IP4\tS44\t-0.04318501
ARL6IP6\tS60\t-0.4527278
ARL6IP6\tS71\t-0.3487457
ARL6IP6\tS80\t-0.2901624
ARL6IP6\tT19\t0.02687089
ARMC1\tS267\t-0.25138896
ARMC10\tS45\t-0.121457405
ARMC10\tS45\t0.5297226
ARMCX3\tS110\t-0.0297353
ARMCX3\tS43\t-0.069268919
ARMCX3\tS61\t0.07176267
ARMCX3\tS72\t0.1634987
ARMCX6\tT166\t-0.02677411
ARNT\tS68\t-0.14135685
ARPC1B\tS311\t-0.336628
ARPP19\tS23\t0.08270261
ARRB1\tS404\t0.1934563
ARRB1\tT402\t0.18485515
ARRDC1\tS256\t-0.2788286
ARVCF\tS140\t0.0097152
ARVCF\tS204\t0.04739887
ARVCF\tS272\t0.05505682
ARVCF\tS846\t0.964719425
ARVCF\tT573\t0.2809564
ASAP1\tS493\t-0.09674571
ASAP1\tS525\t-0.0676515
ASAP1\tS839\t-0.29014475
ASAP1\tS843\t-1.067410475
ASAP1\tT1054\t0.65108555
ASAP2\tS701\t-0.1187583
ASAP2\tS822\t0.1454818
ASAP2\tT798\t-1.176544
ASB9\tS243\t-0.4115024
ASCC2\tS713\t0.6500293
ASCC2\tT233\t0.0416635
ASCC3\tS2195\t0.2849878
ASF1A\tS165\t-0.031059165
ASF1B\tS169\t0.1524851
ASF1B\tT179\t0.2995964
ASH1L\tS1162\t0.028744835
ASH1L\tS1170\t0.0805102
ASH1L\tS1630\t0.3006508
ASH1L\tS1681\t-0.340112
ASH1L\tS1748\t0.079678335
ASH1L\tS476\t-0.4312869
ASH1L\tS482\t-0.4312869
ASH1L\tS529\t-0.03628715
ASH2L\tS101\t0.0289366
ASPM\tS1103\t0.3600833
ASPM\tS1105\t0.2284801
ASPM\tS14\t-0.2171385
ASPM\tS367\t-0.2166523
ASPM\tS425\t-0.3800893
ASPM\tS605\t0.3084773
ASPM\tT563\t0.7302595
ASPSCR1\tS500\t-0.58905115
ASPSCR1\tS502\t-0.2666978
ASUN\tS626\t-0.05760183
ASXL1\tS498\t0.01521204
ASXL2\tS118\t0.07203723
ASXL2\tS367\t0.1428708
ASXL2\tS412\t0.02573757
ASXL2\tS496\t0.082383625
ASXL2\tS502\t0.02729555
ASXL2\tS534\t0.04809668
ASXL2\tS543\t-0.3196936
ASXL2\tS806\t0.11465895
ASXL2\tS814\t0.0354831
ASXL2\tS817\t-0.1763397
ASXL2\tT529\t0.00023027
ATAD2\tS1190\t0.3077866
ATAD2\tS1200\t0.13525238
ATAD2\tS1243\t-0.08118634
ATAD2\tS1283\t0.068351004
ATAD2\tS141\t0.2446436
ATAD2\tS170\t0.2674758
ATAD2\tS327\t0.1760696
ATAD2B\tS1342\t-0.04939721
ATAD2B\tS372\t0.104262845
ATAD2B\tS79\t0.0900387
ATAD2B\tS81\t-0.08039294
ATAD2B\tS939\t0.03294719
ATAD3A\tS321\t0.01834928
ATAD5\tS354\t0.097124625
ATAD5\tS356\t0.18867386
ATAD5\tS602\t0.2923105
ATAD5\tS817\t0.20643054
ATAD5\tS86\t0.4925198
ATAD5\tT590\t0.3252713
ATAT1\tS249\t-0.161922005
ATAT1\tS253\t-0.161922005
ATAT1\tS292\t0.8914201
ATE1\tS162\t-0.09983458
ATF2\tS118\t-0.09035747
ATF2\tS150\t-0.19257571
ATF2\tS94\t-0.2877124
ATF2\tT51\t-0.394642
ATF2\tT53\t-0.395757
ATF6\tS16\t-2.56209
ATF7\tS100\t-0.23918025
ATF7\tS402\t-0.2178431
ATF7\tS97\t-0.1303554
ATF7\tT101\t-0.3674153
ATF7\tT51\t-0.41148595
ATF7\tT53\t-0.3887899
ATF7IP\tS113\t-0.1153787
ATF7IP\tS445\t0.04989575
ATF7IP\tS474\t-0.33665905
ATF7IP\tS477\t0.0888201
ATF7IP\tS556\t-1.283209
ATF7IP\tS672\t0.1275012
ATF7IP2\tS32\t-0.037720364
ATG13\tS239\t-0.39802245
ATG13\tS245\t-0.03213788
ATG16L1\tS268\t-2.223778
ATG2A\tS1327\t-1.252486
ATG2A\tS1402\t-0.2062955
ATG2B\tS1526\t0.2954911
ATG2B\tS1743\t-0.3894701
ATG2B\tS240\t-0.2863042
ATG2B\tS497\t-1.59318
ATG2B\tS886\t-0.6155965
ATG9A\tS675\t-0.6094204
ATG9A\tS735\t-0.307313505
ATG9A\tS738\t-0.06998181
ATG9A\tS741\t-0.06998181
ATG9A\tS828\t-0.2224309
ATL1\tS10\t-1.8469175
ATL3\tS535\t-0.4303845
ATM\tS1981\t0.10143174
ATM\tT1885\t0.0650208
ATN1\tS101\t0.0745666
ATN1\tS107\t-0.2027213
ATN1\tS112\t0.027100844
ATN1\tS118\t-0.123269713
ATN1\tS119\t-0.123269713
ATN1\tS168\t-0.09363269
ATN1\tS34\t0.1301402
ATN1\tS77\t-0.12570425
ATN1\tS79\t0.1519886
ATOX1\tS47\t-0.1435481
ATOX1\tT50\t-0.2764327
ATP10B\tS225\t-0.1596053
ATP11C\tS445\t0.0165288
ATP13A1\tS781\t0.1800205
ATP13A1\tS787\t-0.29602236
ATP13A2\tS55\t-0.095924105
ATP13A3\tS817\t-0.1093744
ATP13A3\tS98\t-0.4501042
ATP1A1\tS16\t-0.04626543
ATP1A1\tS228\t-0.5944583
ATP1A1\tS722\t0.021382515
ATP2A2\tS663\t0.2378085
ATP2A2\tT441\t0.24732
ATP2A2\tT443\t-0.08368915
ATP2B1\tS1119\t0.07327549
ATP2B1\tS1142\t0.472945378
ATP2B1\tS242\t1.01571005
ATP2B1\tT1129\t0.193774943
ATP2B4\tT1133\t-0.4593775
ATP5A1\tS76\t-0.2038675
ATP5B\tT213\t0.56849905
ATP5I\tS66\t0.02828617
ATP6V0A2\tS695\t-0.17331705
ATP6V0D1\tS283\t-0.05872838
ATP7A\tS1385\t-1.1008086
ATP7A\tS1388\t0.1773438
ATP7A\tS1395\t-0.5618988
ATP7A\tS270\t-0.6597682
ATP7A\tS357\t0.054954605
ATP7A\tT152\t0.0167816
ATP7A\tT327\t-0.03768053
ATR\tS435\t-0.53298305
ATRIP\tS224\t0.07368314
ATRIP\tS518\t-0.7405768
ATRX\tS1061\t-0.02570568
ATRX\tS1322\t0.039306288
ATRX\tS1324\t0.039306288
ATRX\tS1326\t0.039306288
ATRX\tS1348\t-0.022003165
ATRX\tS1352\t-0.00444933
ATRX\tS1527\t0.3205425
ATRX\tS1996\t-0.01281016
ATRX\tS25\t-0.19895295
ATRX\tS26\t-0.1379811
ATRX\tS34\t-0.115445235
ATRX\tS52\t0.1458731
ATRX\tS594\t0.9347052
ATRX\tS598\t0.44807245
ATRX\tS675\t-0.02281254
ATRX\tS677\t0.02019986
ATRX\tS704\t-0.7568915
ATRX\tS729\t-0.3174273
ATRX\tS731\t-0.3174273
ATRX\tS784\t-1.099958
ATRX\tS819\t0.68794765
ATRX\tS849\t-0.059525
ATRX\tS850\t-0.059525
ATRX\tS889\t0.09234277
ATRX\tT674\t0.08188502
ATXN1\tS238\t-0.2764851
ATXN1\tS406\t0.5824597
ATXN1\tS775\t-0.08176648
ATXN1\tS88\t0.2239167
ATXN1L\tS284\t-4.356148
ATXN1L\tS361\t0.31417945
ATXN1L\tT330\t1.38521
ATXN1L\tT456\t0.2931426
ATXN2\tS387\t0.07778991
ATXN2\tS521\t-0.22836735
ATXN2\tS649\t0.215469345
ATXN2\tS693\t0.1712069
ATXN2\tS705\t0.4438793
ATXN2\tS782\t-0.45322165
ATXN2\tS810\t0.3214664
ATXN2\tT587\t-0.9550313
ATXN2\tT662\t0.08365592
ATXN2\tT692\t0.063023085
ATXN2\tT855\t0.90110205
ATXN2L\tS111\t-0.5375916
ATXN2L\tS306\t0.52342975
ATXN2L\tS391\t0.3862592
ATXN2L\tS559\t0.1526378
ATXN2L\tS594\t-0.1690794
ATXN2L\tS634\t-0.238863581
ATXN2L\tS680\t0.1640138
ATXN2L\tS684\t0.099449955
ATXN7\tS638\t0.06529664
ATXN7L3\tS170\t0.12937365
ATXN7L3\tS288\t0.003746074
AUNIP\tS267\t0.05921687
AUP1\tS288\t-2.123685
AUP1\tT154\t-0.4577321
AVEN\tS261\t-1.524583
AVEN\tS94\t-0.10253855
AZI1\tS114\t-2.94253
AZI1\tS146\t0.26304822
AZI1\tS150\t0.42517865
AZI1\tS47\t0.02351315
AZI1\tS78\t-0.7076046
AZI1\tS795\t-2.813063
AZI1\tS87\t-0.2547511
AZI1\tS89\t-0.16466485
AZI1\tT96\t-0.031273295
AZI2\tS318\t0.799984285
AZI2\tS343\t0.1304037
AZI2\tS353\t-0.04300666
BABAM1\tS29\t0.10353198
BABAM1\tS47\t-0.6842828
BABAM1\tS49\t0.0114431
BACE2\tS461\t0.1083571
BACH1\tS196\t-0.081242735
BACH1\tS417\t-1.05183545
BACH1\tS445\t0.2807188
BACH1\tS718\t0.8177051
BAD\tS118\t-0.008885445
BAD\tS134\t0.568324
BAD\tS25\t-0.01231529
BAD\tS99\t-0.09107951
BAG2\tS73\t-0.06274599
BAG3\tS173\t0.3572705
BAG3\tS289\t-0.3421406
BAG3\tS377\t-1.528408
BAG3\tS385\t-0.61495845
BAG3\tS386\t-0.7574084
BAG3\tT285\t-0.4979139
BAG3\tT406\t0.099612175
BAG6\tS1075\t-0.102837
BAG6\tS1111\t0.2781037
BAG6\tS113\t-0.05578624
BAG6\tS958\t-0.08292726
BAG6\tS967\t0.007051912
BAHCC1\tS1110\t-0.1145506
BAHCC1\tS2044\t-0.002173585
BAHCC1\tS2471\t-0.03796186
BAHD1\tS121\t-1.411733
BAHD1\tS184\t-0.03568267
BAI1\tS1257\t-0.3845083
BAI1\tS1278\t0.197488
BAI1\tS1306\t0.3632271
BAI1\tS1469\t0.009633875
BAI1\tT1308\t0.2138761
BAIAP2\tS261\t0.161027
BAIAP2\tS336\t0.1035707
BAIAP2\tS366\t0.4679055
BAIAP2\tS454\t0.082618665
BAIAP2\tT340\t0.04194384
BAIAP2L1\tS255\t-0.230405038
BAIAP2L1\tS261\t-0.33931845
BAIAP2L1\tS414\t-0.2444116
BAIAP2L1\tT257\t-0.155545628
BAIAP2L2\tS429\t0.09618688
BAIAP2L2\tS451\t0.378730485
BAIAP2L2\tS463\t0.01464098
BAIAP2L2\tS464\t-0.1087674
BAP1\tS274\t-0.10761383
BAP1\tS377\t-0.1986592
BAP1\tS579\t-0.042948172
BAP18\tS110\t-0.2549951
BAP18\tS36\t0.50628635
BAP18\tS36\t-0.2443649
BAP18\tS96\t-0.05446722
BARD1\tS364\t0.004465491
BARD1\tS410\t0.1294808
BARD1\tT299\t0.131567765
BAZ1A\tS1363\t-0.0811253
BAZ1A\tS1413\t-0.01100637
BAZ1A\tS702\t-0.02866064
BAZ1A\tT1420\t-0.5031507
BAZ1A\tT1547\t0.2230518
BAZ1A\tT731\t0.0650208
BAZ1B\tS1338\t0.2435472
BAZ1B\tS1464\t-0.01244626
BAZ1B\tS158\t0.02420025
BAZ1B\tS160\t0.038537885
BAZ1B\tS161\t0.171463
BAZ1B\tS361\t0.009777201
BAZ1B\tS701\t-0.07075442
BAZ1B\tS704\t-0.009364599
BAZ1B\tS712\t-0.041156955
BAZ1B\tS943\t-0.02445785
BAZ1B\tT706\t-0.09787242
BAZ1B\tT941\t-0.0459079
BAZ2A\tS1152\t0.3430097
BAZ2A\tS1338\t-0.1984274
BAZ2A\tS1365\t-0.3834541
BAZ2A\tS1510\t0.0911243
BAZ2A\tS1751\t-0.04367569
BAZ2A\tS464\t-0.66504584
BAZ2A\tS477\t-0.40892532
BAZ2B\tT1087\t0.2841587
BAZ2B\tT1089\t-0.22291545
BAZ2B\tT1818\t-0.057763765
BAZ2B\tT1942\t-4.32399
BBX\tS704\t0.0888201
BBX\tS814\t-0.04033371
BBX\tT819\t0.25758615
BCAR1\tY249\t-0.228769195
BCAR3\tS375\t-0.31494494
BCAS3\tS480\t0.20444835
BCAS3\tS602\t0.004033884
BCAS3\tS854\t-0.4839041
BCAS3\tS893\t0.216486
BCAS3\tS907\t-0.728407
BCKDHA\tS371\t0.004465491
BCKDHA\tS381\t0.168642
BCKDK\tS31\t-0.06346944
BCL10\tS134\t-0.05892373
BCL10\tS138\t-1.93821
BCL2L12\tS241\t-0.049931525
BCL2L12\tS272\t-0.2347029
BCL2L13\tS303\t0.1583371
BCL2L13\tS420\t0.08379207
BCL2L13\tS426\t-0.4057955
BCL3\tS41\t-0.09754815
BCL6\tS343\t-0.0841599
BCL6\tS427\t0.25425209
BCL6\tT429\t0.3344539
BCL7B\tS114\t-0.048909145
BCL7B\tS118\t0.10423901
BCL7B\tS120\t0.26505035
BCL7B\tS122\t0.10236065
BCL7C\tS114\t-0.22101815
BCL7C\tS122\t0.384871945
BCL7C\tS126\t-0.5847605
BCL7C\tS156\t-1.6898
BCL7C\tT111\t-0.01696449
BCL7C\tT118\t-0.03505305
BCL9\tS104\t-2.4006905
BCL9\tS278\t-0.01397502
BCL9\tS291\t-0.1812743
BCL9\tS687\t0.01592577
BCL9\tT115\t-0.4626145
BCL9\tT315\t0.0275787
BCL9L\tS1010\t-0.04711482
BCL9L\tS116\t0.83022335
BCL9L\tS118\t-2.78986
BCL9L\tS21\t0.08391985
BCL9L\tS750\t0.3562565
BCL9L\tS813\t-0.1856055
BCL9L\tS934\t-2.288487
BCLAF1\tS175\t-0.009785733
BCLAF1\tS181\t0.05852425
BCLAF1\tS194\t-0.11146858
BCLAF1\tS196\t-0.04790505
BCLAF1\tS220\t-0.05368838
BCLAF1\tS223\t-0.0018484
BCLAF1\tS226\t-0.0018484
BCLAF1\tS228\t0.1724071
BCLAF1\tS260\t0.254594
BCLAF1\tS262\t0.254594
BCLAF1\tS266\t0.107760845
BCLAF1\tS283\t-0.04103585
BCLAF1\tS285\t0.00161872
BCLAF1\tS288\t-0.13402675
BCLAF1\tS295\t-0.05490493
BCLAF1\tS339\t0.09464151
BCLAF1\tS383\t0.05021207
BCLAF1\tS387\t0.03871708
BCLAF1\tS395\t-0.030033975
BCLAF1\tS494\t-0.1434684
BCLAF1\tS510\t0.02517066
BCLAF1\tS529\t0.231878775
BCLAF1\tS576\t0.8881799
BCLAF1\tS656\t0.04558271
BCLAF1\tS658\t0.02247432
BCLAF1\tS688\t0.35259178
BCLAF1\tT255\t-0.062184045
BCLAF1\tT339\t0.33825495
BCLAF1\tT400\t-0.03345142
BCLAF1\tT564\t0.01601688
BCLAF1\tT838\t0.1867541
BCLAF1\tY282\t-0.016391035
BCOR\tS1127\t-0.2083443
BCOR\tS1139\t-0.1446322
BCOR\tS336\t0.3338817
BCOR\tS422\t-0.1440104
BCOR\tS423\t0.05852425
BCORL1\tS599\t-0.247236
BCR\tS122\t-0.04496998
BDH1\tS219\t0.08868441
BDP1\tS1524\t-0.11743755
BDP1\tS2227\t-0.32863145
BECN1\tS64\t-0.09700799
BEND3\tS379\t0.02389408
BEND3\tS489\t0.0045941
BEND3\tS93\t-0.12598309
BET1L\tS9\t0.4608998
BHLHE40\tS383\t-0.6512011
BICC1\tS612\t-0.19447815
BICD1\tS570\t0.1496496
BICD1\tS593\t0.3782061
BICD2\tS395\t0.23503325
BICD2\tS582\t-0.07605218
BICD2\tS608\t-1.142057
BICD2\tS615\t-1.504387
BIN1\tS265\t-0.08597133
BIN1\tS267\t0.1465249
BIN1\tS272\t0.1465249
BIN1\tS300\t0.11117035
BIN1\tT296\t-0.0421357
BIRC6\tS2955\t-0.151610465
BIRC6\tS3591\t-0.4629326
BIRC6\tS480\t-0.1734658
BIRC6\tS482\t-0.1734658
BIRC6\tS486\t-0.17436935
BIRC7\tS37\t-0.45531665
BLM\tS464\t0.5049763
BLM\tT125\t0.3830546
BLOC1S1\tS22\t-0.03343664
BLOC1S3\tS27\t-0.06297207
BLOC1S3\tS65\t-0.2110638
BLOC1S3\tT25\t-0.06297207
BLOC1S3\tT63\t-0.2110638
BLOC1S4\tT165\t-0.08280504
BLOC1S5\tS25\t-0.41318365
BLVRA\tS237\t0.0160683
BLZF1\tS362\t-0.59238755
BMP2K\tS1029\t-0.4763176
BMP2K\tS1076\t-0.161379
BMPR2\tS375\t0.45315575
BMPR2\tS862\t-0.3904886
BMPR2\tS863\t-0.3496297
BMPR2\tT379\t-0.1720347
BMS1\tS552\t0.143524
BNC2\tS308\t-0.1128023
BNC2\tS734\t0.4041402
BNIP2\tS235\t-0.03135623
BNIP3\tS86\t-0.2679305
BNIP3L\tS25\t-0.2143059
BNIP3L\tS47\t-0.5772097
BNIP3L\tS80\t-0.04727875
BOD1L1\tS143\t-0.07172444
BOD1L1\tS1531\t0.08691968
BOD1L1\tS1701\t-0.6854429
BOD1L1\tS2203\t-0.022930423
BOD1L1\tS2779\t-0.3041131
BOD1L1\tS2780\t-0.1594484
BOD1L1\tS2905\t0.254473
BOD1L1\tS2954\t-1.695126
BOD1L1\tS2964\t0.2340108
BOD1L1\tS2973\t-1.668409
BOD1L1\tS2986\t-0.3386153
BOD1L1\tS3019\t-0.0688616
BOD1L1\tS482\t0.007051912
BOD1L1\tS484\t0.007051912
BOD1L1\tS635\t-0.9020656
BOD1L1\tS648\t-1.4285235
BOD1L1\tS659\t-1.586883
BOD1L1\tT2956\t-1.6007985
BOD1L1\tT660\t0.32758655
BOK\tS7\t-0.11786295
BOK\tS8\t-0.090000135
BOLA1\tS123\t-0.3704895
BOP1\tS126\t-0.04386902
BOP1\tS127\t-0.04386902
BOP1\tT106\t0.3482324
BPTF\tS1092\t0.3213509
BPTF\tS1161\t-0.1530615
BPTF\tS2326\t-0.008827389
BPTF\tS433\t-0.02527979
BPTF\tS517\t-0.2368774
BPTF\tS624\t0.1252544
BPTF\tT1164\t-0.0187937
BPTF\tT600\t0.0560354
BRAF\tS399\t-0.58707835
BRAF\tS729\t0.0494913
BRAF\tT401\t-0.5076647
BRAP\tS67\t-0.1349841
BRAP\tS87\t-0.09152519
BRAP\tT278\t0.061817505
BRAT1\tS742\t0.4490067
BRAT1\tT581\t-0.3678434
BRCA1\tS1040\t0.6864527
BRCA1\tS1046\t0.2000021
BRCA1\tS1228\t0.1068843
BRCA1\tS1317\t0.2408638
BRCA1\tS138\t0.00302647
BRCA1\tS711\t-0.01624937
BRCA1\tS713\t0.2006298
BRCA1\tS975\t0.4577113
BRCA1\tS984\t-0.01439759
BRCA1\tT671\t-0.1253683
BRCA2\tS93\t0.062184377
BRD1\tS128\t0.0321009
BRD1\tS906\t-0.16978027
BRD1\tS934\t-0.121157
BRD1\tS983\t-0.79958545
BRD2\tS298\t0.035554285
BRD2\tS301\t-0.031469575
BRD2\tS37\t-2.222027
BRD2\tS611\t0.3120843
BRD3\tS263\t-0.01546168
BRD3\tT250\t0.4052289
BRD4\tS1117\t0.1800205
BRD4\tS469\t-0.0914945
BRD4\tS470\t-0.1411915
BRD7\tS279\t0.01649632
BRD7\tS289\t0.05977056
BRD8\tS259\t-0.4565635
BRD8\tS275\t-0.1600082
BRD8\tS381\t-0.197964
BRD8\tS573\t0.02729555
BRD8\tS615\t0.14581185
BRD8\tT255\t-0.2069596
BRD8\tT563\t-0.07693452
BRD9\tT103\t-0.063331985
BRF1\tS315\t0.2127561
BRF1\tS376\t-0.48565885
BRIP1\tS1032\t0.04572251
BRIP1\tS197\t-1.445873
BRIX1\tS261\t-0.22988495
BRMS1L\tS149\t0.038998
BRPF1\tS120\t-0.03311538
BRPF1\tS460\t-0.07672148
BRPF1\tS462\t-0.07672148
BRPF1\tS75\t-0.275984115
BRPF1\tS84\t-0.184254448
BRPF1\tS866\t-0.0151555
BRPF1\tS928\t0.04765393
BRPF1\tS932\t0.199864695
BRPF1\tT926\t0.31516025
BRPF3\tS962\t-0.149107775
BRPF3\tS965\t-0.187490675
BRSK1\tS108\t0.2565276
BRSK1\tS145\t-1.18478475
BRSK1\tS79\t0.5439907
BRSK2\tS88\t0.1583371
BRWD1\tS1475\t-0.007463541
BRWD1\tS1678\t-0.4578906
BRWD1\tS1793\t0.1746621
BRWD1\tS1904\t0.12808616
BRWD1\tS1905\t0.12808616
BRWD1\tS1907\t-0.01214634
BRWD1\tS1943\t0.09433092
BRWD1\tS2018\t0.2778657
BRWD1\tS2020\t0.2778657
BRWD1\tS2131\t-0.35932825
BRWD1\tS649\t0.2991274
BRWD3\tS1175\t-0.3861478
BSDC1\tS326\t-1.897167
BSG\tS153\t0.03407487
BTBD7\tS296\t0.1021878
BTF3\tS158\t0.36202405
BTF3\tS30\t-0.08636951
BUB1\tS314\t0.53242715
BUB1\tS596\t-0.9415311
BUB1\tS655\t0.08215749
BUB1B\tS670\t0.086149065
BUB3\tS211\t0.046414715
BUD13\tS151\t-0.056323925
BUD13\tS163\t-0.180366684
BUD13\tS197\t0.09111808
BUD13\tS201\t0.06653696
BUD13\tS235\t-0.030888682
BUD13\tS240\t0.24893025
BUD13\tS248\t-0.02307916
BUD13\tS271\t-0.01777067
BUD13\tS325\t0.08311115
BUD13\tS354\t-0.08587942
BUD13\tS357\t-0.08587942
BUD13\tS358\t-0.08587942
BUD13\tT135\t0.1230039
BUD13\tT147\t0.1389324
BUD13\tT159\t0.010206346
BYSL\tS98\t-0.1363787
C10orf11\tS10\t0.09271621
C10orf11\tS152\t0.09271621
C10orf11\tS153\t0.09271621
C10orf11\tS9\t0.09271621
C10orf12\tS273\t0.1008431
C10orf12\tS449\t0.03646811
C10orf12\tT65\t0.175934585
C11orf30\tS1036\t-0.0633599
C11orf30\tS1038\t0.016088215
C11orf30\tS1112\t0.04332211
C11orf30\tS174\t-0.08774875
C11orf30\tT1031\t-0.3141226
C11orf68\tS12\t-0.04293233
C11orf74\tS193\t-0.33761495
C11orf84\tS148\t-0.0337763
C11orf84\tS152\t-0.08040822
C11orf84\tS248\t-0.1574315
C11orf84\tS251\t0.257715525
C11orf84\tS308\t0.08406419
C11orf84\tT253\t-0.2551156
C11orf84\tT255\t-0.2551156
C11orf84\tT49\t-0.04838241
C11orf96\tS399\t-0.07438028
C12orf43\tS108\t0.2664326
C12orf43\tS149\t-0.0614056
C12orf43\tT181\t0.424922
C12orf43\tT49\t0.4802651
C12orf45\tS178\t0.3279173
C13orf23\tS591\t-0.4168083
C14orf159\tS11\t0.08583257
C15orf39\tS208\t0.6535186
C15orf39\tS996\t0.0415233
C15orf52\tS193\t0.3904475
C15orf52\tS201\t-0.03853962
C15orf52\tS387\t-0.365781725
C15orf52\tS392\t-0.25612965
C15orf52\tS448\t0.1923535
C15orf52\tS55\t0.2738142
C15orf52\tT204\t-0.05563627
C16orf55\tS94\t-0.0615639
C16orf74\tT32\t-0.3755715
C17orf100\tS54\t0.32568785
C17orf59\tS168\t0.05630613
C17orf59\tT196\t0.22377645
C17orf75\tS18\t0.07573799
C17orf85\tS25\t-0.1465792
C18orf25\tS145\t-1.069543
C18orf25\tS147\t-1.033747
C18orf25\tS34\t-0.05139744
C18orf25\tS66\t-0.6333508
C18orf25\tS67\t0.4936473
C18orf25\tS69\t-0.0622572
C18orf25\tS76\t0.0012392
C19orf26\tS319\t0.46319375
C19orf26\tS324\t0.7990183
C19orf26\tS398\t-0.1007241
C19orf26\tS408\t-0.1162229
C19orf47\tS57\t-0.4655598
C19orf47\tS84\t0.1573025
C19orf47\tS87\t0.2067682
C19orf47\tT88\t0.1389455
C19orf55\tS356\t-1.924837
C19orf57\tS370\t-0.08543549
C1QBP\tS213\t0.10994043
C1orf131\tS278\t0.1047392
C1orf198\tT173\t0.10532815
C1orf21\tS61\t-0.2686778
C1orf226\tS223\t0.07655907
C1orf52\tS158\t0.02389408
C1orf86\tS65\t3.7454675
C20orf112\tS130\t-0.004262259
C20orf112\tS18\t-0.3156839
C20orf112\tS400\t-0.2228686
C21orf2\tS136\t0.3119681
C21orf2\tS177\t0.1258756
C21orf2\tS95\t-0.22666635
C22orf28\tS300\t0.0800714
C2CD2\tS492\t0.1909309
C2CD2\tS494\t0.2016338
C2CD2L\tS464\t0.2916035
C2CD2L\tS466\t0.2916035
C2CD2L\tS59\t-0.3011415
C2CD2L\tS660\t0.151244297
C2CD2L\tT672\t0.344419995
C2CD3\tS2114\t-0.2382382
C2CD3\tS2132\t0.01249849
C2CD3\tS2146\t0.058316215
C2CD3\tS2328\t-0.02749851
C2CD3\tS976\t-1.279599
C2CD5\tS260\t-0.4043627
C2CD5\tS262\t-0.47434175
C2CD5\tS295\t0.03102083
C2CD5\tS305\t0.3297552
C2CD5\tS659\t-0.4848931
C2CD5\tS661\t-0.4848931
C2CD5\tS662\t-0.4848931
C2CD5\tS864\t-0.2983533
C2CD5\tS903\t-0.07164862
C2CD5\tT314\t0.5464624
C2orf3\tS174\t-0.061554465
C2orf3\tS180\t-0.061554465
C2orf3\tS40\t-0.3460228
C2orf3\tS96\t0.04572251
C2orf3\tT97\t0.04572251
C2orf44\tS690\t-1.07899
C2orf49\tS182\t-0.3272216
C2orf49\tS189\t-0.33299515
C2orf49\tS193\t-1.2184965
C2orf49\tT197\t0.179333393
C3orf17\tS195\t0.3903376
C3orf17\tS258\t0.32311455
C3orf37\tT221\t0.12877053
C3orf70\tS120\t-0.7550399
C3orf80\tS187\t-0.056983997
C4orf19\tS47\t-0.10723785
C5orf30\tS167\t-0.214660185
C5orf30\tS25\t0.0984196
C6orf106\tS149\t0.110096
C7orf50\tS175\t0.01521204
C7orf50\tS23\t-0.14928878
C7orf50\tS59\t-0.11313
C8orf33\tT19\t0.9356107
C9JYP6\tS6\t-0.2124672
C9orf142\tS148\t-0.07295315
C9orf40\tS69\t-0.08794807
C9orf40\tS71\t-0.18309055
C9orf40\tS76\t-0.4164616
C9orf72\tS9\t-2.977327
C9orf78\tS15\t-0.04242711
C9orf78\tS17\t-0.0204868
C9orf78\tS261\t-0.11713
C9orf78\tT253\t0.1726418
C9orf89\tS113\t-0.1138791
CAAP1\tS203\t-0.1952856
CAAP1\tS312\t-0.1992554
CAAP1\tT90\t-0.6418513
CABIN1\tS11\t-0.599331
CABIN1\tS1740\t0.23697385
CABIN1\tS2094\t0.01235413
CABIN1\tT2154\t-0.7050059
CABLES1\tT150\t0.39726045
CACTIN\tS476\t0.2055176
CAD\tS1038\t-0.2071779
CAD\tS1406\t0.169763495
CAD\tS147\t-0.5784346
CAD\tS1859\t-0.2527243
CAD\tT1833\t0.1843941
CAD\tT1884\t0.09949727
CADM1\tS406\t-0.19560835
CADM4\tS361\t0.2141248
CADPS2\tS56\t0.1251221
CADPS2\tS58\t0.286885575
CALD1\tS125\t0.2412301
CALD1\tS196\t0.03224201
CALD1\tS196\t-0.1388545
CALD1\tS202\t-0.08345885
CALD1\tS463\t0.6599246
CALD1\tS498\t0.40245355
CALD1\tS7\t-0.03029511
CALD1\tT285\t-0.5265974
CALD1\tT469\t0.6957307
CALD1\tT492\t0.40245355
CALM1\tS18\t0.31625395
CAMK2D\tT287\t0.190678
CAMK2D\tT336\t-0.16309497
CAMK2G\tT287\t0.01777946
CAMK4\tS360\t0.03576464
CAMKK2\tS129\t-1.334498
CAMKK2\tS133\t-2.45354285
CAMKK2\tS495\t-0.04134286
CAMSAP1\tS1080\t-1.947751
CAMSAP1\tS1398\t0.112449301
CAMSAP1\tS1427\t0.1760674
CAMSAP1\tS563\t0.1625968
CAMSAP1\tS575\t-0.1663408
CAMSAP1\tS722\t-0.4961576
CAMSAP1\tS728\t-0.524417
CAMSAP1\tT1144\t-2.177099
CAMSAP2\tS1121\t0.002450562
CAMSAP2\tS1266\t-0.1206392
CAMSAP2\tS1274\t0.007051655
CAMSAP2\tS1284\t-0.9067989
CAMSAP2\tS1286\t-0.1459405
CAMSAP2\tS1292\t0.1150332
CAMSAP2\tS1294\t-0.2652578
CAMSAP2\tS437\t0.1078218
CAMSAP2\tS572\t0.1174291
CAMSAP2\tS646\t-0.08031666
CAMSAP2\tS783\t0.11835145
CAMSAP2\tS835\t-2.922483
CAMSAP2\tS909\t0.3756394
CAMSAP2\tS992\t0.007339063
CAMSAP2\tT838\t-1.5391215
CAND1\tS558\t-0.02872299
CANX\tS554\t-0.21221305
CANX\tS564\t-0.16101075
CANX\tS583\t0.04278438
CANX\tT562\t-0.035289954
CAP1\tS308\t0.1162316
CAP1\tS34\t0.440208
CAP1\tT307\t0.086371485
CAP2\tS301\t0.15572671
CAPN2\tS462\t0.5821706
CAPN2\tT464\t0.1961033
CAPRIN1\tS307\t0.107610925
CAPZA1\tS9\t0.06087747
CAPZA2\tS9\t-0.0120534
CAPZB\tS2\t0.2289726
CARHSP1\tS41\t-0.01160256
CARHSP1\tS52\t0.01592577
CARHSP1\tT23\t0.2423281
CARS\tS102\t-0.07998114
CARS\tS390\t-0.1910466
CASC3\tS117\t0.14985885
CASC3\tS125\t0.090616335
CASC3\tS148\t0.1562672
CASC3\tS35\t-0.2469946
CASC3\tS363\t0.05408442
CASC3\tS39\t-0.30415095
CASC4\tS328\t-0.1481291
CASC4\tS366\t-0.3449047
CASC4\tS374\t-0.01794279
CASC5\tS1050\t-0.506578
CASC5\tS376\t0.52142275
CASC5\tT513\t0.07356668
CASK\tS51\t0.1378969
CASK\tS571\t-0.03451487
CASKIN2\tS314\t0.02062666
CASKIN2\tS321\t-0.1514101
CASKIN2\tS389\t-0.2850732
CASKIN2\tS613\t-0.08114059
CASKIN2\tS615\t-0.121008965
CASKIN2\tS643\t-0.3883555
CASKIN2\tT746\t0.1148864
CASKIN2\tT877\t0.01188076
CASP2\tS157\t-1.969524
CASP2\tS340\t-0.3393999
CASP4\tS16\t-1.133812
CASP4\tS83\t-0.2348048
CASP7\tS16\t0.08814155
CASP8AP2\tS1278\t0.06723205
CASP8AP2\tS1368\t-0.05869837
CASP8AP2\tS18\t-0.082259935
CASP8AP2\tS20\t0.02573757
CASP8AP2\tS567\t-0.01763609
CASP8AP2\tS858\t-0.107881
CASP8AP2\tS862\t-0.107881
CASP8AP2\tS940\t0.1567849
CASP8AP2\tT1277\t0.1417161
CASP8AP2\tT1340\t-0.110121015
CASP8AP2\tT793\t-0.02118936
CAST\tS11\t-0.03299376
CAST\tS291\t-0.5126783
CAST\tS412\t-1.279249
CAST\tS414\t0.0889556
CAST\tS625\t0.0202881
CAV1\tS37\t0.1740229
CAV1\tS6\t0.1336951
CAV1\tS9\t0.1470623
CAV2\tS36\t-0.09668401
CBFA2T2\tS33\t0.12277067
CBFA2T2\tS4\t-0.2579248
CBFB\tS173\t0.0244615
CBFB\tS176\t0.05297228
CBL\tS483\t-0.173545615
CBL\tS486\t-0.04885762
CBLB\tS656\t0.6467157
CBLB\tS694\t-0.1133484
CBLB\tS955\t-2.298034
CBR1\tS151\t-0.200636145
CBR3\tT162\t0.6445184
CBX3\tS102\t-0.665687175
CBX3\tS93\t-0.2702428
CBX3\tS95\t-0.0867678
CBX3\tS97\t0.114377548
CBX3\tS99\t0.02346825
CBX4\tS182\t0.08065767
CBX4\tS434\t-0.19242945
CBX4\tS467\t-0.1526765
CBX5\tS14\t-0.3094599
CBX5\tS92\t0.5255678
CBX6\tS283\t0.069056035
CBX8\tS191\t-0.05363805
CBX8\tS265\t0.3480057
CBY1\tS9\t0.1777266
CC2D1A\tS239\t-1.058233
CCDC102A\tS12\t0.03955951
CCDC102A\tS26\t-0.1161133
CCDC102A\tS28\t-0.01703749
CCDC111\tS126\t-1.134477
CCDC12\tS149\t0.4453935
CCDC124\tS141\t0.217479
CCDC130\tS286\t0.08569661
CCDC130\tS306\t-0.000230819
CCDC130\tS332\t-0.04586325
CCDC130\tS362\t-0.1161602
CCDC132\tS494\t0.121546
CCDC132\tS498\t0.121546
CCDC132\tS559\t-0.4265479
CCDC132\tS561\t-0.2452321
CCDC132\tY557\t-0.22899573
CCDC137\tS19\t0.1188912
CCDC14\tS105\t0.83827565
CCDC14\tS355\t-0.2246545
CCDC14\tS735\t-0.0754592
CCDC28B\tS46\t0.1297446
CCDC43\tT139\t-0.01263544
CCDC50\tT310\t-0.1427196
CCDC58\tT97\t0.08208733
CCDC6\tS240\t-0.5976053
CCDC6\tS244\t-0.7531998
CCDC6\tS325\t0.250970615
CCDC6\tS367\t-0.310790085
CCDC6\tT380\t-0.5443717
CCDC61\tS376\t2.252264
CCDC71\tS208\t0.184534355
CCDC71\tS97\t0.1606799
CCDC82\tS131\t-0.260221
CCDC82\tS219\t0.3021728
CCDC86\tS102\t0.071544621
CCDC86\tS113\t-0.02795443
CCDC86\tS128\t0.1982427
CCDC86\tS160\t0.0692898
CCDC86\tS18\t0.01278325
CCDC86\tS21\t0.132790654
CCDC86\tS47\t0.01464098
CCDC86\tS58\t-0.007521628
CCDC86\tS80\t0.02636632
CCDC86\tS91\t-0.000830855
CCDC86\tT3\t0.1866274
CCDC88A\tS1019\t-0.381611
CCDC88A\tS1673\t-0.04911355
CCDC88A\tS1688\t-0.2307699
CCDC88A\tS233\t0.5101518
CCDC88A\tS237\t0.5101518
CCDC88A\tT1644\t-0.1930187
CCDC88A\tT1772\t0.2278643
CCDC9\tS202\t0.1031283
CCDC9\tS376\t0.6379297
CCDC9\tS386\t-0.62265505
CCDC9\tS390\t-0.8080813
CCDC9\tT381\t0.3770134
CCDC9\tT385\t-0.319816375
CCDC9\tT389\t-1.12208265
CCDC93\tS300\t0.3303289
CCDC94\tS211\t-0.09418701
CCDC94\tS213\t-0.09418701
CCM2\tS164\t-0.1457809
CCM2\tS384\t0.06364096
CCNB2\tS92\t0.11703
CCNC\tS272\t-0.07258895
CCNE1\tS21\t0.007913023
CCNE1\tS260\t0.05769283
CCNE2\tS21\t0.1154328
CCNE2\tS338\t0.1000357
CCNE2\tT347\t0.1000357
CCNK\tS324\t0.08120319
CCNK\tS329\t0.07097116
CCNK\tS340\t-0.0311941
CCNK\tS9\t-0.17567239
CCNL1\tS335\t-0.5307391
CCNL1\tS338\t0.3970504
CCNL1\tS342\t-0.127053
CCNL1\tS352\t-0.01038142
CCNL1\tS65\t0.0615688
CCNL1\tT325\t0.307200073
CCNL1\tT67\t0.0524142
CCNL2\tS108\t-0.001891156
CCNL2\tS147\t0.01278325
CCNT2\tS480\t-0.1481131
CCNT2\tS601\t0.02772026
CCNY\tS25\t-0.9105561
CCNY\tS324\t-1.2051915
CCNY\tS326\t-0.05431738
CCNY\tS83\t0.05436236
CCNYL1\tS274\t0.02616273
CCNYL1\tS51\t0.1924466
CCP110\tS372\t0.1199537
CCP110\tS400\t-0.49353275
CCP110\tS641\t-0.3374233
CCPG1\tS42\t0.1918568
CCSAP\tS145\t0.0426443
CCSAP\tS240\t0.4574554
CCSAP\tS80\t-0.1581556
CCT2\tS3\t-0.02977955
CCT2\tS5\t0.2031386
CCT3\tS244\t0.0189818
CCT3\tS252\t-0.6211777
CCT6A\tS205\t0.1340894
CCT7\tT4\t0.01278325
CCT8\tT381\t0.0790197
CCZ1\tS266\t0.1044708
CD22\tS629\t1.002435755
CD276\tS525\t-0.3059133
CD2AP\tS458\t0.3700527
CD2AP\tS510\t0.2847626
CD2AP\tS514\t0.445197
CD2AP\tS582\t0.1021878
CD2BP2\tS194\t0.08048292
CD2BP2\tS195\t0.091385175
CD2BP2\tS49\t-0.02608757
CD3EAP\tS126\t0.047867275
CD3EAP\tS128\t0.1235331
CD3EAP\tS27\t0.1200864
CD3EAP\tS285\t0.07107621
CD3EAP\tS488\t0.19533875
CD3EAP\tS490\t-0.1326296
CD44\tS284\t-0.1811985
CD44\tS302\t0.161917985
CD44\tS304\t0.0692898
CD44\tS315\t0.35051497
CD44\tT318\t0.7123756
CD44\tT324\t-0.08632359
CD97\tS738\t-2.928402
CD99\tS168\t0.3156822
CDAN1\tS264\t-0.2840188
CDAN1\tS276\t-0.2383233
CDC14A\tS426\t0.4440309
CDC16\tS508\t-0.8634937
CDC16\tT529\t0.1491292
CDC20\tS104\t0.3641567
CDC20\tS41\t0.4469972
CDC20\tT106\t0.2195867
CDC20\tT70\t0.1336951
CDC23\tS470\t0.2579087
CDC23\tT478\t0.2624331
CDC25A\tS221\t0.46143905
CDC25B\tS188\t0.3089433
CDC25B\tS197\t0.1347467
CDC25B\tS208\t-0.9421685
CDC25B\tS312\t-0.1279357
CDC25B\tS334\t0.06791403
CDC25B\tS42\t0.2802438
CDC25B\tS50\t0.4850192
CDC25C\tT48\t-2.1310605
CDC26\tS42\t0.17022685
CDC27\tS369\t0.24018835
CDC27\tS435\t0.4655044
CDC40\tS43\t0.15079215
CDC42BPA\tS1630\t-0.09394066
CDC42BPA\tS1768\t-0.2009744
CDC42BPA\tS1770\t-0.086377575
CDC42BPA\tS1773\t0.02729555
CDC42BPA\tS940\t0.0407951
CDC42BPB\tS1690\t-0.1760551
CDC42EP1\tS121\t0.1718473
CDC42EP1\tS190\t0.3155663
CDC42EP1\tS192\t0.14958305
CDC42EP1\tS195\t0.054167115
CDC42EP1\tS343\t0.27691015
CDC42EP1\tS346\t-0.44129995
CDC42EP2\tS109\t0.4426516
CDC42EP3\tS100\t-1.7870115
CDC42EP3\tS108\t-0.2628152
CDC42EP3\tS144\t-1.733075
CDC42EP3\tS89\t-1.41318355
CDC42EP3\tT98\t0.5481407
CDC42EP4\tS109\t0.5124797
CDC42EP4\tS118\t0.3851549
CDC42EP4\tS292\t0.3562565
CDC42EP4\tS295\t-0.3472333
CDC42EP4\tS64\t0.0889556
CDC5L\tT377\t-0.3762408
CDC5L\tT385\t-0.543426635
CDC5L\tT396\t-0.532727875
CDC5L\tT424\t-0.2710782
CDC6\tS45\t0.7150148
CDC6\tS74\t-0.02789152
CDCA2\tS24\t0.7816245
CDCA2\tS470\t-0.00061653
CDCA2\tS591\t0.3317052
CDCA2\tS710\t0.4068631
CDCA2\tS726\t0.3193213
CDCA2\tS756\t0.4250295
CDCA2\tS936\t0.02687089
CDCA3\tS199\t0.61868125
CDCA3\tS209\t0.3720605
CDCA3\tS68\t0.07956584
CDCA3\tS87\t-0.7914578
CDCA3\tT212\t0.568324
CDCA3\tT214\t0.4490067
CDCA5\tS209\t0.1560082
CDCA5\tS21\t0.02417773
CDCA5\tS35\t-0.3268763
CDCA5\tS75\t-0.2101122
CDCA5\tT159\t0.5981746
CDCA7L\tS104\t-0.3066458
CDCA7L\tS107\t-0.3066458
CDCA7L\tS116\t-0.1960126
CDCA7L\tS161\t-0.031712785
CDCA7L\tS21\t-0.1334797
CDCA7L\tS260\t-0.305521
CDCA8\tS219\t0.2490205
CDCA8\tT106\t0.4794375
CDH19\tS685\t-0.2013108
CDH2\tS824\t-0.37028975
CDK1\tT14\t0.222398175
CDK1\tY15\t0.22869835
CDK11B\tS254\t-0.1807897
CDK11B\tS260\t-0.078589745
CDK11B\tS47\t0.05366741
CDK11B\tS72\t-0.1843426
CDK11B\tS729\t-0.150173398
CDK11B\tT572\t-0.1072748
CDK11B\tT728\t-0.131417163
CDK12\tS1083\t0.1082234
CDK12\tS32\t0.10671928
CDK12\tS332\t0.115951805
CDK12\tS333\t0.22848619
CDK12\tS334\t0.1248574
CDK12\tS341\t0.14567719
CDK12\tS343\t0.14567719
CDK12\tS345\t0.14567719
CDK12\tS383\t0.09261344
CDK12\tS385\t0.09261344
CDK12\tS423\t0.1152996
CDK12\tS681\t-0.183916325
CDK12\tS685\t-0.17922145
CDK12\tT1244\t-0.092884774
CDK12\tT1246\t0.1574251
CDK12\tT57\t0.2159891
CDK13\tS1048\t-0.03943152
CDK13\tS1054\t0.6783423
CDK13\tS315\t0.07121356
CDK13\tS317\t0.07121356
CDK13\tS325\t-0.2406894
CDK13\tS383\t0.08678382
CDK13\tS4\t-0.222041675
CDK13\tS437\t0.1220763
CDK13\tS439\t0.1220763
CDK13\tS525\t-0.04410696
CDK13\tS662\t0.1051417
CDK13\tS664\t0.026304335
CDK13\tT1058\t0.346355427
CDK13\tT1087\t-0.1265017
CDK13\tT1186\t-0.007594068
CDK14\tS24\t-0.7223394
CDK16\tS110\t-0.5838292
CDK16\tS138\t0.44801495
CDK16\tS146\t0.04362443
CDK16\tS153\t-0.3270587
CDK16\tS155\t0.7974448
CDK16\tS65\t-0.99988015
CDK16\tS95\t-0.056757195
CDK16\tT135\t0.5202463
CDK16\tY203\t0.17231095
CDK17\tS105\t0.197261835
CDK17\tS122\t-0.1493926
CDK17\tS137\t0.0533895
CDK17\tS165\t-0.2846865
CDK17\tS180\t-0.09281702
CDK17\tS182\t0.2519311
CDK17\tS9\t0.1232026
CDK18\tS12\t-0.100778
CDK18\tS72\t-0.170596025
CDK18\tS87\t-0.1163635
CDK5\tT17\t0.2571313
CDK5\tY15\t-0.05849714
CDK5RAP2\tS1074\t-1.427906
CDK5RAP2\tS1808\t0.2158649
CDK5RAP2\tS697\t-0.3507064
CDK7\tS321\t0.3265373
CDK9\tS56\t-0.08338574
CDKL5\tS529\t0.129391515
CDKL5\tT528\t0.107290585
CDKN1A\tS130\t-0.3548148
CDKN1A\tS31\t0.20730965
CDKN1B\tS10\t-0.05583121
CDKN2AIP\tS10\t-0.05874342
CDR2\tS189\t-0.573102
CDR2L\tS304\t-0.5285941
CDS2\tS21\t0.07382025
CDS2\tS33\t-0.0248101
CDS2\tS41\t0.3075451
CDT1\tS316\t0.167358
CDT1\tS318\t0.01106615
CDV3\tS106\t0.15043259
CDV3\tS107\t0.2858165
CDV3\tS30\t0.3516284
CDV3\tS37\t0.21343375
CDV3\tS8\t-0.2121496
CDYL\tS30\t0.03843611
CEBPZ\tS621\t-0.153591303
CEBPZ\tS629\t-0.0286024
CELF1\tS18\t-0.670127
CELF1\tS22\t-0.6192927
CELSR1\tS2960\t-0.3335706
CENPA\tS17\t0.1137005
CENPA\tS19\t0.127105
CENPA\tS27\t0.12313133
CENPB\tS156\t-0.1463077
CENPB\tS307\t0.3322782
CENPB\tT150\t0.006101132
CENPC1\tS177\t0.12215835
CENPC1\tS225\t-0.1825568
CENPC1\tS333\t0.079522925
CENPC1\tS447\t0.06446896
CENPC1\tS538\t-0.03528351
CENPC1\tS600\t-0.1093682
CENPC1\tS613\t-0.2230369
CENPC1\tS620\t0.157222045
CENPC1\tS73\t0.01035019
CENPC1\tS732\t0.19902595
CENPC1\tS773\t-0.008058267
CENPC1\tT130\t-0.03768053
CENPC1\tT516\t0.662479
CENPC1\tT734\t0.1139672
CENPE\tS2518\t0.5005982
CENPF\tS1747\t0.6089038
CENPF\tS1750\t0.9135371
CENPF\tS1822\t0.2085173
CENPF\tS276\t0.3203114
CENPF\tS2996\t0.35138685
CENPF\tS3007\t0.351890475
CENPF\tS3119\t0.1886542
CENPF\tS3150\t-0.2351104
CENPF\tS3179\t-0.4689048
CENPF\tS876\t0.85238775
CENPF\tT3177\t-0.31548399
CENPI\tS284\t-0.008928966
CENPI\tS520\t-0.39289195
CENPJ\tS260\t0.3090597
CENPJ\tS759\t0.63386915
CENPJ\tS859\t-0.1006233
CENPN\tS282\t0.2558028
CENPO\tS29\t-0.988499
CENPQ\tS249\t0.168559425
CENPT\tS397\t-0.09506509
CENPT\tS47\t0.09328973
CEP112\tS195\t-0.1475751
CEP120\tS415\t0.177500857
CEP128\tS950\t0.2365963
CEP152\tS1405\t0.110096
CEP164\tS472\t0.1920679
CEP164\tS566\t0.06695026
CEP164\tS588\t-0.25634905
CEP170\tS1112\t0.02062666
CEP170\tS1165\t0.1286893
CEP170\tS1239\t0.02091112
CEP170\tS1241\t0.020342115
CEP170\tS1247\t0.08909126
CEP170\tS1251\t0.5733364
CEP170\tS1270\t-2.83671
CEP170\tS1306\t-0.2454887
CEP170\tS1515\t-0.1312184
CEP170\tS1521\t0.1676149
CEP170\tS1522\t0.043304987
CEP170\tS1529\t-0.2718106
CEP170\tS356\t-0.1573671
CEP170\tS359\t-0.00268925
CEP170\tS379\t0.2571313
CEP170\tS446\t-0.04386902
CEP170\tS466\t1.0701229
CEP170\tS497\t0.03026536
CEP170\tS630\t0.1319846
CEP170\tS838\t-0.1237483
CEP170\tS881\t-0.2671143
CEP170\tS933\t-0.116541953
CEP170\tT1240\t0.010527703
CEP170\tT1533\t-0.70573295
CEP170\tT377\t0.173668005
CEP170\tT501\t-0.1512659
CEP170\tT644\t0.3039269
CEP170\tT760\t0.4233092
CEP170\tT920\t-1.10538
CEP170\tY502\t-0.0518178
CEP170B\tS1065\t-0.2747387
CEP170B\tS1109\t0.1580403
CEP170B\tS1114\t0.0889556
CEP170B\tS1129\t0.05755419
CEP170B\tS1440\t0.07162537
CEP170B\tS1443\t-1.433117
CEP170B\tS290\t-0.00652125
CEP170B\tS448\t0.02056122
CEP170B\tS466\t-0.65935945
CEP170B\tS585\t-0.7056881
CEP170B\tS603\t0.432773
CEP170B\tS641\t0.7985898
CEP170B\tS702\t-0.0612851
CEP170B\tS759\t-0.6378275
CEP170B\tS783\t-0.06725845
CEP170B\tS881\t-0.4078803
CEP170B\tS884\t-0.3556638
CEP170B\tS918\t-0.1521153
CEP170B\tT472\t-0.64351665
CEP192\tS1355\t-1.14541525
CEP192\tS180\t0.06763869
CEP192\tS474\t0.9782803
CEP192\tS664\t0.097123951
CEP192\tS800\t-0.098674807
CEP250\tS2179\t-0.1628225
CEP250\tS2229\t-0.0917643
CEP250\tS2322\t0.26741705
CEP250\tS2332\t0.2363395
CEP350\tS1648\t-0.04320615
CEP350\tS1653\t-0.51326675
CEP350\tS1818\t-0.1054266
CEP350\tS2115\t0.09491159
CEP350\tS2206\t0.5174602
CEP350\tS2341\t-0.5923536
CEP350\tS2460\t-0.3396372
CEP350\tS2839\t-0.41933765
CEP350\tS2860\t0.139704725
CEP350\tS365\t0.3106741
CEP350\tS695\t0.02743714
CEP350\tT878\t0.12618
CEP41\tS119\t0.01306909
CEP41\tS99\t0.1008431
CEP55\tS425\t-1.203037
CEP55\tS428\t-1.6374085
CEP55\tT430\t-1.248759
CEP57\tS10\t-0.1578015
CEP57\tS362\t-0.1791716
CEP63\tS449\t-0.4714887
CEP68\tS249\t-0.1333056
CEP76\tS83\t-0.79724625
CEP78\tS644\t0.2751112
CEP78\tS654\t0.3166091
CEP85\tT35\t0.6250754
CEP85L\tS15\t-0.7609013
CEP89\tS221\t0.2699907
CEP97\tS308\t-0.1153787
CEP97\tS500\t0.6443225
CEP97\tT502\t-0.388601
CERS2\tS341\t-0.05273297
CERS2\tS348\t-0.1005769
CERS2\tS349\t-0.1005769
CERS2\tT346\t-0.1005769
CERS4\tS254\t-0.1343821
CERS4\tS261\t-0.1343821
CERS4\tS262\t-0.1343821
CETN2\tS20\t-0.07263444
CFL1\tS156\t0.1580785
CFL1\tS3\t-0.9183331
CFL1\tT25\t0.02540065
CFL2\tS3\t-1.125951
CGN\tS165\t-0.3091092
CGN\tT34\t0.144221415
CHAF1A\tS141\t0.04208399
CHAF1A\tS203\t-0.001298968
CHAF1A\tS206\t0.11865615
CHAF1A\tS772\t0.0413831
CHAF1A\tS775\t-0.00585743
CHAF1A\tT865\t0.57845565
CHAF1B\tS409\t0.2249589
CHAF1B\tS410\t0.06253617
CHAF1B\tS429\t0.46911208
CHAF1B\tS458\t0.02247432
CHAF1B\tT433\t0.6117873
CHAMP1\tS108\t-0.09241705
CHAMP1\tS204\t-0.03380579
CHAMP1\tS214\t-0.1356494
CHAMP1\tS217\t-0.058404275
CHAMP1\tS282\t-0.08722872
CHAMP1\tS284\t0.1334675
CHAMP1\tS286\t0.02913487
CHAMP1\tS297\t0.03871708
CHAMP1\tS308\t-0.010392535
CHAMP1\tS311\t0.00121031
CHAMP1\tS319\t0.0145765
CHAMP1\tS382\t-0.29806235
CHAMP1\tS386\t-0.8659631
CHAMP1\tS405\t0.03280615
CHAMP1\tS416\t-0.09214021
CHAMP1\tS427\t-0.08851665
CHAMP1\tS432\t-0.01849804
CHAMP1\tS436\t-0.01849804
CHAMP1\tS443\t0.378948135
CHAMP1\tS445\t0.29396385
CHAMP1\tS452\t0.1076879
CHAMP1\tS459\t0.06571014
CHAMP1\tS476\t-0.000909215
CHAMP1\tS507\t0.8316341
CHAMP1\tS512\t0.41792805
CHAMP1\tS542\t-0.1339229
CHAMP1\tS603\t-0.1947406
CHAMP1\tS615\t0.67265685
CHAMP1\tS627\t0.03731201
CHAMP1\tS632\t-0.1821639
CHAMP1\tS633\t-0.1821639
CHAMP1\tS634\t0.021764
CHAMP1\tS651\t0.0107556
CHAMP1\tS653\t-0.1152536
CHAMP1\tT103\t-0.101412335
CHAMP1\tT458\t-0.1262498
CHCHD3\tS113\t-0.6438336
CHCHD3\tS29\t0.01934605
CHCHD3\tS50\t0.1782366
CHD1\tS1385\t-0.9975207
CHD1\tS1677\t-0.38999565
CHD1\tS1688\t-0.0439582
CHD1\tS215\t0.2393981
CHD1\tS216\t0.2393981
CHD1\tS5\t-0.31964765
CHD1L\tS523\t-0.0650986
CHD2\tS1365\t-0.06422346
CHD2\tS1386\t0.1050075
CHD2\tS1728\t-0.3737571
CHD2\tS207\t-0.1986426
CHD2\tS208\t-0.1986426
CHD3\tS1601\t-0.12718922
CHD3\tS1605\t-0.01670174
CHD3\tS352\t0.8697925
CHD3\tS597\t0.04110281
CHD3\tS713\t0.1200864
CHD3\tS73\t-0.4924844
CHD4\tS101\t-0.296546925
CHD4\tS1301\t-0.5657455
CHD4\tS1342\t0.4015212
CHD4\tS1524\t0.1087586
CHD4\tS1528\t0.04521032
CHD4\tS1530\t-0.31496454
CHD4\tS1563\t-0.2010952
CHD4\tS1569\t-0.22430183
CHD4\tS1595\t-0.14636885
CHD4\tS1641\t0.06488286
CHD4\tS508\t-0.100413365
CHD4\tS524\t-0.139999165
CHD4\tS96\t-0.296546925
CHD4\tS98\t-0.296546925
CHD4\tT1533\t-0.38090945
CHD4\tT1538\t-0.3761519
CHD4\tT1542\t-0.19508227
CHD4\tT1546\t-0.2143472
CHD4\tT1646\t-0.01028495
CHD4\tT1672\t0.008486926
CHD4\tT510\t-0.15023466
CHD4\tT522\t-0.07229713
CHD6\tS2680\t0.154972
CHD6\tT1339\t-0.1435481
CHD7\tS1577\t0.04348443
CHD7\tS1581\t0.04348443
CHD7\tS2229\t0.1163647
CHD7\tS2395\t0.593019
CHD7\tS2533\t-0.9671373
CHD7\tS2559\t0.1058121
CHD7\tS2956\t-0.05987086
CHD7\tT2551\t0.7695178
CHD8\tS1420\t0.163241
CHD8\tS1424\t0.163241
CHD8\tS1995\t0.1759289
CHD8\tS2008\t-0.02405221
CHD8\tS2046\t-0.000606022
CHD8\tS2069\t-0.1443292
CHD8\tS2071\t-0.1443292
CHD8\tS2519\t0.2282337
CHD8\tS549\t0.127105
CHD8\tS550\t0.127105
CHD8\tS562\t0.19260085
CHD9\tS1468\t0.153027
CHD9\tS1472\t0.153027
CHD9\tS2856\t0.02193766
CHD9\tS550\t0.05699965
CHD9\tS611\t0.1672295
CHD9\tS612\t0.1672295
CHD9\tS616\t0.1672295
CHD9\tS654\t0.3215818
CHEK1\tS280\t-0.9211607
CHEK1\tS296\t0.2767945
CHEK1\tS317\t-0.05614614
CHEK2\tS379\t0.1992483
CHERP\tS815\t0.09301919
CHERP\tS817\t0.030871142
CHERP\tS822\t0.1938348
CHERP\tS823\t0.1938348
CHERP\tT819\t0.04040144
CHFR\tS10\t0.07737969
CHMP1A\tS101\t0.2728593
CHMP2B\tS158\t0.09693644
CHMP3\tS200\t-0.03683668
CHMP4B\tS184\t0.02375215
CHMP7\tS417\t0.000144286
CHMP7\tS431\t-0.4350464
CHMP7\tY242\t-0.18042725
CHORDC1\tS110\t-0.041390408
CHORDC1\tT199\t-0.16521051
CHRAC1\tS124\t0.6824834
CHTF18\tS225\t0.1119661
CHTF18\tS64\t0.06267433
CHTF18\tS73\t-0.332989
CHTF18\tS871\t-0.1110249
CHTF18\tT51\t0.2373189
CHURC1-FNTB\tT436\t0.116764
CIC\tS1082\t-2.345418
CIC\tS1340\t-1.170881
CIC\tS1345\t-1.170881
CIC\tS1405\t-0.00707212
CIC\tS1609\t0.4836154
CIC\tS1630\t0.4696776
CIC\tS1813\t0.4556494
CIC\tS2153\t0.02090563
CIC\tS2201\t-0.1432453
CIC\tS227\t-2.503638
CIC\tS2288\t1.71449365
CIC\tS2303\t0.4457345
CIC\tS2315\t0.5771105
CIC\tS423\t-0.2656273
CIC\tS645\t0.035871717
CIC\tS650\t0.10742
CIC\tS710\t0.026872
CIC\tS780\t-0.2555116
CIC\tT1344\t1.97997375
CIC\tT1492\t0.2067682
CIC\tT2314\t3.996027
CIC\tT489\t0.2621926
CIC\tT755\t0.0292761
CINP\tS69\t0.444985
CINP\tS70\t-0.1667132
CIR1\tS202\t-0.04097178
CIRBP\tS148\t0.20127647
CIT\tS1982\t0.4504797
CIT\tS2013\t-0.02004788
CIT\tS440\t0.1359287
CIT\tS480\t-0.02060385
CIZ1\tT143\t0.1047392
CIZ1\tT484\t0.089624
CKAP2\tS565\t0.5989369
CKAP2\tT563\t0.71423115
CKAP2L\tT742\t0.6545866
CKAP4\tS232\t-0.1001593
CKAP4\tS26\t-0.7553321
CKAP4\tS460\t-0.3134412
CLASP1\tS1069\t0.06115411
CLASP1\tS1135\t0.05380643
CLASP1\tS1162\t0.3123167
CLASP1\tS600\t0.1082234
CLASP1\tS662\t-1.157964
CLASP1\tS665\t0.0184365
CLASP1\tS687\t0.122362125
CLASP1\tS691\t-0.01944885
CLASP1\tS797\t0.1955996
CLASP1\tT1073\t0.1420866
CLASP1\tT718\t-0.2562007
CLASP2\tS1163\t0.1427401
CLASP2\tS1166\t-0.4611838
CLASP2\tS1224\t-0.3623063
CLASP2\tS546\t0.375957
CLASP2\tS601\t0.1027253
CLASP2\tS603\t0.07573799
CLASP2\tS688\t0.14422765
CLASP2\tS692\t-0.0558959
CLASP2\tS758\t0.3029917
CLASP2\tS762\t-0.0049738
CLASP2\tS797\t-0.057614987
CLASP2\tS808\t-0.29573
CLASP2\tT806\t-0.1879207
CLASP2\tT998\t0.31919175
CLASRP\tS294\t0.006285619
CLASRP\tS547\t0.2140004
CLCC1\tS438\t-1.2284735
CLCC1\tS509\t0.241108
CLCC1\tS532\t0.3658045
CLCC1\tT482\t0.002018352
CLCN2\tS668\t-0.0857488
CLDN12\tS228\t-0.1855562
CLDN12\tS231\t0.07888308
CLEC16A\tS980\t-1.250646
CLIC4\tS4\t-0.1543293
CLIC6\tS293\t-0.3157557
CLINT1\tS227\t-0.101280825
CLINT1\tS232\t-0.073710425
CLINT1\tS234\t-0.073710425
CLINT1\tS299\t0.027518545
CLIP1\tS143\t0.1866274
CLIP1\tS180\t0.3493653
CLIP1\tS195\t0.4186757
CLIP1\tS200\t0.3260771
CLIP1\tS204\t0.3260771
CLIP1\tS348\t-0.2676353
CLIP1\tS963\t0.03394505
CLIP1\tT140\t-0.15893805
CLIP1\tT146\t0.15810535
CLIP1\tT182\t0.1896336
CLIP2\tS207\t-0.2882055
CLIP2\tS294\t0.3293956
CLIP2\tS923\t-0.372998695
CLK1\tS140\t0.0533895
CLK3\tS135\t0.03731201
CLK3\tS76\t0.151832792
CLK4\tS138\t-0.07519545
CLMN\tS635\t-0.3635865
CLMP\tT359\t0.3924274
CLN3\tS12\t-0.15831785
CLN3\tS14\t-0.16410105
CLN6\tS31\t-0.2947387
CLNS1A\tS102\t-0.2084776
CLOCK\tT461\t-0.1498727
CLSPN\tS1225\t0.2761988
CLSPN\tS225\t0.1557492
CLSPN\tS639\t0.02400685
CLSPN\tS65\t0.018124843
CLSPN\tS67\t0.060033215
CLSPN\tS698\t-0.488307825
CLSPN\tS700\t-0.25653029
CLSPN\tS746\t0.06032421
CLSPN\tS75\t0.2972502
CLSPN\tS759\t-0.3551101
CLSPN\tS775\t-0.01700825
CLSPN\tS782\t-0.02154073
CLSPN\tS83\t0.43164095
CLSPN\tS886\t-0.1142258
CLSPN\tS890\t-0.3390167
CLSPN\tS894\t-0.00039155
CLSPN\tT660\t0.17522555
CLSPN\tT891\t0.252930565
CLTA\tS105\t-0.2306683
CLUH\tS664\t0.11666502
CLUH\tS723\t-0.29990485
CMIP\tS224\t-0.3615461
CNDP2\tT6\t0.1853591
CNGA4\tS185\t-2.489823
CNGA4\tT186\t-2.489823
CNGA4\tT191\t-2.489823
CNKSR3\tS150\t-0.24446425
CNKSR3\tS208\t0.07382025
CNKSR3\tS304\t-0.900422
CNNM3\tS673\t0.18691777
CNNM3\tS700\t0.03083044
CNNM4\tS664\t0.2180281
CNOT2\tS156\t0.74315565
CNOT2\tS233\t-0.120443
CNOT2\tT237\t0.2175745
CNOT2\tT84\t0.1400203
CNOT3\tS291\t-1.8091765
CNOT3\tS299\t0.366588
CNOT3\tT292\t-0.9939534
CNOT4\tS301\t-0.1371559
CNOT4\tS432\t-1.146244
CNOT4\tT629\t0.09153062
CNP\tS150\t0.07806332
CNPY2\tS115\t-0.12722292
CNTROB\tS790\t0.3089433
COASY\tS19\t-0.3527315
COASY\tS207\t-0.12643009
COASY\tS212\t-0.239626665
COBL\tS239\t0.03562387
COBLL1\tS204\t0.6099689
COBLL1\tS256\t0.322257665
COBLL1\tS305\t-0.09382147
COBLL1\tS326\t0.2509616
COBLL1\tS344\t0.0319964
COBLL1\tS356\t0.1576905
COBLL1\tS438\t-0.2293485
COBLL1\tS441\t-0.180577
COBLL1\tS483\t-0.151923
COBLL1\tS911\t-0.0282486
COBLL1\tS917\t-1.57055
COBLL1\tS920\t-1.4190195
COBLL1\tS947\t-0.4311506
COBLL1\tT1056\t-1.6833635
COBLL1\tT260\t0.4377208
COBLL1\tT284\t-0.1671991
COBLL1\tT915\t-0.113606215
COG1\tS7\t-0.05171316
COG4\tS6\t0.03322923
COG5\tS197\t0.06308875
COG7\tS506\t-0.1514581
COIL\tS271\t0.3446131
COIL\tT122\t0.1750454
COIL\tT303\t0.16221
COIL\tT456\t0.1583371
COL19A1\tS81\t0.1499097
COL4A3BP\tS505\t-0.44656375
COMMD10\tS155\t0.04121263
COPA\tS173\t-0.1208589
COPA\tS402\t-0.4947392
COPA\tT591\t0.3918777
COPB1\tS933\t0.03967947
COPB2\tS830\t-0.1179126
COPE\tS13\t-0.133848685
COPE\tS99\t0.08922691
COPG1\tS12\t-0.3044872
COPRS\tS54\t0.2502339
CORO7\tS21\t-0.17614385
CPD\tT1368\t0.15261186
CPD\tT1370\t0.21346976
CPEB1\tS103\t-0.5127606
CPEB1\tS133\t-0.1343821
CPEB2\tS209\t-0.06689578
CPEB2\tS526\t0.04640105
CPEB2\tS529\t-0.132222332
CPEB4\tS97\t-0.5976272
CPEB4\tS99\t0.563939
CPNE1\tS55\t-0.07593054
CPNE3\tS14\t0.3181144
CPNE3\tS242\t-0.147282
CPOX\tS112\t-0.1492326
CPOX\tS416\t0.3650205
CPSF2\tS419\t-0.02209736
CPSF2\tS420\t-0.02209736
CPSF2\tS423\t-0.02209736
CPSF3\tS369\t0.2875905
CPSF6\tT334\t-0.08653805
CPSF7\tS196\t0.2309407
CPSF7\tS48\t0.235482
CPSF7\tT194\t0.2914856
CRAMP1L\tS1198\t-0.3134053
CRAMP1L\tS304\t0.2075181
CRAMP1L\tS593\t0.0454332
CREB1\tS108\t-0.1841007
CREB1\tS111\t-0.1841007
CREB1\tS142\t-1.163914
CREB1\tS143\t-1.2380735
CREB1\tS271\t-0.0124172
CREB1\tS340\t0.12401715
CREBBP\tS121\t0.1677432
CREBBP\tS2063\t-0.1202629
CREBBP\tT974\t-0.36902115
CREBZF\tS14\t0.101357795
CREBZF\tS189\t0.04012096
CREBZF\tS50\t0.3039269
CRELD2\tS70\t-0.03199034
CREM\tS163\t-0.1819511
CRIP2\tT109\t0.2263851
CRK\tS125\t0.5701714
CRK\tS194\t0.188021
CRTC2\tS433\t-1.367806
CRTC2\tS456\t-1.081588
CRTC2\tS70\t0.2498701
CRTC3\tS368\t-0.4359134
CRTC3\tS370\t-0.04101585
CRTC3\tS4\t0.54828335
CRTC3\tS62\t0.1541943
CRY1\tS88\t-0.6651343
CRYBG3\tS1280\t-2.1813995
CRYBG3\tS316\t-0.062444985
CRYBG3\tS329\t0.289683005
CRYBG3\tS340\t-0.249788
CRYBG3\tS457\t-0.54439095
CRYBG3\tS636\t-1.565545
CRYBG3\tS655\t-0.8268981
CRYBG3\tS912\t-1.540652
CRYBG3\tS931\t-2.453083
CRYBG3\tS994\t-0.9528804
CRYBG3\tT954\t0.2036397
CSDE1\tS116\t-1.2667345
CSDE1\tT761\t-0.5499158
CSF1\tS235\t0.5081244
CSNK1A1\tS156\t0.00499292
CSNK1A1\tT349\t-1.2132145
CSNK1D\tS361\t0.94357225
CSNK1D\tS382\t0.4561753
CSNK1D\tT347\t-1.413038
CSNK1E\tS363\t0.1474369
CSNK1E\tS389\t0.1553607
CSNK1E\tS390\t0.3107677
CSNK1E\tS405\t-0.01848341
CSNK1E\tS408\t0.26529576
CSNK1E\tT407\t0.07915612
CSNK1G3\tS115\t0.087414065
CSNK1G3\tS130\t-0.04774096
CSNK1G3\tS94\t0.2754839
CSNK2A2\tS18\t-0.05617618
CSNK2B\tS205\t0.1043367
CSNK2B\tS209\t0.1984942
CSPG4\tT2274\t0.139175965
CSPP1\tS130\t-0.1328626
CSTF2\tS507\t0.2871176
CSTF2T\tS563\t0.1044708
CSTF3\tS691\t-0.0493076
CTAGE5\tS456\t-0.02622665
CTAGE5\tS468\t0.32350954
CTAGE5\tS498\t0.03071585
CTAGE5\tS514\t-0.3665175
CTAGE5\tS516\t-0.4104664
CTAGE5\tS555\t0.1082234
CTAGE5\tY439\t0.50907985
CTDNEP1\tS46\t-0.1658228
CTDP1\tS740\t0.2939589
CTDP1\tS869\t-0.02707209
CTDP1\tS872\t-0.02707209
CTDSPL2\tS104\t-0.5916141
CTDSPL2\tS134\t0.2237931
CTDSPL2\tS165\t-0.0372974
CTDSPL2\tS28\t-3.515035
CTDSPL2\tT86\t0.57689785
CTIF\tS18\t-0.00028853
CTIF\tS299\t-2.321712
CTNNA1\tS118\t-0.1208903
CTNNA1\tS48\t-0.277380375
CTNNA1\tS641\t-0.03922143
CTNNA2\tS323\t-0.02275668
CTNNA2\tS655\t0.38622535
CTNNA2\tT325\t-0.15336725
CTNNA2\tT654\t0.39534031
CTNNA2\tT658\t0.9199883
CTNNB1\tS191\t0.05255495
CTNNB1\tS222\t0.05547326
CTNNB1\tS47\t0.065441206
CTNNB1\tS552\t-0.07078467
CTNNB1\tS675\t0.02375215
CTNNB1\tT556\t-0.088533805
CTNNBL1\tS545\t-0.01038142
CTNND1\tS230\t-0.01113722
CTNND1\tS232\t0.085365075
CTNND1\tS252\t0.3067288
CTNND1\tS268\t0.1510794
CTNND1\tS269\t0.386277565
CTNND1\tS346\t-0.2347199
CTNND1\tS349\t-0.2804573
CTNND1\tS352\t-0.1741818
CTNND1\tS4\t0.1812935
CTNND1\tS47\t0.141411035
CTNND1\tS841\t-0.1325084
CTNND1\tS893\t-0.3408427
CTNND1\tS914\t-0.03000043
CTNND1\tT177\t0.1367164
CTNND1\tT201\t0.2001277
CTNND1\tT59\t0.20831655
CTNND1\tT637\t0.000865329
CTNND1\tT863\t0.04935203
CTNND1\tT900\t0.3159139
CTNND1\tT926\t0.2707084
CTNND1\tT927\t0.3336527
CTNND1\tY859\t-0.137412175
CTPS1\tS571\t0.09880232
CTPS1\tS573\t0.11005803
CTPS1\tS574\t0.04539784
CTPS1\tS575\t0.08161233
CTPS1\tS578\t0.2464509
CTPS2\tS568\t-0.00771268
CTPS2\tS571\t-0.068130675
CTPS2\tS574\t0.06832678
CTPS2\tS576\t-0.15544215
CTR9\tS1039\t0.04912469
CTR9\tS1041\t0.1476312
CTR9\tS1043\t0.1476312
CTR9\tS1081\t-0.00906998
CTR9\tS1085\t-0.00906998
CTR9\tS1087\t-0.00906998
CTR9\tS941\t0.201924055
CTR9\tS943\t0.37185168
CTR9\tS970\t0.01392662
CTR9\tT925\t-0.0354165
CTTN\tS405\t-1.8943305
CTTN\tS417\t-0.4284105
CTTN\tS418\t-1.226206
CTTN\tS426\t0.2320467
CTTN\tT399\t-1.974546
CTTN\tT401\t-1.124876
CTTN\tY421\t-0.217586735
CTTNBP2\tS1012\t0.006077425
CTTNBP2NL\tS285\t-0.1458128
CTTNBP2NL\tS481\t-0.054579585
CTTNBP2NL\tS484\t-0.06572487
CTTNBP2NL\tS488\t0.1687703
CTTNBP2NL\tS557\t-1.8029555
CTTNBP2NL\tS563\t-1.33233877
CTTNBP2NL\tS568\t-0.470725485
CTTNBP2NL\tS592\t-0.3416469
CTU1\tS200\t-0.1843918
CTU2\tS419\t-0.4230619
CUEDC2\tS110\t-0.6171225
CUL3\tS713\t0.2369518
CUL4A\tS10\t0.7220288
CUL4B\tS133\t-0.1538959
CUL4B\tS15\t-0.2810356
CUL4B\tT135\t-0.08601724
CUL4B\tT35\t0.01549758
CUL4B\tT72\t-0.03702909
CUL7\tS339\t-0.66604265
CUL9\tS2326\t-0.010206665
CUL9\tS820\t0.168845665
CUX1\tS1069\t0.07354603
CUX1\tS1216\t-1.6160145
CUX1\tS1237\t1.110096
CUX1\tS1332\t0.0629005
CUX1\tS1333\t0.0629005
CUX1\tS1337\t-0.1231149
CUX1\tS1378\t-0.18532601
CUX1\tS1458\t-0.88652625
CUX1\tT1380\t-0.1407301
CWC22\tS39\t0.01464098
CWC22\tS61\t-0.1750448
CWC22\tS786\t0.12683965
CWC22\tS829\t-0.09086437
CWC22\tS866\t0.2940766
CWC25\tS155\t-0.1220674
CWF19L2\tS479\t-0.001154638
CXXC1\tS19\t0.03393393
CXXC1\tS224\t0.05464008
CXXC1\tS6\t-0.3152351
CXorf23\tS192\t-0.8118016
CXorf38\tT314\t0.4135941
CYB5B\tS2\t0.06198353
CYB5R3\tS15\t0.04628156
CYBA\tS168\t-0.7361964
CYBRD1\tS190\t-0.2629882
CYBRD1\tS202\t0.04020769
CYBRD1\tS204\t0.089150918
CYFIP1\tT1234\t-0.002967085
CYLD\tS418\t-0.400266
CYLD\tS422\t-0.400266
DAAM2\tS1050\t-0.9783786
DAAM2\tS1052\t0.2630345
DAAM2\tS656\t0.03012422
DAB2IP\tS509\t-1.32945
DAB2IP\tS554\t-0.1428948
DAB2IP\tS785\t0.3169567
DAB2IP\tS802\t-2.1922705
DACT3\tS10\t-0.1172194
DACT3\tS426\t-0.098548485
DACT3\tS520\t0.25437395
DAGLB\tS293\t0.5721537
DAXX\tS103\t0.1368475
DAXX\tS420\t0.08610431
DAXX\tS593\t0.1857398
DAXX\tS596\t-0.05198236
DAXX\tS613\t0.23382325
DAXX\tS627\t0.3520805
DBF4\tS359\t0.005040595
DBF4\tS413\t0.02913487
DBF4\tS420\t0.1052758
DBF4\tS508\t0.0586628
DBF4\tT553\t0.1212807
DBN1\tS142\t-0.008827389
DBN1\tS272\t-0.5563085
DBN1\tS274\t-0.84366485
DBN1\tS312\t0.418364335
DBN1\tS337\t-0.14289
DBN1\tS339\t-0.130335675
DBN1\tT335\t0.407399925
DBNL\tS232\t0.5853471
DBNL\tS232\t0.11300794
DBNL\tS278\t-0.4545885
DBNL\tS283\t-0.3035595
DBNL\tS284\t0.8941387
DBR1\tS514\t0.1585955
DCAF10\tS63\t-0.3803648
DCAF10\tS92\t-0.1353007
DCAF11\tS11\t-0.06149587
DCAF5\tS386\t-0.69683425
DCAF5\tS566\t-0.02905805
DCAF5\tS712\t-0.1856874
DCAF6\tS336\t-0.4233521
DCAF6\tS649\t0.013107145
DCAF6\tT654\t-0.06896749
DCAF8\tS253\t-0.2129187
DCBLD1\tT602\t0.1797658
DCBLD2\tS720\t-0.5750564
DCBLD2\tS760\t0.42430188
DCBLD2\tT632\t-0.0965915
DCBLD2\tT717\t0.1848341
DCBLD2\tY750\t0.36805205
DCK\tS74\t0.22569466
DCLRE1A\tS590\t0.1146336
DCLRE1B\tS379\t0.3095383
DCLRE1C\tS171\t-0.110000155
DCNP1\tS167\t0.1123665
DCP1A\tS180\t-0.742772
DCP1A\tS226\t-0.7065118
DCP1A\tS315\t-0.7203029
DCP1A\tS353\t-0.06065305
DCP1A\tS373\t0.6643918
DCP1A\tS422\t0.136878285
DCP1A\tS522\t-1.010425
DCP1A\tS523\t0.6427478
DCP1A\tS525\t0.4564796
DCP1A\tT401\t0.7613993
DCP1A\tT528\t0.3732863
DCP1A\tT531\t0.3658948
DCP1B\tS173\t-0.4555344
DCP1B\tS346\t0.004465491
DCP1B\tS409\t-0.1398397
DCP1B\tS45\t-0.09657606
DCP2\tS246\t0.09220742
DCP2\tS247\t0.09220742
DCP2\tS249\t0.09220742
DCP2\tS284\t0.243116295
DCPS\tS24\t-0.3116692
DCTN1\tS283\t-0.07447146
DCTN2\tS320\t0.04065565
DCUN1D4\tS11\t-0.7809585
DCUN1D5\tS48\t0.21274748
DCUN1D5\tS9\t-0.09028066
DDB1\tT118\t0.02601036
DDB2\tS24\t0.164208765
DDB2\tS26\t0.108520978
DDHD1\tS723\t-0.005989535
DDHD1\tS727\t-0.08664525
DDI2\tS106\t-0.5286356
DDRGK1\tS30\t-0.1465313
DDX1\tS481\t0.07025199
DDX10\tS539\t0.01549758
DDX10\tS831\t-2.0421
DDX17\tS479\t0.1710787
DDX17\tS64\t-0.551522
DDX20\tS268\t-0.1037669
DDX20\tS48\t-0.05054728
DDX20\tS672\t-0.004588091
DDX20\tS677\t0.05076385
DDX20\tS678\t0.018882225
DDX20\tS703\t0.1735112
DDX20\tS714\t0.255682
DDX20\tT688\t0.0706135
DDX20\tT705\t-0.007685725
DDX21\tS121\t0.1051417
DDX21\tS13\t-0.4862465
DDX21\tS168\t0.03922255
DDX21\tS171\t0.0606998
DDX21\tS71\t0.1606621
DDX21\tS89\t0.05644473
DDX23\tS14\t-0.061704685
DDX24\tS82\t0.2313095
DDX28\tS28\t-0.0727558
DDX39B\tY13\t-0.145372899
DDX3Y\tS71\t0.46524647
DDX41\tS21\t-0.20304635
DDX41\tS23\t-0.113793495
DDX41\tS66\t-0.261367235
DDX41\tS68\t-0.65674
DDX42\tS185\t-0.12640995
DDX46\tS804\t0.1773438
DDX47\tS14\t0.2030132
DDX47\tS9\t0.03815525
DDX5\tS6\t0.1838359
DDX51\tS103\t0.1227389
DDX51\tS83\t0.000865329
DDX54\tS75\t-0.03929557
DDX54\tS782\t-0.02601411
DDX54\tT74\t-0.01214072
DDX55\tS513\t-0.1151912
DDX59\tS64\t-0.147038
DDX59\tS76\t-0.06791125
DEAF1\tS162\t-0.1555661
DEAF1\tT298\t-0.149597345
DEAF1\tT418\t-0.1448873
DECR2\tS275\t0.19615625
DECR2\tS277\t0.1553607
DEF8\tS380\t0.391663445
DEK\tS19\t0.08596853
DEK\tS243\t0.05588976
DEK\tS244\t0.05588976
DEK\tS251\t0.05588976
DEK\tS301\t0.3293781
DEK\tS303\t0.3293781
DEK\tS306\t0.3293781
DEK\tS307\t0.3293781
DEK\tS32\t-0.00915847
DEK\tS51\t0.3691593
DEK\tT13\t0.01735182
DENND1A\tS473\t0.3242345
DENND1A\tS546\t0.98855045
DENND1B\tS653\t-0.636106
DENND4A\tS1225\t-1.122743
DENND4A\tS1587\t0.1199537
DENND4A\tS1589\t0.3635636
DENND4C\tS1225\t-1.652402
DENND4C\tS1277\t0.3765187
DENND4C\tS1278\t-0.7071113
DENND4C\tS1293\t0.09330265
DENND4C\tS1662\t-0.84280775
DENND4C\tS968\t-0.6083863
DENND4C\tS973\t-0.5755509
DENND4C\tS989\t-0.6006867
DENND4C\tS996\t-0.4774219
DENND5B\tS822\t0.3482198
DENND6A\tS127\t-0.05466199
DENR\tS73\t0.08501676
DENR\tT86\t-0.13109224
DEPDC5\tS1430\t0.006281545
DEPDC5\tS502\t0.3350312
DEPDC5\tS579\t-0.3157557
DERA\tT292\t0.188241201
DFFA\tS315\t0.1059462
DFNA5\tS252\t0.128803715
DGAT1\tS18\t-0.399924575
DGCR14\tS292\t-0.5616646
DGCR14\tT3\t-0.8061399
DGCR14\tT386\t-0.4854181
DGCR14\tT450\t0.006046604
DGCR2\tS157\t-1.553691
DGCR8\tS373\t0.270828
DGCR8\tS377\t0.165157615
DGCR8\tS8\t-0.189121
DGCR8\tS92\t-0.00852931
DGCR8\tS95\t0.229711
DHCR7\tS14\t-0.009045174
DHPS\tS78\t0.3402774
DHX16\tS103\t-0.0284546
DHX16\tS106\t-0.03892492
DHX16\tS107\t-0.0284546
DHX16\tS160\t0.02715413
DHX29\tS200\t-0.217256
DHX34\tS20\t-0.05547139
DHX34\tS749\t-0.03668866
DHX34\tS750\t-0.03668866
DHX38\tS199\t-0.51082485
DHX38\tT117\t-0.1338437
DHX40\tS571\t0.1859609
DHX57\tS127\t0.06087747
DHX57\tS132\t-0.1168328
DHX8\tS129\t-0.1408874
DHX8\tS460\t0.005759195
DHX9\tS125\t0.10868649
DHX9\tS321\t0.5172253
DIAPH1\tS1230\t-0.6306254
DIAPH1\tS22\t-0.6226713
DICER1\tS1160\t-0.13631045
DICER1\tS1470\t-1.244505
DIDO1\tS1030\t-0.003061786
DIDO1\tS1040\t0.01649632
DIDO1\tS1456\t-0.7321218
DIDO1\tS152\t-0.1235126
DIDO1\tS154\t-0.1235126
DIDO1\tS1617\t-0.11766745
DIDO1\tS1714\t-0.1509936
DIDO1\tS805\t-0.08931336
DIDO1\tS809\t-0.07667424
DIDO1\tS811\t-0.06199282
DIDO1\tT1046\t0.04040144
DIDO1\tT1469\t-0.09616375
DIDO1\tT151\t-0.1235126
DIEXF\tS153\t-0.2778472
DIP2A\tS94\t0.0321009
DIP2A\tT283\t0.06350289
DIP2B\tS100\t-0.1108536
DIP2B\tS201\t-0.3225053
DIP2B\tS203\t-0.2664471
DIP2B\tS259\t-0.02501553
DIP2B\tS80\t-0.2019412
DIP2B\tS9\t-0.4542688
DIP2B\tT71\t0.3138263
DIP2C\tS5\t-0.09169434
DIP2C\tS89\t-0.3860535
DIP2C\tT264\t-0.1128023
DIRC2\tS26\t-0.1411596
DIS3L2\tS139\t-0.25536015
DIS3L2\tS31\t0.6157929
DIS3L2\tS875\t-0.18516528
DISP1\tS1380\t-0.015889075
DKC1\tS21\t0.09857001
DKC1\tS451\t-0.04306611
DKC1\tS453\t0.02019986
DKC1\tS455\t-0.091379
DKC1\tS485\t0.29122365
DKC1\tS494\t0.06225996
DKC1\tS513\t0.217479
DKC1\tT458\t0.1296127
DLAT\tS100\t-0.04868077
DLC1\tS129\t-1.068756
DLC1\tS140\t-0.4915713
DLC1\tS159\t0.2010065
DLC1\tS89\t0.95097155
DLG1\tS158\t-0.173979485
DLG1\tS466\t0.2547149
DLG1\tS520\t0.3876934
DLG1\tS524\t0.1465249
DLG5\tS1556\t1.62034685
DLG5\tT836\t0.09504669
DLGAP4\tS126\t0.02318429
DLGAP4\tS62\t-0.6789334
DLGAP4\tT175\t0.2103706
DLGAP4\tT376\t0.1681285
DLGAP5\tS662\t0.3302142
DLGAP5\tS689\t0.4160191
DLGAP5\tS725\t0.5481407
DLGAP5\tS777\t0.3181144
DLGAP5\tS787\t0.1896664
DLGAP5\tS789\t0.2531421
DLL3\tT532\t-0.102837
DLX1\tS108\t0.087224575
DLX1\tS209\t-0.03583058
DLX6\tS117\t-0.5385133
DLX6\tS120\t-0.235034465
DMAP1\tS412\t-0.4673571
DMAP1\tS418\t-0.4431635
DMAP1\tS448\t0.02687089
DMAP1\tT409\t-0.2707474
DMAP1\tT445\t-0.02476601
DMD\tS2205\t-0.08127795
DMD\tS2279\t-0.49133745
DMD\tS2280\t0.1232689
DMXL1\tS1896\t0.1649149
DMXL1\tS1901\t-0.3027243
DMXL1\tS1908\t-0.8161896
DMXL1\tS1970\t-0.0914945
DMXL1\tS3013\t-0.2829481
DMXL1\tS918\t-0.1117107
DMXL1\tT2407\t-0.4406159
DMXL2\tS1857\t-0.02835164
DMXL2\tS2399\t-1.110511
DMXL2\tS451\t-0.06520422
DMXL2\tS945\t0.1785922
DNAAF2\tS461\t0.04194384
DNAJA1\tS335\t-0.02876362
DNAJA2\tS123\t0.006581425
DNAJA2\tS147\t-0.2138013
DNAJB1\tS171\t-0.1008862
DNAJB14\tS29\t-0.3951696
DNAJB6\tS277\t-0.003235265
DNAJB6\tS315\t0.1526378
DNAJC1\tS430\t0.08501676
DNAJC1\tS479\t0.6767757
DNAJC1\tS480\t0.6767757
DNAJC14\tT265\t-0.3887899
DNAJC17\tS112\t-0.1894499
DNAJC2\tS47\t-0.307554865
DNAJC2\tS49\t0.5342314
DNAJC21\tS423\t-0.09003497
DNAJC5\tS10\t-0.0841044
DNAJC6\tS709\t0.20463425
DNM1L\tS616\t0.048725095
DNMBP\tS684\t-0.6580713
DNMBP\tS689\t-1.079865
DNMT1\tS127\t0.2589409
DNMT1\tS141\t-1.723229
DNMT1\tS143\t-1.7918055
DNMT1\tS154\t0.3399355
DNMT1\tS6\t0.07135073
DNMT1\tS714\t0.01621099
DNMT3A\tS105\t-0.108892
DNMT3A\tS75\t-0.1965911
DNMT3A\tT138\t0.120528295
DNTTIP2\tS117\t0.2740529
DNTTIP2\tS330\t-0.3390531
DNTTIP2\tT232\t0.54938745
DNTTIP2\tT610\t-0.2291705
DOCK1\tS1664\t0.3022024
DOCK1\tS1681\t0.3122005
DOCK1\tS1743\t-0.09595915
DOCK10\tS12\t-0.4622964
DOCK10\tS1232\t-0.1442972
DOCK10\tS1257\t-0.1051628
DOCK10\tS1261\t0.03914951
DOCK10\tS1292\t-0.029178677
DOCK10\tS1295\t-0.17611061
DOCK10\tS1318\t-0.081538503
DOCK10\tS1322\t-0.1963431
DOCK10\tS168\t0.08705537
DOCK10\tS877\t-0.1306181
DOCK10\tT1323\t-0.038125193
DOCK10\tT1406\t0.052438492
DOCK10\tT196\t0.4362684
DOCK11\tS440\t-0.005289984
DOCK4\tS1614\t-0.204517
DOCK4\tS1620\t0.2116352
DOCK4\tS1700\t0.31039175
DOCK4\tS1714\t-1.21142625
DOCK5\tS1756\t-2.150081
DOCK5\tS1766\t0.1978653
DOCK5\tS1775\t1.2032113
DOCK5\tS1789\t-2.2969795
DOCK5\tS1834\t0.03646811
DOCK5\tT1794\t-2.706888
DOCK6\tS1343\t0.038840235
DOCK6\tS159\t-0.04690613
DOCK6\tS176\t-0.1925681
DOCK6\tS178\t-0.1467069
DOCK6\tS186\t0.80042857
DOCK6\tT182\t-0.1995663
DOCK6\tT2029\t-0.077624715
DOCK7\tS1306\t0.36064575
DOCK7\tS1383\t0.05505682
DOCK7\tS1421\t0.607170175
DOCK7\tS1425\t0.562948
DOCK7\tS1429\t0.46911975
DOCK7\tS180\t0.024765517
DOCK7\tS182\t0.05038073
DOCK7\tS190\t0.09328973
DOCK7\tS30\t0.5405349
DOCK7\tS452\t-0.7481658
DOCK7\tS863\t-0.734152215
DOCK7\tS864\t0.0333154
DOCK7\tS896\t-0.8075996
DOCK7\tS898\t-0.9145481
DOCK7\tS900\t-0.25205215
DOCK7\tS910\t-0.6935744
DOCK7\tS946\t0.02998291
DOCK7\tS948\t0.2147466
DOCK7\tS963\t0.3490255
DOCK7\tS964\t0.05699965
DOCK7\tT142\t0.1410403
DOCK8\tS371\t-0.141239905
DOCK9\tS1254\t0.18954
DOCK9\tT1210\t0.3801753
DOK1\tS269\t-0.702562
DONSON\tS9\t0.3494785
DOPEY2\tS597\t-0.108877492
DOS\tS641\t-0.5450029
DOT1L\tS1035\t0.1082234
DOT1L\tS1104\t0.06129241
DOT1L\tS1153\t0.162867007
DOT1L\tS1246\t-0.0339441
DOT1L\tS1349\t-0.03640749
DOT1L\tS374\t-0.08036248
DOT1L\tS826\t0.1196882
DOT1L\tS834\t0.10180821
DOT1L\tS902\t0.144046835
DOT1L\tT900\t0.1875023
DPF2\tS142\t-0.3503202
DPF2\tS200\t0.4341344
DPM1\tS9\t0.2714257
DPYSL2\tS518\t-0.03382058
DPYSL2\tS522\t0.04865466
DPYSL2\tT509\t0.171463
DPYSL2\tT514\t-0.03382058
DPYSL2\tT521\t0.05672221
DPYSL3\tS102\t-1.530614
DPYSL3\tS636\t0.007482617
DPYSL3\tS75\t-0.38870005
DPYSL3\tS95\t0.2725011
DPYSL3\tT623\t0.08569661
DSG2\tS680\t0.2502339
DSG2\tS782\t-0.08375268
DSN1\tS315\t0.2626737
DSN1\tS65\t0.140517
DSP\tS22\t0.5842764
DST\tS1560\t-0.2356369
DST\tS2393\t0.7261619
DST\tS2692\t0.4852206
DST\tS2707\t0.1822713
DST\tS2731\t0.6459783
DST\tS2849\t-0.3732525
DST\tS3097\t-0.1994045
DST\tS4148\t-0.10199013
DST\tS415\t-0.03750277
DST\tS4150\t-0.06568733
DST\tT5045\t0.6875086
DSTN\tS3\t-1.021424
DTD1\tS197\t0.08841301
DTD1\tS205\t0.2074287
DTL\tS384\t0.16015235
DTL\tS515\t-1.94291435
DTL\tS516\t-2.349235
DTL\tT387\t0.53323675
DTL\tT466\t-0.59480135
DTNA\tT19\t0.3594439
DTNB\tS320\t-0.2162305
DTNBP1\tS11\t1.4212605
DTNBP1\tS316\t-0.076618405
DTNBP1\tS321\t-0.076618405
DTX2\tS269\t-0.17825425
DTX3L\tS202\t-1.099247
DTX3L\tS532\t0.5835512
DTX3L\tS9\t-0.04583352
DUOX1\tS79\t0.034261813
DUS2L\tS410\t0.09868897
DUS3L\tS272\t-0.0404821
DUS3L\tS277\t-0.03787305
DUS3L\tT273\t0.05616735
DUSP22\tS15\t-0.003755912
DUSP6\tS226\t-3.021704
DUSP6\tS53\t0.1510794
DUSP9\tT164\t1.007985
DUT\tS11\t0.058420125
DUT\tS13\t0.024036
DUT\tS14\t0.09612688
DUT\tS4\t0.2178511
DUT\tS88\t0.007051912
DUT\tS99\t-0.079332885
DUT\tT10\t0.25852775
DUT\tT161\t0.2587673
DVL1L1\tS643\t-0.1906843
DYNC1H1\tS3917\t-0.06878593
DYNC1H1\tS4368\t-0.1531577
DYNC1H1\tT4366\t-0.01598676
DYNC1I2\tS51\t0.1237986
DYNC1I2\tS73\t0.10995104
DYNC1I2\tS81\t-1.474853
DYNC1I2\tS86\t-1.254289
DYNC1I2\tT89\t-0.2103959
DYNC1LI1\tS207\t-0.140412
DYNC1LI1\tS510\t-2.514738
DYNC1LI1\tS516\t-2.514738
DYNC1LI1\tT513\t-2.0451085
DYNC1LI2\tS194\t0.02119536
DYRK1A\tS529\t-0.05086491
DYRK1A\tY312\t0.1168971
E2F4\tT14\t0.1317212
E2F5\tT261\t-0.068921873
E2F7\tS95\t0.4510132
E2F7\tT45\t0.197488
E2F8\tS102\t0.1428708
E2F8\tS413\t0.479748
E2F8\tS71\t-0.03342185
E2F8\tT60\t-0.3978663
EAF1\tS158\t-0.02167473
EAF1\tS165\t0.1307074
EAF2\tS154\t-0.063021296
EAPP\tS109\t0.04194384
EAPP\tS111\t0.04194384
EBAG9\tS36\t-0.02392968
EBAG9\tT41\t-0.24665625
ECM29\tS833\t0.17072894
ECT2\tS366\t0.5508022
EDC3\tS131\t-0.1072593
EDC4\tS33\t0.7243883
EDC4\tS565\t-0.02977955
EDC4\tS723\t-0.4872169
EDC4\tS780\t-1.914847
EDC4\tS844\t0.2498701
EDC4\tT693\t0.3798428
EED\tS34\t-0.3016685
EEF1B2\tS106\t0.070684879
EEF1B2\tS8\t-0.05778208
EEF1B2\tS90\t-0.0155346
EEF1B2\tS95\t0.115724893
EEF1B2\tT93\t0.109903975
EEF1D\tS133\t0.2396424
EEF1D\tS162\t-0.02478684
EEF1D\tS37\t0.0103545
EEF1D\tS40\t0.080917905
EEF1D\tS41\t-0.1266592
EEF1D\tT147\t0.01020692
EEF2\tT435\t-0.264364805
EEF2K\tS18\t-0.03966622
EEF2K\tS27\t0.2974849
EEF2K\tS31\t0.2974849
EEF2K\tS71\t0.1853591
EEF2K\tS72\t0.0006148
EEF2K\tS74\t-0.03400065
EEF2K\tS78\t-0.2533604
EFCAB4B\tS263\t0.004935633
EFHD2\tS11\t0.0116388
EFHD2\tS204\t0.26825435
EFHD2\tS74\t0.4192153
EFHD2\tS76\t0.3988976
EFNB2\tS260\t-0.11092265
EFR3A\tS650\t0.1142337
EFR3B\tS95\t0.1915626
EFTUD2\tS598\t-0.4654872
EGLN1\tS12\t-0.216860025
EGLN1\tS125\t0.1924466
EGLN2\tS130\t-0.15133
EHBP1\tS171\t0.04879416
EHBP1\tS260\t-0.7618246
EHBP1\tS391\t-0.153948
EHBP1\tS393\t-0.1808321
EHBP1\tS397\t0.2349994
EHBP1\tS401\t-0.21553455
EHBP1\tS675\t-0.7039009
EHBP1\tS716\t-0.5261819
EHBP1\tS893\t0.3491388
EHBP1\tS987\t-2.702656
EHBP1\tT258\t-0.82670325
EHBP1L1\tS1017\t-0.06821108
EHBP1L1\tS1257\t-0.5139344
EHBP1L1\tS170\t0.03131608
EHBP1L1\tS191\t-0.3124914
EHBP1L1\tS285\t0.01035019
EHBP1L1\tS310\t0.04110281
EHBP1L1\tS964\t-0.01135527
EHBP1L1\tT284\t-0.05665628
EHD1\tS355\t-0.06191751
EHD1\tS456\t0.1214134
EHMT2\tS140\t-0.06002127
EHMT2\tS173\t0.000865329
EHMT2\tS232\t-1.314912
EHMT2\tS535\t0.137125415
EHMT2\tT521\t-0.06700153
EI24\tS326\t-0.175753825
EI24\tS330\t-0.08415025
EIF1\tS9\t0.0766959
EIF2A\tS506\t0.01077991
EIF2AK2\tS83\t0.09153062
EIF2AK2\tT88\t-0.000634928
EIF2AK3\tS715\t-0.5993746
EIF2AK4\tS672\t-0.03788779
EIF2AK4\tT667\t-0.03418983
EIF2B1\tS7\t0.03955951
EIF2B4\tS130\t0.3447149
EIF2B4\tT137\t-0.392048165
EIF2B4\tT86\t-0.0407937
EIF2B5\tS544\t0.01506926
EIF2C2\tS387\t0.02630426
EIF2S1\tT279\t0.7195778
EIF2S2\tS2\t0.07148806
EIF2S2\tS67\t0.445409
EIF2S2\tT111\t0.681854
EIF3A\tS1188\t-0.1987751
EIF3A\tS1336\t-0.5179571
EIF3A\tS584\t-0.7013181
EIF3A\tS881\t-1.63584115
EIF3A\tS882\t-0.6101909
EIF3A\tS978\t-0.1641244
EIF3C\tS166\t-0.2011283
EIF3C\tS181\t-0.46063805
EIF3C\tS182\t-0.46063805
EIF3C\tS39\t-0.01823502
EIF3D\tS161\t0.1323794
EIF3G\tS42\t0.03252402
EIF3G\tT41\t-0.02503023
EIF3H\tS183\t-0.08882236
EIF3J\tS11\t-0.1151599
EIF3J\tS127\t0.4063189
EIF3J\tS13\t-0.268278
EIF3J\tT109\t0.2522945
EIF4A1\tT242\t0.02190613
EIF4A2\tT244\t-0.3044159
EIF4A3\tS10\t0.2451187
EIF4A3\tS12\t0.448901
EIF4A3\tT163\t0.34884545
EIF4B\tS406\t-0.27321965
EIF4B\tS409\t-0.251058
EIF4B\tS422\t-0.3765037
EIF4B\tS424\t0.119568985
EIF4B\tS425\t-0.638724625
EIF4B\tS442\t-0.5559479
EIF4B\tS445\t-0.3728041
EIF4B\tS459\t-0.3342616
EIF4B\tS497\t0.07080147
EIF4B\tS498\t-0.01756246
EIF4B\tS504\t-0.101187185
EIF4B\tT420\t-0.35662125
EIF4B\tT450\t-0.5559479
EIF4B\tT461\t-0.6165694
EIF4E2\tS13\t0.14514674
EIF4EBP1\tS6\t-0.21765465
EIF4EBP1\tS65\t-0.124428045
EIF4EBP1\tS83\t-0.01557832
EIF4EBP1\tT10\t0.4525954
EIF4EBP1\tT37\t-0.01198073
EIF4EBP1\tT46\t-0.098704455
EIF4EBP1\tT70\t-0.205865895
EIF4EBP1\tT77\t-0.2777963
EIF4EBP1\tT82\t-0.09330947
EIF4EBP2\tS65\t-0.68684985
EIF4EBP2\tT70\t-0.65204845
EIF4ENIF1\tS115\t0.5537537
EIF4ENIF1\tS540\t0.02375215
EIF4ENIF1\tS553\t-0.3300662
EIF4ENIF1\tS563\t-0.07635633
EIF4ENIF1\tS74\t0.1432628
EIF4ENIF1\tS78\t0.08882194
EIF4ENIF1\tS927\t0.2066433
EIF4ENIF1\tT768\t-0.1381081
EIF4ENIF1\tT867\t0.725905
EIF4G1\tS1100\t-0.04611645
EIF4G1\tS1122\t-0.26734
EIF4G1\tS1144\t-1.942973
EIF4G1\tS1151\t-0.0965915
EIF4G1\tS227\t-0.196029
EIF4G1\tT120\t0.5492256
EIF4G1\tT231\t-0.1371114
EIF4G1\tT580\t0.5268162
EIF4G1\tT967\t0.1540647
EIF4G1\tY224\t0.22478383
EIF4G2\tS17\t0.1352722
EIF4G2\tT508\t0.606916
EIF4G3\tS1156\t-1.0478269
EIF4G3\tS1409\t0.03379299
EIF4G3\tS164\t0.4667576
EIF4G3\tS495\t0.09166604
EIF4G3\tS495\t-0.1349785
EIF5\tS229\t0.1804026
EIF5\tS389\t-0.01366915
EIF5\tS390\t-0.01366915
EIF5A\tT45\t-0.00293045
EIF5B\tS107\t-0.2349236
EIF5B\tS113\t-0.07993509
EIF5B\tS1168\t0.05644473
EIF5B\tS121\t0.24863931
EIF5B\tS135\t0.05755419
EIF5B\tS137\t0.04156633
EIF5B\tS164\t0.06942715
EIF5B\tS182\t0.67420538
EIF5B\tS186\t0.56053725
EIF5B\tS190\t-0.145981868
EIF5B\tS214\t0.08038475
EIF5B\tS66\t-0.0504787
EIF5B\tT301\t0.83760845
EIF5B\tY134\t-0.04529746
EIF6\tS235\t0.1530574
ELAC2\tS205\t-0.0102942
ELAC2\tS208\t-0.03433883
ELAC2\tS212\t-0.04669748
ELAC2\tS213\t-0.09488379
ELAC2\tS215\t-0.04924789
ELAVL1\tS2\t0.247055465
ELAVL1\tS202\t0.4595366
ELF1\tS163\t0.043321563
ELF1\tS168\t0.077884868
ELF2\tS113\t0.12047875
ELF4\tS188\t0.03881375
ELF4\tS641\t0.1167697
ELK1\tS140\t0.1544536
ELK1\tS142\t0.1237986
ELK1\tS270\t-1.856842
ELK1\tS368\t-1.4495765
ELK3\tS115\t0.6207741
ELK3\tS245\t1.4585615
ELK3\tS247\t1.309234
ELK3\tS396\t0.2438989
ELL\tS309\t-0.07806102
ELL\tS442\t0.02005774
ELL\tS444\t0.12141124
ELMSAN1\tS461\t-0.7271407
ELMSAN1\tS661\t-0.6489145
ELMSAN1\tS709\t0.024927265
ELMSAN1\tS894\t-0.050611292
ELMSAN1\tT704\t0.12496112
ELMSAN1\tT715\t0.1112984
ELMSAN1\tT893\t-0.042995433
EMC2\tT121\t0.2537472
EMC4\tS36\t0.150498875
EMD\tS8\t0.36671475
EMD\tS87\t-0.010445
EMD\tT10\t-0.37075395
EME1\tS111\t0.1359287
EME1\tS117\t-0.08891436
EME1\tT150\t0.43381655
EMG1\tS5\t-0.1725387
EML3\tS176\t-0.8060139
EML3\tS198\t-1.395701
EML3\tS883\t-0.1472021
EML3\tT881\t-0.26983795
EML4\tS146\t0.8101552
EML4\tS903\t0.29687785
EML4\tT897\t0.307445425
EML4\tT899\t0.08355702
EML6\tT1914\t0.1918153
ENAH\tT489\t0.77218855
ENGASE\tS64\t0.05901417
ENO1\tS141\t-0.3167617
ENO1\tS157\t0.031804485
ENO1\tS254\t0.0198906
ENO1\tS263\t-0.04252295
ENO1\tS27\t0.06014071
ENO1\tS272\t0.1168971
ENO1\tS40\t-0.02551478
ENO1\tS419\t0.04292445
ENO2\tS263\t-0.002384655
ENO2\tT265\t-0.102789115
ENOSF1\tY315\t-0.301788655
ENOSF1\tY324\t-0.301788655
ENOX2\tS211\t0.04189418
ENSA\tS2\t0.6777111
ENSA\tS62\t0.5684214
ENTHD2\tS272\t-0.3743993
ENTHD2\tS51\t0.2591821
EP300\tS1038\t-0.176267
EP300\tS1726\t-0.1000046
EP400\tS1659\t-0.3902639
EP400\tS2613\t0.1835818
EP400\tS938\t-0.1205608
EP400\tT937\t-0.1205608
EPB41\tS555\t-0.08381383
EPB41\tS631\t0.1887806
EPB41\tS85\t0.158807405
EPB41\tS92\t0.02715413
EPB41\tT60\t0.4281424
EPB41L1\tT577\t-0.01884875
EPB41L2\tS170\t-0.2517277
EPB41L2\tS226\t0.3284918
EPB41L2\tS38\t-0.1727988
EPB41L2\tS386\t-0.01712503
EPB41L2\tS39\t-0.11527944
EPB41L2\tS499\t-0.005014863
EPB41L2\tS550\t-0.1705564
EPB41L2\tS562\t0.1988712
EPB41L2\tS58\t0.009490535
EPB41L2\tS627\t1.056514
EPB41L2\tS658\t1.003458
EPB41L2\tS683\t0.2753592
EPB41L2\tS7\t0.230572
EPB41L2\tS715\t-0.2289595
EPB41L2\tS718\t0.2588203
EPB41L2\tT3\t-0.07600565
EPB41L2\tT659\t0.953526
EPB41L3\tS443\t-0.2865506
EPB41L3\tS448\t0.10068455
EPB41L3\tS460\t0.4564589
EPB41L3\tS462\t0.111805275
EPB41L3\tS478\t0.127976955
EPB41L3\tS7\t-0.138763875
EPB41L3\tS740\t-0.1353958
EPB41L3\tS88\t0.01306909
EPB41L3\tT2\t-0.27027232
EPB41L3\tT487\t0.2497463
EPB41L3\tT510\t0.1830736
EPB41L5\tS517\t0.123931
EPB41L5\tS550\t-0.175254985
EPB41L5\tT439\t-0.5819504
EPB49\tS105\t-1.0990756
EPB49\tS156\t0.8339831
EPB49\tS16\t-0.12842712
EPB49\tS333\t-0.131553445
EPB49\tS372\t0.2735755
EPB49\tS92\t1.301997
EPC2\tS538\t-0.08897574
EPC2\tT353\t0.1120464
EPHA2\tS897\t-1.470358325
EPHA2\tS901\t-1.5683208
EPN1\tS435\t-2.189417
EPN1\tS447\t0.1158324
EPN1\tS454\t-0.5487546
EPN1\tS473\t0.5152079
EPN1\tT460\t0.5315686
EPN1\tT462\t0.4693651
EPN1\tT464\t-0.4456641
EPN1\tT470\t0.4362684
EPN2\tS173\t0.005902907
EPN2\tS192\t-0.04272425
EPN2\tS195\t-0.04272425
EPN2\tS429\t-0.05911911
EPN2\tT451\t0.4341344
EPPK1\tS2282\t-3.666485
EPRS\tS1000\t0.04640009
EPRS\tS434\t0.151729
EPRS\tS880\t0.11260288
EPRS\tS882\t0.1495195
EPRS\tS885\t0.03352301
EPRS\tS886\t0.142197183
EPS15\tS108\t0.01051485
EPS15\tS324\t-0.4314814
EPS15\tS796\t-0.2797741
EPS15\tS814\t-0.4128463
EPS15L1\tS108\t0.12246944
EPS15L1\tS229\t-0.6901021
EPS15L1\tS374\t-0.2621402
EPS15L1\tS593\t-0.3148582
EPS15L1\tT366\t-0.2019743
EPS8\tS625\t-0.1839656
EPS8\tS659\t-0.365096635
EPS8\tS667\t0.48799495
EPS8\tS685\t-0.0519524
EPS8\tT223\t0.3711686
EPS8\tT629\t-0.22935045
ERAL1\tS173\t0.1580785
ERBB2\tS368\t1.445833
ERBB2\tT15\t-2.723468
ERBB2\tT480\t0.09410089
ERBB2IP\tS1158\t0.582267
ERBB2IP\tS1179\t0.2329063
ERBB2IP\tS598\t0.38664485
ERBB2IP\tS602\t0.38664485
ERBB2IP\tS603\t0.38664485
ERBB2IP\tS852\t0.1614362
ERBB2IP\tS857\t-0.14228365
ERBB2IP\tT485\t0.04096256
ERBB3\tS1035\t-2.310218
ERBB3\tS1038\t-3.004277
ERBB3\tS1045\t0.8972404
ERBB3\tS627\t0.02204824
ERBB3\tS923\t0.2475629
ERC1\tS17\t0.378366655
ERC1\tS21\t0.171353
ERCC3\tS202\t0.17341275
ERCC5\tS384\t-0.02302053
ERCC5\tS562\t-0.49181535
ERCC5\tS563\t-0.153735825
ERCC6\tS1142\t-0.198344155
ERCC6\tS1348\t-0.224705
ERCC6\tS486\t0.3617683
ERCC6\tS489\t0.3617683
ERCC6L\tS1028\t-0.1798251
ERCC6L\tS1069\t-0.134287
ERCC6L\tS807\t0.46668115
ERCC6L\tS820\t0.001730139
ERCC6L\tS946\t-1.068648
ERCC6L\tS984\t-0.4769801
ERCC6L2\tS331\t-0.1147537
ERCC6L2\tS77\t-0.1594698
ERCC6L2\tS80\t-0.1594698
ERF\tS131\t-3.894944
ERF\tS154\t0.8169683
ERF\tS161\t-2.16955
ERF\tS185\t-3.19661675
ERF\tS187\t-3.0415845
ERF\tS21\t-3.704912
ERF\tS373\t0.42541955
ERF\tS531\t-3.474017
ERF\tT3\t-4.420496
ERF\tT526\t-2.605771
ERGIC3\tS118\t-0.1528209
ERICH1\tS238\t-0.1141757
ERICH1\tS254\t0.09207205
ERICH1\tT62\t0.4791271
ERRFI1\tS273\t-0.1984114
ESCO1\tS523\t-0.0463101
ESCO2\tS244\t-0.01013442
ESCO2\tS512\t0.310336571
ESCO2\tS75\t0.3154358
ESF1\tS153\t0.1769609
ESF1\tS198\t0.1579492
ESF1\tS222\t-0.058107825
ESF1\tS228\t-0.066456763
ESF1\tS657\t0.035611935
ESF1\tS663\t0.072790968
ESF1\tS694\t0
ESF1\tS823\t0.1887806
ESF1\tT229\t-0.066456763
ESPL1\tS801\t-0.2083276
ESRRA\tS19\t-0.002889865
ESRRA\tS26\t-0.10155629
ESYT1\tS1044\t0.01464098
ESYT1\tS830\t-0.03686623
ESYT1\tT906\t0.2585793
ESYT2\tS654\t-0.2647091
ESYT2\tS656\t0.1447023
ESYT2\tS662\t0.4784891
ESYT2\tS702\t0.267837415
ESYT2\tS718\t-0.3932458
ESYT2\tS721\t-0.346133725
ESYT2\tS724\t-0.449951
ESYT2\tT664\t0.287842098
ESYT2\tT668\t0.5783108
ESYT2\tT716\t-0.1049284
ETFA\tS140\t0.06722574
ETS1\tT38\t-0.6258007
ETV3\tS139\t-4.825156
ETV3\tS159\t-1.753945
ETV3\tS170\t0.5622791
ETV3\tS245\t-2.975283
ETV3\tS250\t-2.74978125
ETV4\tS101\t-0.79918915
ETV6\tS16\t-0.1171457
ETV6\tS203\t-0.1441059
ETV6\tS22\t0.118373023
ETV6\tS271\t-0.3161688
ETV6\tT18\t-0.07233107
ETV6\tT4\t0.070068578
EVA1A\tS102\t-0.08118634
EVA1B\tS152\t-0.5139756
EVA1B\tT156\t-0.13634505
EVA1B\tT158\t0.1937087
EVC\tS81\t-0.1924638
EVI2B\tS268\t-0.20295215
EVI2B\tS294\t0.2941943
EXO1\tS639\t-0.001545055
EXO1\tS659\t0.044297547
EXO1\tS660\t0.08542464
EXOC1\tS298\t0.1935825
EXOC1\tS455\t0.5044678
EXOC1\tS458\t0.41088595
EXOC1\tS486\t0.51004155
EXOC4\tS32\t-3.755454
EXOC4\tT237\t0.09044699
EXOC8\tS19\t-0.01236355
EXOSC2\tS94\t0.02290045
EXOSC9\tS290\t-0.02315247
EXOSC9\tS49\t0.00656082
EYA1\tS19\t0.5219553
EYA1\tS309\t-0.04498488
EYA3\tS209\t-0.83177165
EYA3\tS216\t-0.05391295
EYA3\tT223\t0.1523782
EYA4\tS361\t0.03294719
EZH2\tS363\t0.4487953
EZH2\tS366\t0.3492521
EZH2\tT367\t0.0793084
EZH2\tT487\t-0.001703375
F2R\tS395\t0.003039975
F2R\tS418\t0.02162186
FAF1\tS582\t-0.02693978
FAH\tT313\t-0.06697135
FAM101B\tS34\t-1.589659
FAM101B\tS6\t-0.5150473
FAM103A1\tS36\t-0.1142695
FAM110B\tS301\t0.05547326
FAM114A1\tS196\t-2.312581
FAM114A1\tS2\t0.19457238
FAM114A2\tS75\t-1.845518
FAM117B\tS10\t-0.0391473
FAM117B\tS220\t-0.08222458
FAM117B\tS273\t-0.2901447
FAM117B\tS307\t0.238089345
FAM117B\tS391\t-0.23353425
FAM117B\tS449\t-0.0250794
FAM117B\tT396\t-0.18735917
FAM118A\tS129\t0.15481082
FAM120A\tS1023\t0.1249898
FAM120A\tS1075\t-0.8414424
FAM120A\tS383\t-0.46249165
FAM120A\tS506\t0.02677181
FAM120A\tS652\t-0.1708899
FAM120A\tS925\t0.4805754
FAM120A\tT655\t-0.017897915
FAM122A\tS143\t0.2503926
FAM122A\tS147\t-0.19853235
FAM122A\tS189\t0.170749705
FAM122A\tS270\t0.10646655
FAM122A\tS276\t0.3536632
FAM122A\tS35\t-0.1076012
FAM122A\tS37\t0.10358311
FAM122A\tS48\t0.10358311
FAM122A\tS62\t0.170202805
FAM122A\tS76\t0.2211965
FAM122A\tT149\t-0.797037
FAM122B\tS115\t-0.191077525
FAM122B\tS119\t-0.09016225
FAM122B\tS137\t0.0039693
FAM122B\tS141\t0.0039693
FAM122B\tS58\t0.07189995
FAM122B\tS64\t-0.0524311
FAM126A\tS413\t0.2053925
FAM126A\tS415\t-0.1143319
FAM126A\tS453\t-0.002122364
FAM126B\tS491\t0.2529
FAM126B\tS508\t-1.032448
FAM126B\tT306\t0.1055439
FAM129A\tS582\t-1.2715395
FAM129A\tS596\t1.291269
FAM129A\tS602\t0.084815565
FAM129B\tS628\t-2.838461
FAM129B\tS633\t-2.4912035
FAM129B\tS652\t-0.2259177
FAM129B\tS668\t-0.1586709
FAM129B\tS678\t-1.6642375
FAM129B\tS679\t-1.934731
FAM129B\tS683\t-1.933959
FAM133B\tS82\t-0.1752077
FAM134A\tS132\t-0.3371383
FAM134A\tS138\t-0.1993216
FAM134A\tS344\t-0.1026666
FAM134A\tS385\t-0.1106199
FAM134C\tS258\t-0.07460819
FAM134C\tS26\t-0.3538365
FAM134C\tS260\t-0.07460819
FAM134C\tS313\t-0.08956488
FAM134C\tS320\t-0.02666059
FAM134C\tS360\t0.4480552
FAM134C\tS373\t0.08909126
FAM134C\tT10\t-1.517957
FAM134C\tT307\t0.01002631
FAM134C\tT310\t0.02204824
FAM13A\tS313\t-0.1030373
FAM149B1\tS37\t0.2579761
FAM160A2\tS524\t-1.115844
FAM160A2\tS530\t0.86614385
FAM160A2\tS537\t0.6076958
FAM160A2\tS547\t-0.34465035
FAM160A2\tS600\t-0.036408233
FAM160A2\tS873\t-0.3351713
FAM160A2\tS911\t1.116165
FAM160A2\tS915\t0.7432926
FAM160A2\tT916\t0.5622791
FAM160B1\tS617\t-0.09554288
FAM169A\tS466\t-0.2882585
FAM171A2\tS410\t0.1768333
FAM171A2\tS411\t0.2542336
FAM171A2\tS446\t-0.26141415
FAM171A2\tS789\t0.3156822
FAM171B\tS504\t0.57806
FAM171B\tS779\t0.0551957
FAM171B\tS794\t0.02630426
FAM175B\tS280\t-0.5742185
FAM177A1\tS70\t-0.02693978
FAM177A1\tT71\t-0.03255102
FAM178A\tS21\t-0.2605148
FAM178A\tS555\t-0.2276921
FAM178B\tS52\t0.1812935
FAM179B\tS836\t0.1547128
FAM184A\tS109\t0.271019021
FAM188B\tS392\t-1.575056
FAM189A2\tS114\t-0.05240114
FAM189B\tS201\t-0.046564999
FAM189B\tS262\t-0.2475254
FAM189B\tS293\t-0.05616116
FAM193A\tS1144\t0.392757
FAM193A\tS1165\t0.107851176
FAM193A\tS293\t0.367679
FAM193A\tS393\t0.043152755
FAM193A\tT1128\t-0.7471241
FAM195A\tS82\t-0.1865511
FAM195B\tS21\t-0.69764
FAM198B\tS200\t0.02885203
FAM200A\tS46\t0.5275716
FAM207A\tS188\t0.43238525
FAM207A\tT34\t-0.1000974
FAM208A\tS1103\t-0.2447876
FAM208A\tS694\t-2.292369
FAM208A\tS699\t0.37135665
FAM208A\tS927\t0.036664055
FAM208A\tT819\t0.3431235
FAM208B\tS1172\t-0.7027067
FAM208B\tS1541\t0.090224065
FAM208B\tS2009\t0.01549758
FAM208B\tS685\t-0.2706082
FAM20C\tS75\t0.03167748
FAM214B\tS254\t-0.30604585
FAM214B\tS255\t-0.360262825
FAM219A\tS17\t0.2505978
FAM219A\tS55\t-0.22174515
FAM219A\tS98\t-0.1862783
FAM219A\tT96\t-0.1862783
FAM219B\tS41\t-0.04760933
FAM21A\tS1054\t0.07970238
FAM21A\tS1075\t-0.74941925
FAM21A\tS1169\t-0.8354197
FAM21A\tS1180\t-0.0186761
FAM21A\tS158\t-0.096112205
FAM21A\tS160\t-0.3349893
FAM21A\tS288\t-2.464474
FAM21A\tS333\t-0.03244349
FAM21A\tS352\t-0.8833424
FAM21A\tS498\t0.05060612
FAM21A\tS539\t0.0380769
FAM21A\tS620\t0.07905095
FAM21A\tS728\t-0.138309625
FAM21A\tS787\t0.3912178
FAM21A\tS802\t0.21911065
FAM21A\tS996\t0.27540175
FAM21A\tT331\t-0.00592768
FAM21A\tT437\t0.7008835
FAM21C\tS478\t-2.5964065
FAM21C\tS539\t-0.0290566
FAM21C\tS663\t-1.053883
FAM21C\tS991\t0.07025199
FAM21C\tS992\t0.2530211
FAM222B\tS296\t-0.1709461
FAM50A\tS165\t0.2701102
FAM53C\tS122\t0.1548424
FAM53C\tS232\t0.054051834
FAM53C\tS234\t0.054051834
FAM53C\tS273\t0.2781037
FAM53C\tS299\t-0.00813082
FAM63A\tS103\t-1.3244171
FAM63B\tS587\t-0.3782529
FAM63B\tS94\t-1.082652
FAM64A\tS16\t-0.2600828
FAM65A\tS347\t-0.1141602
FAM65A\tS707\t-0.7077601
FAM65A\tT351\t0.09707135
FAM65B\tS21\t0.06887715
FAM65B\tS37\t0.04976465
FAM65B\tS439\t0.06433112
FAM65B\tS523\t-1.138442
FAM73B\tS203\t0.1721035
FAM73B\tS220\t0.36643925
FAM73B\tS224\t0.127151285
FAM73B\tS276\t0.185486
FAM73B\tT206\t0.04879416
FAM76B\tS193\t0.07614867
FAM76B\tT215\t0.4324971
FAM83H\tS1003\t-0.0712393
FAM83H\tS1061\t0.09599187
FAM83H\tS1068\t0.076314515
FAM83H\tS1147\t-0.1239212
FAM83H\tS513\t0.3938555
FAM83H\tS516\t-0.04856142
FAM83H\tS523\t0.2827364
FAM83H\tS647\t0.2653169
FAM83H\tS785\t-0.09310941
FAM83H\tS870\t-0.05940474
FAM83H\tS881\t0.09599187
FAM83H\tS892\t0.03083044
FAM83H\tS914\t0.06115411
FAM83H\tS925\t0.1293489
FAM83H\tS936\t-0.03704382
FAM83H\tS998\t-0.4175789
FAM83H\tT1065\t0.14539285
FAM83H\tT1108\t0.2970153
FAM83H\tT822\t0.05644473
FAM83H\tT894\t0.3485893
FAM84B\tS299\t-0.3313363
FAM84B\tS300\t-0.3313363
FAM86C1\tS15\t-0.06626118
FAM8A1\tS81\t-1.902767
FAM91A1\tS332\t0.039172905
FAM91A1\tS671\t-0.963138
FANCB\tT555\t0.1844707
FANCD2\tS1435\t-0.04947187
FANCD2\tS592\t0.005471901
FANCE\tS180\t0.102994
FANCE\tS210\t0.59027325
FANCE\tS249\t-0.05719648
FANCI\tS407\t0.29655405
FANCM\tS370\t0.06818932
FARP1\tS427\t-0.1934532
FARP1\tS510\t-0.3733459
FARP1\tS863\t-0.414967035
FARP1\tS871\t0.05130255
FARP1\tS872\t-0.2303129
FARP1\tS889\t-0.08034721
FARP1\tT24\t0.1359287
FARP2\tS212\t-0.2734478
FARP2\tS27\t-0.120553895
FARP2\tS439\t0.05436236
FARP2\tS446\t0.33360891
FARP2\tS876\t-1.873378
FARP2\tT22\t0.1147668
FARP2\tT28\t0.113294405
FARSA\tS193\t-0.1872701
FAS\tT284\t0.11029055
FASN\tS1411\t-0.0669864
FASN\tS1421\t0.038998
FASN\tS1584\t-0.1236383
FASN\tS207\t-0.04462767
FASN\tS2198\t0.2319238
FASN\tS2236\t0.180632375
FASN\tS265\t0.14045155
FASN\tS725\t0.1921942
FASN\tT1407\t-0.3267842
FASN\tT2204\t-1.232972
FASN\tT262\t-0.23032994
FASN\tT976\t-0.08828545
FAT1\tS4473\t-0.185507
FBF1\tS142\t-0.71662175
FBL\tS124\t0.1515991
FBRS\tS237\t-0.028090655
FBRS\tS309\t-0.09423319
FBRS\tS730\t0.4876921
FBRS\tT948\t0.821302
FBRSL1\tS68\t0.09585687
FBRSL1\tS864\t0.2979544
FBRSL1\tT720\t0.7562548
FBXL19\tS300\t-0.2317014
FBXL19\tT305\t-0.224288905
FBXL20\tS389\t-0.09374498
FBXL20\tT385\t-0.10824379
FBXO28\tS344\t0.01221106
FBXO4\tS12\t-0.03067821
FBXO41\tS478\t-0.7378314
FBXO41\tT479\t-0.4590998
FBXO42\tS365\t-0.19976819
FBXO42\tS552\t0.1730048
FBXO42\tT539\t0.1730048
FBXO9\tS10\t0.2257685
FBXW5\tS284\t-0.065329615
FBXW9\tS59\t-0.52758505
FCHO2\tS354\t-0.06399719
FCHO2\tS370\t0.111165
FCHO2\tT420\t0.2367069
FCHSD2\tS508\t-1.1966145
FERMT3\tS337\t-0.1323724
FEZ2\tS135\t0.03139513
FGD1\tS114\t-0.4766535
FGD1\tS135\t-0.793492
FGD1\tS48\t0.3283769
FGD1\tS745\t-0.254856789
FGD1\tS954\t-0.4126783
FGD1\tT711\t-0.58208
FGD4\tS141\t-0.640164
FGD4\tS186\t-0.23206035
FGD4\tS702\t-0.2979986
FGD4\tT158\t-0.09916985
FGD6\tS515\t-0.09552744
FGFR1OP\tS156\t0.3661153
FGFR1OP\tS160\t-0.41698595
FGFR1OP\tS182\t0.2853431
FHDC1\tS1012\t-0.5692009
FHDC1\tS570\t0.3138263
FHDC1\tS736\t-0.3982464
FHOD1\tS367\t-0.2308884
FHOD1\tS486\t0.5540485
FHOD1\tS498\t-0.2629882
FIGNL1\tS46\t0.1009056
FIP1L1\tS149\t0.07929271
FIP1L1\tS259\t0.162081
FIP1L1\tS304\t-0.1452703
FIP1L1\tS492\t-0.008580658
FIP1L1\tS496\t0.041084525
FIP1L1\tS500\t0.158143875
FIP1L1\tS554\t-0.2048676
FIP1L1\tT494\t-0.06740964
FKBP15\tS1012\t-1.069846
FKBP15\tS1024\t0.31175445
FKBP15\tS1114\t-0.259602625
FKBP15\tS1158\t-0.4940315
FKBP15\tS1164\t0.30719975
FKBP15\tS14\t-1.720374
FKBP15\tS307\t0.23988515
FKBP15\tS311\t0.237928625
FKBP15\tS320\t0.06763869
FKBP15\tS346\t0.06322686
FKBP15\tS939\t-0.07005846
FKBP15\tS940\t-0.07005846
FKBP15\tS941\t-0.07005846
FKBP15\tS956\t-0.2218924
FKBP15\tS979\t-0.1133016
FKBP1A\tS9\t0.04572251
FKBP3\tS100\t0.1321162
FKBP3\tS36\t-0.1282982
FKBP4\tS15\t-0.2978035
FKBP4\tS258\t0.2423281
FKBP4\tT436\t0.2699907
FKBP5\tS13\t0.08455005
FKBP5\tS445\t0.241108
FLAD1\tS9\t0.464639475
FLCN\tS62\t-0.305955175
FLCN\tS73\t-0.24642082
FLI1\tS39\t-0.1700189
FLII\tS801\t-0.1046818
FLNA\tS1084\t-1.661357
FLNA\tS1459\t0.00302647
FLNA\tS1726\t-0.2111973
FLNA\tS1827\t0.10593442
FLNA\tS2144\t0.1979836
FLNA\tS2150\t0.2553195
FLNA\tS2155\t0.1206174
FLNA\tS2172\t-0.1003758
FLNA\tS2276\t0.1214134
FLNA\tS2311\t-0.984727
FLNA\tS2319\t-0.01732945
FLNA\tS2321\t-0.04578878
FLNA\tS2331\t-0.064020935
FLNA\tS966\t-0.35923915
FLNA\tS968\t-0.4934918
FLNA\tT2591\t-0.1173648
FLNB\tS1536\t-0.32387685
FLNB\tS2138\t-0.1577855
FLNB\tS2509\t-0.3088947
FLNB\tS2512\t-0.394942
FLNB\tS983\t-0.1074147
FLNC\tS2200\t0.5812066
FLRT3\tS585\t-0.0518178
FLRT3\tS593\t0.2331518
FLRT3\tT592\t0.03294719
FLVCR1\tT90\t-0.4433421
FLYWCH1\tS21\t0.2385423
FLYWCH1\tS502\t0.2593026
FLYWCH2\tS21\t-0.2815792
FMN1\tS168\t-0.4215346
FMN1\tS201\t0.2568899
FMN1\tS235\t0.3979125
FMN1\tS518\t0.005184378
FMN1\tS525\t-0.71828725
FMN1\tS554\t0.3015876
FMN1\tS586\t0.5970305
FMN1\tS842\t0.05088473
FMN2\tS295\t-0.5027095
FMN2\tS361\t-0.2942432
FMN2\tS396\t-0.13403225
FMN2\tS400\t-0.13403225
FMN2\tS482\t-0.171011
FMN2\tS516\t0.1717192
FMN2\tT345\t0.03885755
FMNL1\tS184\t0.1361914
FMNL1\tS624\t0.0296568
FMNL1\tS675\t-0.024351855
FMNL2\tS1016\t-0.5767769
FMNL2\tS188\t0.188826285
FMNL2\tS406\t-0.1009636
FMNL2\tS679\t0.4987614
FMNL3\tS174\t-0.0894341
FMNL3\tS191\t0.270228605
FMNL3\tS93\t-0.2287567
FMNL3\tT95\t0.05255495
FNBP1\tS296\t0.288160615
FNBP1\tS299\t0.61695165
FNBP1\tS492\t-0.245365917
FNBP1L\tS295\t0.1695402
FNBP1L\tS430\t-0.3875248
FNBP1L\tS431\t-0.3155105
FNBP1L\tS443\t0.1248574
FNBP4\tS116\t0.1664584
FNBP4\tS18\t-0.06736432
FNBP4\tS432\t0.06060078
FNBP4\tS435\t-0.16655975
FNBP4\tS464\t-0.1054577
FNBP4\tS499\t0.1301325
FNBP4\tS508\t0.118520885
FNBP4\tT479\t0.05060612
FNBP4\tT517\t-0.006970587
FNDC3A\tS147\t-0.033943465
FNDC3A\tS151\t-0.006361886
FNDC3A\tS157\t0.1557492
FNDC3B\tS208\t0.024036
FNIP1\tS1207\t0.4380799
FNIP1\tS175\t-0.3223393
FNIP1\tS280\t-0.1531257
FNIP1\tS641\t-0.03275755
FNIP1\tS669\t0.24929775
FNIP1\tS698\t-0.3203961
FNIP1\tS901\t0.063918631
FOSL1\tS101\t-0.2069115
FOSL1\tS191\t-0.9549764
FOSL1\tS252\t-3.270553
FOSL1\tS265\t-2.86835125
FOSL1\tS74\t-0.9094446
FOSL2\tS161\t-0.049889258
FOXC1\tS235\t0.37086445
FOXC1\tS241\t0.3628354
FOXC1\tS272\t-0.28604725
FOXC1\tS320\t0.2187192
FOXD2\tS96\t-0.03430809
FOXD3\tS40\t0.13321785
FOXD3\tS46\t0.457603475
FOXJ2\tS172\t0.07382025
FOXJ2\tS46\t-0.2227339
FOXJ3\tS187\t-0.04751734
FOXJ3\tS189\t-0.24286347
FOXJ3\tT182\t-0.04751734
FOXJ3\tY180\t-0.04751734
FOXK1\tS102\t-0.14485765
FOXK1\tS106\t-0.03320045
FOXK1\tS213\t-0.20289132
FOXK1\tS223\t-0.02151049
FOXK1\tS239\t-1.094002
FOXK1\tS243\t-1.083661
FOXK1\tS257\t-0.3876054
FOXK1\tS295\t-0.14485765
FOXK1\tS299\t0.01991543
FOXK1\tS416\t0.3393655
FOXK1\tS420\t0.1431322
FOXK1\tS428\t-0.0418134
FOXK1\tS441\t0.1314418
FOXK1\tS445\t0.09356022
FOXK1\tS468\t0.5917751
FOXK1\tS472\t0.0538694
FOXK1\tT245\t-1.140177
FOXK1\tT436\t0.20568085
FOXK2\tS170\t0.03322923
FOXK2\tS30\t-0.08807714
FOXK2\tS369\t0.074249
FOXK2\tS373\t0.074249
FOXK2\tS394\t0.363770713
FOXK2\tS398\t0.07587489
FOXK2\tS428\t-0.09418701
FOXK2\tT13\t0.13280463
FOXK2\tT389\t0.024706625
FOXM1\tS466\t0.06115411
FOXM1\tS493\t0.04495695
FOXO1\tS287\t0.004945555
FOXO1\tS470\t-0.16353325
FOXO3\tS253\t0.3447149
FOXO3\tS284\t0.151729
FOXO3\tS299\t-0.027685195
FOXO3\tS7\t0.043951958
FOXO3\tS75\t-0.1912114
FOXO4\tS175\t-1.4218875
FOXP4\tS86\t0.418136
FRA10AC1\tS278\t-0.3414092
FRMD4A\tS350\t0.2853431
FRMD4A\tS353\t0.26251185
FRMD4A\tS359\t0.28228635
FRMD4A\tS362\t0.3477144
FRMD4A\tS628\t-0.95099195
FRMD4A\tS638\t1.047608
FRMD4A\tS642\t0.572137375
FRMD4A\tS675\t-0.069678085
FRMD4A\tS679\t-0.028766655
FRMD4A\tS712\t0.2169825
FRMD4A\tS785\t0.05921687
FRMD4A\tS837\t-0.29815405
FRMD4A\tT659\t0.05955635
FRMD4A\tT717\t0.20514596
FRMD4A\tT831\t0.4108837
FRMD4A\tT882\t0.6586457
FRMD4B\tS280\t-0.8139813
FRMD4B\tS430\t0.03740203
FRMD5\tS360\t0.2829734
FRMD6\tS337\t0.4326387
FRMD6\tS420\t0.0628015
FRMD6\tS430\t0.2624711
FRMD6\tS445\t0.12356165
FRMD6\tS448\t0.28052075
FRMD6\tS465\t-0.03109086
FRMD6\tS467\t0.09261344
FRMD8\tS21\t-1.797711
FRMD8\tS24\t-2.120491
FRS2\tS226\t-2.883137
FRS2\tT227\t-2.902389
FRY\tS1936\t0.4424504
FRYL\tS1957\t-0.1049456
FRYL\tS479\t-1.18091
FRYL\tS844\t0.1538053
FRYL\tT1959\t0.3145225
FRYL\tT2270\t-0.09169434
FRYL\tT2547\t0.02460336
FSCN1\tT403\t0.16319852
FSIP1\tS341\t0.6645739
FSTL1\tS130\t0.3446012
FTSJ1\tS269\t-1.838461
FTSJ3\tS335\t-0.02992677
FTSJ3\tS336\t-0.02992677
FTSJ3\tS584\t-0.03699945
FTSJ3\tS599\t0.08678382
FTSJ3\tS676\t0.6436715
FTSJ3\tS688\t0.7026576
FTSJD2\tS51\t0.5034506
FTSJD2\tS53\t0.4322858
FTSJD2\tS55\t0.4322858
FTSJD2\tS64\t-0.259715565
FTSJD2\tS66\t0.1968587
FTSJD2\tS75\t0.2590615
FUBP1\tS140\t-0.3049471
FUBP1\tT153\t-0.004710893
FUBP3\tS296\t0.06612369
FUNDC2\tS151\t-0.6708879
FUS\tS220\t-0.1727825
FXR1\tS406\t0.2701102
FXR1\tS409\t0.2701102
FXR1\tS420\t0.1772638
FXR1\tS423\t0.1695509
FXR1\tS432\t0.52893525
FXR1\tS587\t0.2096405
FXR2\tS566\t0.130282805
FXR2\tS601\t-0.065261915
FXR2\tS603\t0.06466267
FYCO1\tS1155\t0.071323945
FYN\tS21\t-0.005058268
FYTTD1\tS16\t0.00805652
FZD6\tS315\t-0.4587826
FZD6\tS324\t-0.2185984
G3BP1\tS149\t0.02828617
G3BP1\tS230\t-0.1178506
G3BP1\tS231\t0.1076879
G3BP1\tS232\t0.03398861
G3BP2\tS141\t-0.2138052
G3BP2\tS149\t-0.2530165
G3BP2\tT227\t-0.1721322
G6PD\tS26\t-0.48688565
G6PD\tS8\t0.1945914
GAB1\tS355\t-0.65039005
GAB1\tS381\t0.07587489
GAB2\tS226\t-0.19436675
GAB2\tS384\t-0.4344223
GAB2\tS505\t-2.664197
GABRE\tS212\t-0.168607915
GAGE2D\tT39\t-0.3140698
GAGE4\tT40\t-0.3415485
GAGE6\tT40\t-0.30957445
GAK\tS826\t-0.1960621
GAK\tS829\t-0.1960621
GALNT11\tS82\t-0.331064
GAPDH\tT154\t0.22046715
GAPDH\tT184\t0.06515872
GAPVD1\tS1019\t-0.9154459
GAPVD1\tS1046\t-0.16559195
GAPVD1\tS740\t0.5462371
GAPVD1\tS746\t-1.446109
GAPVD1\tS902\t-0.2872044
GAPVD1\tS903\t-0.5079725
GAPVD1\tT1013\t0.3455744
GAPVD1\tT390\t-0.1298128
GAPVD1\tT762\t-0.146826993
GAREM\tS545\t-0.7232056
GAREM\tS631\t0.02204824
GAREM\tS673\t-0.8679628
GAS2L1\tS292\t0.02715413
GAS2L1\tS306\t-0.11555879
GAS2L1\tS490\t0.06377902
GAS2L1\tS657\t-0.5313645
GAS2L1\tT193\t0.2832106
GAS2L3\tS307\t0.1837088
GAS2L3\tS570\t-0.4226945
GAS7\tS103\t-0.07966616
GAS7\tS316\t0.6831125
GAS7\tS49\t-0.8434481
GAS7\tS57\t-0.36474071
GAS7\tS60\t-0.2152515
GAS7\tS92\t-0.37794246
GAS7\tT317\t-0.1750448
GAS7\tT93\t0.21026155
GATAD2A\tS100\t0.1305355
GATAD2A\tS107\t0.06845853
GATAD2A\tS113\t0.124663515
GATAD2A\tS114\t0.0586628
GATAD2A\tS340\t0.2648367
GATAD2A\tT189\t-0.0740006
GATAD2A\tT49\t0.004177767
GATAD2B\tS122\t0.03919573
GATAD2B\tS129\t-0.103428915
GATAD2B\tS134\t0.159744125
GATAD2B\tS135\t0.02616273
GATAD2B\tS334\t0.2850568
GATAD2B\tS338\t-1.390094
GATAD2B\tS486\t0.1857398
GATAD2B\tT120\t0.076879471
GBF1\tS1298\t-0.061825878
GBF1\tS1318\t0.02913487
GBF1\tS1335\t0.126506395
GBF1\tS1773\t-1.430781
GBF1\tS1781\t-0.0248227
GBF1\tS1784\t-1.348317
GBF1\tS1789\t-0.5595791
GBF1\tT1317\t-0.02486513
GCFC2\tS206\t-0.128711745
GCFC2\tS214\t-0.1421623
GCFC2\tS217\t-0.1421623
GCFC2\tT213\t-0.1421623
GCLC\tS8\t0.302410065
GDAP1\tS11\t0.0354831
GDI2\tS61\t-0.1158944
GEMIN4\tT73\t-0.9563689
GEMIN5\tS778\t-0.08499168
GEMIN5\tT51\t0.6196966
GEMIN5\tT807\t0.3238716
GEMIN7\tT3\t0.334225
GEMIN8\tS185\t-0.5216694
GEN1\tS249\t0.4718637
GEN1\tS893\t1.357496
GFAP\tS305\t0.0167015
GFPT1\tS243\t0.1607912
GFPT1\tT244\t0.1640138
GFPT1\tT245\t0.18511503
GGA2\tS326\t-2.26042
GGA2\tS400\t-2.707097
GGNBP2\tS360\t-0.01016343
GGT7\tS72\t-2.548269
GGT7\tS79\t-1.928058
GGT7\tS83\t1.421156
GHDC\tS87\t-0.24344116
GIGYF1\tS230\t-0.003423245
GIGYF1\tS24\t-0.63262575
GIGYF1\tS406\t-0.6542857
GIGYF1\tS538\t-0.2100789
GIGYF1\tS756\t-0.55613775
GIGYF2\tS160\t-1.027822
GIGYF2\tS189\t-0.2967398
GIGYF2\tS236\t-0.1401577
GIGYF2\tS26\t-1.903469
GIGYF2\tS275\t-1.225835
GIGYF2\tS30\t-2.0797805
GIGYF2\tS593\t-2.157464
GIGYF2\tT382\t-0.1667293
GIGYF2\tT403\t-0.1667293
GIPC1\tT238\t0.0102729
GIT1\tS361\t-0.4352578
GIT1\tS362\t-0.4071148
GIT1\tS385\t-0.03384398
GIT1\tS388\t-0.1160351
GIT1\tS561\t0.2919769
GIT1\tS571\t-0.1235911
GIT1\tS592\t-0.8232312
GIT1\tS596\t-0.6019107
GIT1\tT392\t0.0182068
GIT1\tT480\t-0.485903
GIT2\tS394\t0.09679074
GIT2\tS397\t0.09679074
GJB1\tS258\t0.3103401
GJB1\tS266\t-0.2330233
GJC1\tS326\t-0.23639785
GLCCI1\tS105\t0.1541943
GLCCI1\tS108\t0.0697996
GLCCI1\tS223\t0.009920342
GLCCI1\tS258\t0.17934635
GLCCI1\tS30\t-0.02558812
GLCCI1\tS303\t0.217727
GLCCI1\tS345\t0.3067288
GLCCI1\tS398\t0.127747299
GLCCI1\tT350\t0.139615145
GLCE\tS9\t-0.4230813
GLE1\tS88\t-0.7184739
GLI2\tS1033\t0.0247452
GLI2\tS234\t-0.63720855
GLI2\tS60\t0.1926992
GLI3\tS445\t-0.3905665
GLI3\tS664\t0.08052122
GLI4\tS86\t-0.1009946
GLIS1\tS460\t-0.1851461
GLIS1\tS464\t-0.6074848
GLS\tS449\t0.112814655
GLTSCR1\tS513\t0.03412015
GLTSCR2\tS29\t0.0533895
GLTSCR2\tS93\t0.271067
GLTSCR2\tT28\t0.1348781
GLUD1\tT410\t-0.2123836
GMDS\tS14\t-0.1728314
GMIP\tS234\t-0.1709948
GMIP\tS459\t0.03616195
GMIP\tS914\t-0.06466092
GMIP\tS919\t-0.3559038
GMPS\tS313\t-0.38495305
GMPS\tS332\t0.208787245
GMPS\tT318\t-0.1481131
GNB2\tT29\t0.1293489
GNB2\tT31\t0.4192021
GNB2L1\tS161\t0.1963978
GNB2L1\tS276\t0.32054045
GNB2L1\tT6\t0.4124021
GNB2L1\tT96\t0.3449877
GNG12\tS26\t0.1284253
GNG12\tS49\t-0.08152214
GNG2\tS3\t0.10887815
GNG2\tS8\t0.1302719
GNG2\tT52\t-0.04709989
GNG2\tT6\t0.050037895
GNG5\tS6\t0.160099565
GNL1\tS324\t-0.2015429
GNL1\tS51\t-0.0178993
GNL1\tT48\t0.000721115
GNL1\tT50\t0.0073717
GNL2\tS580\t-0.0277044
GNL2\tS581\t0.03815525
GNL2\tS582\t-0.1081454
GOLGA1\tS33\t-0.000245268
GOLGA1\tS36\t-0.3254616
GOLGA1\tS41\t0.2508404
GOLGA2\tS66\t-0.3693149
GOLGA3\tS1392\t0.087977575
GOLGA3\tS465\t-1.138442
GOLGA4\tS118\t-0.12727134
GOLGA4\tS266\t-0.2017089
GOLGA4\tS29\t-0.11782285
GOLGA4\tS71\t0.03689012
GOLGA4\tT31\t0.24656107
GOLGA5\tS116\t-0.9424458
GOLGB1\tS138\t0.193630385
GOLIM4\tS538\t-0.1138011
GOLIM4\tS583\t-0.04747256
GOLM1\tT245\t-0.17793605
GOLPH3\tS35\t-0.028412605
GOLPH3\tS36\t-0.4230233
GON4L\tS1268\t-0.07958472
GON4L\tS1976\t0.11172296
GON4L\tS2052\t0.09356022
GON4L\tS2106\t0.01406952
GON4L\tS346\t-0.05358351
GON4L\tT1444\t0.06515872
GORASP1\tT143\t-0.2566558
GORASP2\tS383\t-0.07778692
GORASP2\tT154\t-1.067757
GORASP2\tT157\t-0.8279989
GOSR1\tS49\t-0.09378667
GOT2\tT333\t-0.07242203
GPATCH1\tS6\t0.198249185
GPATCH1\tS8\t0.198249185
GPATCH2\tS115\t-0.00488457
GPATCH2\tS117\t-0.00488457
GPATCH2\tS284\t0.1135672
GPATCH2\tS54\t0.06438585
GPATCH2\tT50\t0.010025835
GPATCH2L\tS444\t-0.522592
GPATCH2L\tS86\t-0.01157343
GPATCH2L\tS88\t-0.068343365
GPATCH4\tS128\t0.02955887
GPATCH4\tS130\t-0.016450455
GPATCH8\tS1003\t0.111432
GPATCH8\tS1029\t-2.094002
GPATCH8\tS575\t0.007482617
GPATCH8\tS662\t-0.04653361
GPATCH8\tS680\t0.1857398
GPATCH8\tS931\t-0.14162322
GPATCH8\tS936\t0.08194433
GPATCH8\tT1037\t0.3746222
GPBP1\tS56\t-0.7390831
GPBP1L1\tS274\t-0.4608131
GPBP1L1\tS49\t-0.6204677
GPBP1L1\tT301\t0.4701387
GPBP1L1\tT354\t0.24840753
GPCPD1\tS175\t-0.06484205
GPHN\tS188\t-0.2382552
GPHN\tS194\t-0.100778
GPHN\tS200\t-0.09180756
GPHN\tS270\t0.5312614
GPI\tS107\t0.03068919
GPI\tS455\t0.29881675
GPI\tT109\t0.08664794
GPKOW\tS42\t-0.06419326
GPKOW\tT216\t0.1063484
GPM6B\tS174\t0.4297401
GPM6B\tS176\t0.2456174
GPN1\tS314\t-0.9331324
GPN1\tS338\t-0.1289607
GPNMB\tS531\t0.5736653
GPR124\tS774\t-0.08053862
GPR124\tS890\t-0.2494792
GPR126\tS1184\t0.4066407
GPR143\tS343\t-0.3102535
GPR155\tS741\t0.03097168
GPR155\tS837\t-0.01912653
GPR161\tS298\t-0.2853896
GPR56\tS681\t-0.3589529
GPR56\tS684\t0.4758112
GPRIN1\tS389\t-0.1274943
GPRIN1\tS452\t0.1428708
GPRIN1\tS64\t-0.08623541
GPRIN1\tS73\t0.09166604
GPRIN1\tS75\t-0.1065601
GPRIN1\tS776\t-1.33601795
GPRIN1\tS895\t0.2933705
GPRIN1\tS95\t-0.2765725
GPRIN3\tS214\t0.1064823
GPRIN3\tS32\t-0.342671
GPRIN3\tS336\t-0.35078
GPRIN3\tS517\t-0.3424149
GPRIN3\tS57\t-1.395815
GPRIN3\tS583\t-0.552223325
GPRIN3\tS619\t0.09775336
GPRIN3\tT581\t-0.01673535
GPS1\tS220\t0.2947824
GPS1\tS454\t-0.4566031
GPS1\tT459\t0.2066433
GPSM1\tS364\t-0.2155798
GPSM1\tS390\t-0.6646768
GPSM1\tS446\t-0.3356992
GPSM1\tS448\t-0.3824758
GPSM1\tS470\t-0.42762515
GPSM2\tS408\t-0.04983019
GPX1\tS34\t-0.04504905
GPX3\tS155\t0.1335492
GPX3\tS160\t0.1401242
GPX3\tS166\t0.1401242
GPX3\tT159\t0.028552605
GPX3\tT165\t0.1401242
GRAMD1A\tS263\t-0.3498123
GRAMD1A\tS267\t-0.336584275
GRAMD1A\tS8\t0.5796629
GRASP\tS94\t0.03308822
GRASP\tT77\t2.837358
GRB10\tS360\t-0.182625865
GRB10\tS370\t0.1086248
GRB10\tS418\t0.08474465
GREB1\tS87\t0.01963077
GRHL1\tT211\t0.005759195
GRHPR\tS272\t0.12390482
GRK6\tS450\t0.3430985
GRK6\tT451\t0.5097465
GRSF1\tS126\t0.1768578
GRWD1\tS119\t-0.1458926
GRWD1\tS122\t-0.1704752
GRWD1\tT10\t-0.4873585
GSE1\tS606\t0.3825271
GSE1\tS805\t0.1281614
GSG2\tS147\t0.094030914
GSG2\tT112\t0.2053925
GSK3A\tS2\t0.01777946
GSK3A\tY216\t0.02687089
GSK3B\tT390\t-0.4115216
GSK3B\tT392\t-0.51559505
GSR\tT340\t0.3292958
GSS\tS415\t-0.1627026
GTF2E2\tS18\t-0.3335524
GTF2E2\tT19\t0.4997821
GTF2F1\tS385\t-0.0073227
GTF2F1\tS391\t0.0900295
GTF2F1\tS433\t0.4587276
GTF2F1\tS449\t0.2551986
GTF2F1\tT156\t-1.60165
GTF2F1\tT389\t-0.06927775
GTF2F1\tT427\t-0.01433185
GTF2I\tS103\t-0.5584741
GTF2I\tS16\t-0.45278025
GTF2I\tS210\t-0.3285617
GTF2I\tT537\t0.3660284
GTF2IRD1\tS448\t-0.2193539
GTF3C1\tS1062\t-1.375728
GTF3C1\tS1068\t-7.25E-05
GTF3C1\tS1611\t0.160342965
GTF3C1\tS1845\t-0.1494086
GTF3C1\tS1856\t-0.13008435
GTF3C1\tS1865\t-0.608364475
GTF3C1\tS1868\t-0.587860075
GTF3C1\tS739\t0.0162768
GTF3C1\tS751\t-0.2159819
GTF3C1\tT1064\t-1.569679
GTF3C2\tS132\t-0.06005131
GTF3C2\tS167\t-0.04217456
GTF3C2\tS893\t-0.08359977
GTF3C2\tS904\t0.06983963
GTF3C3\tS282\t0.4951835
GTF3C3\tS43\t-0.006419843
GTF3C4\tS611\t-0.01544707
GTPBP1\tS24\t-0.2654139
GTPBP1\tS25\t-0.195203
GTPBP1\tS44\t-0.06292688
GTPBP1\tS47\t-0.06292688
GTPBP1\tS69\t-0.1431657
GTPBP1\tS72\t-0.1180379
GTPBP4\tS558\t-0.1601371
GTSE1\tS168\t0.7831633
GTSE1\tS457\t-3.035878
GTSE1\tS575\t0.135722665
GTSE1\tS583\t0.16770244
GTSE1\tS592\t0.3983503
GTSE1\tT466\t1.183963
GTSE1\tT677\t0.4925198
GULP1\tS108\t-1.770683
GYG2\tS428\t-0.4514647
GYPC\tS101\t-0.0123478
GYS1\tS645\t-0.5306141
GYS1\tS647\t0.5665572
GYS1\tS652\t-0.08932873
GYS1\tS653\t-0.078679165
GYS1\tS657\t-0.093994375
GYS1\tS710\t0.4944668
GZF1\tS613\t0.02616273
H1FX\tS31\t0.185486
H2AFY\tS169\t0.10785845
H2AFY\tT129\t0.1928254
H2AFY\tT177\t0.15178215
H3F3B\tS58\t0.06584801
H3F3B\tT81\t0.3317052
HABP4\tS108\t0.548511475
HABP4\tS7\t-0.5794476
HABP4\tT268\t-0.1006387
HACE1\tS385\t-0.5381362
HACL1\tS165\t0.1301402
HACL1\tS4\t0.006190286
HADHA\tS419\t0.01806431
HAUS6\tS472\t0.2321696
HAUS6\tS517\t0.1048734
HAUS6\tS770\t-0.9898218
HAUS6\tS908\t0.40397829
HAUS6\tT549\t-0.2032361
HBP1\tS372\t-0.73281065
HBS1L\tS117\t-1.023387
HBS1L\tS246\t-4.7259515
HBS1L\tS249\t0.9847208
HBS1L\tS67\t-1.223441
HBS1L\tT231\t0.009060428
HCFC1\tS1507\t-0.2303975
HCFC1\tS2063\t0.2639958
HCFC1\tS3\t-0.0551487
HCFC1\tS411\t-0.01240695
HCFC1\tS598\t0.2854231
HCFC1\tS6\t-0.1554054
HCFC1\tS666\t-0.1624926
HDAC1\tS393\t-0.1118354
HDAC1\tS409\t-0.264062
HDAC1\tS421\t0.2126137
HDAC1\tS423\t0.0500489
HDAC2\tS364\t-0.1762018
HDAC2\tS392\t0.005184378
HDAC2\tS394\t0.005184378
HDAC4\tS246\t0.024062557
HDAC4\tS467\t-0.228815265
HDAC4\tS565\t-0.1376636
HDAC4\tS632\t-0.4654403
HDAC5\tS1023\t-0.2600655
HDAC5\tS53\t0.5005982
HDAC6\tS22\t-0.340861
HDAC7\tS449\t-0.4242617
HDAC7\tS450\t1.134287
HDAC7\tT249\t0.29921825
HDGF\tS107\t-2.9117795
HDGF\tS132\t0.036456205
HDGF\tS133\t0.034616485
HDGF\tS165\t0.04572251
HDGF\tS202\t0.073539015
HDGF\tS206\t-0.05850305
HDGF\tT200\t-0.08952827
HDGFRP2\tS12\t0.01306909
HDGFRP2\tS137\t0.06626152
HDGFRP2\tS230\t0.184005885
HDGFRP2\tS232\t0.184005885
HDGFRP2\tS234\t0.184005885
HDGFRP2\tS240\t0.057541883
HDGFRP2\tS366\t-0.04689121
HDGFRP2\tS369\t-0.04689121
HDGFRP2\tS370\t-0.04689121
HDGFRP2\tS454\t-1.880551
HDGFRP2\tS490\t0.2236697
HDGFRP2\tS608\t-0.088993245
HDGFRP2\tS625\t-0.2372652
HDGFRP2\tS633\t-0.06671438
HDGFRP2\tS633\t0.2272483
HDGFRP2\tS652\t-0.1423693
HDGFRP2\tS664\t-0.4904967
HDGFRP2\tT607\t-0.1710922
HDLBP\tS31\t-0.02736617
HEATR1\tS19\t0.1139672
HEATR3\tS15\t-0.2422469
HEATR5A\tS1328\t-0.4735506
HEATR5A\tT1528\t-0.0680296
HEATR6\tS336\t-0.0323611
HEATR6\tS643\t0.07519039
HECTD1\tS1533\t0.5772475
HECTD1\tS1544\t0.39688247
HECTD1\tS1547\t0.022065225
HECTD1\tS1772\t-0.02075023
HECTD1\tS631\t0.21288475
HECTD1\tS632\t-0.04170275
HECTD4\tT2330\t0.033644425
HECW1\tS1041\t0.2148892
HEG1\tS1319\t0.2068932
HEG1\tS1359\t0.2162376
HELB\tS1048\t-0.3953972
HELB\tS1058\t0.1188912
HELB\tS967\t-0.05548631
HELLS\tS487\t0.018208183
HELZ\tS1317\t0.08365592
HELZ\tS1442\t-0.178747
HELZ\tS1463\t-0.178747
HELZ\tS1614\t-0.03798105
HELZ\tS1620\t-0.2481935
HELZ\tS1660\t0.3306731
HELZ\tS629\t-0.2972715
HELZ\tT1776\t-2.0524335
HELZ2\tS1452\t-0.2360956
HELZ2\tT1450\t-0.093988195
HERC1\tS1328\t-1.299312
HERC1\tS1491\t-0.07778692
HERC1\tS2723\t-0.050781025
HERC1\tT1429\t-0.08531305
HERC1\tT2701\t0.7099963
HERC2\tS1366\t-0.22777467
HERC2\tS1588\t-1.390321
HERC2\tS1948\t-0.1208469
HERC2\tS2454\t0.07162537
HERC2\tS368\t-0.2205301
HERC2\tS372\t0.0124111
HERC2\tT3480\t-1.541744
HEXIM2\tS29\t-0.161075125
HEXIM2\tS76\t0.24245
HEXIM2\tT46\t-0.07774127
HGSNAT\tS211\t0.55043645
HGSNAT\tS215\t-0.10084139
HGSNAT\tS217\t-0.045569005
HIATL1\tS2\t-0.06475148
HIBADH\tS88\t-0.4054876
HIC2\tS330\t-0.0778986
HIF1A\tS392\t-1.276504
HIGD1A\tS8\t0.09247811
HIP1\tS320\t-0.42325935
HIP1\tS323\t-0.21453685
HIP1\tS516\t-0.01864412
HIPK1\tS967\t0.2949141
HIPK1\tY352\t0.2853431
HIPK2\tS800\t0.5989369
HIRA\tS494\t0.1003336
HIRA\tS505\t-0.1541366
HIRA\tS617\t-0.1262812
HIRA\tT511\t0.1338266
HIRA\tT542\t-0.002440175
HIRIP3\tS125\t-0.053113614
HIRIP3\tS142\t-0.1394265
HIRIP3\tS143\t-0.1394265
HIRIP3\tS196\t0.06557227
HIRIP3\tS199\t0.06557227
HIRIP3\tS223\t-0.001327887
HIRIP3\tS227\t-0.039230124
HIRIP3\tS289\t0.130102195
HIRIP3\tS291\t0.130102195
HIRIP3\tS330\t0.04124304
HIRIP3\tS332\t0.04124304
HIRIP3\tS333\t0.04124304
HIRIP3\tS359\t2.311212
HIRIP3\tS363\t2.311212
HIRIP3\tS370\t-0.085086595
HIRIP3\tS372\t-0.1315002
HIRIP3\tS530\t-0.05742169
HIRIP3\tS87\t-0.037461475
HIRIP3\tT358\t2.311212
HIRIP3\tT84\t-0.1462683
HIST1H1A\tS2\t0.02261638
HIST1H1B\tS18\t0.17940045
HIST1H1B\tS2\t0.092450115
HIST1H1B\tT11\t0.39912125
HIST1H1B\tT4\t0.14075636
HIST1H1B\tT9\t0.0907526
HIST1H1C\tS2\t0.110096
HIST1H1D\tS2\t0.081410255
HIST1H1D\tT10\t0.2774134
HIST1H1D\tT18\t0.105999065
HIST1H1D\tT4\t0.17373554
HIST1H1E\tS2\t0.096876465
HIST1H1E\tS37\t0.1823108
HIST1H1E\tT18\t0.08498372
HIST1H4A\tS48\t0.1253867
HIST1H4A\tY52\t-0.20280645
HIST2H2BF\tS65\t-0.06500481
HIVEP1\tS1036\t-0.4886938
HIVEP1\tS1158\t0.2450088
HIVEP1\tS1735\t-0.1808551
HIVEP1\tS1749\t0.06112328
HIVEP1\tS1884\t-0.07582404
HIVEP1\tS2297\t0.08188502
HIVEP1\tS2599\t0.44076175
HIVEP1\tS2682\t0.1544536
HIVEP1\tS2703\t0.2025117
HIVEP1\tS2706\t0.2025117
HIVEP1\tS2707\t0.2025117
HIVEP1\tS479\t0.1631122
HIVEP1\tS537\t-0.07522661
HIVEP1\tS571\t-0.08401261
HIVEP2\tS1032\t-0.08642095
HIVEP2\tS1085\t-0.052814295
HIVEP2\tS1443\t-0.253756
HIVEP2\tS1447\t-0.33660485
HIVEP2\tS296\t-0.0986137
HIVEP2\tS412\t-0.04797963
HIVEP2\tS565\t-2.5246095
HIVEP2\tS71\t-0.6746597
HIVEP2\tS769\t-0.9086018
HIVEP2\tS819\t-0.65837675
HIVEP3\tS1433\t0.04138263
HIVEP3\tS2034\t-0.4677529
HIVEP3\tS682\t-0.041444245
HIVEP3\tS931\t0.049655785
HJURP\tS473\t0.1399933
HJURP\tS496\t-0.4645443
HJURP\tS595\t0.346191
HJURP\tS642\t0.0586628
HKR1\tS10\t0.48553275
HKR1\tS15\t0.48553275
HKR1\tS158\t0.15151649
HKR1\tS159\t0.1489992
HLA-A\tS356\t0.3663642
HLA-A\tS359\t0.3663642
HLA-C\tS357\t-0.06889495
HLCS\tS79\t-0.5500636
HMBOX1\tT253\t0.2058929
HMBS\tS15\t-0.06904317
HMG20A\tS105\t-0.03392393
HMGA1\tS102\t0.07194386
HMGA1\tS103\t0.07194386
HMGA1\tS36\t0.1742785
HMGA1\tS38\t-0.06301725
HMGA1\tS44\t0.5886127
HMGA1\tS49\t-0.06301725
HMGA1\tS99\t0.1214134
HMGA1\tT39\t0.1322477
HMGA1\tT42\t0.2035144
HMGA1\tT53\t0.45988945
HMGA2\tS101\t-0.08002695
HMGA2\tS102\t-0.08658398
HMGA2\tS105\t-0.06188735
HMGA2\tS44\t0.1218111
HMGCS1\tS4\t0.10577719
HMGCS1\tS486\t-0.019528345
HMGCS1\tS495\t0.1664584
HMGN1\tS76\t0.10113864
HMGN1\tS79\t-0.02231707
HMGN3\tS78\t0.1331689
HMGN5\tS93\t-0.2254132
HMGXB4\tS101\t-0.06511372
HMGXB4\tS102\t0.05102402
HMGXB4\tS105\t0.1076532
HMGXB4\tS497\t0.0442889
HMGXB4\tS502\t0.162081
HMGXB4\tS512\t0.162081
HMHA1\tS23\t0.2744107
HMHA1\tS25\t-0.16955
HMHA1\tS577\t-0.00699709
HMHA1\tS578\t-0.1742143
HMHA1\tS951\t-0.4169046
HN1\tS131\t-0.6126375
HN1\tS28\t0.237199545
HN1\tS80\t0.30549135
HN1\tS87\t0.07587489
HN1\tS88\t0.07751644
HN1\tT54\t0.1003049
HN1L\tS30\t0.08868441
HN1L\tS69\t0.3287216
HN1L\tS97\t0.2726204
HN1L\tT76\t0.6646648
HNRNPA1\tS199\t0.2343867
HNRNPA1\tS2\t0.104024005
HNRNPA1\tS364\t0.3351203
HNRNPA1\tS4\t0.168324482
HNRNPA1\tS6\t0.021339535
HNRNPA2B1\tS198\t-0.07876168
HNRNPA2B1\tS212\t-0.0147182
HNRNPA2B1\tS231\t-0.001154638
HNRNPA2B1\tS259\t0.09949727
HNRNPA2B1\tS344\t-0.031882915
HNRNPA2B1\tT4\t0.523596
HNRNPA3\tS14\t0.1896664
HNRNPAB\tS242\t0.790785
HNRNPAB\tS255\t-0.5594516
HNRNPC\tS219\t0.04348443
HNRNPC\tS224\t-0.2607267
HNRNPC\tS227\t-0.01683311
HNRNPC\tS239\t-0.2087277
HNRNPC\tS240\t-0.1796944
HNRNPC\tS246\t-0.1776055
HNRNPC\tS247\t-0.13047853
HNRNPC\tS285\t-0.1680741
HNRNPC\tS31\t0.1078218
HNRNPD\tS190\t0.1512094
HNRNPD\tS71\t0.43273398
HNRNPD\tS80\t0.005116342
HNRNPD\tS82\t-0.046285573
HNRNPD\tS83\t-0.1715693
HNRNPD\tS87\t-0.1886277
HNRNPD\tT193\t0.11553399
HNRNPF\tS104\t-0.5059428
HNRNPH1\tS104\t-0.1091253
HNRNPH1\tS310\t-0.06639713
HNRNPH1\tS63\t0.01535482
HNRNPH2\tS310\t-0.1402208
HNRNPH3\tS216\t-0.07560303
HNRNPH3\tS298\t-0.246173
HNRNPK\tS192\t0.0167816
HNRNPK\tS260\t0.095722
HNRNPK\tS355\t-0.1508173
HNRNPK\tS36\t-0.0621133
HNRNPK\tS377\t0.1123665
HNRNPL\tS101\t0.104605
HNRNPL\tS185\t0.2667565
HNRNPL\tS188\t0.002882472
HNRNPL\tS52\t0.25072265
HNRNPL\tT487\t0.03660879
HNRNPM\tS165\t-0.5193578
HNRNPM\tS29\t-0.229243535
HNRNPM\tS536\t-0.03583058
HNRNPM\tS579\t-0.0328757
HNRNPR\tS252\t-0.07877694
HNRNPU\tS3\t0.2825487
HNRNPU\tS4\t0.29139485
HNRNPU\tS59\t0.1067503
HNRNPU\tS66\t-0.01326146
HNRNPUL1\tS512\t-0.01170433
HNRNPUL2\tS161\t-0.009596922
HNRNPUL2\tS168\t-0.058434415
HNRNPUL2\tS185\t0.0550368
HNRNPUL2\tS228\t-0.1201218
HNRNPUL2\tT165\t-0.0970697
HNRPDL\tS122\t0.08936255
HOMER3\tS159\t-0.4404788
HOMER3\tS256\t-0.07357541
HOMEZ\tT451\t-0.07222484
HOXA1\tT299\t-0.1242042
HOXA3\tS148\t-0.186039945
HOXA3\tS263\t-0.3082694
HOXB6\tS214\t0.06143053
HOXC10\tS189\t0.0018319
HOXC10\tT8\t0.16215495
HOXC9\tS159\t0.01706665
HOXD3\tS261\t0.2081427
HOXD3\tS266\t0.2081427
HOXD9\tS146\t-0.08101851
HP1BP3\tS249\t0.05838585
HP1BP3\tS441\t-0.23673365
HP1BP3\tS442\t-0.23673365
HP1BP3\tS446\t-0.23673365
HPS4\tS373\t-0.347307
HPS5\tS347\t-0.6596203
HPS5\tS349\t-0.4161667
HPS5\tS420\t-0.08106426
HPS5\tS565\t0.4466797
HPS5\tS581\t-0.2352801
HR\tS416\t-0.480303235
HRH1\tS285\t0.1008431
HS1BP3\tS139\t-0.2581272
HS1BP3\tS194\t-0.07885314
HS1BP3\tS3\t0.2547149
HSF1\tS292\t0.2168583
HSF1\tS303\t0.27122732
HSF1\tS307\t-0.08019466
HSF1\tS314\t-0.165402
HSF1\tS363\t-0.03762701
HSF1\tS368\t-0.06825502
HSF1\tT357\t-0.007035898
HSF1\tT367\t-0.105085875
HSF1\tT369\t0.006679178
HSP90AA1\tS231\t0.000576887
HSP90AA1\tS263\t-0.07359061
HSP90AA1\tS315\t0.07778991
HSP90AA1\tS453\t-0.052028994
HSP90AA1\tT109\t-0.1172083
HSP90AA1\tT317\t0.1125
HSP90AA2\tS263\t-0.05873085
HSP90AB1\tS226\t-0.009335519
HSP90AB1\tS255\t0.002912582
HSP90AB1\tS261\t-0.003235265
HSP90AB1\tS445\t0.060725815
HSP90AB1\tS452\t0.001297885
HSP90AB1\tS718\t-0.2107299
HSP90B1\tS746\t-0.2470117
HSPA12A\tS23\t0.4455148
HSPA4\tS647\t0.1873877
HSPA4\tS76\t0.2017593
HSPA4\tS780\t-0.119951675
HSPA4\tT538\t-0.4965495
HSPA8\tS2\t-0.08123219
HSPA8\tS221\t0.2713062
HSPA8\tS541\t-0.113550665
HSPA9\tS627\t0.07880442
HSPB1\tS15\t-0.8224521
HSPB1\tS176\t-0.2599618
HSPB1\tS199\t-0.2161159
HSPB1\tS65\t-1.952601
HSPB1\tS82\t-0.7955087
HSPB1\tT202\t-0.1644316
HSPBP1\tS354\t-0.2200428
HSPD1\tS252\t0.14595785
HSPD1\tS253\t0.1088924
HSPD1\tS410\t0.230203
HSPD1\tS488\t0.1877678
HSPD1\tS70\t-0.01527212
HSPD1\tT164\t0.160124832
HSPE1\tS51\t0.087414472
HSPE1\tS53\t-0.009567836
HSPE1\tS64\t-1.0251339
HSPH1\tS809\t-0.00844007
HSPH1\tT815\t-0.1521474
HTATSF1\tS453\t0.1547128
HTATSF1\tS481\t0.1393385
HTATSF1\tS529\t-0.2626074
HTATSF1\tS579\t0.05130255
HTATSF1\tS597\t-0.1697192
HTATSF1\tS600\t-0.1697192
HTATSF1\tS607\t-0.2178263
HTATSF1\tS616\t0.06322686
HTATSF1\tS624\t-0.08411971
HTATSF1\tS642\t0.08867649
HTATSF1\tS676\t-0.04450865
HTATSF1\tS702\t-0.01805973
HTATSF1\tS713\t-0.106762605
HTATSF1\tS714\t0.06915226
HTATSF1\tS721\t0.069468065
HTR7\tS285\t0.2073932
HTT\tS1179\t0.7121115
HTT\tS1199\t-0.0565512
HTT\tS1874\t-0.3063234
HTT\tS419\t0.1145003
HTT\tS432\t-0.01907205
HUWE1\tS1368\t-0.05231144
HUWE1\tS1395\t0.01178193
HUWE1\tS1903\t-1.4078715
HUWE1\tS1907\t-0.61318016
HUWE1\tS2362\t0.029775975
HUWE1\tS2365\t0.2149951
HUWE1\tS2370\t0.2033009
HUWE1\tS2595\t-0.3540348
HUWE1\tS2887\t-0.087414825
HUWE1\tS2888\t-0.22348516
HUWE1\tS2940\t-0.4718688
HUWE1\tS3662\t-0.6278948
HUWE1\tS3752\t-1.0522727
HUWE1\tS3757\t-0.70547905
HUWE1\tS3808\t-0.11954405
HUWE1\tS3816\t-0.1259506
HUWE1\tS3919\t-1.394032
HUWE1\tT1722\t-0.3530264
HUWE1\tT2366\t0.10172015
HUWE1\tT2889\t-0.3561438
HUWE1\tT3924\t-0.1148535
HYLS1\tS147\t0.6307783
HYLS1\tS297\t-0.7094812
HYOU1\tS582\t0.501982565
IARS\tS1047\t0.09191805
IARS\tS1049\t-0.04646712
IBTK\tS844\t0.03238294
ICAM1\tT521\t0.3392514
ICAM1\tT530\t0.01249718
IER3\tS31\t-2.143054
IER3\tT37\t-2.05322046
IFFO1\tS132\t-0.0501546
IFFO1\tS379\t0.80268185
IFI16\tS10\t-0.004305641
IFI16\tS106\t-0.1496966
IFI16\tS153\t0.02026661
IFI16\tS463\t-0.055094325
IFI16\tS8\t-0.004305641
IFI16\tT123\t0.3813941
IFIH1\tS301\t-0.07034535
IFNAR1\tS426\t0.08188502
IFNAR2\tS384\t-0.112751896
IFNAR2\tS400\t-0.1146131
IFNGR1\tS299\t-0.97159925
IFRD2\tS195\t-0.4728516
IFRD2\tS197\t-0.4728516
IFRD2\tS198\t-0.4728516
IFT140\tS1443\t-1.499973
IFT140\tS360\t0.00302647
IFT43\tS78\t-1.338287
IFT88\tS105\t-1.841094
IGF2BP1\tS181\t-0.01949203
IGF2BP2\tS162\t-0.06760033
IGF2BP2\tS164\t-0.01854207
IGF2BP2\tT507\t-0.05316439
IGF2BP3\tT528\t-0.21525799
IGF2R\tS2409\t0.01478381
IGFBP3\tS201\t0.36828327
IGFBP5\tS116\t0.5145551
IGFBP5\tS125\t0.53686235
IGFBP5\tS179\t0.6997293
IGFBP5\tT123\t0.6506306
IGFBP5\tT124\t0.61146745
IKBKB\tS613\t0.09071802
IKBKB\tS636\t0.1283081
IKBKB\tS638\t0.7897263
IKBKG\tS19\t-0.309824195
IKBKG\tS386\t-0.002006713
IKZF2\tS56\t0.1444379
IL16\tS566\t-0.06589875
IL16\tS798\t0.375196
IL17RA\tS674\t-0.6088921
IL1RAP\tS555\t-0.005782364
IL1RAP\tS557\t0.0559992
ILF2\tS52\t0.108272065
ILF2\tS68\t0.03083044
ILF2\tS73\t0.08301003
ILF2\tS76\t-0.075629173
ILF3\tS382\t0.1055439
ILF3\tS384\t0.04054174
ILF3\tS476\t0.062869085
ILF3\tS477\t-0.04367569
ILF3\tS482\t-0.137572035
ILF3\tS506\t0.160259389
ILF3\tS62\t-0.085956
ILF3\tT486\t-0.17229475
ILF3\tT504\t-0.092800875
ILF3\tT596\t0.291132
ILKAP\tS13\t-0.2102457
IMMT\tS113\t0.4495945
IMMT\tT576\t0.13711245
IMMT\tT578\t-0.129817315
IMPACT\tS297\t0.27276757
IMPDH1\tS176\t0.17766165
IMPDH1\tT6\t-0.5997025
IMPDH2\tS122\t0.03998062
IMPDH2\tS160\t0.07395734
IMPDH2\tS416\t0.1809117
INADL\tS522\t0.02189474
INADL\tS645\t-0.1232139
INCENP\tS119\t0.41694245
INCENP\tS143\t-0.2116651
INCENP\tS197\t0.1963552
INCENP\tS214\t0.1963552
INCENP\tS263\t-0.171076
INCENP\tS275\t0.2613503
INCENP\tS291\t0.4416959
INCENP\tS306\t-0.03907317
INCENP\tS311\t0.19300679
INCENP\tS314\t0.500904
INCENP\tS421\t0.057443995
INCENP\tS72\t0.3470986
INCENP\tS824\t0.3245803
INCENP\tS827\t0.3245803
INCENP\tT213\t0.1963552
INCENP\tT239\t0.02828617
INCENP\tT292\t0.5535571
INCENP\tT828\t0.3245803
INF2\tS1183\t-0.1222243
INF2\tS1188\t-0.01359632
INF2\tS1192\t0.09207205
INF2\tS1204\t-0.037136345
INF2\tS372\t-0.06781787
INF2\tS589\t-0.134778085
INF2\tT1179\t-0.1065912
INF2\tT1187\t0.08011265
INF2\tT1206\t-0.3189016
ING5\tS118\t0.123931
INO80\tS1512\t0.1513393
INO80\tS1516\t-0.5222397
INO80\tS236\t-0.3067517
INO80B\tS127\t0.59490195
INO80B\tS132\t0.542633375
INO80B\tS63\t-0.04944745
INO80C\tT13\t0.47726625
INO80D\tS130\t-0.09673025
INO80D\tS132\t-0.01393134
INO80E\tS154\t0.4458326
INO80E\tT90\t0.2659169
INPP4A\tS487\t-0.0449997
INPP4A\tT489\t-0.4759927
INPP5E\tS241\t-0.3828332
INPP5E\tS99\t-0.208011
INPP5F\tS1103\t-0.09100267
INPP5F\tS668\t-0.06310771
INPP5F\tS827\t0.004752986
INPP5F\tS830\t-0.094161985
INPP5F\tS940\t-0.2490163
INPP5F\tS942\t-0.03744355
INPPL1\tS1003\t-0.7859249
INPPL1\tS132\t-0.03896945
INTS1\tS1327\t0.1027253
INTS1\tS1395\t0.35107045
INTS1\tS307\t-0.0628967
INTS10\tS231\t-0.1045733
INTS10\tS381\t0.1414329
INTS10\tS382\t0.028725415
INTS12\tS128\t0.0610158
INTS3\tS499\t-0.07946331
INTS3\tS501\t-0.03503213
INTS3\tS536\t-0.4279447
INTS5\tS1010\t-0.007507107
INTS5\tS279\t0.154972
INTS6\tS137\t0.16852962
INTS9\tS143\t-0.1005923
INTU\tS655\t-0.01442668
INVS\tS614\t-0.05169819
IP6K1\tS212\t-0.0463101
IPO11\tS342\t-0.1940581
IQCE\tS284\t0.34137255
IQCE\tS574\t0.114367
IQCE\tT248\t-0.01930195
IQCE\tT255\t0.234040775
IQCE\tT256\t-0.102507225
IQCE\tT5\t-0.4455749
IQCJ-SCHIP1\tS90\t0.1570437
IQGAP1\tS1147\t-0.008217905
IQGAP1\tS2\t-0.1951204
IQGAP1\tS482\t0.06253617
IQGAP3\tS496\t-0.05105278
IQGAP3\tT1372\t-0.06181205
IQSEC1\tS166\t-0.33924205
IQSEC1\tS498\t0.1129003
IQSEC1\tS926\t-0.1466271
IQSEC1\tS941\t-0.063404395
IRAK1\tS131\t-0.6323382
IRF2BP1\tS125\t0.283092
IRF2BP1\tS186\t0.3991163
IRF2BP1\tS384\t-0.07860939
IRF2BP1\tS421\t-0.08379852
IRF2BP1\tS436\t0.01963077
IRF2BP1\tS453\t0.06626152
IRF2BP2\tS131\t0.2692725
IRF2BP2\tS175\t0.09153062
IRF2BP2\tS240\t-0.6995131
IRF2BP2\tS344\t-0.09657606
IRF2BP2\tS380\t-0.0344736
IRF2BP2\tS383\t0.1054098
IRF2BP2\tS390\t0.096927585
IRF2BP2\tS393\t0.032533913
IRF2BP2\tS439\t-0.007811666
IRF2BP2\tS441\t0.26058685
IRF2BP2\tS444\t0.02361021
IRF2BP2\tS446\t0.29628165
IRF2BP2\tT376\t-0.3325555
IRF2BP2\tT388\t-0.055895935
IRF2BPL\tS215\t-0.02577904
IRF2BPL\tS334\t-0.732267
IRF2BPL\tS547\t-0.08242314
IRF2BPL\tS657\t-0.1953847
IRF2BPL\tS658\t-0.331642675
IRF2BPL\tS659\t0.3527585
IRF2BPL\tS662\t-0.2713916
IRF3\tS27\t-2.281667
IRS1\tS1101\t-0.1267065
IRS1\tS3\t-0.2251265
IRS1\tS307\t-0.197418
IRS1\tS312\t-0.02240502
IRS1\tS330\t-0.1913431
IRS1\tS345\t0.3131298
IRS1\tS348\t0.2045164
IRS1\tS503\t0.4042536
IRS1\tS766\t0.126171155
IRS1\tT446\t0.08106696
IRS1\tT453\t0.08106696
IRS2\tS1162\t0.17856219
IRS2\tS1174\t-1.0993973
IRS2\tS1176\t0.1382902
IRS2\tS1203\t-1.491713
IRS2\tS1237\t0.57275383
IRS2\tS306\t0.184046725
IRS2\tS365\t-0.8522764
IRS2\tS384\t0.4098937
IRS2\tS388\t0.3459641
IRS2\tS391\t0.2419622
IRS2\tS560\t-0.0752616
IRS2\tS577\t0.2436691
IRS2\tS594\t-0.1609756
IRS2\tS608\t0.1828194
IRS2\tS679\t-1.335481
IRS2\tS730\t-0.223145875
IRS2\tS735\t0.097010545
IRS2\tS736\t0.08841301
IRS2\tS752\t0.2188431
IRS2\tS828\t1.0778857
IRS2\tS973\t0.0494913
IRS2\tT350\t0.4827451
IRS2\tT520\t0.3502709
IRS2\tT527\t-0.32540995
IRX5\tS180\t0.22007405
IRX5\tS311\t0.8850276
IRX5\tS317\t0.9429103
ISCU\tS14\t0.02672926
ITCH\tS180\t-0.66302165
ITCH\tS199\t0.293135
ITFG2\tS220\t0.07162537
ITFG2\tT218\t0.2076286
ITFG3\tS21\t0.1008431
ITGA4\tS1011\t0.51548005
ITGA4\tS1021\t0.06956466
ITGA5\tS128\t0.02644594
ITGB1\tT777\t-0.2167529
ITGB1BP1\tS34\t-0.06804466
ITGB1BP1\tT38\t-0.1937997
ITGB3\tT767\t-0.09152971
ITGB3\tT777\t0.23158005
ITGB3\tT779\t0.2951353
ITGB5\tS770\t-0.254552523
ITM2C\tT37\t-0.3018884
ITPKA\tS20\t0.1886542
ITPKB\tS120\t-1.103116
ITPKB\tS174\t-0.156072715
ITPKB\tS176\t-0.05906558
ITPKB\tS204\t-0.271026
ITPKB\tS269\t0.04530324
ITPKB\tS355\t-0.6044545
ITPKB\tS43\t-3.94864
ITPKB\tS447\t0.373509
ITPKB\tS49\t-3.628769
ITPKB\tS65\t-0.6137189
ITPKB\tT202\t-0.31635449
ITPKB\tT33\t-0.02291795
ITPKB\tT449\t0.431393
ITPKC\tT336\t0.4321042
ITPR1\tS1701\t-0.1196044
ITPR2\tS1160\t-0.9524617
ITPR2\tS2633\t0.2373189
ITPR3\tS1832\t0.3965339
ITPR3\tS2609\t0.3094091
ITPR3\tS2670\t0.03646811
ITPR3\tS916\t0.09328973
ITPR3\tS934\t0.587557
ITPR3\tT795\t0.01777946
ITPRIPL2\tS139\t-0.4729712
ITSN2\tS210\t0.3356313
ITSN2\tS857\t-0.14032738
ITSN2\tS860\t-0.2804923
ITSN2\tS862\t-0.034594825
ITSN2\tY941\t-0.5231517
IVNS1ABP\tS322\t0.7211539
IVNS1ABP\tS326\t0.7211539
IWS1\tS11\t-0.003220786
IWS1\tS157\t-0.056014813
IWS1\tS159\t0.00287928
IWS1\tS196\t-0.042614148
IWS1\tS198\t-0.003278616
IWS1\tS209\t-0.2048814
IWS1\tS211\t-0.2047483
IWS1\tS222\t-0.2048814
IWS1\tS224\t-0.2048814
IWS1\tS235\t-0.05841782
IWS1\tS237\t-0.086854075
IWS1\tS248\t-0.02773377
IWS1\tS25\t-0.15635518
IWS1\tS250\t-0.02273907
IWS1\tS252\t-0.02773377
IWS1\tS27\t-0.24615244
IWS1\tS287\t-0.03584551
IWS1\tS289\t-0.083754528
IWS1\tS300\t-0.04333369
IWS1\tS302\t-0.04333369
IWS1\tS304\t0.081338615
IWS1\tS313\t-0.036117625
IWS1\tS315\t0.089256105
IWS1\tS348\t0.120352
IWS1\tS363\t0.192954355
IWS1\tS365\t0.192954355
IWS1\tS377\t-0.02626384
IWS1\tS398\t-0.075771845
IWS1\tS400\t-0.18264196
IWS1\tS415\t0.09877915
IWS1\tS420\t0.09877915
IWS1\tS422\t0.09877915
IWS1\tS426\t0.17572615
IWS1\tS429\t0.17572615
IWS1\tS438\t-0.34011115
IWS1\tS440\t0.1926992
IWS1\tS49\t0.07093885
IWS1\tS511\t-0.02448724
IWS1\tS513\t-0.02448724
IWS1\tS54\t0.10796224
IWS1\tS69\t0.246712
IWS1\tS7\t-0.07509635
IWS1\tS720\t-1.294774
IWS1\tS80\t0.154324
IWS1\tS82\t0.154324
IWS1\tT17\t-0.003220786
IWS1\tT67\t0.246712
IWS1\tT725\t0.7774513
JDP2\tT148\t-0.5680346
JMJD1C\tS1046\t0.15406255
JMJD1C\tS135\t-0.98261205
JMJD1C\tS138\t-0.6716001
JMJD1C\tS1825\t-0.07576323
JMJD1C\tS1871\t0.07368314
JMJD1C\tS435\t0.01275351
JMJD1C\tS761\t0.5463635
JMJD1C\tT1870\t0.05491792
JMY\tS115\t0.3290661
JMY\tS713\t-0.1388387
JMY\tS877\t-0.001732303
JOSD1\tS15\t9.31E-05
JPH1\tS465\t0.3341269
JRK\tS409\t0.2868812
JUN\tS100\t-1.303472
JUN\tS243\t-1.838166
JUN\tS63\t-1.8923775
JUN\tT62\t-1.324022
JUNB\tS251\t-0.1686254
JUNB\tS259\t-0.5664423
JUNB\tT255\t-0.1812149
JUND\tS255\t0.60309795
JUND\tS90\t-0.8956097
KANK1\tS167\t-0.1587676
KANK1\tS28\t-0.179482
KANK1\tS723\t-0.00028853
KANK1\tS84\t-0.3104861
KANK2\tS158\t-0.3712917
KANK2\tS19\t-0.987312
KANK2\tS323\t-0.3316449
KANK2\tS375\t0.03224201
KANK2\tS478\t-0.293616
KANK2\tS548\t-0.8839813
KANK2\tT14\t-0.1984477
KANSL1\tS1045\t0.14495259
KANSL1\tS1082\t-0.194724
KANSL1\tS249\t0.06174313
KANSL1\tS268\t0.03717139
KANSL1\tS991\t-0.260889095
KANSL1\tS994\t0.04656085
KANSL1\tT1003\t-0.6398717
KANSL1L\tS714\t-1.4085405
KANSL2\tS351\t0.02019986
KANSL2\tS355\t0.02019986
KANSL2\tS358\t0.02019986
KANSL2\tT314\t0.21540515
KANSL3\tS536\t0.22916055
KANSL3\tS539\t0.339023575
KANSL3\tS540\t0.3154503
KAT5\tS103\t-0.02053593
KAT5\tS86\t0.3427823
KAT5\tS90\t0.3427823
KAT6A\tS1090\t0.09329845
KAT6A\tS448\t-0.79027545
KAT6A\tS473\t0.10742
KAT6A\tT1142\t0.3107449
KAT6B\tS420\t0.2092662
KAT7\tS100\t-0.276726175
KAT7\tS102\t-0.288891003
KAT7\tS124\t0.278084769
KAT7\tS57\t0.5628652
KAT7\tS99\t-0.230517275
KAT7\tT88\t0.1094274
KAT8\tS348\t-0.118541295
KAT8\tS37\t-0.1287083
KATNA1\tS170\t0.2053925
KATNA1\tS93\t-0.3273484
KATNAL1\tS174\t0.1676149
KAZN\tS340\t0.49598605
KAZN\tS346\t0.49598605
KAZN\tS8\t0.0889556
KBTBD11\tS107\t0.1710787
KBTBD8\tY60\t0.3691593
KCNMA1\tS572\t1.1541335
KCNN4\tS367\t-0.01035232
KCNQ5\tS448\t0.1583371
KCNQ5\tS893\t-0.35742355
KCNQ5\tT450\t0.2609891
KCTD1\tS551\t-0.2179055
KCTD12\tS185\t-0.0918942
KCTD12\tT196\t-1.4985665
KCTD15\tS35\t0.077104673
KCTD15\tS38\t-0.045124057
KCTD3\tS741\t0.02559065
KCTD3\tS791\t-0.6861273
KCTD5\tS10\t0.305095
KDELR3\tS209\t-0.240104665
KDM1A\tS131\t-0.210229
KDM1A\tS137\t-0.210229
KDM1A\tS166\t-0.1159726
KDM1A\tS69\t-0.3230466
KDM1B\tS17\t0.1032627
KDM2A\tS28\t0.03689012
KDM2A\tS558\t0.41120115
KDM2A\tS692\t-0.04522302
KDM2A\tS718\t-0.254766518
KDM2A\tS731\t-0.02388648
KDM2A\tT550\t0.5291712
KDM2A\tT713\t-0.8388733
KDM2B\tS906\t-0.03239995
KDM2B\tS910\t-0.03239995
KDM2B\tS962\t0.068602
KDM3A\tS273\t0.0569371
KDM3A\tS393\t-0.1202786
KDM3A\tS411\t0.24732
KDM3B\tS1253\t-0.33401605
KDM3B\tS289\t-2.449218
KDM3B\tS314\t0.4286517
KDM3B\tS779\t0.07147495
KDM4A\tS523\t0.1244606
KDM4B\tS566\t-1.433234
KDM5A\tS1331\t0.70331653
KDM5A\tS1438\t0.26584485
KDM5A\tS1488\t0.1314578
KDM5A\tS1598\t0.3049782
KDM5A\tS1603\t0.3049782
KDM5A\tS1666\t-0.368756
KDM5A\tS204\t0.001874253
KDM5C\tS1359\t-0.1344295
KDM5C\tS301\t-0.1198396
KDM6A\tS367\t-0.1936842
KDM6B\tS224\t-0.006970587
KHDRBS1\tS18\t-0.1149099
KHDRBS1\tS20\t-0.5363566
KHNYN\tS359\t-0.2899508
KHSRP\tS181\t-0.04945692
KHSRP\tS184\t-0.3286842
KHSRP\tS193\t-0.4280641
KHSRP\tT100\t0.1674864
KIAA0100\tS1951\t-0.08736544
KIAA0195\tS105\t-0.06599133
KIAA0195\tS81\t-0.1654667
KIAA0195\tS96\t-0.3381957
KIAA0226\tS388\t-0.1243143
KIAA0232\tS156\t0.3257317
KIAA0317\tS327\t-1.593006
KIAA0319L\tS415\t0.0327697
KIAA0355\tS723\t-0.2821229
KIAA0430\tS1406\t0.044396655
KIAA0556\tS1163\t0.3781787
KIAA0556\tS453\t0.000576887
KIAA0556\tS660\t-0.249091
KIAA0556\tS718\t-0.642144
KIAA0556\tS777\t0.2282337
KIAA0753\tS190\t-0.24221415
KIAA0753\tS287\t0.003416105
KIAA0753\tS821\t-0.3681224
KIAA0753\tS826\t-0.3962514
KIAA0754\tS181\t-0.154927015
KIAA0754\tS25\t-0.1869023
KIAA0754\tS53\t0.02261638
KIAA0754\tS64\t-0.2053804
KIAA0754\tS666\t-0.1419076
KIAA0754\tT122\t0.01135251
KIAA0754\tT179\t0.032894895
KIAA0930\tS233\t0.6881356
KIAA0930\tS245\t-1.4137665
KIAA0930\tS255\t-0.7318047
KIAA0930\tS270\t-0.1558393
KIAA0930\tS272\t0.1118326
KIAA0930\tS290\t-0.1607499
KIAA0930\tS328\t-0.4844894
KIAA0930\tT259\t-0.4096928
KIAA0947\tS1692\t0.068605735
KIAA0947\tS1712\t0.033731305
KIAA0947\tS1854\t0.2611096
KIAA0947\tS1903\t0.1360601
KIAA0947\tS255\t-0.00028853
KIAA0947\tS516\t0.378938
KIAA0947\tS533\t0.050920648
KIAA0947\tS925\t-0.2392425
KIAA0947\tS960\t-0.32050035
KIAA0947\tT1642\t-0.01333419
KIAA1033\tS1157\t-0.1000665
KIAA1109\tS1354\t-0.26986
KIAA1109\tS2367\t-0.3716651
KIAA1109\tS2726\t0.05916685
KIAA1109\tS2754\t-0.000750383
KIAA1109\tS3652\t-2.37932
KIAA1109\tS3705\t-1.866597
KIAA1109\tS4893\t-0.310683
KIAA1109\tS628\t-0.20667555
KIAA1109\tT3700\t-1.949422
KIAA1109\tT3995\t-0.9742908
KIAA1143\tS50\t0.088239605
KIAA1211\tS1010\t0.6623878
KIAA1211\tS125\t-0.820438
KIAA1211\tS867\t-1.502914
KIAA1211\tS968\t-1.820056
KIAA1211\tT964\t-1.820056
KIAA1429\tS133\t-0.123764
KIAA1429\tS138\t-0.03185759
KIAA1429\tS1579\t0.08624023
KIAA1429\tS173\t0.02062666
KIAA1429\tS222\t-0.06130017
KIAA1429\tT184\t-0.1556947
KIAA1430\tS218\t1.0215918
KIAA1432\tS909\t0.4534386
KIAA1468\tS170\t-0.4249007
KIAA1468\tS180\t0.029665857
KIAA1468\tS186\t-0.106483686
KIAA1468\tS193\t0.11703
KIAA1468\tS453\t0.07093885
KIAA1468\tS51\t0.210864245
KIAA1468\tS54\t-0.30371178
KIAA1468\tS56\t-0.195224255
KIAA1468\tT183\t-0.106483686
KIAA1468\tT88\t0.20309655
KIAA1522\tS379\t0.08179667
KIAA1522\tS545\t-0.4111955
KIAA1522\tS862\t0.4189995
KIAA1522\tS929\t-0.100778
KIAA1522\tT162\t0.14394888
KIAA1549\tS1345\t-0.270587965
KIAA1549L\tS1274\t0.1981169
KIAA1549L\tS1310\t0.1036654
KIAA1549L\tS1333\t-0.09483393
KIAA1549L\tS1543\t-0.08036248
KIAA1549L\tS1546\t0.05755419
KIAA1551\tS868\t-0.3344618
KIAA1598\tS407\t-0.0740006
KIAA1598\tS434\t-0.06846822
KIAA1598\tS446\t0.01235413
KIAA1614\tS728\t-0.1465952
KIAA1671\tS1224\t0.1064823
KIAA1671\tS284\t0.0476273
KIAA1671\tS508\t0.08256635
KIAA1671\tS749\t-0.7478266
KIAA1671\tT600\t-0.66792405
KIAA1704\tS105\t-0.0141644
KIAA1731\tS1388\t-0.2517277
KIAA1737\tS302\t0.24654355
KIAA1755\tS426\t-0.6229762
KIAA1755\tS429\t-0.97734505
KIAA1755\tS462\t0.121387725
KIAA1755\tS463\t0.4635179
KIAA1755\tS548\t-0.06506837
KIAA1958\tS97\t-0.321114135
KIAA1967\tS124\t0.01135251
KIAA1967\tS569\t0.02545406
KIAA1967\tS627\t0.01478381
KIAA1967\tS675\t0.1307991
KIAA1967\tS678\t0.1294808
KIAA1967\tS681\t0.1372412
KIAA1967\tT35\t0.4899927
KIAA1967\tT484\t-0.057384025
KIAA2026\tS527\t0.27854475
KIDINS220\tS1502\t-0.057614954
KIDINS220\tS1507\t0.004669815
KIDINS220\tS1536\t-0.5937245
KIDINS220\tS885\t-0.0512347
KIDINS220\tS918\t0.1151664
KIDINS220\tT1509\t-0.03348874
KIF11\tT926\t0.5848663
KIF13A\tS1650\t-0.4896254
KIF13B\tS1381\t0.2012575
KIF13B\tS1400\t0.11503415
KIF13B\tS1410\t0.3929768
KIF13B\tS1432\t-0.081118525
KIF13B\tS1497\t0.2848694
KIF13B\tS1644\t0.4253519
KIF13B\tS1797\t-0.004899065
KIF14\tS12\t0.3873625
KIF14\tS1200\t0.2283569
KIF14\tT915\t0.0132123
KIF15\tS1044\t-2.622643
KIF16B\tS1100\t-0.7419909
KIF16B\tS1172\t-0.2286553
KIF16B\tS582\t0.1839629
KIF18B\tS404\t-0.1126307
KIF18B\tS642\t1.029559
KIF18B\tS825\t0.2635152
KIF18B\tT677\t0.1268407
KIF1B\tS1011\t-0.1556947
KIF1B\tS1141\t-0.04068977
KIF1B\tS1408\t0.002450562
KIF1B\tS1441\t0.05227683
KIF1B\tS1567\t-0.4005488
KIF1B\tS663\t-0.03148894
KIF1B\tS665\t-0.03148894
KIF1C\tS494\t0.107826025
KIF20A\tS514\t0.1329059
KIF21A\tS1176\t-0.3563285
KIF21A\tS1203\t0.06515872
KIF22\tS475\t0.3444877
KIF22\tS494\t-2.130049
KIF22\tT395\t0.4325002
KIF23\tS682\t0.42124421
KIF23\tS684\t0.002154555
KIF23\tS686\t-0.09793703
KIF23\tS867\t0.04362443
KIF23\tS902\t0.5823634
KIF23\tS911\t-1.1554255
KIF24\tS439\t0.5062973
KIF24\tS440\t0.023208718
KIF24\tS450\t0.282390885
KIF24\tS502\t0.5613017
KIF24\tS512\t0.5463635
KIF24\tS887\t0.46564745
KIF24\tT872\t-0.06671332
KIF26B\tS1117\t0.5180315
KIF26B\tS1298\t-0.0201487
KIF26B\tS1304\t0.141218865
KIF26B\tS1379\t0.02991098
KIF26B\tS1390\t-0.373235095
KIF26B\tS1575\t0.4848943
KIF26B\tS749\t0.3772904
KIF26B\tT743\t0.3772904
KIF2A\tS113\t0.3302083
KIF2C\tS115\t0.888227
KIF3A\tS687\t-0.5781762
KIF4A\tS1001\t0.4462498
KIF4A\tS394\t0.52674845
KIF4A\tS801\t-0.7257801
KIF4A\tS815\t0.314417715
KIF4A\tS961\t0.364125
KIF4A\tT1161\t0.2941116
KIF4A\tT1181\t0.2251515
KIF4A\tT799\t0.6520046
KIF5B\tS933\t-0.1832283
KIF5B\tS938\t-0.05809745
KIF5B\tT935\t-0.09383028
KIF5C\tS935\t-0.2260453
KIFAP3\tS16\t-0.15444616
KIFC1\tS6\t0.1394695
KIRREL\tS560\t-0.1439944
KIRREL\tT563\t-0.2899811
KLC1\tS460\t0.07368314
KLC1\tS521\t-0.04821826
KLC1\tS591\t0.03674946
KLC2\tS151\t-0.2751752
KLC2\tS445\t0.311038
KLC2\tS582\t-0.1342712
KLC2\tS589\t0.095722
KLC2\tS610\t0.09801521
KLC4\tS519\t-0.4563062
KLC4\tS565\t-0.060059427
KLC4\tS590\t0.03149354
KLF12\tS202\t-0.3162407
KLF12\tT209\t-0.33186465
KLF13\tS162\t0.5144809
KLF16\tS109\t0.1130337
KLF16\tS52\t-0.01781133
KLF3\tS250\t0.2969562
KLF6\tS171\t-0.5048165
KLF9\tS122\t-0.7759103
KLHDC4\tS382\t-0.037142483
KLHDC4\tS387\t-0.007434585
KLHL13\tS603\t-0.6213108
KLHL22\tT605\t-0.1825404
KLHL24\tS19\t0.80479275
KLHL9\tS603\t-0.7552347
KNOP1\tS265\t0.533195
KPNA1\tT3\t0.09031146
KPNA2\tS490\t0.8976871
KPNA2\tS62\t0.2715452
KPNA2\tT9\t0.6577315
KPNA3\tS60\t0.1106305
KPNA4\tS60\t0.1583371
KPNA6\tS3\t0.07395734
KPNA6\tS6\t0.3926472
KRBA1\tS253\t-0.6249106
KRI1\tS136\t0.070168485
KRI1\tS171\t-0.1006851
KRI1\tS309\t0.30404585
KRI1\tS628\t-0.018127535
KRI1\tS639\t-0.05735972
KRIT1\tT151\t-0.04034645
KRR1\tS3\t0.2202061
KRTCAP2\tT124\t0.1068843
KSR1\tT133\t0.2585793
KSR1\tT137\t0.2585793
KTI12\tS184\t-0.7392517
KTN1\tS1313\t0.006190286
KTN1\tS75\t0.146898295
KTN1\tS77\t0.2189671
KTN1\tS79\t0.3041605
KTN1\tT153\t0.1509495
L1CAM\tS1172\t0.1430015
L3MBTL1\tS117\t0.02304246
L3MBTL2\tS67\t-0.16149764
L3MBTL2\tS683\t0.1723594
L3MBTL2\tS689\t0.06805168
L3MBTL2\tS73\t-0.3735889
L3MBTL2\tT66\t-0.01103595
L3MBTL2\tT76\t-0.091943505
L3MBTL3\tS608\t-0.3927241
LAD1\tS64\t-2.145157
LAMTOR1\tS27\t0.13505105
LAMTOR1\tS55\t-0.05166824
LAMTOR1\tS56\t0.07436837
LAMTOR1\tS97\t-0.20208305
LARP1\tS143\t-0.1439625
LARP1\tS517\t-0.21911065
LARP1\tS521\t-0.19628855
LARP1\tS548\t-0.1146755
LARP1\tS627\t-0.18322425
LARP1\tS631\t-0.11686204
LARP1\tS75\t-0.0713151
LARP1\tS766\t-0.144726145
LARP1\tS774\t-0.07812175
LARP1\tS824\t-0.2461901
LARP1\tS868\t0.045912105
LARP1\tS90\t-0.1069175
LARP1\tT1071\t-0.4322988
LARP1\tT376\t-1.463708
LARP1\tT526\t0.06942715
LARP1\tT649\t0.03125411
LARP1\tT724\t0.43858395
LARP1\tT856\t0.049571555
LARP1\tT865\t-0.036178515
LARP1B\tS60\t0.1088924
LARP1B\tS841\t0.10165
LARP1B\tT407\t-0.07453221
LARP4\tS512\t-0.2814389
LARP4\tS526\t0.2617113
LARP4B\tS398\t-0.4759965
LARP4B\tS434\t-0.72839905
LARP4B\tS568\t-0.802512
LARP4B\tS599\t0.05389011
LARP4B\tS601\t0.0880058
LARP4B\tS664\t-1.216988
LARP4B\tS736\t-0.4785384
LARP6\tS409\t0.1751732
LARP6\tS56\t-0.54274695
LARP7\tS258\t-0.2361739
LARP7\tS261\t0.057123795
LARP7\tS265\t0.32850135
LARP7\tS286\t0.2192151
LARP7\tS298\t-0.5445848
LARP7\tS299\t-1.410653175
LARP7\tS305\t-0.8311048
LARP7\tS337\t0.018499265
LARP7\tS350\t0.3307878
LARP7\tS351\t-0.2249242
LARP7\tT338\t0.01660436
LAS1L\tS543\t0.1043367
LAS1L\tS600\t0.01049345
LAS1L\tT596\t-0.077448365
LAS1L\tT602\t0.1070183
LAS2\tS161\t-1.402626
LASP1\tS146\t0.2465906
LASP1\tT104\t0.5635487
LASP1\tT68\t0.5483379
LATS1\tS464\t0.2457391
LATS1\tS613\t0.062755815
LATS1\tT262\t0.08542464
LATS2\tS576\t0.1288213
LCMT2\tS20\t0.1186256
LCORL\tS282\t-0.3018349
LDB1\tS266\t-0.3691472
LDHA\tY239\t0.177599
LEF1\tS42\t-0.07454742
LEMD2\tS134\t-0.2657954
LEMD2\tS138\t0.32816315
LEMD2\tS139\t0.32816315
LEMD2\tS174\t-0.6422316
LEMD2\tS499\t0.07231157
LEMD2\tS5\t0.3083608
LEMD3\tS144\t0.17348415
LEMD3\tS187\t0.1584662
LEMD3\tS19\t-0.426703
LEMD3\tS259\t-0.10745964
LEMD3\tS261\t-0.1757127
LEMD3\tS27\t0.49462995
LEMD3\tT365\t-0.5723857
LENG9\tS416\t-0.2327351
LEO1\tS10\t0.001153714
LEO1\tS14\t-0.088208943
LEO1\tS162\t-0.006564787
LEO1\tS171\t0.03787417
LEO1\tS179\t0.03787417
LEO1\tS197\t-0.01295008
LEO1\tS205\t0.1483484
LEO1\tS212\t0.02591417
LEO1\tS220\t0.02591417
LEO1\tS229\t-0.01302711
LEO1\tS238\t-0.01302711
LEO1\tS273\t0.1311943
LEO1\tS277\t-0.01252345
LEO1\tS279\t-0.1562412
LEO1\tS294\t0.09477648
LEO1\tS296\t0.09477648
LEO1\tS300\t0.02133754
LEO1\tS607\t-0.17573916
LEO1\tS608\t-0.17573916
LEO1\tS610\t-0.17573916
LEO1\tS630\t0.020031675
LEO1\tS658\t0.01049345
LEO1\tS66\t-0.020790557
LEO1\tT188\t0.1174291
LEO1\tT629\t0.06545936
LGALS1\tS30\t0.1365852
LIG1\tS111\t0.04334458
LIG1\tS170\t-0.07264963
LIG1\tS21\t0.08093054
LIG1\tS36\t-0.031665161
LIG1\tS46\t0.02238825
LIG1\tS770\t0.170149445
LIG1\tT151\t0.1805297
LIG1\tT152\t0.181675
LIG1\tT164\t0.1610493
LIG3\tS210\t-0.1000356
LIG3\tS241\t0.00121685
LIG3\tS242\t0.0415233
LIMA1\tS202\t-0.01635697
LIMA1\tS205\t-0.1989461
LIMA1\tS209\t-0.01409163
LIMA1\tS214\t0.154191605
LIMA1\tS329\t-0.2622959
LIMA1\tS525\t-0.05790554
LIMA1\tS537\t-0.48017055
LIMCH1\tS144\t-1.7519755
LIMCH1\tS364\t0.6776209
LIMCH1\tS511\t0.246712
LIMCH1\tS559\t-0.3018349
LIMCH1\tS58\t0.1915555
LIMCH1\tS72\t0.123726355
LIMCH1\tS813\t0.5216539
LIMCH1\tT56\t0.2440345
LIMD1\tS272\t0.2260152
LIMD1\tS277\t-1.541282
LIMD1\tS314\t-0.3682159
LIMD1\tS384\t-0.50226
LIMD1\tS424\t-1.0542953
LIMK1\tS196\t0.3702759
LIMK1\tS288\t-1.1970225
LIMK1\tS296\t0.073225745
LIN28B\tS203\t0.00935353
LIN28B\tS25\t0.024036
LIN37\tS135\t0.1836641
LIN37\tS138\t-0.16730385
LIN37\tS182\t-0.1718721
LIN54\tS414\t0.002018352
LIN54\tS89\t-0.017373815
LIN54\tS93\t-0.177441415
LIN9\tS309\t-0.7796701
LIN9\tS321\t0.1159654
LIN9\tS65\t-4.6067015
LIN9\tS95\t0.05921687
LIN9\tT96\t0.1428708
LIPE\tS853\t0.4267478
LIPE\tS855\t0.1692837
LLGL1\tS420\t0.013082658
LMNA\tS107\t-0.3347528
LMNA\tS12\t-0.5437616
LMNA\tS212\t0.0415233
LMNA\tS22\t0.28769589
LMNA\tS301\t-0.04425574
LMNA\tS307\t0.1076242
LMNA\tS390\t0.07765318
LMNA\tS392\t0.09707135
LMNA\tS395\t0.3168407
LMNA\tS407\t0.2373189
LMNA\tS414\t-0.004844795
LMNA\tS458\t-0.03882121
LMNA\tS463\t0.05838585
LMNA\tS5\t0.105087015
LMNA\tS51\t0.01392662
LMNA\tS533\t-0.1024498
LMNA\tS603\t0.045528375
LMNA\tS616\t0.08318759
LMNA\tS619\t0.17412825
LMNA\tS628\t0.1904253
LMNA\tS632\t0.03347031
LMNA\tS636\t-0.01196617
LMNA\tS66\t-0.2326673
LMNA\tS71\t-0.1019697
LMNA\tT19\t0.6338497
LMNA\tT623\t0.6934605
LMNB1\tS23\t0.282773
LMNB1\tS302\t0.08379207
LMNB1\tT20\t0.1998534
LMNB1\tT283\t0.0936011
LMNB1\tT5\t-0.2099787
LMNB2\tS17\t0.271904157
LMNB2\tS296\t0.0218051
LMNB2\tS37\t0.271904157
LMNB2\tS385\t0.2144704
LMNB2\tS400\t-0.1802501
LMNB2\tS404\t0.02955887
LMNB2\tS477\t-0.1284875
LMNB2\tT14\t0.17389575
LMNB2\tT34\t0.17389575
LMO7\tS1115\t-0.07072407
LMO7\tS1116\t0.162674905
LMO7\tS1159\t0.1979911
LMO7\tS116\t-0.1297655
LMO7\tS1176\t0.2849878
LMO7\tS1182\t-0.9037922
LMO7\tS1252\t0.02176055
LMO7\tS1259\t0.1916889
LMO7\tS246\t0.1819295
LMO7\tS257\t0.4406334
LMO7\tS276\t0.16466935
LMO7\tS280\t0.2974849
LMO7\tS342\t0.05199848
LMO7\tS370\t0.5112122
LMO7\tS372\t0.533962
LMO7\tS417\t-0.15539955
LMO7\tS471\t-1.993896
LMO7\tS533\t-0.3156301
LMO7\tS539\t0.7271222
LMO7\tS621\t0.3415075
LMO7\tS626\t0.0860192
LMO7\tS654\t-0.16675105
LMO7\tS657\t-0.7251599
LMO7\tS692\t0.342792805
LMO7\tT1114\t0.22139815
LMO7\tT117\t-0.02799853
LMO7\tT615\t-0.23674165
LMO7\tT622\t0.5331852
LNP\tS172\t-0.2440699
LNP\tS177\t0.2621882
LNP\tS189\t-1.174086658
LNP\tS222\t0.23842
LNP\tS316\t-0.1146599
LNP\tS379\t-0.03778416
LONP1\tS434\t0.07436169
LPAR1\tS341\t-0.4177137
LPCAT2\tS530\t0.08664794
LPHN2\tS1322\t-0.051591315
LPIN1\tS168\t-0.9233589
LPIN1\tS294\t-0.0209405
LPIN1\tT141\t-0.6071941
LPIN2\tS106\t-0.3970871
LPIN2\tS243\t-0.3523447
LPIN2\tS245\t-0.39068205
LPIN3\tS224\t0.148763288
LPXN\tS188\t-0.279444
LPXN\tS267\t-0.1469632
LRBA\tS10\t-0.02644013
LRBA\tS1498\t-0.2598583
LRBA\tS2485\t-1.410121
LRCH1\tS370\t-0.1071039
LRCH1\tS393\t-0.065232345
LRCH1\tS532\t-0.5270964
LRCH1\tS536\t-0.5561388
LRCH1\tT568\t0.05158086
LRCH2\tS359\t-0.242038
LRCH2\tT617\t0.09774555
LRCH3\tS324\t0.04586229
LRCH3\tS415\t-0.3629185
LRCH3\tS419\t0.7758512
LRCH3\tS633\t1.03655485
LRCH3\tT329\t-0.222722245
LRCH4\tS21\t0.26972449
LRCH4\tS25\t0.01830229
LRCH4\tS281\t-0.1744749
LRCH4\tS380\t-1.47305
LRCH4\tS506\t-0.04912849
LRFN1\tS674\t0.1653644
LRIF1\tS386\t0.03955951
LRIF1\tS402\t0.3329657
LRP12\tS701\t0.2234226
LRP6\tS1355\t-0.1506733
LRPAP1\tS247\t-0.2207823
LRPAP1\tS50\t-0.2650324
LRR1\tT124\t0.2005043
LRRC16A\tS1094\t-1.413972
LRRC16A\tS1101\t-2.640344
LRRC16A\tS1216\t0.7027462
LRRC16A\tS1235\t0.662479
LRRC16A\tS1270\t0.1292171
LRRC16A\tS968\t0.4032677
LRRC16A\tT1128\t-1.3209725
LRRC16A\tT916\t0.1323794
LRRC41\tS276\t-3.46118
LRRC47\tS518\t0.021055533
LRRC47\tS561\t0.08215725
LRRFIP1\tS116\t0.5525737
LRRFIP1\tS120\t0.21661
LRRFIP1\tS16\t0.59224925
LRRFIP1\tS3\t0.03266509
LRRFIP1\tS521\t-0.15994615
LRRFIP1\tS555\t-1.13576
LRRFIP1\tS581\t-1.007174
LRRFIP1\tS618\t-0.5960124
LRRFIP1\tS638\t0.01449814
LRRFIP1\tS713\t-0.238801175
LRRFIP1\tS714\t-0.1053336
LRRFIP1\tS733\t0.1423481
LRRFIP1\tS746\t0.144762665
LRRFIP1\tS766\t-0.4075549
LRRFIP1\tS768\t-0.1584938
LRRFIP2\tS88\t0.1180938
LRRFIP2\tS91\t-0.04648925
LRRFIP2\tS92\t0.02417773
LRRFIP2\tS96\t-0.05542635
LRWD1\tS212\t0.01948842
LRWD1\tS243\t0.1139672
LRWD1\tS245\t0.066580025
LRWD1\tS251\t0.008309405
LRWD1\tS259\t0.01963057
LSM12\tS16\t-0.126234
LSM12\tT75\t0.06018582
LSM14A\tS141\t0.03294719
LSM14A\tS142\t0.1237986
LSM14A\tS151\t-0.03160689
LSM14A\tS175\t0.07395734
LSM14A\tT153\t-0.003828249
LSM14B\tS115\t-0.2572866
LSM14B\tS154\t0.4248146
LSM14B\tS165\t0.4912887
LUC7L\tS363\t-0.08774875
LUC7L2\tS18\t-0.986988
LUC7L2\tS347\t-0.1628318
LUC7L2\tT17\t-0.6163262
LUC7L3\tS425\t-0.015293102
LUC7L3\tS431\t0.034685843
LUZP1\tS570\t0.1367164
LUZP1\tS639\t0.18890838
LUZP1\tS905\t-0.03284614
LUZP1\tS995\t-0.257597
LUZP1\tT249\t0.3647966
LUZP1\tT679\t0.4623665
LUZP1\tT777\t0.2950176
LY9\tS67\t0.2750071
LYAR\tS276\t-1.5943195
LYN\tS13\t0.09274875
LYSMD1\tS99\t0.02998291
LYSMD2\tS24\t0.020790715
LYSMD2\tS29\t0.07038926
LYSMD2\tS4\t0.7388017
LYSMD2\tS5\t0.5073125
LYST\tS2105\t-0.04204087
LYST\tS2124\t-0.02717504
LYST\tS2128\t0.07176267
LYST\tS2149\t0.0880058
LYST\tS2152\t0.04138286
LYST\tS2166\t-0.193832325
LYST\tS2167\t-0.374733175
LYST\tS2170\t-0.374733175
LYST\tS2213\t-0.156889983
LYST\tS2217\t0.272271075
LYST\tS2627\t-0.01196617
LYST\tS2632\t0.05523255
LYST\tS517\t-0.1927275
LZTS1\tS172\t0.2100148
LZTS1\tS174\t0.1708224
LZTS1\tS209\t0.0416635
LZTS1\tS231\t0.0741775
LZTS1\tS233\t0.1200864
LZTS1\tS254\t-0.5064346
LZTS2\tS301\t0.05491792
LZTS2\tS311\t-0.29040455
M0R1G4\tS102\t-0.07663017
M0R1G4\tS201\t0.2203299
M0R1G4\tS205\t0.1175621
M0R1G4\tS36\t0.17230135
M0R1G4\tS49\t0.132837844
M0R1G4\tT32\t0.1037455
M6PR\tS267\t-0.0678935
MACF1\tS275\t-0.07419803
MACF1\tS3922\t0.08759864
MACF1\tS4490\t0.34926078
MACF1\tS4491\t0.09612688
MACF1\tS4516\t0.1137005
MACF1\tS7068\t-0.2395321
MACF1\tS7497\t-0.08838806
MADD\tS1158\t-0.02436978
MADD\tS156\t0.08854871
MADD\tS775\t-0.8514619
MADD\tS777\t0.356250115
MADD\tS783\t0.210021138
MADD\tS996\t-0.1976165
MAF1\tS60\t-0.67827455
MAF1\tS68\t-0.053968986
MAF1\tS75\t-0.2588048
MAGEA11\tS208\t0.009203812
MAGEA11\tS76\t0.553791785
MAGED2\tS190\t-0.06999161
MAGED2\tS191\t-0.01229323
MAGED2\tS194\t-0.04180478
MAGED2\tS197\t0.07833651
MAGED2\tS2\t0.047843185
MAGED2\tS247\t0.257252
MAGED2\tS265\t-0.01320315
MAGED2\tT72\t-0.7748979
MAGI3\tS832\t-0.1804462
MAGOH\tS108\t0.16253155
MAK16\tS197\t-0.181800225
MAK16\tS199\t-0.213882875
MAK16\tS200\t-0.217245825
MAK16\tS229\t-0.110215
MAK16\tS232\t-0.110215
MAML1\tS314\t0.24099733
MAML1\tS360\t-0.003134088
MAML1\tS45\t0.1518587
MAML3\tS170\t-0.07215301
MAML3\tS351\t-0.1841951
MAMLD1\tS651\t0.07826542
MANEAL\tS83\t0.187838495
MAP1A\tS1218\t-0.098817035
MAP1A\tS1326\t-0.46321235
MAP1A\tS1600\t-0.1034414
MAP1A\tS1654\t0.02062666
MAP1A\tS1675\t-0.3492906
MAP1A\tS1776\t-0.1250693
MAP1A\tS1818\t-0.2845283
MAP1A\tS2235\t-0.541261
MAP1A\tS2449\t-0.6468123
MAP1A\tS986\t-0.046313683
MAP1A\tS996\t-0.4139222
MAP1A\tT504\t-2.440655
MAP1A\tT675\t-0.3549809
MAP1B\tS1016\t-0.2770269
MAP1B\tS1154\t-0.01228624
MAP1B\tS1252\t-0.0614056
MAP1B\tS1256\t-0.01373055
MAP1B\tS1258\t-0.176428185
MAP1B\tS1260\t0.0569815
MAP1B\tS1262\t-0.2713916
MAP1B\tS1265\t-0.245865
MAP1B\tS1298\t0.05630613
MAP1B\tS1378\t-0.3388822
MAP1B\tS1387\t-0.79316885
MAP1B\tS1389\t-0.38625555
MAP1B\tS1396\t-1.429939
MAP1B\tS1400\t-0.8881918
MAP1B\tS1427\t0.07833651
MAP1B\tS1438\t-0.2058628
MAP1B\tS1501\t-0.266316
MAP1B\tS1520\t-1.496549
MAP1B\tS1620\t-0.1001438
MAP1B\tS1625\t-0.09360196
MAP1B\tS1779\t-0.1202536
MAP1B\tS1782\t-0.251367
MAP1B\tS1785\t-0.251367
MAP1B\tS1793\t-0.46588595
MAP1B\tS1797\t-1.8714435
MAP1B\tS1915\t-0.09352498
MAP1B\tS343\t-0.2968107
MAP1B\tS561\t-0.5958161
MAP1B\tS614\t-0.06475148
MAP1B\tS831\t-0.09328702
MAP1B\tS832\t-0.22969652
MAP1B\tS937\t-0.1325305
MAP1B\tS995\t1.255863
MAP1B\tT1067\t-0.176218
MAP1B\tT1503\t-0.320414
MAP1B\tT1788\t-0.2832462
MAP1B\tT1853\t0.5670587
MAP1B\tT1949\t0.10023234
MAP1B\tT527\t-0.0935624
MAP1S\tS446\t0.07778991
MAP1S\tS631\t0.1007085
MAP1S\tS703\t-0.01417899
MAP1S\tS705\t-0.01417899
MAP1S\tS733\t-0.16187575
MAP1S\tS736\t-0.18756015
MAP2\tS1151\t-0.1358872
MAP2\tS1320\t-0.2342786
MAP2\tS1343\t-0.184597203
MAP2\tS1349\t-0.2277256
MAP2\tS1394\t-0.03846561
MAP2\tS1530\t-0.159557
MAP2\tS1551\t0.1372412
MAP2\tS1630\t0.2434253
MAP2\tS1649\t0.1027253
MAP2\tS1778\t0.11076596
MAP2\tS1782\t0.01264022
MAP2\tS1783\t-0.006057632
MAP2\tS1786\t0.01264022
MAP2\tS281\t-1.231041
MAP2\tS784\t-1.6141762
MAP2\tS817\t-0.8230135
MAP2\tS829\t-0.3903585
MAP2\tT1588\t0.54639265
MAP2\tT1591\t0.39329325
MAP2\tT1601\t0.44338995
MAP2\tT1609\t0.3675947
MAP2\tT1612\t0.003314423
MAP2\tT1615\t0.1563967
MAP2\tT1645\t0.2041437
MAP2\tT1652\t0.07231157
MAP2\tT423\t-0.4412323
MAP2K1\tT386\t-1.853077
MAP2K2\tS222\t-1.4158448
MAP2K2\tS226\t-2.271392
MAP2K2\tS23\t-0.5133498
MAP2K2\tS293\t-1.395314
MAP2K2\tS295\t-1.4630285
MAP2K2\tT394\t-1.024414
MAP2K4\tS257\t-0.9906337
MAP2K4\tS90\t-0.04908374
MAP2K6\tT28\t0.3375398
MAP3K1\tS1455\t-0.9047016
MAP3K1\tS21\t-0.2518606
MAP3K1\tS266\t0.2560445
MAP3K1\tS292\t-0.4636287
MAP3K1\tS923\t-0.07955427
MAP3K11\tS507\t0.256286
MAP3K11\tS524\t0.1663298
MAP3K11\tS789\t0.8115959
MAP3K11\tT702\t-0.44317165
MAP3K12\tS11\t-0.07801536
MAP3K12\tS642\t0.28650045
MAP3K12\tS667\t-0.3869777
MAP3K2\tS153\t-0.2336169
MAP3K2\tS163\t0.01235413
MAP3K2\tS164\t-0.1367593
MAP3K2\tS239\t-0.02066238
MAP3K2\tS26\t0.1658761
MAP3K2\tS331\t-0.01741709
MAP3K2\tT337\t-0.0141644
MAP3K3\tS147\t-0.9405247
MAP3K3\tS237\t-0.0867879
MAP3K3\tS250\t-0.078716
MAP3K3\tS337\t-2.8402005
MAP3K3\tS340\t-2.619182
MAP3K4\tS1135\t-0.6135643
MAP3K4\tS431\t-0.2943494
MAP3K6\tS707\t-0.1968225
MAP3K7\tS389\t0.1160985
MAP3K7\tS412\t0.17990245
MAP3K7\tS427\t0.7263823
MAP3K7\tS428\t0.8398003
MAP3K9\tS270\t-0.27105565
MAP4\tS116\t-0.081368505
MAP4\tS14\t-0.6769875
MAP4\tS1679\t-0.8452873
MAP4\tS1841\t0.04739887
MAP4\tS1932\t0.4337073
MAP4\tS1970\t0.2685541
MAP4\tS2073\t0.4982509
MAP4\tS2086\t0.4250295
MAP4\tS2218\t0.5198438
MAP4\tS297\t-0.02072092
MAP4\tS347\t0.44695865
MAP4\tS375\t0.2709474
MAP4\tS457\t-0.2658822
MAP4\tS524\t-0.08968676
MAP4\tS527\t0.15501689
MAP4\tS653\t0.2535053
MAP4\tS68\t-1.9492635
MAP4\tS723\t-0.1817057
MAP4\tS806\t0.06073913
MAP4\tT114\t0.665931705
MAP4\tT1295\t-1.0109747
MAP4\tT1462\t-2.084335
MAP4\tT1832\t0.04068203
MAP4\tT299\t0.01449814
MAP4\tT538\t0.01092296
MAP4\tT588\t0.4374408
MAP4\tT602\t0.5112656
MAP4K2\tS385\t-0.400366925
MAP4K3\tS377\t0.2168583
MAP4K3\tS486\t0.213828
MAP4K4\tS571\t0.3383388
MAP4K4\tS608\t0.5053784
MAP4K4\tS625\t-0.1209844
MAP4K4\tS733\t-0.27068913
MAP4K4\tS735\t-0.14697748
MAP4K4\tS769\t0.1248574
MAP4K4\tS774\t-0.06387655
MAP4K4\tS780\t0.2938414
MAP4K4\tS799\t-0.2623651
MAP4K4\tS875\t0.0543517
MAP4K4\tS933\t-0.04926284
MAP4K4\tS946\t0.1582078
MAP4K4\tT712\t-0.076583895
MAP4K4\tT879\t0.36638455
MAP4K5\tS335\t0.2225573
MAP4K5\tS433\t-0.1741329
MAP4K5\tT333\t-0.6543538
MAP7\tS55\t0.138784254
MAP7\tS63\t0.7167714
MAP7D1\tS112\t-0.4074366
MAP7D1\tS113\t-0.2699123
MAP7D1\tS116\t0.1989745
MAP7D1\tS399\t0.1502997
MAP7D1\tS446\t0.22668005
MAP7D1\tS454\t-0.1111808
MAP7D1\tS460\t0.05883942
MAP7D1\tS544\t-0.04748748
MAP7D1\tS548\t0.04546691
MAP7D1\tS552\t0.1301402
MAP7D1\tS576\t-0.2615064
MAP7D1\tS70\t-0.5165324
MAP7D1\tS742\t0.1839629
MAP7D1\tS86\t0.1189967
MAP7D1\tS89\t0.1806571
MAP7D1\tS93\t-0.006274913
MAP7D1\tT122\t0.1969144
MAP7D1\tT47\t-0.1842279
MAP7D1\tT51\t-0.02623332
MAP7D1\tT585\t0.1036654
MAP7D1\tT97\t-0.006274913
MAP7D2\tS131\t-2.21489335
MAP7D3\tS165\t0.2854613
MAP7D3\tS400\t0.2654369
MAP7D3\tS420\t0.42541035
MAP9\tS79\t-0.186014025
MAPK1\tT185\t-3.909534
MAPK1\tT190\t0.5022287
MAPK1\tY187\t-3.74183
MAPK14\tS2\t-0.03258049
MAPK14\tT180\t0.502055
MAPK14\tY182\t-0.003784795
MAPK1IP1L\tS15\t0.1767058
MAPK3\tT202\t-3.346494
MAPK3\tY204\t-5.587619
MAPK6\tS189\t0.6552743
MAPK6\tS665\t0.18451725
MAPK7\tS592\t-0.12275695
MAPK7\tT594\t0.42213295
MAPKAP1\tS463\t0.2591821
MAPKAPK5\tS205\t0.3353879
MAPKBP1\tS320\t-0.44238745
MAPKBP1\tS764\t-0.351332
MAPRE2\tS9\t-0.02394437
MAPT\tS579\t-2.538091
MAPT\tS721\t0.2087669
7-Mar\tS312\t-0.05784214
MARCKS\tS101\t-1.808033
MARCKS\tS118\t-1.38081957
MARCKS\tS128\t0.75524415
MARCKS\tS135\t-0.2288919
MARCKS\tS145\t-0.210701085
MARCKS\tS147\t0.00216585
MARCKS\tS170\t0.09558696
MARCKS\tS26\t-0.094279435
MARCKS\tS27\t-0.07312004
MARCKS\tS29\t-0.10509635
MARCKS\tS46\t0.1154328
MARCKS\tS52\t-0.09637554
MARCKS\tS63\t-0.08880699
MARCKS\tS81\t-0.4033892
MARCKS\tT120\t-1.52440695
MARCKS\tT143\t0.1072862
MARCKS\tT150\t0.229900935
MARCKSL1\tS104\t-0.3487394
MARCKSL1\tS117\t-0.06591075
MARCKSL1\tS151\t0.14400375
MARCKSL1\tS22\t-0.04866583
MARCKSL1\tS71\t0.1558787
MARCKSL1\tT148\t-0.003743225
MARCKSL1\tT85\t-0.064295565
MARK2\tS212\t0.14311197
MARK2\tS365\t-0.02621979
MARK2\tS390\t0.5911049
MARK2\tS421\t0.07382975
MARK2\tS43\t-1.270312
MARK2\tS455\t0.02800333
MARK2\tS568\t0.118242105
MARK2\tS570\t0.2773897
MARK2\tS618\t0.007923215
MARK2\tS623\t0.11140475
MARK2\tS630\t0.3095255
MARK2\tT208\t0.298189
MARK3\tS400\t0.2110703
MARK3\tS469\t0.2172308
MARK3\tS529\t-0.110685535
MARK3\tS540\t0.1004395
MARK3\tS543\t0.01521368
MARK3\tS583\t0.1344838
MARK3\tT536\t0.607170845
MARK4\tS438\t-0.08460911
MARK4\tS594\t-0.3816674
MAST2\tS1032\t-1.162622
MAST2\tS1344\t-0.99512565
MAST2\tS148\t0.076953415
MAST2\tS191\t1.449155
MAST2\tS66\t0.386811
MAST2\tS855\t0.08460858
MAST2\tS900\t0.2082676
MAST3\tS134\t0.2001277
MAST3\tS146\t0.05533457
MAST3\tS57\t-1.405334
MAST3\tS774\t0.4396763
MAST3\tS793\t0.4447707
MASTL\tS370\t0.000865329
MASTL\tS453\t0.1945914
MASTL\tS512\t0.87677955
MAT1A\tS206\t0.024246865
MAT2B\tS271\t-0.07119386
MATR3\tS188\t-1.016483
MATR3\tS195\t-0.8608292
MATR3\tS206\t-0.2223468
MATR3\tS596\t-0.122915435
MATR3\tS598\t-0.04698066
MATR3\tS604\t0.003280375
MATR3\tS606\t0.038903375
MATR3\tS814\t-0.3212069
MAVS\tS222\t-1.411157
MAVS\tS24\t-1.211532
MAVS\tS258\t-0.4866306
MAX\tS11\t-0.1473299
MAX\tS11\t-0.03261004
MAX\tS2\t-0.08243921
MAX\tS2\t-0.03261004
MB21D1\tS143\t-0.4069045
MBD1\tS114\t-0.01842497
MBD1\tS163\t-0.05180597
MBD1\tS165\t0.08199209
MBD1\tS297\t-0.1918704
MBD1\tS335\t0.1118326
MBD1\tS337\t0.2777237
MBD1\tS343\t-0.435495
MBD3\tS39\t0.29566455
MBD3\tS85\t-0.9353378
MBD4\tS387\t0.1218111
MBD5\tS238\t-0.090326695
MBD6\tS975\t-0.021292365
MBIP\tS49\t0.07011455
MBNL1\tT6\t0.5551291
MBOAT7\tS285\t-0.04547609
MBP\tS249\t-0.007507107
MCAM\tS606\t-0.4043054
MCAM\tS614\t0.1957256
MCAM\tS627\t0.338503605
MCAM\tS628\t-0.142793105
MCC\tS1018\t-0.0372067
MCC\tS129\t-1.581519
MCC\tS308\t-0.2024059
MCC\tS310\t0.23105235
MCC\tS389\t-0.2224645
MCC\tS484\t0.2625534
MCC\tT1017\t-0.06396707
MCF2L\tS251\t-1.4695435
MCF2L\tS606\t0.008228
MCM2\tS108\t-0.0570504
MCM2\tS13\t0.03365203
MCM2\tS139\t-0.009756644
MCM2\tS26\t-0.04363102
MCM2\tS27\t0.01864976
MCM2\tS4\t-0.050480075
MCM2\tS40\t0.08556063
MCM2\tS41\t0.097249255
MCM2\tS5\t0.065198235
MCM2\tS7\t0.180901885
MCM2\tT35\t0.0321818
MCM2\tT39\t0.099130629
MCM3\tS668\t-0.3963084
MCM3\tS672\t-0.305842
MCM3\tS704\t0.02998291
MCM3\tS711\t0.1146336
MCM3\tT4\t0.4347749
MCM3\tT674\t-0.25818375
MCM3\tT713\t0.05864457
MCM3\tT722\t-0.03665894
MCM3AP\tS430\t0.1634748
MCM3AP\tS527\t-0.3278734
MCM3AP\tS538\t0.4829249
MCM4\tS3\t0.5405048
MCM4\tT7\t-0.2864977
MCM6\tS13\t0.1027253
MCM6\tS762\t-0.191813216
MCM9\tS534\t-0.4651805
MCM9\tT292\t0.6735958
MCOLN1\tS29\t-0.251107745
MCOLN1\tS557\t0.01449814
MCOLN1\tT34\t-0.3060738
MCOLN3\tS12\t0.01166703
MCRS1\tS22\t-0.1174117
MCRS1\tS282\t-0.01096279
MCRS1\tT103\t0.01506926
MCTP2\tS11\t-0.1671829
MDC1\tS1033\t-0.2781287
MDC1\tS1068\t0.1815478
MDC1\tS1086\t-0.08597133
MDC1\tS1570\t0.2502339
MDC1\tS168\t-0.114004
MDC1\tS1711\t-0.3747669
MDC1\tS1775\t-0.3383963
MDC1\tS299\t0.141608685
MDC1\tS329\t-0.23361311
MDC1\tS376\t-0.0275322
MDC1\tS453\t-0.2696861
MDC1\tS495\t-0.03041296
MDC1\tS498\t-0.03041296
MDC1\tS505\t-0.054556855
MDC1\tS641\t-0.0830495
MDC1\tS780\t0.09882372
MDC1\tS793\t1.921132
MDC1\tS964\t-0.004406986
MDC1\tT1198\t-0.2817896
MDC1\tT1280\t-0.03225588
MDC1\tT1425\t-0.07992015
MDC1\tT1548\t-0.005405813
MDC1\tT1567\t0.05977056
MDC1\tT1589\t0.5459684
MDC1\tT1608\t-0.05614614
MDC1\tT1649\t0.05443335
MDC1\tT1671\t0.14790419
MDC1\tT301\t0.141608685
MDC1\tT331\t-0.29631431
MDC1\tT378\t0.00451515
MDC1\tT455\t-0.2696861
MDC1\tT797\t0.01378388
MDFIC\tS130\t-0.25230915
MDFIC\tS133\t-0.08884413
MDH2\tS310\t0.01406952
MDM2\tS105\t-1.296403
MDM4\tS120\t0.44555585
MDN1\tS4538\t-0.03247723
MDN1\tS4752\t0.027614433
MDN1\tS4754\t0.005040595
MDN1\tS4889\t-0.01157343
MDN1\tS5015\t-0.004522744
MDN1\tT4898\t-0.02670465
MDS025\tS118\t-0.41151435
MECP2\tS241\t0.03167748
MECP2\tS435\t-0.2653619
MECP2\tS92\t-0.01498058
MED1\tS1192\t0.04893365
MED1\tS1207\t0.0218905
MED1\tS1219\t0.1631122
MED1\tS1401\t0.33984795
MED1\tS1475\t2.771611
MED1\tS1479\t0.875204145
MED1\tS1481\t2.771611
MED1\tS1482\t1.054494502
MED1\tS795\t-2.360379
MED1\tT1215\t0.1051417
MED1\tT1440\t0.24732
MED1\tT805\t0.23008
MED12\tS1258\t0.04040144
MED12\tS635\t-0.2024889
MED12\tS688\t-0.06948135
MED12\tS698\t0.091017225
MED12\tS700\t0.2359474
MED13\tS395\t-0.57193025
MED13\tS481\t-0.2077943
MED13\tS483\t-0.0091476
MED13\tS530\t0.2710043
MED13\tS537\t0.23527035
MED13\tS890\t0.0984196
MED13L\tS1081\t0.3092926
MED13L\tS878\t-0.1632033
MED13L\tS923\t-0.0957895
MED14\tS1136\t-0.5607918
MED14\tS617\t-0.05132443
MED15\tT492\t-0.28149795
MED15\tT501\t-0.37606275
MED16\tS326\t-0.2522088
MED19\tS226\t-0.090454559
MED24\tS361\t-0.02206802
MED24\tS364\t-0.02206802
MED24\tS849\t-1.7417465
MED24\tS860\t0.1440464
MED26\tS314\t-0.22671175
MED26\tS322\t0.1208827
MED26\tS373\t0.03618686
MED26\tS447\t0.05907837
MED26\tS535\t-0.1186486
MED26\tS7\t0.07696952
MED26\tT323\t-0.061969292
MED8\tS82\t0.09585687
MED9\tS46\t-0.28146365
MEF2A\tS235\t0.6335121
MEF2A\tS255\t0.110096
MEF2A\tS98\t-0.146758935
MEF2C\tS222\t0.4326638
MEF2C\tS228\t0.4288459
MEF2C\tS240\t0.2220626
MEF2C\tS405\t-0.037314291
MEF2C\tS413\t-0.005116172
MEF2C\tS419\t0.1575611
MEF2C\tS421\t-0.10118585
MEF2D\tS121\t-1.4385265
MEF2D\tS180\t0.3653566
MEF2D\tS192\t0.1461339
MEF2D\tS231\t0.4552286
MEF2D\tS251\t0.1623389
MEF2D\tS437\t0.0633648
MEF2D\tS443\t0.038464403
MEF2D\tS465\t-0.03057501
MEF2D\tS98\t0.07148806
MEGF10\tT979\t1.170438
MEIS1\tS70\t0.02494577
MELK\tS450\t0.1463945
MELK\tS457\t0.09044699
MEPCE\tS217\t0.3494785
MEPCE\tS254\t0.1263122
MEPCE\tS330\t0.08936255
MEPCE\tS60\t0.041178915
MEPCE\tS69\t0.12220825
MEPCE\tT213\t0.3398215
MEPCE\tT291\t0.15552835
MESDC1\tS3\t0.01578305
METAP2\tS29\t0.2320467
METTL1\tS27\t0.4889262
METTL10\tS17\t0.44746025
METTL10\tS21\t-0.04114987
METTL13\tS266\t-1.319298
METTL16\tS325\t-0.000187559
METTL16\tS419\t0.08365592
METTL16\tS455\t-0.09527829
METTL16\tS498\t-0.13215684
METTL22\tS132\t-0.03308228
METTL2B\tT154\t-0.05286499
METTL3\tS43\t-0.01654117
METTL3\tS50\t0.121546
METTL6\tS229\t-0.05041281
MEX3A\tS338\t-0.54096235
MEX3A\tS428\t0.2441454
MEX3B\tS4\t0.3596336
MEX3B\tS442\t0.06129241
MEX3C\tS145\t-0.099567225
MEX3C\tS320\t-1.188496
MEX3C\tS545\t-0.00496135
MEX3C\tS88\t-0.1215493
MEX3C\tT547\t-0.12864656
MEX3D\tS514\t-0.3073229
MFAP1\tS116\t-0.2271371
MFAP1\tS118\t-0.1253683
MFAP1\tS132\t-0.09881453
MFAP1\tS133\t-0.09881453
MFAP1\tS52\t0.009920342
MFAP1\tS53\t0.009920342
MFAP1\tT267\t0.07176267
MFAP3L\tS203\t-0.3981671
MFF\tS105\t0.5460672
MFF\tS146\t0.6929628
MFF\tS151\t0.04935203
MFF\tS155\t-0.1924802
MFF\tS157\t-0.02541194
MFF\tS202\t-1.110044
MFF\tS21\t-0.7868705
MFF\tT115\t-0.347564
MFF\tT137\t-2.240111
MFF\tT138\t-2.21739
MFGE8\tS42\t0.1949696
MFN1\tS6\t-0.2370645
MFSD12\tT245\t-2.147394
MFSD6\tT10\t-0.001501157
MGA\tS1208\t0.09247811
MGA\tS1412\t0.238204755
MGA\tS1422\t-0.3416286
MGA\tS1430\t-0.2348557
MGA\tS2332\t0.06695026
MGA\tS2712\t-0.009045174
MGA\tS56\t0.01049345
MGA\tS607\t0.2950176
MGA\tS851\t-0.3023152
MGEA5\tS364\t0.034225645
MGEA5\tS505\t0.2493846
MGRN1\tS437\t-0.111199825
MGRN1\tS493\t0.2617113
MGRN1\tS501\t-0.2890831
MGRN1\tS502\t-0.188381
MIA3\tS1431\t-0.2347561
MIA3\tS1678\t0.2224336
MIA3\tS1725\t0.3323928
MIA3\tS1740\t0.010508115
MIA3\tS1741\t0.02304246
MIA3\tS1906\t-0.18043
MIA3\tS407\t-0.3603048
MIA3\tS408\t-0.3603048
MICAL1\tS1057\t-0.05411405
MICAL1\tS613\t-0.6034679
MICAL1\tS617\t-0.75720885
MICAL1\tS818\t-1.859509
MICAL1\tS858\t-0.7294829
MICAL3\tS1134\t0.48880771
MICAL3\tS1143\t-0.10763064
MICAL3\tS1152\t-0.0334809
MICAL3\tS1156\t0.004286705
MICAL3\tS1310\t-0.5095736
MICAL3\tS1337\t-0.06319809
MICAL3\tS1371\t-0.14134465
MICAL3\tS1400\t0.82309195
MICAL3\tS1649\t-0.05814248
MICAL3\tS685\t-2.48452775
MICAL3\tS687\t-2.2609415
MICAL3\tS956\t-0.1474586
MICAL3\tS977\t-0.05553135
MICAL3\tT1291\t2.4841475
MICAL3\tT1341\t0.48876485
MICAL3\tT1574\t0.29588665
MICAL3\tT797\t0.5950261
MICALL1\tS273\t-0.09354039
MICALL1\tS295\t-0.094145
MICALL1\tS414\t-0.6959797
MICALL1\tS471\t0.3931363
MICALL1\tS484\t0.119863135
MICALL1\tS486\t0.1797773
MICALL1\tS578\t0.07011455
MICALL1\tT318\t1.12496935
MICALL1\tT467\t0.4063189
MICALL2\tS110\t-0.2725413
MICALL2\tS143\t0.0734089
MICALL2\tS153\t-0.1880523
MICALL2\tS247\t0.154063885
MICALL2\tS249\t0.2288495
MICALL2\tS294\t0.7949357
MICALL2\tS494\t0.29752485
MICALL2\tS503\t1.0493275
MICALL2\tS649\t0.053821046
MICALL2\tS658\t0.1150332
MICALL2\tS660\t-0.25028185
MICALL2\tS712\t-0.74245805
MICALL2\tS726\t-2.671912
MICALL2\tT725\t-2.18356175
MID1\tS92\t0.02244795
MID1\tS96\t0.079975725
MID1IP1\tT67\t-1.730392
MIER1\tS422\t0.2110122
MIER1\tS425\t0.2110122
MIER1\tS426\t0.4242772
MIER1\tS430\t-0.06414803
MIER1\tS541\t0.07773795
MIIP\tS303\t-0.1979228
MINK1\tS601\t0.54017065
MINK1\tS763\t-0.1342237
MINK1\tS778\t0.1637564
MIOS\tS766\t-0.06298716
MIS18BP1\tS1008\t0.21318895
MIS18BP1\tS1104\t0.4140272
MIS18BP1\tS1116\t0.1176951
MIS18BP1\tS135\t0.4710314
MIS18BP1\tS192\t0.30410655
MIS18BP1\tS299\t0.41927075
MIS18BP1\tT1087\t0.481299
MITF\tS414\t-0.2187158
MITF\tS491\t-0.0770704
MITF\tS516\t-0.2264931
MKI67\tS1131\t-0.1466909
MKI67\tS1253\t0.3540007
MKI67\tS1376\t0.2923105
MKI67\tS1861\t0.2182232
MKI67\tS1937\t0.685985
MKI67\tS2105\t0.0500489
MKI67\tS2223\t0.30733365
MKI67\tS2299\t0.4935937
MKI67\tS2344\t-0.04662296
MKI67\tS2466\t0.1562672
MKI67\tS2588\t0.06115411
MKI67\tS2828\t0.3751785
MKI67\tS308\t0.09747601
MKI67\tS357\t-0.210012
MKI67\tS584\t0.004033884
MKI67\tS648\t0.4990678
MKI67\tS713\t0.2941943
MKI67\tT1261\t0.5904344
MKI67\tT1315\t0.6205865
MKI67\tT1327\t0.6094713
MKI67\tT1355\t0.083060525
MKI67\tT1691\t0.71553015
MKI67\tT1747\t0.3126652
MKI67\tT1801\t0.6723801
MKI67\tT1923\t0.5663768
MKI67\tT1963\t0.5020251
MKI67\tT2231\t0.5460653
MKI67\tT2268\t0.729444
MKI67\tT2325\t0.5322671
MKI67\tT2389\t0.7865964
MKI67\tT2406\t0.6876878
MKI67\tT328\t0.08460858
MKI67\tT761\t0.3825012
MKI67IP\tS218\t-1.028823
MKI67IP\tS247\t-0.266715
MKI67IP\tT223\t0.09518178
MKI67IP\tT227\t0.644739225
MKI67IP\tT234\t0.65846425
MKI67IP\tT238\t0.4477378
MKI67IP\tT279\t0.2072682
MKL1\tS156\t-0.55011165
MKL1\tS385\t-2.017098
MKL1\tS454\t-0.2927403
MKL1\tS807\t-0.548353775
MKL1\tS809\t-1.3828012
MKL1\tT450\t0.652777
MKL2\tS554\t-0.536566
MKL2\tS77\t-2.9968995
MKL2\tS882\t-1.892232
MKL2\tS885\t-1.7315755
MKL2\tT381\t0.76758685
MKNK1\tS180\t0.04558271
MKNK2\tS74\t-0.1659982
MKRN2\tS113\t-0.4677129
MLANA\tS87\t-0.01014715
MLANA\tY104\t-0.27802015
MLF1\tS9\t-0.5480795
MLF1IP\tS136\t-0.4484101
MLF1IP\tS139\t-0.4484101
MLF1IP\tS141\t-0.4214389
MLF1IP\tT147\t-1.04428235
MLF1IP\tT98\t0.06667474
MLF2\tS238\t0.4938523
MLH1\tS477\t-0.2133535
MLH1\tS486\t-0.2068616
MLIP\tS135\t-0.04372084
MLIP\tS464\t-0.034102257
MLIP\tT136\t0.173232075
MLK4\tS528\t0.143524
MLK4\tS614\t-0.29223565
MLL\tS1056\t-0.3128746
MLL\tS153\t0.17175296
MLL\tS1647\t-0.06339414
MLL\tS1799\t-0.2931822
MLL\tS1820\t-0.113038945
MLL\tS197\t0.01364095
MLL\tS2060\t-0.090904795
MLL\tS2353\t-0.0181021
MLL\tS2354\t-0.0181021
MLL\tS279\t0.2493846
MLL\tS2900\t0.4125105
MLL\tS2988\t0.4821255
MLL\tS2998\t-0.6983655
MLL\tS3473\t-0.03316636
MLL\tS3477\t-0.03316636
MLL\tS518\t0.42948075
MLL\tT1801\t-0.2589984
MLL\tT1807\t-0.113963252
MLL\tT337\t-0.0809422
MLL2\tS1180\t-0.208161
MLL2\tS1671\t-0.2557183
MLL2\tS1834\t1.06356545
MLL2\tS2260\t-0.76451445
MLL2\tS2274\t-1.548607
MLL2\tS2640\t-0.58892035
MLL2\tS3199\t-0.643383
MLL2\tS4359\t-0.08787139
MLL2\tS468\t-0.2069694
MLL2\tS4738\t0.01963077
MLL2\tS477\t-0.2069694
MLL2\tS4822\t0.09098883
MLL2\tS4849\t-0.114662835
MLL2\tS654\t-0.1540885
MLL2\tT1843\t0.07997543
MLL2\tT1911\t0.2447202
MLL2\tT2228\t0.235322255
MLL2\tT2229\t0.43086175
MLL2\tT4682\t-0.04377975
MLL3\tS1225\t-0.1353958
MLL3\tS1493\t-0.4630519
MLL3\tS200\t0.255682
MLL3\tS28\t-0.1599598
MLL3\tS4034\t-0.09155598
MLL3\tS4263\t-0.1406768
MLL3\tS4267\t-0.1583972
MLL3\tS89\t0.022300422
MLL3\tT1219\t0.2198677
MLL3\tT3977\t-0.08193439
MLL5\tS623\t0.4244092
MLL5\tS837\t0.25048685
MLLT1\tS359\t-0.135376543
MLLT1\tS361\t-0.158991222
MLLT1\tS440\t0.2295879
MLLT4\tS1090\t-0.06307752
MLLT4\tS1114\t-0.03686623
MLLT4\tS1189\t-0.51314885
MLLT4\tS1282\t0.04656085
MLLT4\tS1508\t-0.0362596
MLLT4\tS1513\t0.6960997
MLLT4\tS1519\t0.2752454
MLLT4\tS1703\t-0.7577695
MLLT4\tS1705\t-0.6928979
MLLT4\tS1728\t-0.1558232
MLLT4\tS1761\t0.2932527
MLLT4\tS1781\t-0.34755105
MLLT4\tS1786\t0.0759774
MLLT4\tS1806\t0.1346153
MLLT4\tS216\t-0.106738475
MLLT4\tS424\t0.1074197
MLLT4\tS655\t-0.14171915
MLLT4\tT1239\t0.2626737
MLLT4\tT1337\t0.009700305
MLLT4\tT1341\t-0.000385195
MLLT4\tT214\t-0.13894474
MLLT4\tT249\t0.5889964
MLLT6\tS258\t-0.05916426
MLLT6\tS261\t0.063701665
MLLT6\tS378\t0.7458827
MLLT6\tS382\t0.2448927
MLLT6\tT451\t-0.004146521
MLPH\tS155\t0.01834928
MLPH\tS159\t-0.09069541
MLPH\tS162\t-0.302139855
MLPH\tS223\t0.4636224
MLPH\tS231\t0.03801472
MLPH\tS336\t-0.8498091
MLPH\tS337\t-1.022273
MLPH\tS337\t-0.1278725
MLPH\tS364\t0.4927591
MLPH\tS397\t-0.25704565
MLPH\tS402\t-0.221595415
MLPH\tS403\t-0.221595415
MLPH\tS420\t-0.3050752
MLPH\tS444\t-0.2601864
MLPH\tS463\t-2.57E-05
MLPH\tS481\t0.54045025
MLPH\tS484\t0.54045025
MLPH\tT165\t-0.302139855
MLPH\tT401\t-0.221595415
MLPH\tT458\t0.006804045
MLTK\tS593\t0.1090262
MLTK\tS633\t0.4096896
MLTK\tS691\t0.3827226
MLTK\tS727\t0.4599561
MLXIP\tS27\t0.06584801
MLXIP\tS33\t0.06584801
MLXIP\tS9\t0.3207734
MMACHC\tS245\t-0.4595391
MME\tS6\t0.6201171
MMGT1\tS117\t0.09031146
MMGT1\tS120\t0.24351018
MMTAG2\tS216\t-0.069256145
MMTAG2\tS217\t-0.04352697
MMTAG2\tS220\t-0.038895299
MMTAG2\tT219\t0.094996465
MOCOS\tS528\t-0.08730415
MOCOS\tS530\t0.007875055
MOCS2\tS20\t-0.6143813
MON1A\tS31\t0.07929271
MON1A\tS56\t0.06818932
MON1B\tS59\t-0.20429474
MON1B\tS61\t-0.10191314
MON1B\tS66\t-0.153254
MON2\tS1177\t0.3668118
MON2\tS1182\t-1.0139548
MON2\tT1187\t-1.004248
MORC2\tS553\t0.01564032
MORC2\tS634\t-0.10178599
MORC2\tS681\t0.7956839
MORC2\tS715\t0.23240945
MORC2\tS717\t0.23240945
MORC3\tS560\t-2.046504
MOSPD2\tS283\t-0.03747111
MOV10\tS969\t-0.3183618
MOV10\tS97\t0.1346153
MOV10\tT254\t0.1856129
MPHOSPH10\tS120\t-0.30651245
MPHOSPH10\tS139\t-0.30651245
MPHOSPH10\tS163\t-0.2159484
MPHOSPH10\tS167\t-0.38433845
MPHOSPH10\tS171\t-0.38433845
MPHOSPH8\tS136\t-0.043024611
MPHOSPH8\tS138\t-0.043024611
MPHOSPH8\tS164\t0.1563967
MPHOSPH8\tS403\t0.1294808
MPHOSPH8\tS51\t-0.1618631
MPHOSPH8\tT454\t0.4757075
MPHOSPH9\tS645\t0.5178876
MPHOSPH9\tT481\t0.486663
MPLKIP\tS133\t-0.5641581
MPND\tS214\t-0.27737995
MPND\tS216\t-0.6110995
MPP1\tS140\t0.3393655
MPP5\tS14\t-0.20997235
MPP5\tS84\t0.202487
MPRIP\tS1016\t-0.07995069
MPRIP\tS220\t-0.0413907
MPRIP\tS224\t-0.3751037
MPRIP\tS226\t-0.1437934
MPRIP\tS269\t0.1996252
MPRIP\tS289\t0.01035019
MPRIP\tS292\t-1.050622
MPRIP\tS294\t-1.682412
MPRIP\tS326\t0.1755566
MPRIP\tS360\t0.3105392
MPRIP\tS362\t0.03337007
MPRIP\tS365\t-0.4714687
MPRIP\tS619\t-1.099927
MPRIP\tS662\t-0.2734827
MPRIP\tS663\t-0.438039
MPRIP\tS891\t-0.541555
MPRIP\tS977\t-0.06334885
MPRIP\tT348\t0.266066105
MPRIP\tT383\t0.5594026
MPRIP\tT542\t0.1126334
MPST\tS15\t-0.1595085
MPST\tS17\t0.130576395
MPZ\tS195\t0.03068919
MPZL1\tS205\t-0.08823938
MPZL1\tS209\t0.04502354
MPZL1\tS218\t-0.2881704
MPZL1\tS220\t-0.7215632
MPZL1\tS259\t-0.05745545
MPZL1\tY262\t-0.67319155
MRE11A\tS687\t-0.02567627
MRE11A\tS688\t-0.02567627
MRGBP\tS195\t-0.1060942
MRPS36\tS61\t-0.2165631
MRTO4\tS82\t0.15043445
MSANTD2\tS13\t0.02941749
MSANTD2\tS27\t0.08732703
MSANTD2\tS48\t0.02431962
MSANTD3\tS274\t0.06129241
MSANTD3\tS98\t-0.01587007
MSANTD4\tS137\t0.1676149
MSH6\tS137\t0.08243007
MSH6\tS14\t0.2533384
MSH6\tS227\t-0.03259527
MSH6\tS252\t0.3682655
MSH6\tS254\t0.2960756
MSH6\tS256\t0.56256745
MSH6\tS261\t0.3682655
MSH6\tS41\t0.026268465
MSH6\tS43\t0.1549072
MSH6\tS79\t0.2901885
MSI2\tS257\t-0.814717
MSL1\tS126\t0.03632757
MSL2\tS373\t-0.4477305
MSL3\tS201\t0.20989
MSL3\tS234\t0.1076879
MSL3\tT239\t0.1076879
MSN\tS407\t0.01035019
MSN\tS429\t0.3484591
MSN\tS527\t-0.11491354
MSN\tT526\t-0.18849665
MST4\tS4\t-0.2950395
MSTO1\tS495\t-0.04750241
MTA1\tS386\t0.04278438
MTA1\tS449\t-0.086066125
MTA1\tS522\t0.01449814
MTA1\tS576\t0.0439044
MTA3\tS427\t-0.150369
MTA3\tS429\t-0.046040955
MTBP\tS639\t-0.0927863
MTCH1\tS364\t0.2580967
MTDH\tS298\t-0.224689075
MTDH\tS308\t-0.1042476
MTDH\tS426\t-0.07544398
MTDH\tS494\t-1.378419
MTDH\tS568\t0.6276068
MTDH\tT143\t-0.4543281
MTDH\tT462\t0.2741722
MTERFD1\tS27\t-0.26653695
MTFR1\tS248\t0.3301113
MTFR1\tS77\t0.2485129
MTFR1L\tS103\t0.5809173
MTFR1L\tS225\t0.1183597
MTFR1L\tS226\t0.2273714
MTFR2\tS119\t-0.4422616
MTHFD1L\tS357\t-0.205214
MTM1\tS13\t0.13924065
MTMR14\tS624\t-0.98703685
MTMR3\tS613\t0.1060803
MTMR3\tS633\t-0.003745115
MTMR3\tS647\t0.09234277
MTMR4\tS572\t-0.0158195
MTMR6\tS556\t-1.1440375
MTMR6\tS561\t-1.203037
MTMR6\tS589\t-0.7415858
MTOR\tS2481\t-0.3576845
MTOR\tS567\t-1.2075275
MTPN\tT31\t0.09369545
MTR\tS61\t-0.5741326
MTRR\tS171\t-0.02751323
MTSS1\tT208\t0.9216912
MTSS1L\tS579\t0.01763692
MTSS1L\tS601\t-1.691534
MTTP\tS563\t-1.5176525
MTUS1\tS399\t-0.6744755
MTUS1\tS443\t0.2179435
MTX3\tS284\t0.3975839
MUC16\tS772\t0.1833276
MUC16\tT774\t0.1833276
MUM1\tS472\t-0.09343258
MUS81\tS60\t-0.04613136
MVB12A\tS170\t-0.03889355
MVB12A\tS232\t-0.7201365
MVB12B\tT211\t0.141084268
MVP\tS864\t-0.2217241
MVP\tS867\t-0.39857435
MVP\tS873\t-0.3508536
MXRA7\tS128\t-0.449848
MYBBP1A\tS11\t-0.1060787
MYBBP1A\tS1163\t0.206018
MYBBP1A\tS1186\t-0.9448321
MYBBP1A\tS1267\t0.07683272
MYBBP1A\tS1308\t0.2346239
MYBBP1A\tS492\t0.081844285
MYBBP1A\tT1269\t-0.2834041
MYBL2\tS217\t0.1545833
MYBL2\tS258\t0.005471901
MYBL2\tS397\t-0.2843443
MYBL2\tS428\t0.46206515
MYBL2\tT242\t-0.03775449
MYBL2\tT381\t0.5261689
MYBL2\tT416\t0.8690028
MYC\tS76\t-3.188215
MYC\tS78\t-3.228824
MYC\tT72\t-3.029971
MYCBP2\tS1472\t0.040262078
MYCBP2\tS2315\t-0.4050884
MYCBP2\tS2749\t0.0569743
MYCBP2\tS2751\t0.35672115
MYCBP2\tS2774\t0.5050778
MYCBP2\tS3467\t-1.590832
MYCBP2\tS3893\t0.02386096
MYCBP2\tS3894\t0.08558378
MYD88\tS244\t-0.4184463
MYEF2\tS17\t-0.1805116
MYEF2\tT13\t-0.06481183
MYH10\tS1937\t0.412047955
MYH10\tS1939\t0.3832627
MYH10\tS1952\t-0.0694487
MYH10\tS1956\t-0.16401764
MYH10\tS1962\t-0.2851259
MYH10\tS641\t-0.268556
MYH3\tS161\t0.4383832
MYH9\tS1714\t0.09301919
MYH9\tS1943\t0.02460336
MYL12A\tS19\t0.04614182
MYL12A\tT18\t-0.04419625
MYLK\tS576\t0.77998795
MYLK\tS579\t-0.48001605
MYO10\tS1143\t0.1086248
MYO10\tS1148\t-0.121178755
MYO10\tS1883\t-0.1219261
MYO10\tT1158\t0.1340894
MYO10\tT1888\t0.4838368
MYO16\tS955\t-0.038796488
MYO18A\tS102\t-0.243224
MYO18A\tS140\t0.1095611
MYO18A\tS145\t0.059767185
MYO18A\tS164\t0.3914378
MYO18A\tS1640\t-0.01887803
MYO18A\tS1970\t-0.1750096
MYO18A\tS1974\t0.1382902
MYO18A\tS2020\t-0.36862275
MYO18A\tS2041\t0.082278873
MYO18A\tS2043\t0.1718473
MYO18A\tS234\t2.59800685
MYO18A\tS35\t0.2182696
MYO18A\tS72\t0.6325478
MYO18A\tS74\t0.03280615
MYO18A\tS83\t0.91696085
MYO18A\tS985\t0.72669095
MYO1B\tS60\t0.2056428
MYO1C\tS10\t-0.233118484
MYO1C\tS389\t0.08501676
MYO1C\tS845\t0.02502885
MYO1E\tT1011\t0.84819625
MYO5A\tS1205\t-0.4941492
MYO5A\tS1477\t-0.04342966
MYO5A\tS600\t0.08392822
MYO9A\tS1230\t0.2713062
MYO9A\tS1299\t0.009920342
MYO9A\tS1317\t-0.4231007
MYO9A\tS1733\t0.1431322
MYO9B\tS1043\t0.6283537
MYO9B\tS1114\t-0.079707712
MYO9B\tS1115\t-0.09005026
MYO9B\tS1253\t0.06942715
MYO9B\tS1261\t0.2036397
MYO9B\tS1267\t-0.394983
MYO9B\tS1290\t-0.1784204
MYO9B\tS1354\t0.3670355
MYO9B\tS1405\t-0.524168
MYO9B\tS1408\t-0.53415095
MYO9B\tS1992\t-0.22218495
MYO9B\tS2035\t-0.06693817
MYO9B\tS717\t-0.4537155
MYO9B\tT1271\t-0.6482812
MYO9B\tT1346\t-0.4375256
MYOF\tS174\t-0.15749835
MYOF\tS309\t-0.1105888
MYOF\tT172\t-0.003653625
MYSM1\tS110\t0.00302647
MYSM1\tS118\t0.09585344
MYSM1\tS265\t-0.1385528
MYSM1\tS267\t-0.31193821
MYSM1\tS340\t-0.0407937
MZF1\tS8\t-0.1915738
N4BP1\tS258\t0.01192487
N4BP1\tS288\t-0.40042925
N4BP1\tS300\t0.1008431
N4BP1\tT242\t0.3048614
N4BP1\tT426\t0.3075451
N4BP2\tT857\t-0.2714961
NAA10\tS186\t-0.001400102
NAA10\tS205\t-0.013282163
NAA10\tS209\t0.109354475
NAA11\tS186\t-0.2232391
NAA15\tS588\t0.4214855
NAA30\tS152\t0.145221
NAA30\tS190\t-0.4449074
NAA30\tS199\t-0.857103
NAA30\tS39\t-0.03926587
NAA30\tS55\t-0.06883129
NAA30\tS89\t-0.0387175
NAB1\tS183\t-0.3608419
NAB1\tS407\t-0.186968245
NAB2\tS147\t-0.07705842
NAB2\tS159\t-0.6390048
NAB2\tS162\t-0.5689179
NAB2\tS171\t-0.09005026
NAB2\tS209\t-0.044093935
NAB2\tS479\t0.4992718
NAB2\tS6\t0.01278325
NAB2\tT434\t0.006621249
NAB2\tT8\t-0.01505348
NACA\tS87\t0.17501525
NACA\tT82\t0.03745244
NAF1\tS315\t-0.01854186
NAGK\tS76\t-0.08243844
NAMPT\tS472\t0.1479579
NANS\tS134\t0.01264022
NAP1L1\tS10\t0.324004
NAP1L1\tS69\t0.07313477
NAP1L1\tT62\t0.3524196
NAP1L4\tS12\t-0.111644225
NAP1L4\tS125\t-0.04334858
NAP1L4\tS304\t-0.251280064
NAP1L4\tS5\t0.0344753
NAP1L4\tS7\t0.0481854
NAP1L4\tT51\t-0.2550983
NARG2\tS279\t-0.10791464
NARG2\tS468\t-0.089840355
NASP\tS244\t0.001586012
NASP\tS321\t-0.3435494
NASP\tS397\t-0.1106822
NASP\tS421\t0.1222089
NASP\tS451\t0.0247499
NASP\tS726\t-0.07114842
NASP\tT390\t0.3542265
NAT10\tS934\t0.1035311
NAT6\tS217\t0.2771516
NAV1\tS1374\t-0.1986096
NAV1\tS199\t0.1583371
NAV1\tS452\t0.08038475
NAV1\tS490\t0.1277653
NAV1\tS648\t-0.62750735
NAV1\tS754\t-0.01173338
NAV1\tS760\t0.1784573
NAV1\tS90\t-0.07728459
NAV2\tS1104\t-0.64035305
NAV2\tS1177\t-0.0448576
NAV2\tS1193\t0.2871176
NAV2\tS1232\t-0.02236109
NAV2\tS1393\t-0.3542954
NAV2\tS1397\t-0.229932235
NAV2\tS1401\t-0.3542954
NAV2\tS1524\t-0.97871045
NAV2\tS1526\t-0.368756
NAV2\tS1854\t0.1200864
NAV2\tS394\t-0.140428
NAV2\tS972\t0.007913023
NAV2\tT1234\t-0.05695087
NAV3\tS1113\t-0.03393872
NAV3\tS1186\t0.4114263
NAV3\tS1189\t0.107234075
NAV3\tS1190\t0.264893
NAV3\tS1245\t0.1719754
NAV3\tS1282\t-3.1093985
NAV3\tS1286\t-3.1093985
NAV3\tS1553\t0.4184599
NAV3\tS1566\t0.2420842
NAV3\tS275\t0.3236583
NAV3\tS654\t-0.367540925
NAV3\tS797\t0.5292712
NAV3\tS988\t0.1926992
NAV3\tT1112\t-0.13505244
NBAS\tS473\t-0.01372705
NBEA\tS1526\t0.05283319
NBEA\tS1711\t-0.5932033
NBEAL1\tS2589\t-0.09846104
NBEAL2\tS1829\t-0.1872143
NBEAL2\tS2555\t-0.74772965
NBEAL2\tS2558\t-0.323163105
NBEAL2\tT1683\t-1.655717
NBEAL2\tT1825\t-0.1872143
NBN\tS397\t0.2340108
NBN\tS432\t0.1245928
NBR1\tS622\t0.3560218
NBR1\tS656\t0.5684214
NBR1\tT658\t0.70233015
NCAM1\tS774\t-0.6199134
NCAM2\tS644\t-0.1273134
NCAPD2\tS1330\t-1.81504575
NCAPD2\tS1333\t-1.6375
NCAPD2\tS585\t0.3074285
NCAPD2\tT1331\t-2.592159
NCAPD2\tT1339\t0.9778759
NCAPD3\tS1384\t0.01392662
NCAPG\tS390\t0.3164249
NCAPG\tS674\t0.00302647
NCAPG\tS973\t0.0167816
NCAPG\tS975\t0.0167816
NCAPG\tT931\t0.7135343
NCAPH\tS27\t-0.9972311
NCAPH\tS432\t0.4304994
NCAPH\tT49\t0.2884176
NCAPH2\tS186\t0.1491292
NCAPH2\tS262\t0.06488286
NCBP1\tS22\t-4.594365
NCDN\tS3\t0.03787417
NCK1\tS85\t-1.639085
NCK1\tS91\t1.090108
NCK2\tS90\t-0.00323195
NCK2\tS94\t0.2620723
NCK2\tY110\t-0.4208971
NCKAP5L\tS1269\t-1.41997
NCKAP5L\tS177\t-0.44052645
NCKAP5L\tS447\t0.19651045
NCKAP5L\tS489\t0.3673619
NCKAP5L\tS494\t0.288095795
NCKAP5L\tS763\t-0.9431113
NCL\tS145\t-0.32036
NCL\tS153\t-0.32036
NCL\tS28\t0.14100244
NCL\tS34\t0.14100244
NCL\tS41\t-0.04169926
NCL\tS42\t0.05769283
NCL\tS580\t0.125651
NCL\tS619\t0.0844
NCL\tS67\t0.09342498
NCL\tT69\t0.2278643
NCOA1\tS22\t0.02219017
NCOA1\tS372\t-0.1961778
NCOA1\tS698\t-0.1833921
NCOA2\tS29\t0.008773791
NCOA2\tS699\t-0.03331266
NCOA3\tS214\t0.04656085
NCOA3\tS551\t-0.03142997
NCOA3\tS569\t-0.04625051
NCOA3\tS694\t0.1130337
NCOA3\tS857\t0.05074544
NCOA3\tS860\t0.033146445
NCOA3\tS867\t0.1953476
NCOA5\tS164\t0.146689
NCOA5\tS381\t-0.6433503
NCOA5\tS9\t-0.08242314
NCOA6\tS1745\t-0.159781585
NCOA6\tS2018\t-1.444243
NCOA7\tS162\t0.30228055
NCOA7\tS179\t0.780812153
NCOA7\tS211\t0.03632757
NCOA7\tS585\t0.442227
NCOR1\tS1015\t-0.08787139
NCOR1\tS1212\t0.1223414
NCOR1\tS1279\t0.8508794
NCOR1\tS13\t1.348737
NCOR1\tS1488\t0.346191
NCOR1\tS1549\t0.097690755
NCOR1\tS157\t-0.126927
NCOR1\tS158\t0.01906128
NCOR1\tS172\t0.05686093
NCOR1\tS1874\t0.1779815
NCOR1\tS1878\t0.1779815
NCOR1\tS2017\t-0.05074153
NCOR1\tS2081\t0.1236661
NCOR1\tS2099\t1.03780375
NCOR1\tS2234\t-0.02707209
NCOR1\tS224\t-0.1787306
NCOR1\tS2292\t0.86545755
NCOR1\tS933\t-0.06464438
NCOR1\tT1383\t0.608261
NCOR2\tS1018\t-0.1780286
NCOR2\tS1173\t0.1557492
NCOR2\tS121\t1.6377335
NCOR2\tS1251\t0.6041662
NCOR2\tS149\t-0.20969017
NCOR2\tS152\t-0.02041585
NCOR2\tS1539\t1.140844
NCOR2\tS1778\t-0.5794476
NCOR2\tS1855\t-0.1034724
NCOR2\tS1861\t0.347166685
NCOR2\tS1864\t-0.1387433
NCOR2\tS1974\t0.158854
NCOR2\tS2008\t0.2957772
NCOR2\tS2057\t0.1314578
NCOR2\tS215\t-0.07521603
NCOR2\tS2226\t-0.1200904
NCOR2\tS2261\t-0.002859378
NCOR2\tS2416\t-0.19921435
NCOR2\tS2429\t0.1589833
NCOR2\tS2456\t1.339993
NCOR2\tS750\t0.06087747
NCOR2\tS753\t-0.26621865
NCOR2\tS939\t0.28842989
NCOR2\tS956\t0.091980695
NCOR2\tT1383\t0.07737969
NCOR2\tT1436\t1.2963745
NCOR2\tT1455\t0.8714494
NCOR2\tT156\t0.0262015
NCOR2\tT946\t0.51482885
NDC80\tS69\t0.110096
NDE1\tS211\t0.40975775
NDE1\tS282\t0.4606901
NDE1\tT215\t0.5408981
NDE1\tT243\t0.4278206
NDE1\tT246\t0.169925
NDEL1\tS231\t1.117555575
NDNL2\tS60\t0.174663995
NDNL2\tS64\t0.2288495
NDRG1\tS260\t-0.7356197
NDRG1\tS262\t-0.280083268
NDRG1\tS263\t0.04096256
NDRG1\tS266\t-0.1276676
NDRG1\tS292\t0.01578305
NDRG1\tT258\t-0.6004679
NDRG1\tT265\t-0.37223535
NDRG1\tT296\t0.05649509
NDRG2\tS289\t0.167548825
NDRG2\tS303\t0.05408155
NDRG2\tS307\t-0.00540835
NDRG2\tS309\t-0.4581284
NDRG2\tT287\t0.45532915
NDRG2\tT305\t-0.00540835
NDRG3\tS315\t-0.1618631
NDRG3\tS319\t-0.2983032
NDRG3\tS322\t-0.23093905
NDRG3\tS323\t-0.159282565
NDRG3\tT317\t0.1222659
NDRG4\tS17\t0.3558898
NDUFB7\tS73\t0.02517066
NDUFV3\tS162\t-0.1476815
NDUFV3\tS164\t-0.05818751
NDUFV3\tS470\t0.03040665
NDUFV3\tS98\t0.1147668
NEDD1\tS411\t-0.61294505
NEDD1\tS516\t0.04684024
NEDD4\tS328\t-0.207584
NEDD4L\tS303\t0.030023705
NEDD4L\tS342\t-0.343435
NEDD4L\tS448\t0.01957266
NEDD4L\tS449\t0.2723816
NEDD4L\tS475\t0.04918825
NEDD4L\tS479\t0.27453
NEDD4L\tS483\t0.1139672
NEDD4L\tS487\t0.27453
NEDD4L\tT318\t-0.6921285
NEDD4L\tT473\t0.62252025
NEDD9\tY345\t-0.1803155
NEFL\tS472\t-0.1115392
NEIL2\tS68\t-0.005550656
NEIL2\tT70\t0.04697992
NEIL3\tS450\t0.31329987
NEK1\tS1057\t-0.097965
NEK1\tS799\t-1.137743
NEK1\tS805\t-0.7149174
NEK1\tS983\t-0.01635147
NEK4\tS372\t-0.41036315
NEK4\tS395\t0.7704748
NEK4\tS474\t0.4565959
NEK4\tS572\t-0.9491988
NEK4\tS588\t-0.06546082
NEK9\tS29\t-1.020282
NEK9\tS868\t-0.8117003
NELFA\tS363\t-0.2261555
NELFA\tT277\t-1.926591
NELFA\tT365\t-0.1121141
NELFB\tS557\t-0.1770333
NELFE\tS115\t-0.008653237
NELFE\tS353\t0.08895719
NELFE\tS51\t0.3970362
NEMF\tS375\t-0.08347749
NEMF\tS705\t-0.09862908
NEMF\tS706\t-0.09862908
NEMF\tS789\t-1.978918
NEMF\tS791\t-1.609376
NEO1\tS863\t0.248292
NES\tS1282\t0.20373165
NES\tS1347\t-0.191442
NES\tS1409\t-0.04388382
NES\tS1418\t-0.04388382
NES\tS1452\t-0.99715255
NES\tS1577\t-0.0264989
NES\tS352\t-0.5139344
NES\tS358\t-1.0312055
NES\tS413\t0.018711
NES\tS471\t-0.3156839
NES\tS578\t0.09639683
NES\tS680\t-0.7988179
NES\tS768\t0.06212175
NES\tS934\t-0.08555793
NET1\tS21\t-0.6635566
NEURL4\tS465\t0.3043942
NEURL4\tS865\t-0.00660736
NEURL4\tS870\t-0.2036049
NF1\tS2515\t0.05949366
NF1\tS2521\t-0.5185771
NF1\tS2523\t-1.2423475
NF1\tS2543\t-0.706347
NF1\tS2597\t-2.0270425
NF1\tS2802\t-0.05892373
NF1\tS864\t0.399554
NF1\tS876\t-1.5284475
NF1\tS879\t-1.7596775
NF1\tS882\t-1.725935
NF1\tS883\t-0.4704291
NF1\tT2565\t-0.02343107
NF1\tT862\t0.5062067
NF2\tS315\t-0.299118765
NF2\tS518\t-0.04872551
NFAT5\tS484\t0.10458856
NFAT5\tS485\t0.1004395
NFATC1\tS220\t-0.08098795
NFATC1\tS232\t-0.3534134
NFATC1\tS890\t-0.1637204
NFATC2\tS128\t0.4245997
NFATC2\tS197\t-0.4848326
NFATC2\tS20\t-0.4296148
NFATC2\tS201\t-0.4848326
NFATC2\tS205\t-1.541534
NFATC2\tS216\t0.03618686
NFATC2\tS235\t-0.7744289
NFATC2\tS248\t-0.16065325
NFATC2\tS343\t0.01720924
NFATC2\tS717\t-0.16775
NFATC2\tS737\t0.151805975
NFATC2\tS739\t0.148148106
NFATC2\tS781\t-0.31743855
NFATC2\tS836\t-0.1397444
NFATC2\tS90\t0.4512243
NFATC2IP\tS127\t0.18199105
NFATC2IP\tS204\t-0.1240941
NFATC2IP\tS314\t0.1496496
NFATC2IP\tS369\t0.2261386
NFATC2IP\tS84\t0.3984598
NFATC2IP\tS88\t0.2370741
NFATC2IP\tS90\t0.2370741
NFATC2IP\tS92\t0.2370741
NFATC3\tS1063\t-0.6050908
NFATC3\tS247\t0.01345169
NFATC3\tS344\t-2.904116
NFATC3\tS366\t-0.03831742
NFATC4\tS213\t-0.010535
NFATC4\tS217\t0.1953476
NFATC4\tS289\t-0.1686254
NFATC4\tS295\t-0.09387246
NFE2L2\tS199\t-0.1021401
NFIA\tS300\t-0.1455734
NFIA\tS319\t-0.1455734
NFIB\tS328\t0.1317212
NFIB\tT359\t0.4387695
NFIC\tS185\t-0.10213745
NFIC\tS313\t-0.03374672
NFIC\tS314\t-0.005970677
NFIC\tS324\t0.1333004
NFIC\tS330\t0.188021
NFIC\tS334\t-0.1756313
NFIL3\tS353\t-2.397752
NFIX\tS300\t0.007913023
NFIX\tS300\t-0.07602172
NFIX\tS340\t0.235482
NFIX\tS360\t0.2561654
NFKB1\tS893\t-0.1212825
NFKB1\tS937\t0.02955887
NFKB2\tS23\t0.4065367
NFKBIE\tS183\t-0.2370814
NFRKB\tS1021\t0.4520683
NFRKB\tS1290\t-0.05407774
NFRKB\tS226\t-0.1850805
NFRKB\tS298\t-0.001457859
NFRKB\tS351\t-0.07963043
NFRKB\tS494\t0.07491644
NFYA\tS297\t0.2691529
NGDN\tS142\t0.076179415
NGDN\tS143\t0.076179415
NGDN\tS214\t-0.1128179
NGEF\tY11\t-0.03670348
NGEF\tY12\t-0.03670348
NGFR\tT199\t-0.01429554
NGFR\tT264\t-0.19737501
NGRN\tS41\t0.05658348
NHLRC2\tS221\t-0.30829405
NHS\tS237\t-0.3995025
NHS\tT819\t-0.1527567
NHSL1\tS1085\t-0.3316085
NHSL1\tS1163\t0.51311515
NHSL1\tS1177\t0.8708696
NHSL1\tS1187\t0.1573025
NHSL1\tS1229\t-1.280124
NHSL1\tS1272\t-0.9559276
NHSL1\tS1288\t-0.9755101
NHSL1\tS1382\t-0.1392874
NHSL1\tS1384\t-0.9451099
NHSL1\tS1398\t1.398022
NHSL1\tS150\t-0.2052473
NHSL1\tS1551\t0.8914192
NHSL1\tS190\t0.177854
NHSL1\tS324\t0.1482182
NHSL1\tS926\t-0.7713968
NHSL1\tS937\t-0.8012041
NHSL1\tT1231\t-1.2925885
NHSL1\tT132\t-0.030344785
NHSL1\tT1346\t-0.4599926
NHSL1\tT1388\t-1.391456
NHSL1\tT209\t0.2950176
NIN\tS1107\t0.1035311
NIN\tS1119\t-0.118925905
NIN\tS1155\t-0.1273052
NIN\tS1500\t0.3963788
NIN\tS1512\t0.1331689
NIN\tS234\t0.116269375
NIN\tS803\t0.5760868
NINL\tS191\t-0.2421234
NIPBL\tS2658\t0.02644594
NIPBL\tS2672\t-0.1319612
NIPBL\tS274\t-0.3676759
NIPBL\tS280\t-0.39636175
NIPBL\tS318\t-0.08415025
NIPBL\tS350\t-0.02143826
NISCH\tS1284\t0.03455219
NKAP\tS149\t0.03801472
NKAP\tS157\t-0.1843426
NKAP\tT161\t-0.1843426
NKTR\tS1077\t0.153546
NKTR\tS1146\t-1.436979
NKTR\tS463\t0.2642361
NKTR\tT1155\t0.25222555
NKX2-4\tS271\t0.05977056
NMD3\tS11\t0.159858695
NMD3\tS25\t-0.04504441
NMD3\tS258\t-0.2426011
NMD3\tS468\t0.3284984
NMD3\tT433\t0.2613706
NMD3\tT470\t0.28097265
NME1\tS120\t0.03632757
NME1\tS122\t-0.03244768
NME2\tS235\t0.003889986
NME2\tT94\t0.306379
NMNAT1\tS117\t-0.1926945
NMT1\tS47\t0.08038475
NMT1\tS83\t-0.5389326
NMT2\tS38\t0.03745244
NO66\tS109\t0.2097652
NOB1\tS184\t-0.09933989
NOB1\tS201\t0.07505342
NOC2L\tS49\t0.080488171
NOC2L\tS56\t0.1422174
NOC2L\tS672\t-0.021453148
NOC2L\tS673\t-0.071418888
NOC3L\tS787\t0.405161
NOL3\tT149\t-0.06082435
NOL6\tS283\t0.007195495
NOL6\tS289\t0.05893986
NOL8\tS1044\t-0.0450146
NOL8\tS1045\t-0.0450146
NOL8\tS1046\t-0.0450146
NOL8\tS1061\t0.02800333
NOL8\tS298\t0.3298698
NOL8\tS304\t0.3298698
NOL8\tS365\t0.1263122
NOL8\tS378\t-0.02638136
NOL8\tT302\t0.3298698
NOL8\tT381\t0.06322686
NOL9\tS84\t-0.2892454
NOL9\tS88\t-0.2892454
NOL9\tS93\t-0.2255988
NOL9\tS97\t-0.2144472
NOL9\tT90\t-0.2255988
NOLC1\tS563\t-0.03420462
NOLC1\tS643\t0.2251515
NOM1\tS317\t0.03040665
NOM1\tS320\t0.03040665
NOM1\tS321\t0.03040665
NOM1\tS57\t-0.168328619
NOMO1\tS1205\t0.1561377
NOMO3\tS1205\t0.01306909
NONO\tT410\t0.2740656
NONO\tT428\t0.2127561
NONO\tT450\t0.2337653
NOP14\tS146\t0.252763455
NOP14\tS148\t0.005154557
NOP14\tS157\t0.28496195
NOP14\tS96\t0.1257833
NOP2\tS181\t0.03576464
NOP2\tS36\t0.27626875
NOP2\tS58\t-1.325214
NOP2\tS666\t0.6821238
NOP2\tS732\t-0.01500969
NOP2\tS734\t-0.0571957
NOP2\tS786\t0.13765435
NOP2\tT185\t0.03576464
NOP2\tT195\t0.1184926
NOP2\tT603\t0.2865311
NOP56\tS519\t-0.0368601
NOP56\tS520\t-0.0778971
NOP56\tS563\t-1.87706875
NOP56\tS569\t0.1678717
NOP56\tS570\t0.14596755
NOP58\tS109\t-0.62522795
NOP58\tS483\t0.63896685
NOP58\tS502\t0.001469865
NOP58\tS514\t-0.02489323
NOSIP\tS138\t-0.09887633
NOSIP\tT168\t0.3872522
NOTCH2\tS1778\t0.4557546
NOTCH2\tT1716\t-0.1346354
NPAT\tS1151\t-0.02579328
NPAT\tS1296\t-1.5491075
NPAT\tS207\t-0.001602306
NPAT\tS554\t-1.07192775
NPHP4\tS142\t-0.280615
NPM1\tS10\t0.0545572
NPM1\tS125\t0.1158324
NPM1\tS242\t0.2672564
NPM1\tS243\t0.08406419
NPM1\tS254\t0.62734745
NPM1\tS4\t0.1513393
NPM1\tS6\t-0.6114908
NPM1\tS70\t-0.01286838
NPM1\tS88\t-0.07093623
NPM1\tT95\t0.32279635
NQO1\tS82\t-0.1855726
NR1H3\tS63\t-0.4343053
NR2C1\tS215\t-0.80763575
NR2C2\tS19\t0.1497797
NR2C2\tS219\t-0.3123838
NR2C2\tS328\t0.3591837
NR2C2\tS46\t0.1158324
NR2C2\tS55\t0.1454818
NR2C2\tS68\t0.2138761
NR2C2\tT224\t0.040000325
NR2C2\tT352\t0.000721115
NR2F6\tS40\t0.116551725
NR3C1\tS269\t-0.15025671
NR3C1\tS45\t0.9309862
NR3C1\tT8\t-0.2398217
NR4A1\tS205\t-0.1688362
NR4A2\tS118\t-1.0341397
NR4A2\tS187\t-0.4645443
NR4A2\tS288\t-0.7167419
NR4A2\tS296\t-0.2612927
NRBF2\tS103\t-0.4468165
NRBP1\tS11\t-0.3466305
NRBP1\tS2\t0.0542234
NRBP1\tS422\t-0.8127644
NRBP1\tS428\t-0.2560123
NRBP1\tT431\t-0.2272022
NRBP1\tT433\t0.03576464
NRBP2\tS26\t-0.24587282
NRBP2\tT411\t-0.2159316
NRD1\tS86\t0.007913023
NRD1\tS94\t0.08406419
NRD1\tS96\t0.285347514
NRF1\tS136\t0.09247811
NRIP1\tS626\t0.001683315
NRIP2\tS46\t-0.1712547
NSD1\tS217\t0.2006386
NSD1\tS2202\t0.115566
NSF\tS202\t-0.183947005
NSFL1C\tS114\t-0.02561753
NSFL1C\tS272\t0.05227683
NSL1\tS4\t-0.03851003
NSL1\tT242\t0.11369046
NSMCE4A\tT345\t-2.190948
NSRP1\tS248\t-0.031484153
NSRP1\tS254\t0.04049151
NSRP1\tS255\t-0.06671438
NSRP1\tS33\t0.1009776
NSRP1\tT275\t0.256286
NSUN2\tS456\t0.08963377
NSUN2\tS473\t-0.2319724
NSUN2\tS743\t-0.04303549
NSUN2\tS751\t-0.026289545
NSUN2\tT453\t-0.094854083
NSUN4\tS157\t0.1175621
NSUN5\tS167\t-0.1278725
NSUN5\tS327\t0.115566
NSUN5P2\tS444\t0.310471
NSUN5P2\tT442\t0.310471
NT5C\tS182\t-0.1049301
NTF4\tS170\t0.1468761
NTHL1\tS37\t0.06488286
NUCB1\tS369\t-0.2767298
NUCB1\tT148\t-0.2073278
NUCKS1\tS113\t-0.06411792
NUCKS1\tS130\t-0.150433
NUCKS1\tS132\t-0.150433
NUCKS1\tS144\t-0.12767631
NUCKS1\tS181\t0.168727843
NUCKS1\tS19\t-0.02870476
NUCKS1\tS204\t-0.113276465
NUCKS1\tS214\t-0.17823365
NUCKS1\tS223\t0.04110281
NUCKS1\tS229\t0.02573757
NUCKS1\tS234\t0.02573757
NUCKS1\tS240\t0.02573757
NUCKS1\tS54\t-0.2386977
NUCKS1\tS58\t-0.1539762
NUCKS1\tS61\t-0.1397125
NUCKS1\tS73\t-0.06790855
NUCKS1\tS75\t-0.089692717
NUCKS1\tS79\t-0.048028913
NUCKS1\tT179\t0.3373114
NUCKS1\tT202\t-0.059177545
NUDC\tS139\t0.038517563
NUDC\tS260\t-0.135079
NUDC\tS277\t0.36182595
NUDC\tS281\t0.02389408
NUDC\tT108\t0.06073913
NUDC\tT145\t0.003900825
NUDCD1\tS388\t-0.440146
NUDCD3\tS146\t0.04208399
NUDT9\tS71\t0.144424695
NUFIP1\tS403\t-0.09075569
NUFIP2\tS112\t0.3912178
NUFIP2\tS212\t0.4931349
NUFIP2\tS214\t0.56553485
NUFIP2\tS608\t0.2932523
NUFIP2\tS629\t-0.7808594
NUFIP2\tS652\t0.1424789
NUFIP2\tT220\t0.1355624
NUFIP2\tT571\t0.006190286
NUFIP2\tT631\t-1.0273515
NUMA1\tS1225\t0.04278438
NUMA1\tS169\t-0.1658713
NUMA1\tS1757\t-0.2837377
NUMA1\tS1769\t0.1677432
NUMA1\tS1862\t0.4823335
NUMA1\tS200\t0.1592589
NUMA1\tS271\t-0.4959797
NUMA1\tS395\t0.3257317
NUMA1\tT1776\t0.4244922
NUMA1\tT2000\t0.09653179
NUMA1\tT2055\t0.1723594
NUMA1\tT2106\t0.1976139
NUMB\tS292\t0.5394318
NUMB\tS350\t-1.523338
NUMB\tS575\t0.153027
NUMB\tT352\t-0.3384548
NUMBL\tT279\t1.01901655
NUP107\tS11\t0.2817873
NUP107\tS37\t-0.1946085
NUP107\tS4\t-0.01361091
NUP107\tT46\t0.62938
NUP107\tT82\t-0.4289336
NUP133\tS41\t-0.04485701
NUP133\tS45\t0.3819478
NUP133\tS50\t0.01321208
NUP133\tS7\t0.4333868
NUP133\tT28\t0.4064278
NUP153\tS192\t0.02361021
NUP153\tS203\t-0.08738079
NUP153\tS209\t0.1070183
NUP153\tS240\t0.05491792
NUP153\tS320\t0.2602666
NUP153\tS330\t-0.6242432
NUP153\tS334\t-0.58719445
NUP153\tS338\t-1.5231245
NUP153\tS343\t0.2834477
NUP153\tS516\t-1.88518
NUP153\tS522\t0.39005005
NUP153\tS529\t0.4435006
NUP153\tS607\t0.4042492
NUP153\tS614\t-1.193041
NUP153\tS633\t0.2462257
NUP153\tT102\t-0.104899
NUP153\tT588\t0.05797008
NUP153\tT699\t0.67055855
NUP155\tS994\t-0.080176644
NUP160\tS1157\t-0.01773837
NUP188\tS1709\t-0.57080535
NUP188\tS1717\t-0.645277
NUP205\tS1165\t0.04502354
NUP205\tS1167\t0.04572251
NUP205\tS1939\t0.2634132
NUP205\tS1942\t0.087114195
NUP205\tT3\t0.156262505
NUP210\tT1844\t0.1561377
NUP214\tS1070\t-0.2268645
NUP214\tS1170\t-0.341813025
NUP214\tS430\t2.449456
NUP214\tS433\t-1.2565175
NUP214\tS537\t-2.0892585
NUP214\tS599\t-1.6831365
NUP214\tS667\t-0.2029206
NUP214\tS929\t0.09098883
NUP214\tS991\t-0.1749308
NUP214\tT1192\t-0.8336701
NUP214\tT437\t-1.31763025
NUP214\tT990\t-0.2176082
NUP35\tS242\t-0.1235754
NUP35\tS38\t-0.082155305
NUP35\tS49\t0.5302706
NUP35\tS56\t0.352797158
NUP35\tS8\t-2.6261375
NUP35\tS88\t0.9250736
NUP35\tT248\t-0.16955
NUP35\tT256\t-0.1729778
NUP35\tT291\t0.1989969
NUP35\tT31\t-1.625934
NUP35\tT48\t-1.625934
NUP50\tS221\t-0.8816935
NUP50\tS315\t0.4239545
NUP50\tS330\t0.1815478
NUP50\tS52\t0.131123755
NUP54\tS241\t-0.02951446
NUP62\tS418\t0.1742785
NUP85\tS617\t-0.043300865
NUP88\tS35\t-0.13183296
NUP88\tS49\t-0.1370146
NUP88\tS50\t-0.2109757
NUP88\tS517\t-0.002107897
NUP88\tT525\t0.1897929
NUP93\tS52\t-0.1799559
NUP93\tS80\t-0.8659631
NUP93\tT236\t-0.2983888
NUP98\tS1023\t0.06115411
NUP98\tS1028\t-0.2490848
NUP98\tS1060\t0.005471901
NUP98\tS608\t0.08093054
NUP98\tS612\t-0.91319825
NUP98\tS623\t-1.54393
NUP98\tS673\t-0.8759896
NUP98\tS681\t-0.02689571
NUP98\tS888\t-0.04380954
NUP98\tS934\t0.01963077
NUP98\tT1000\t-0.0490684
NUP98\tT1022\t0.1385524
NUP98\tT1669\t0.169027
NUP98\tT670\t-0.3009459
NUP98\tT687\t-0.20754207
NUPL2\tS106\t-0.242001415
NUSAP1\tS148\t0.3662523
NUSAP1\tS350\t0.63174475
NUSAP1\tT242\t0.5324667
NUSAP1\tT347\t0.74731485
NVL\tS211\t0.02034214
NXF1\tS9\t-0.2436086
OBSL1\tS10\t0.05450115
OBSL1\tS120\t-0.8150977
OCIAD1\tS108\t0.2601461
ODF2\tT243\t-0.059063535
ODF2\tT87\t-0.190602
OFD1\tS629\t-0.04005182
OFD1\tS680\t0.1357976
OFD1\tS734\t-1.04216
OGFR\tS315\t-0.07120904
OGFR\tS349\t-0.1747028
OGFR\tS378\t-0.305931
OGFR\tS484\t-0.01955052
OGFR\tS517\t-0.299485975
OGFR\tS525\t-0.630216825
OGFR\tS537\t-0.2274893
OGFR\tS557\t-0.16996608
OGFR\tS559\t-0.22211525
OGFR\tS565\t-0.07366654
OGFR\tS577\t-0.06567221
OGFR\tS579\t-0.08071329
OGFR\tS597\t-0.1124747
OGFR\tT561\t-0.06214337
OGFRL1\tS381\t-0.04058593
OIP5\tT221\t0.04572251
OLFML2A\tS334\t0.8563643
ORC1\tS199\t-0.1815167
ORC1\tS201\t0.19550345
ORC1\tS258\t0.3115032
ORC1\tS273\t0.09518178
ORC1\tS478\t-0.27892302
ORC2\tT226\t0.01578305
ORC6\tT195\t0.3383388
OSBP\tS190\t-0.0463846
OSBP\tS193\t-0.2714263
OSBP\tS238\t0.05505682
OSBP\tS240\t-0.03886564
OSBP\tS338\t0.2055176
OSBP\tS351\t-0.2254301
OSBP\tS379\t-0.09324865
OSBP\tT377\t-0.66295805
OSBPL10\tS209\t-0.669304
OSBPL10\tS223\t0.3961595
OSBPL10\tS507\t0.01616577
OSBPL11\tS189\t-0.1164261
OSBPL11\tS201\t-0.1973849
OSBPL11\tS286\t0.4438188
OSBPL11\tT27\t0.2786984
OSBPL1A\tS460\t1.030124
OSBPL1A\tS499\t-1.141398
OSBPL1A\tS515\t-0.1295919
OSBPL3\tS251\t0.512702015
OSBPL3\tS265\t0.9339503
OSBPL3\tS304\t0.03040665
OSBPL3\tS372\t-0.1776043
OSBPL3\tS374\t-0.1494432
OSBPL3\tS410\t-0.06623101
OSBPL3\tS437\t-0.5810667
OSBPL5\tS44\t-0.01836652
OSBPL5\tS66\t-2.1365715
OSBPL5\tS82\t0.2515676
OSBPL8\tS14\t0.2242873
OSBPL8\tS314\t0.5253673
OSBPL8\tS35\t-0.1669075
OSBPL8\tS364\t-0.2522947
OSBPL8\tS65\t-0.5832251
OSBPL8\tS807\t-0.1777535
OSBPL8\tS808\t-0.128803
OSBPL8\tS810\t-0.1859729
OSBPL8\tT39\t0.18600419
OSBPL9\tS248\t0.1440464
OSBPL9\tS530\t-0.20299475
OSTM1\tS322\t-1.102961
OTUD4\tS1005\t-0.2862338
OTUD4\tS1022\t-0.04929984
OTUD4\tS1023\t-0.08585471
OTUD4\tS442\t-0.08958966
OTUD5\tS165\t0.9918257
OTUD5\tS177\t-0.8449759
OTUD5\tS64\t-0.07911219
OTUD7B\tS464\t-0.15634132
OTUD7B\tS467\t-0.15634132
OTUD7B\tT547\t0.6559929
OXR1\tS193\t-2.59495175
OXR1\tS194\t-2.711039
OXR1\tS196\t0.5155106
OXR1\tS347\t0.16756
OXSR1\tS339\t-0.09971082
P2RX7\tT359\t-0.2163171
PA2G4\tS2\t-0.09044956
PA2G4\tS361\t-0.17550205
PABPC1\tS315\t0.079195955
PABPC1\tS342\t0.1059022
PABPN1\tS150\t-0.1026356
PACRGL\tS47\t-0.16743163
PACS1\tS355\t0.2855797
PACS1\tS534\t0.2070182
PACS1\tT46\t0.044464
PACS2\tS315\t-0.17180435
PACS2\tS341\t-0.5690725
PACS2\tS378\t-0.01445587
PACSIN3\tS276\t-0.0869057
PACSIN3\tS319\t-0.1570453
PACSIN3\tS354\t0.05769283
PACSIN3\tT324\t0.7388975
PAF1\tS456\t-0.2344652
PAF1\tS460\t-0.2344652
PAF1\tS466\t-0.2344652
PAF1\tT200\t-0.01952021
PAFAH1B2\tS2\t-0.002801564
PAFAH1B2\tS64\t-0.3037747
PAG1\tS229\t0.007626157
PAG1\tS239\t0.6444101
PAG1\tS288\t0.1696685
PAG1\tS351\t-0.556005035
PAG1\tS354\t1.05326555
PAGE1\tS105\t0.0939657
PAGR1\tS143\t-0.05829271
PAGR1\tS148\t-0.05829271
PAGR1\tS237\t-0.2287736
PAGR1\tT138\t-0.05829271
PAICS\tS27\t0.6424705
PAICS\tT238\t0.2045164
PAK1\tS122\t-0.59753725
PAK1\tS46\t0.4069719
PAK1\tS76\t-0.2631741
PAK1\tT114\t-0.6608626
PAK1\tT132\t-0.13716956
PAK1IP1\tS320\t0.2005043
PAK1IP1\tS323\t0.19497425
PAK2\tS132\t0.094237912
PAK2\tS141\t0.2180992
PAK2\tS152\t0.01435528
PAK2\tS197\t0.3151024
PAK2\tS2\t0.2133784
PAK2\tS55\t0.4013028
PAK2\tS58\t-0.069774565
PAK2\tT134\t0.2186544
PAK2\tT154\t0.1722314
PAK2\tT162\t-0.241771
PAK2\tT169\t-0.1522916
PAK2\tT60\t0.1587248
PAK4\tS104\t0.1638265
PAK4\tS148\t0.4945692
PAK4\tS181\t-0.05017373
PAK4\tS195\t0.08949816
PAK4\tS258\t0.118388805
PAK4\tS267\t0.02304246
PAK4\tS474\t-0.01132623
PAK4\tT187\t0.12868775
PAK4\tT207\t0.2027625
PALB2\tS376\t0.03195977
PALLD\tS1116\t-0.1893348
PALLD\tS1118\t-0.1893348
PALLD\tS1121\t-0.143294875
PALLD\tS893\t-3.860819
PALM2\tS382\t0.1293995
PALM2\tS383\t-0.185868
PALM2\tS390\t-0.1500306
PALM2-AKAP2\tS155\t-0.7600887
PALM2-AKAP2\tS383\t-0.185868
PALM2-AKAP2\tS70\t-0.29417358
PALM3\tS303\t-0.166385075
PALM3\tS375\t0.04068203
PAN2\tS1185\t-0.43413835
PAN2\tT1184\t-0.3155151
PAN3\tT38\t0.4671752
PAN3\tT41\t0.39507085
PANK1\tS215\t0.32112
PANK2\tS45\t-0.05790221
PANK2\tS66\t-0.05370328
PANK4\tT367\t0.2415961
PAPD5\tS52\t0.4778845
PAPD7\tS541\t0.05018827
PAPOLA\tS24\t0.117170715
PAPOLG\tS525\t-1.82267
PAPOLG\tS716\t0.5611061
PARD3\tS1298\t-0.006535762
PARD3\tS383\t-0.2840013
PARD3\tS566\t0.01749438
PARD3\tS692\t-0.6101909
PARD3\tS728\t-0.08748806
PARD3\tS792\t0.1272371
PARD3\tS837\t-0.13731595
PARD3\tS852\t0.1257833
PARD3\tS973\t-0.1387751
PARD3\tT579\t-1.52874
PARD3B\tS363\t-0.13610759
PARD3B\tS366\t-0.02782735
PARD3B\tS368\t-0.05563627
PARD3B\tS90\t-0.3711984
PARD6A\tS108\t-0.1278725
PARD6B\tS11\t-0.2758387
PARG\tS137\t-0.2305498
PARG\tS291\t0.418136
PARN\tS496\t0.2499914
PARN\tS509\t0.064917635
PARN\tS558\t0.210074825
PARN\tS562\t0.3675947
PARP1\tS179\t-0.0614056
PARP1\tS277\t0.1293489
PARP1\tS75\t0.1075539
PARP1\tS782\t0.3599514
PARP12\tS75\t-0.4306823
PARP12\tS77\t-0.4306823
PARP2\tS33\t0.3466624
PARP2\tS34\t0.2497487
PARP4\tS1223\t-0.437389
PARP4\tS1713\t-0.01380005
PARP9\tY12\t0.024441995
PARVA\tS14\t-0.77192555
PARVA\tS4\t-0.44786027
PARVA\tS8\t-0.8372476
PARVA\tT16\t-1.09968
PARVA\tT3\t-0.8484789
PARVB\tS54\t-0.5336809
PASK\tS843\t-0.09014243
PATL1\tS120\t-0.4124965
PATL1\tS177\t0.042550865
PATL1\tS179\t-0.115113
PATL1\tS184\t-0.173888975
PATZ1\tS243\t-0.2718096
PATZ1\tS282\t0.078322431
PAWR\tS108\t-3.403301
PAWR\tT267\t0.1977253
PAX3\tS201\t0.1498074
PAX3\tS205\t0.1498074
PAX3\tS209\t0.4096896
PAXBP1\tS262\t-0.1701667
PAXBP1\tS557\t0.006046604
PAXBP1\tS558\t0.006046604
PAXBP1\tS62\t-0.1932523
PBDC1\tS197\t-0.06863459
PBK\tT9\t0.5956945
PBRM1\tS12\t0.8393953
PBRM1\tS13\t0.8393953
PBRM1\tS1468\t0.09801521
PBRM1\tS39\t-1.763563
PBRM1\tS498\t0.32496595
PBRM1\tS651\t0.5174268
PBX2\tS151\t0.1037997
PBX2\tS395\t0.050078705
PBXIP1\tS146\t-0.11482441
PBXIP1\tS147\t-0.11482441
PBXIP1\tS148\t-0.11482441
PCBP1\tS173\t-0.2653273
PCBP1\tS189\t0.06350289
PCBP1\tS190\t0.1330374
PCBP1\tS264\t0.0006449
PCBP1\tS323\t0.237746209
PCBP2\tS173\t0.02133754
PCBP2\tS188\t0.5299708
PCBP2\tS189\t0.4441369
PCBP2\tS189\t0.61335645
PCBP2\tS272\t-0.2876595
PCDH1\tS1140\t0.07477944
PCDH1\tS1173\t-0.08721215
PCDH1\tS918\t0.236462
PCDH1\tS949\t0.4407397
PCDH1\tS962\t-0.06943671
PCDH1\tS971\t0.48886945
PCDH1\tS984\t-0.072437085
PCDH1\tS986\t0.08944565
PCDH10\tS897\t-0.953076
PCDH7\tS1000\t-0.54422295
PCDH7\tS1011\t-0.3806527
PCDH7\tS1185\t0.2067682
PCDH7\tS1212\t-0.086077935
PCDH7\tS974\t-0.03932517
PCDH7\tS989\t-0.08223987
PCDH9\tS932\t-0.1139884
PCDHGB7\tS488\t0.037068
PCDHGB7\tS494\t0.037068
PCDHGB7\tS498\t0.037068
PCDHGC3\tS791\t-0.3163485
PCF11\tS169\t0.041487095
PCF11\tS707\t0.08922691
PCF11\tS800\t0.03759303
PCF11\tS836\t2.403595
PCF11\tS925\t0.3132458
PCF11\tT1530\t-0.007971191
PCF11\tT1535\t-0.05673123
PCF11\tT916\t-0.00043105
PCGF1\tS3\t0.08120319
PCID2\tS24\t0.294945445
PCIF1\tS116\t-0.3712358
PCIF1\tS14\t0.22580823
PCIF1\tS144\t0.00583033
PCIF1\tS19\t-0.1810513
PCIF1\tS26\t0.02684064
PCIF1\tS30\t-0.16293745
PCIF1\tS8\t0.000865329
PCIF1\tT150\t-0.605748125
PCM1\tS110\t0.96348175
PCM1\tS1206\t0.3831652
PCM1\tS1207\t0.5283712
PCM1\tS1318\t-0.5728658
PCM1\tS1697\t0.01192487
PCM1\tS1730\t0.117163
PCM1\tS1765\t-0.017919995
PCM1\tS1768\t-0.017919995
PCM1\tS1776\t-0.00082257
PCM1\tS1958\t-0.02405052
PCM1\tS370\t0.1198209
PCM1\tS372\t0.087153215
PCM1\tS431\t0.5804722
PCM1\tS533\t-0.1143163
PCM1\tS537\t-0.05261062
PCM1\tS542\t0.1174291
PCM1\tS65\t0.1471764
PCM1\tS68\t0.29603189
PCM1\tS69\t0.4587891
PCM1\tS779\t0.05630613
PCM1\tS861\t-0.04896435
PCM1\tS866\t0.1629835
PCM1\tS869\t-0.362556355
PCM1\tS872\t-0.15472397
PCM1\tS93\t-0.3726733
PCM1\tS991\t0.33715205
PCM1\tT1557\t0.6715652
PCM1\tT530\t-0.08456324
PCM1\tT859\t0.068912136
PCM1\tT877\t0.3937456
PCM1\tY535\t-0.08085061
PCNP\tS119\t-0.1129895
PCNP\tS53\t0.476533838
PCNP\tT139\t0.2330291
PCNT\tS1653\t-0.06015664
PCNT\tS2192\t-1.083936
PCNT\tS2214\t-0.2740407
PCNT\tS2352\t-0.1709786
PCNT\tS2477\t-0.32746385
PCNT\tS44\t-0.82626865
PCNX\tS117\t-0.1434046
PCNXL3\tS171\t0.4058835
PCNXL3\tS1909\t-0.2024391
PCNXL3\tS1955\t0.02488704
PCNXL3\tS246\t-0.4588619
PCNXL3\tS287\t-0.0422191
PCNXL3\tT370\t0.05394543
PCYT1A\tS233\t0.002162436
PCYT1A\tS343\t0.121546
PCYT1A\tS347\t0.1647863
PCYT2\tT342\t0.7396151
PDAP1\tS57\t-0.080766157
PDAP1\tS60\t-0.06438325
PDAP1\tS63\t-0.11181402
PDCD11\tS926\t0.233640325
PDCD4\tS446\t-1.276345
PDCD4\tS65\t-1.78081
PDCD4\tS83\t0.1098286
PDCD5\tS119\t0.1042025
PDCD5\tS42\t0.207847
PDE12\tS217\t-0.0544223
PDE12\tS220\t-0.2491706
PDE3B\tS65\t-0.4250169
PDE4A\tS276\t0.0548039
PDE4B\tS133\t0.08949816
PDE4B\tS275\t-0.4003776
PDE4D\tS284\t-0.17470015
PDE4D\tS51\t0.476952
PDE4D\tS55\t0.34975465
PDE4D\tS59\t0.34975465
PDE4D\tS651\t0.8676593
PDE4DIP\tS1096\t-1.581246
PDE4DIP\tS252\t-0.05082255
PDE7B\tS277\t-0.04982565
PDE7B\tT268\t-0.04982565
PDE8A\tS411\t-0.22639665
PDHA1\tS232\t0.1718473
PDHA1\tS293\t0.40757885
PDHA1\tS295\t0.2869995
PDHA1\tS300\t0.3547907
PDHA1\tT231\t0.2278643
PDHX\tS50\t-0.3077675
PDIA6\tS425\t-0.2661425
PDLIM1\tS90\t1.134089
PDLIM2\tS134\t0.4697757
PDLIM2\tS197\t-1.320955
PDLIM5\tS111\t0.3666999
PDLIM5\tS137\t-0.2249242
PDLIM5\tS309\t0.5748183
PDLIM5\tS313\t0.0930047
PDLIM5\tS332\t-0.4719288
PDLIM5\tS360\t-0.2071113
PDLIM5\tT355\t1.268494
PDPK1\tS241\t0.07833651
PDS5A\tS1195\t0.4021764
PDS5A\tS1305\t0.120352
PDS5B\tS1162\t0.1052758
PDS5B\tS1166\t0.02796425
PDS5B\tS1176\t-1.384652
PDS5B\tS1177\t-1.4862155
PDS5B\tS1182\t-0.49715215
PDS5B\tS1257\t-1.571965
PDS5B\tS1283\t0.04502354
PDS5B\tS1358\t-0.0764122
PDS5B\tS1383\t-0.004320131
PDS5B\tT1370\t-0.153636575
PDXDC1\tS718\t0.382029945
PDXDC1\tS722\t0.0352923
PDXDC1\tS779\t-0.208011
PDXDC1\tS786\t-0.0771351
PDZD8\tS521\t0.2783417
PDZD8\tS538\t-0.003958447
PDZD8\tS967\t0.7093789
PDZRN3\tS431\t0.08596853
PEA15\tS90\t-0.23183695
PEAK1\tS1250\t0.3459641
PEAK1\tS1253\t0.17517895
PEAK1\tS214\t0.1050075
PEAK1\tS281\t0.2785796
PEAK1\tS370\t-0.05749677
PEAK1\tS568\t-0.6779909
PEAK1\tS572\t-0.380803
PEAK1\tS819\t-0.1294025
PEAK1\tT1151\t0.1289532
PEAK1\tT539\t0.1392075
PEAK1\tY635\t1.400451
PEAK1\tY641\t3.041712
PEBP1\tS52\t-0.001631145
PEBP1\tS54\t0.107289695
PELI2\tS295\t-0.384806535
PELP1\tS1033\t0.01100133
PELP1\tS13\t0.04767794
PELP1\tS481\t0.05686093
PELP1\tS658\t-0.04254596
PELP1\tT1090\t0.007913023
PELP1\tT745\t-0.01369832
PER1\tS27\t-0.3160431
PEX1\tS859\t-0.2455571
PEX1\tS889\t-0.259461
PEX19\tS146\t0.083023215
PEX19\tS147\t-0.03265429
PEX5L\tS255\t-0.0982592
PFDN5\tS56\t0.03269809
PFKFB2\tS433\t0.07368314
PFKFB2\tT435\t-0.45908
PFKFB3\tS441\t-1.125826725
PFKFB3\tS447\t-0.568727525
PFKFB4\tS10\t-0.02552939
PFKFB4\tS5\t0.40892735
PFKFB4\tS9\t0.109196015
PFKP\tS386\t0.2319238
PGAM1\tS14\t0.1823108
PGAM5\tS80\t-0.2799879
PGBD3\tS158\t0.1196882
PGBD3\tS554\t-0.08361508
PGK1\tS203\t-0.08146109
PGLS\tS49\t0.3455099
PGM1\tS117\t0.0729976
PGM1\tS408\t-0.1996652
PGM1\tT115\t-0.01286838
PGM2\tS165\t0.2128806
PGM2\tT163\t0.27963915
PGM2\tT304\t-0.0349139
PGM2L1\tS175\t-0.0929555
PGM3\tS64\t0.04110281
PGRMC1\tS181\t-0.1445045
PGRMC1\tS57\t-0.1869351
PGRMC1\tT178\t-0.1283298
PGRMC2\tS104\t0.207801495
PGRMC2\tS208\t-0.06045746
PGRMC2\tS90\t-0.06781787
PGRMC2\tT211\t-0.109854515
PGRMC2\tT216\t-0.1879372
PGRMC2\tT93\t0.1119661
PHACTR2\tS11\t-0.4584852
PHACTR2\tS72\t0.1818022
PHACTR2\tT93\t-0.03997765
PHACTR4\tS160\t-0.12516865
PHACTR4\tS254\t-1.1709057
PHACTR4\tS275\t0.1252544
PHACTR4\tS411\t0.0636299
PHACTR4\tS427\t0.77656025
PHACTR4\tS448\t0.08963377
PHACTR4\tS498\t0.0426443
PHACTR4\tS500\t0.0426443
PHACTR4\tT12\t0.1376347
PHACTR4\tT416\t0.228781335
PHAX\tS350\t-0.8888774
PHB\tS213\t0.02447537
PHB2\tS293\t0.2166086
PHC1\tS251\t-0.06037679
PHC1\tT528\t-0.4822304
PHC2\tS592\t0.073711966
PHC2\tT587\t0.2916035
PHC2\tT590\t0.14915609
PHC3\tS253\t0.1986199
PHC3\tS597\t0.04194384
PHC3\tS823\t-0.68993725
PHC3\tT590\t0.03334855
PHC3\tT595\t0.05394543
PHF10\tS12\t-0.41135
PHF10\tS268\t0.07327176
PHF10\tS27\t-0.07937128
PHF10\tS325\t-0.3659086
PHF10\tS36\t-0.1733844
PHF10\tT22\t-0.29951385
PHF12\tS131\t-0.07576478
PHF12\tS134\t-0.1875757
PHF12\tS691\t0.2027625
PHF12\tT671\t-0.0468316
PHF14\tS290\t0.03660879
PHF14\tS294\t-0.1614597
PHF14\tS298\t-0.1234182
PHF14\tS302\t0.3207734
PHF14\tS37\t-0.1131924
PHF14\tS530\t0.001956835
PHF14\tS835\t-3.031622
PHF14\tS84\t0.0504668
PHF14\tS91\t0.166587
PHF16\tS566\t-0.07634119
PHF16\tS85\t-0.010736815
PHF16\tT88\t-0.054518655
PHF17\tS594\t0.1955996
PHF19\tS160\t-0.8446011
PHF19\tS161\t-0.3639022
PHF19\tS366\t0.03955951
PHF2\tS458\t-0.16271085
PHF2\tS459\t-0.15551985
PHF2\tS474\t-0.2867793
PHF2\tS539\t-0.031051445
PHF2\tS655\t-0.9411709
PHF2\tS681\t0.0413831
PHF2\tS705\t0.03576485
PHF2\tS882\t-0.1038909
PHF2\tS899\t-0.1951204
PHF2\tS905\t0.6253641
PHF2\tT479\t0.4909808
PHF2\tT654\t-0.8712316
PHF21A\tS455\t0.71804235
PHF23\tS315\t-0.1013196
PHF23\tS316\t-0.1013196
PHF23\tS317\t-0.1013196
PHF23\tS64\t0.04292445
PHF23\tS74\t0.07847318
PHF3\tS1045\t0.0633648
PHF3\tS1526\t0.03040665
PHF3\tS1554\t0.06324545
PHF3\tS1634\t0.007626157
PHF3\tS37\t-0.3652666
PHF6\tS155\t0.006333955
PHF6\tS155\t-0.25388555
PHF8\tS743\t0.7195778
PHGDH\tT78\t0.1166309
PHIP\tS1281\t-0.02582316
PHIP\tS1283\t-0.02582316
PHIP\tS1525\t0.4308206
PHIP\tS1734\t0.5745375
PHIP\tS1783\t0.000576887
PHIP\tS674\t-3.575718
PHIP\tS879\t-0.1728151
PHIP\tS880\t-0.1728151
PHIP\tS881\t-0.1728151
PHIP\tS911\t0.03618686
PHKA2\tS729\t-0.1251008
PHKA2\tT981\t-0.43865655
PHKB\tS4\t0.03646811
PHLDA2\tS138\t-0.096924145
PHLDA2\tS144\t-0.08751875
PHLDA2\tS3\t-0.7083022
PHLDA2\tS42\t0.1721035
PHLDB1\tS157\t-0.32090205
PHLDB1\tS324\t-0.03815442
PHLDB1\tS334\t0.6778916
PHLDB1\tS381\t0.05164435
PHLDB1\tS404\t0.05686093
PHLDB1\tS419\t0.07436837
PHLDB1\tS430\t-0.7414449
PHLDB1\tS443\t0.170566
PHLDB1\tS461\t0.08351974
PHLDB1\tS470\t0.5471537
PHLDB1\tS489\t0.2972502
PHLDB1\tS501\t-0.04611645
PHLDB1\tS51\t0.4374408
PHLDB1\tS518\t0.004896797
PHLDB1\tS520\t0.004896797
PHLDB1\tS539\t0.103049285
PHLDB1\tS551\t0.332496135
PHLDB1\tS555\t0.36151045
PHLDB1\tS563\t-0.093448
PHLDB1\tS578\t0.013394075
PHLDB1\tS665\t-0.043736275
PHLDB1\tS692\t0.09247811
PHLDB1\tS693\t0.09247811
PHLDB1\tS696\t0.09247811
PHLDB1\tS924\t0.2555611
PHLDB1\tS970\t0.2172308
PHLDB1\tT332\t0.6602662
PHLDB1\tT522\t0.1139672
PHLDB1\tT923\t0.2950176
PHLDB2\tS204\t-0.1000046
PHLDB2\tS334\t0.17234595
PHLDB2\tS468\t-2.260912
PHLDB2\tS513\t-0.2967976
PHLDB2\tS853\t0.4614856
PHLDB2\tT855\t0.5717253
PHLDB3\tS254\t0.2521734
PHLDB3\tT83\t0.4465543
PHLPP1\tS118\t0.02346825
PHLPP1\tS313\t0.40534865
PHLPP1\tS317\t0.002594432
PHLPP1\tS335\t-0.08609995
PHLPP1\tS336\t-0.098446434
PHLPP1\tS425\t-0.0473086
PHLPP1\tT1617\t-0.03978484
PHRF1\tS1032\t-0.05794723
PHRF1\tS1034\t-0.05794723
PHRF1\tS1124\t0.03984026
PHRF1\tS1202\t-0.01770912
PHRF1\tS1229\t-0.08431853
PHRF1\tS1359\t-0.03735477
PHRF1\tS1360\t0.02133754
PHRF1\tS1371\t0.06129241
PHRF1\tS5\t-0.0301036
PHRF1\tS814\t0.2444
PHRF1\tS846\t0.05194004
PHRF1\tS915\t0.14626584
PHRF1\tS936\t-0.1475216
PHRF1\tS948\t0.75054154
PHRF1\tS973\t-0.03723626
PHRF1\tS991\t-0.005565071
PHRF1\tT1391\t0.80240165
PHRF1\tT917\t0.177834933
PI4K2A\tS47\t-0.11733675
PI4K2A\tS51\t-0.5253511
PI4KA\tS1378\t0.01335505
PI4KA\tT192\t0.21344868
PI4KB\tS256\t-0.420453
PI4KB\tS258\t-0.5281155
PI4KB\tS266\t0.87118955
PI4KB\tS294\t-0.9742059
PI4KB\tS413\t-0.2680174
PI4KB\tS496\t0.007626157
PI4KB\tT263\t0.650305
PIAS1\tS503\t0.06970215
PIAS2\tS499\t0.01077991
PICALM\tS315\t0.01692422
PICALM\tT301\t-0.27720455
PIEZO1\tS1391\t-0.49375275
PIEZO1\tS1396\t0.36742632
PIEZO1\tS1621\t-0.05832271
PIEZO1\tS1646\t0.1625968
PIEZO1\tS165\t-0.07897503
PIEZO1\tT1854\t0.6339427
PIEZO1\tT734\t0.5240636
PIEZO2\tS1718\t0.0160683
PIEZO2\tS1836\t-0.2804749
PIEZO2\tS1844\t-0.3948849
PIEZO2\tS1857\t-0.2644778
PIEZO2\tS1881\t-0.0661721
PIEZO2\tS459\t1.4615762
PIF1\tS151\t-0.2014435
PIF1\tS27\t0.05018827
PIGB\tT40\t-0.2519854
PIK3C2A\tS1553\t-0.4589858
PIK3C3\tS244\t-0.2392334
PIK3R2\tS262\t-1.747487
PIK3R2\tS263\t-2.626379
PIK3R4\tS865\t-0.09893812
PIKFYVE\tS1544\t-0.3285617
PIKFYVE\tS1549\t-0.2454887
PIKFYVE\tS1754\t-0.09608249
PIKFYVE\tS299\t0.3736205
PIKFYVE\tS307\t0.1629835
PIKFYVE\tS318\t0.4958998
PIKFYVE\tS329\t-0.7315056
PIKFYVE\tS352\t-0.37234575
PIKFYVE\tS475\t-0.2921042
PIKFYVE\tS73\t0.06086125
PIKFYVE\tS76\t-0.1388069
PIP4K2A\tT3\t-0.1782408
PIP4K2B\tS17\t-0.2322435
PIP5K1A\tS176\t-0.7231103
PIPSL\tS407\t-0.34204445
PITPNC1\tS299\t-0.05788717
PITPNM1\tS593\t0.04837578
PITPNM1\tS621\t-2.8251475
PITPNM2\tS365\t0.1745343
PITPNM2\tS593\t-0.040133465
PITX2\tS40\t0.4643545
PJA1\tT277\t-0.15167111
PJA2\tS428\t-0.1972691
PJA2\tS429\t-0.1972691
PJA2\tS432\t-0.1972691
PKD2\tS166\t-0.3291778
PKD2\tS756\t-0.2312779
PKD2\tS76\t-0.3342252
PKD2\tS775\t0.1642714
PKM\tS100\t-0.44457963
PKM\tS127\t-0.01944819
PKM\tS202\t-0.1654667
PKM\tS222\t-0.1362042
PKM\tS37\t-0.006593726
PKM\tS55\t-0.2652058
PKM\tS77\t-0.121204
PKM\tT41\t0.1257833
PKN1\tS533\t0.1135672
PKN1\tS537\t-0.158641385
PKN1\tS562\t0.24354872
PKN1\tS608\t-0.4451656
PKN1\tS69\t-0.2018416
PKN1\tS8\t0.1896664
PKN1\tS916\t-0.12186999
PKN2\tS302\t0.2224336
PKN2\tS306\t-0.9459434
PKN2\tS360\t0.4046851
PKN2\tS567\t-1.414384
PKN2\tT942\t0.0415233
PKP4\tS221\t0.4727997
PKP4\tS231\t0.14328714
PKP4\tS273\t0.2149951
PKP4\tS281\t0.11510357
PKP4\tS314\t-0.01134079
PKP4\tS337\t0.15159812
PKP4\tS75\t-0.02439917
PKP4\tS776\t0.08120319
PKP4\tT1013\t-0.14440076
PKP4\tT1017\t0.1695402
PLA2G4A\tS434\t0.1017845
PLA2G4A\tS435\t0.01184649
PLA2G4A\tS437\t-0.1422737
PLA2G4A\tS727\t-0.8585149
PLA2G4A\tS729\t-0.6096624
PLAGL2\tS273\t0.221444
PLCB3\tS537\t-0.6355845
PLCG1\tS1221\t-0.8660946
PLCG1\tS1222\t-0.5502115
PLCG1\tS1248\t0.3523065
PLCG1\tS1263\t-0.1263285
PLCG1\tS525\t-0.0907876
PLCG1\tS6\t-0.2158981
PLCL1\tS569\t0.21832285
PLCL1\tS95\t0.1071523
PLCL2\tS1113\t-0.7944824
PLCL2\tT584\t0.05088473
PLD1\tS519\t0.10881132
PLD1\tS591\t0.3060289
PLEC\tS1047\t0.02275842
PLEC\tS125\t0.1166309
PLEC\tS1435\t0.01321208
PLEC\tS149\t-0.03954761
PLEC\tS1721\t0.2397646
PLEC\tS21\t0.03040665
PLEC\tS2688\t-0.22811239
PLEC\tS42\t0.4584962
PLEC\tS4382\t0.41414205
PLEC\tS4384\t0.09801521
PLEC\tS4385\t0.061780648
PLEC\tS4386\t-0.12001732
PLEC\tS4389\t0.04124633
PLEC\tS4390\t0.94563035
PLEC\tS4391\t1.1557599
PLEC\tS4396\t-0.3360699
PLEC\tS4613\t0.211505038
PLEC\tS4620\t0.3087104
PLEC\tS4622\t0.08814155
PLEC\tS4626\t0.1471764
PLEC\tS720\t-0.02067704
PLEC\tT152\t0.01718072
PLEC\tT3785\t-0.135026595
PLEC\tT4030\t-0.04769625
PLEC\tT4623\t0.190057475
PLEKHA1\tS308\t-0.6911266
PLEKHA3\tS244\t-0.3257489
PLEKHA3\tS289\t-2.7163075
PLEKHA4\tS164\t-0.303561
PLEKHA4\tS194\t-0.06600443
PLEKHA4\tS213\t-0.00470263
PLEKHA4\tS229\t0.07694675
PLEKHA4\tS237\t0.138542946
PLEKHA4\tS241\t0.097439565
PLEKHA4\tS274\t0.169925
PLEKHA4\tS345\t0.169027
PLEKHA4\tS552\t-0.017263235
PLEKHA4\tS559\t-0.040015695
PLEKHA4\tS575\t0.058805949
PLEKHA4\tS675\t0.1574319
PLEKHA4\tS723\t-0.48634845
PLEKHA4\tT211\t-0.2597373
PLEKHA5\tS274\t0.06364096
PLEKHA5\tS302\t-0.1697609
PLEKHA5\tS460\t0.2917214
PLEKHA5\tS488\t0.08705537
PLEKHA5\tS791\t0.02984157
PLEKHA5\tS819\t0.206143
PLEKHA5\tS837\t0.112809825
PLEKHA5\tS867\t0.7005285
PLEKHA5\tS915\t0.28984388
PLEKHA5\tS919\t-0.407760325
PLEKHA5\tT300\t-0.123332135
PLEKHA5\tT330\t0.2520522
PLEKHA5\tT850\t0.259858
PLEKHF1\tS227\t-0.09441807
PLEKHF1\tS242\t-0.01845414
PLEKHF1\tS243\t-0.01845414
PLEKHF1\tS249\t-0.01845414
PLEKHF2\tS16\t0.12075
PLEKHG1\tS344\t0.3603081
PLEKHG2\tS1232\t0.03857661
PLEKHG2\tS1289\t0.02545406
PLEKHG2\tT1228\t0.03857661
PLEKHG3\tS1037\t0.003314423
PLEKHG3\tS1040\t1.171783
PLEKHG3\tS1115\t-0.3882044
PLEKHG3\tS433\t-0.1477294
PLEKHG3\tS640\t0.109068329
PLEKHG3\tS643\t0.07066408
PLEKHG3\tS827\t-0.16955
PLEKHG3\tS962\t-2.174426
PLEKHG4\tS64\t-0.1723598
PLEKHM1\tS216\t-0.31588815
PLEKHM1\tS293\t-0.2014268
PLEKHM2\tS307\t-1.941982
PLEKHM2\tS344\t-0.021226663
PLEKHM2\tS539\t0.1450905
PLEKHM2\tT347\t0.3726179
PLEKHM3\tS132\t-0.9017152
PLEKHM3\tS150\t-0.7981403
PLEKHM3\tS350\t-0.48152265
PLEKHN1\tS524\t0.0756884
PLEKHN1\tS79\t-0.3783068
PLEKHO1\tS151\t0.2907782
PLEKHO2\tS114\t0.2559237
PLEKHO2\tS339\t0.177599
PLEKHO2\tS340\t0.2173549
PLEKHO2\tS389\t0.06786444
PLEKHO2\tT174\t0.5393326
PLK1S1\tS143\t0.2368294
PLK1S1\tS150\t0.004752986
PLK1S1\tS184\t1.2216245
PLK1S1\tS303\t-0.4563207
PLK1S1\tS490\t0.6469425
PLN\tS16\t0.334246546
PLS3\tS293\t0.0939657
PLS3\tS339\t0.4539652
PLXNA1\tS1609\t0.03377502
PML\tS36\t0.072637941
PML\tS38\t-0.019649547
PML\tS403\t0.05630613
PML\tS48\t-0.03997765
PML\tS518\t0.309859931
PML\tS527\t0.020979941
PML\tS530\t-0.227094
PML\tS565\t-0.43815455
PML\tS8\t-0.1188522
PML\tT867\t0.04320455
PMS2\tS405\t0.29669965
PNISR\tS290\t-0.152468
PNISR\tS465\t0.3730028
PNISR\tT485\t-0.02958801
PNKP\tT118\t-0.1385686
PNN\tS100\t-0.08205654
PNN\tS347\t-0.07231588
PNN\tS413\t-0.04838241
PNN\tS441\t0.15122911
PNN\tS443\t0.11853679
PNN\tS552\t0.108076875
PNN\tS658\t-0.192876
PNN\tS66\t0.01135251
PNN\tS84\t0.1050075
PNN\tT547\t-0.1517218
PNO1\tS36\t0.100753715
PNPLA2\tS428\t0.235482
PNPLA2\tS476\t-0.5531933
PNPLA6\tS1329\t-0.07873126
PNPLA6\tS345\t-0.40435495
PNPLA6\tS363\t0.9019867
PNPLA6\tS411\t-0.1374256
PNPO\tS223\t-1.095481
POC5\tS80\t1.21176
POC5\tS84\t-1.364088
PODXL2\tS195\t0.8178968
PODXL2\tS520\t0.2415961
POGZ\tS1243\t-0.05018869
POGZ\tS1269\t0.080897685
POGZ\tS1271\t0.1285573
POGZ\tS1272\t0.0551957
POGZ\tS238\t0.2621926
POGZ\tS330\t0.05810868
POGZ\tS350\t-0.1127711
POGZ\tT1273\t0.005471901
POLA2\tS141\t0.12159872
POLA2\tS152\t0.4372224
POLA2\tT127\t0.3670355
POLA2\tT130\t0.30474275
POLD3\tS307\t0.1133004
POLDIP2\tT291\t0.1522483
POLDIP3\tS127\t-0.001154638
POLDIP3\tS275\t-0.6450063
POLDIP3\tS368\t0.1055439
POLDIP3\tS370\t0.29610252
POLDIP3\tS383\t-1.15502
POLE4\tT11\t0.2595437
POLM\tS12\t0.03731201
POLR1A\tS1429\t0.000432815
POLR2A\tS1847\t0.007769512
POLR2A\tS1878\t-0.149655035
POLR2A\tS1899\t-0.267293235
POLR2A\tS1913\t-0.06280626
POLR2A\tS1917\t-0.154799675
POLR2A\tS1920\t-0.109206703
POLR2C\tS122\t0.051552965
POLR2M\tS10\t-0.295209
POLR2M\tS179\t-3.334229
POLR2M\tS270\t0.05394543
POLR3C\tS204\t-0.1430701
POLR3C\tS205\t-0.289263
POLR3E\tS161\t-0.06633877
POLR3E\tS162\t0.0085146
POLR3E\tS503\t-0.171757395
POLR3G\tS157\t-0.302931045
POLR3G\tT133\t-2.2334585
POM121C\tS2\t0.058808285
POM121C\tS246\t0.34854755
POM121C\tS262\t-0.1139572
POM121C\tS275\t0.2464689
POM121C\tS291\t0.24857625
POM121C\tS322\t-0.56060415
POM121C\tS328\t-0.2706605
POM121C\tS358\t-0.63874293
POM121C\tS412\t0.48206335
POM121C\tS416\t0.45226985
POM121C\tS420\t0.154454985
POM121C\tS674\t0.2459823
POM121C\tS935\t-0.31833585
POP1\tS367\t0.1504297
POP1\tS730\t-0.0102651
POU2F1\tS471\t-0.1061874
POU3F2\tS341\t0.1414329
PPA2\tS317\t0.16635203
PPAN\tS359\t0.1294808
PPAPDC2\tS70\t0.9097347
PPARGC1A\tS246\t-0.06101425
PPARGC1A\tS266\t-0.1722785
PPARGC1A\tS273\t-0.1968225
PPARGC1B\tS71\t0.236462
PPFIA1\tS1171\t0.006764703
PPFIA1\tS1172\t0.2027625
PPFIA1\tS150\t-0.6064301
PPFIA1\tS238\t-0.3392904
PPFIA1\tS239\t0.09083852
PPFIA1\tS242\t0.1914362
PPFIA1\tS244\t-0.14816595
PPFIA1\tS530\t0.4486895
PPFIA1\tS666\t0.2702299
PPFIA1\tS668\t0.2402533
PPFIA1\tS763\t-0.1341762
PPFIA1\tT1159\t0.3451693
PPFIA1\tT572\t0.6420084
PPFIA3\tS17\t-0.2974666
PPFIA3\tS645\t0.1133004
PPFIA3\tT714\t-0.1226484
PPFIA4\tS741\t0.06579739
PPFIA4\tS744\t0.04320455
PPFIBP1\tS37\t-1.271914
PPFIBP1\tS40\t-2.142341
PPFIBP1\tS449\t-0.1839984
PPFIBP1\tS509\t0.04110281
PPFIBP1\tS523\t0.01806431
PPFIBP1\tS534\t-0.1388069
PPFIBP1\tS573\t-0.1070572
PPFIBP1\tS576\t-0.9996473
PPFIBP1\tS595\t-0.01724181
PPFIBP1\tS630\t-0.1394265
PPFIBP1\tS632\t-0.08129015
PPFIBP1\tS788\t-0.129655
PPFIBP1\tT792\t-0.198444
PPFIBP1\tT854\t-0.221100295
PPFIBP2\tS387\t0.08637615
PPHLN1\tS157\t-0.02120402
PPHLN1\tS85\t-0.00484117
PPID\tS198\t-0.4719088
PPIG\tS254\t-0.2632179
PPIG\tS256\t-0.2632179
PPIG\tS257\t-0.2632179
PPIG\tS259\t-0.12858626
PPIG\tS356\t-0.08435295
PPIG\tS415\t-0.023955035
PPIG\tS687\t0.09261344
PPIG\tS696\t-0.09017318
PPIG\tS744\t0.076657905
PPIG\tS745\t-0.1965249
PPIG\tS753\t0.1310627
PPIG\tT358\t-0.04809303
PPIG\tT748\t-0.052535695
PPIL1\tS149\t-0.223778
PPIL1\tT147\t-0.1509615
PPIL4\tS178\t-0.1434843
PPIL4\tT182\t-0.06881623
PPIP5K1\tS859\t0.07286042
PPIP5K2\tS1006\t0.00508195
PPIP5K2\tS1016\t-0.5003403
PPIP5K2\tS1074\t0.03477915
PPIP5K2\tS1108\t-0.17093872
PPIP5K2\tS38\t-0.1811821
PPM1D\tS85\t0.1181543
PPM1G\tS201\t0.2999479
PPM1H\tS124\t-0.276957
PPM1J\tS25\t-0.14830669
PPM1J\tS45\t-0.3476374
PPM1J\tS76\t-0.009262905
PPP1CA\tT320\t0.2326607
PPP1R10\tS313\t-0.7629014
PPP1R10\tS382\t-0.03013301
PPP1R10\tS471\t-0.03303802
PPP1R10\tS591\t0.04053405
PPP1R10\tT256\t0.2130051
PPP1R11\tS73\t0.02162186
PPP1R11\tS74\t0.02162186
PPP1R11\tS77\t-0.01317407
PPP1R11\tT75\t-0.01317407
PPP1R12A\tS299\t-0.1767887
PPP1R12A\tS432\t-1.5556155
PPP1R12A\tS445\t-0.6196695
PPP1R12A\tS479\t-0.5380105
PPP1R12A\tS507\t-3.6441365
PPP1R12A\tS509\t-1.792712825
PPP1R12A\tS639\t0.349705
PPP1R12A\tS806\t-0.05427247
PPP1R12A\tS815\t0.09936258
PPP1R12A\tS847\t-0.1035188
PPP1R12A\tS854\t0.2026371
PPP1R12A\tS939\t-0.5220327
PPP1R12A\tT640\t0.2821432
PPP1R12B\tT646\t0.4837569
PPP1R12C\tS364\t-2.153094
PPP1R12C\tS407\t-2.775466
PPP1R12C\tS427\t0.39754755
PPP1R12C\tS509\t-0.357511
PPP1R12C\tS559\t0.2841587
PPP1R12C\tT560\t0.3128975
PPP1R13B\tS671\t-0.4048873
PPP1R13L\tS187\t-2.6042355
PPP1R14B\tS32\t0.4898511
PPP1R15A\tT61\t-1.263646
PPP1R15B\tS508\t-0.1714817
PPP1R15B\tS510\t-0.2245027
PPP1R16A\tS60\t-0.628943
PPP1R18\tS125\t-0.08586418
PPP1R18\tS175\t0.1593708
PPP1R18\tS195\t-0.9038461
PPP1R18\tS224\t-0.5083418
PPP1R18\tS368\t-0.9844168
PPP1R18\tS401\t-0.06981528
PPP1R18\tS490\t-1.185274
PPP1R18\tT199\t0.5671561
PPP1R18\tT493\t-1.240145
PPP1R2\tS121\t-0.093048625
PPP1R2\tS122\t-0.1036894
PPP1R35\tS47\t-0.3238049
PPP1R35\tS52\t0.1036654
PPP1R37\tS540\t0.2536262
PPP1R37\tS557\t-0.8120661
PPP1R3C\tS293\t-0.3566437
PPP1R3D\tS133\t0.160533
PPP1R3D\tS25\t-0.1568174
PPP1R3D\tS74\t0.06446896
PPP1R3D\tS78\t0.06446896
PPP1R3E\tS33\t-0.56474515
PPP1R3F\tS201\t0.0078081
PPP1R3G\tS84\t-0.34084295
PPP1R7\tS12\t0.18127705
PPP1R7\tS24\t-0.02102765
PPP1R7\tS27\t0.0185347
PPP1R7\tS47\t0.68319715
PPP1R9A\tS1131\t-0.3559223
PPP1R9B\tS100\t-1.1984666
PPP1R9B\tS190\t0.1600167
PPP1R9B\tS203\t-1.4425425
PPP2R3A\tS505\t-0.171900455
PPP2R3A\tS562\t-1.24484
PPP2R3A\tS692\t0.1929516
PPP2R5B\tS16\t-0.9481675
PPP2R5E\tS32\t0.132815735
PPP2R5E\tS33\t0.13328736
PPP2R5E\tT7\t-0.306585185
PPP4R2\tS159\t0.000432815
PPP4R2\tS226\t-0.08126266
PPP4R2\tS361\t-0.2663854
PPP4R2\tY162\t-0.114951425
PPP6R1\tS529\t-0.1240313
PPP6R1\tS530\t-0.1240313
PPP6R1\tS531\t-0.1276834
PPP6R1\tS635\t0.060250375
PPP6R1\tS638\t0.060250375
PPP6R1\tS664\t-0.01547628
PPP6R1\tS670\t-0.01547628
PPP6R1\tS759\t-1.4148715
PPP6R1\tT524\t-0.094180155
PPP6R1\tT668\t-0.1131611
PPP6R2\tS289\t-0.096628345
PPP6R2\tS745\t-0.1861306
PPP6R3\tS315\t-0.208161
PPP6R3\tS533\t-0.02742497
PPP6R3\tS571\t-0.03423421
PPP6R3\tS588\t0.09464151
PPP6R3\tT585\t-0.02455337
PPRC1\tS536\t0.55986065
PPRC1\tT181\t0.16292362
PPRC1\tT844\t-0.5990687
PQLC1\tS110\t0.3055621
PQLC1\tT112\t0.5668053
PRC1\tS513\t1.1784542
PRCC\tS157\t-0.1449671
PRCC\tS159\t0.03801472
PRCC\tS267\t-0.01493679
PRCC\tT165\t0.11609528
PRDM10\tS338\t-0.089976005
PRDM10\tT342\t-0.715249
PRDM11\tS29\t0.1900459
PRDM11\tS311\t-0.22763875
PRDM11\tS462\t-0.1397444
PRDM15\tS22\t-0.027194285
PRDM15\tS345\t-0.007402755
PRDM15\tS981\t0.11453717
PRDM2\tS1158\t0.05783146
PRDM2\tS220\t-1.14299
PRDM2\tS246\t-0.7056712
PRDM2\tS538\t0.179039105
PRDX6\tT177\t-0.6866612
PRDX6\tT44\t0.160533
PRG4\tS623\t-0.1764789
PRICKLE2\tS543\t-0.1598792
PRICKLE2\tS571\t-0.06232419
PRICKLE2\tS695\t-0.04476161
PRICKLE2\tS753\t-0.1078025
PRICKLE2\tS806\t-0.11505151
PRICKLE2\tT539\t-0.4928498
PRIM2\tT470\t0.3164934
PRKAA1\tT382\t0.3713915
PRKAA2\tS377\t0.215917171
PRKAA2\tT183\t0.08846587
PRKAB1\tS108\t0.50978975
PRKAB2\tS39\t-0.0592245
PRKACA\tT188\t0.2471984
PRKACA\tT190\t0.18762935
PRKAR1A\tS251\t-0.01875909
PRKAR1A\tS83\t-0.30352346
PRKAR1B\tS3\t0.3267674
PRKAR1B\tS83\t0.2199584
PRKAR2A\tS58\t-1.182491
PRKAR2A\tS78\t-0.1392834
PRKAR2A\tS80\t-0.1392834
PRKAR2A\tS99\t0.1268407
PRKAR2B\tS114\t0.2524157
PRKAR2B\tS83\t0.00458755
PRKAR2B\tS85\t0.00458755
PRKAR2B\tT69\t0.5354558
PRKCA\tS319\t-0.1899272
PRKCD\tS304\t-1.115504
PRKCD\tS307\t-0.64143255
PRKCD\tS664\t0.1552311
PRKCDBP\tS165\t-0.240720175
PRKCDBP\tS166\t-0.1694039
PRKCE\tS329\t0.5691022
PRKCE\tS337\t0.2817873
PRKCE\tS346\t-0.3236953
PRKCE\tS368\t-0.368309
PRKCE\tT309\t0.5815923
PRKCE\tT710\t0.3918777
PRKCI\tT412\t0.149990205
PRKD1\tS205\t-0.1921467
PRKD1\tS208\t-0.2798442
PRKD1\tS235\t-0.5081161
PRKD2\tS40\t-0.01741709
PRKD3\tS213\t-0.09940171
PRKD3\tS27\t0.05116329
PRKD3\tS31\t0.05116329
PRKD3\tS364\t-0.2343464
PRKD3\tS397\t-0.056386075
PRKD3\tS401\t0.07121356
PRKD3\tS6\t0.1644001
PRKDC\tS1790\t-0.1023414
PRKDC\tS2612\t0.01148075
PRKDC\tS314\t-0.2355967
PRKDC\tS3205\t0.09558696
PRKDC\tS4026\t-0.07465374
PRKDC\tS687\t0.00335449
PRKDC\tS893\t0.2261386
PRKDC\tT1793\t-0.04727875
PRKDC\tT2638\t0.323197
PRKDC\tT2647\t0.1797991
PRMT1\tS93\t0.5324667
PRMT3\tS25\t-0.1549345
PRMT3\tS27\t-0.1549345
PROSER2\tS18\t0.3031086
PROSER2\tS212\t-2.483259
PROSER2\tS215\t-1.562133
PROSER2\tS41\t-1.6603625
PROSER2\tS43\t-0.6733705
PROX1\tS199\t-0.19866313
PROX1\tS511\t-0.1286926
PRPF3\tS619\t0.08093054
PRPF31\tT455\t-0.0134736
PRPF38A\tS193\t-0.1586387
PRPF38A\tS194\t-0.1586387
PRPF38B\tS288\t-0.09719323
PRPF38B\tS5\t0.105678
PRPF38B\tS527\t0.084182103
PRPF38B\tS529\t0.167387205
PRPF38B\tS534\t-2.409963015
PRPF40A\tS883\t0.110567833
PRPF40A\tS885\t0.02923664
PRPF40A\tS888\t0.02005774
PRPF40A\tT373\t0.1937087
PRPF40B\tS751\t-0.4406942
PRPF4B\tS142\t0.064292695
PRPF4B\tS144\t0.06010248
PRPF4B\tS20\t0.01849174
PRPF4B\tS23\t0.01849174
PRPF4B\tS257\t0.03506084
PRPF4B\tS277\t-0.01822039
PRPF4B\tS292\t0.087692
PRPF4B\tS294\t0.087692
PRPF4B\tS32\t0.08653752
PRPF4B\tS366\t0.004896797
PRPF4B\tS368\t0.004896797
PRPF4B\tS431\t0.102859925
PRPF4B\tS437\t0.1828194
PRPF4B\tS509\t0.8819541
PRPF4B\tS578\t-0.1031246
PRPF4B\tS580\t-0.18889465
PRPF4B\tS8\t-0.002050113
PRPF4B\tS852\t0.294862
PRPF4B\tT576\t0.0878702
PRPF4B\tY140\t0.0323129
PRPF4B\tY849\t0.1188912
PRPF6\tS263\t-0.16729786
PRPF6\tT266\t0.2618317
PRPSAP1\tS215\t-0.1568684
PRPSAP2\tS227\t-0.07628036
PRPSAP2\tT5\t-0.2228518
PRR11\tS307\t0.49774
PRR11\tS40\t0.1934563
PRR11\tT165\t0.033974975
PRR11\tT326\t0.5334637
PRR12\tS1135\t-0.16461475
PRR12\tS1308\t-0.157722075
PRR12\tS1379\t0.082893985
PRR12\tS1381\t-0.01240263
PRR12\tS1382\t0.00805652
PRR12\tS1568\t0.02304246
PRR12\tS1925\t-0.03849519
PRR12\tS332\t0.1059462
PRR12\tS340\t-0.1780939
PRR12\tS570\t0.070319205
PRR12\tS582\t0.103649003
PRR12\tS651\t-0.1704589
PRR12\tS865\t-0.1262026
PRR12\tT1304\t-0.18823355
PRR12\tT1561\t0.02304246
PRR12\tT1705\t-0.07510959
PRR12\tT686\t0.3305932
PRR14L\tS1029\t-0.06948218
PRR14L\tS1485\t-0.04496645
PRR14L\tS600\t0.2137517
PRR3\tS33\t0.030574075
PRR3\tT26\t0.015135535
PRR5\tS11\t-0.1189306
PRR5\tS282\t0.01120934
PRR5\tS381\t0.4970246
PRR5L\tS28\t-0.2472685
PRRC2A\tS1004\t-0.8117764
PRRC2A\tS1085\t-0.170972505
PRRC2A\tS1089\t-0.05955511
PRRC2A\tS1092\t0.05823559
PRRC2A\tS1106\t-0.2406514
PRRC2A\tS1110\t-0.3614522
PRRC2A\tS1120\t1.249396
PRRC2A\tS1147\t0.1220763
PRRC2A\tS1219\t-0.9496167
PRRC2A\tS1386\t-0.002281261
PRRC2A\tS166\t-0.2355519
PRRC2A\tS1690\t0.09193667
PRRC2A\tS1691\t0.06115411
PRRC2A\tS2113\t0.05206586
PRRC2A\tS342\t-0.08673721
PRRC2A\tS350\t-0.241798205
PRRC2A\tS363\t-0.009698553
PRRC2A\tS380\t-0.02120402
PRRC2A\tS456\t-0.6818625
PRRC2A\tS516\t0.3062623
PRRC2A\tS759\t0.2645965
PRRC2A\tS761\t0.163889712
PRRC2A\tS764\t0.3499314
PRRC2A\tS808\t-0.4490205
PRRC2A\tT1087\t-0.004132565
PRRC2A\tT1108\t-0.5138932
PRRC2A\tT517\t0.4225559
PRRC2A\tT609\t-0.5924406
PRRC2A\tT610\t-0.4924438
PRRC2B\tS1132\t-1.233626
PRRC2B\tS1136\t-1.01336365
PRRC2B\tS1139\t-1.0599775
PRRC2B\tS1395\t0.1406477
PRRC2B\tS166\t-2.128345
PRRC2B\tS1676\t0.27471555
PRRC2B\tS1679\t0.086916275
PRRC2B\tS168\t0.0692898
PRRC2B\tS1843\t1.031254
PRRC2B\tS226\t-0.4363928
PRRC2B\tS388\t0.2621926
PRRC2B\tS416\t-0.9129989
PRRC2B\tS556\t-0.8771815
PRRC2B\tS558\t-0.6474567
PRRC2B\tS613\t0.1747899
PRRC2B\tS740\t-0.03995555
PRRC2B\tS745\t-0.41548
PRRC2B\tS776\t0.143524
PRRC2B\tS795\t-0.031686385
PRRC2B\tS853\t0.08093054
PRRC2B\tS907\t0.1365852
PRRC2B\tT1463\t0.7528342
PRRC2C\tS1246\t0.3713829
PRRC2C\tS1248\t0.2818909
PRRC2C\tS1249\t0.11374235
PRRC2C\tS1544\t0.0354831
PRRC2C\tS2013\t-0.4822708
PRRC2C\tS2105\t-0.2534292
PRRC2C\tS2143\t0.5641342
PRRC2C\tS2260\t0.7118472
PRRC2C\tS779\t0.1465249
PRRC2C\tS878\t-0.007492585
PRRC2C\tT1965\t0.41629745
PRRC2C\tT2673\t0.8454298
PRRC2C\tT2682\t0.5381408
PRRC2C\tT887\t0.1183597
PRRC2C\tY812\t-0.5291144
PRRX1\tS197\t0.2308178
PRRX1\tS21\t0.5947098
PSAT1\tS331\t0.1003049
PSD3\tS235\t-1.7633585
PSD3\tS476\t0.2218153
PSD3\tS485\t0.1399933
PSEN1\tS315\t-0.02082342
PSEN1\tS361\t0.2253984
PSEN2\tS19\t0.02247432
PSEN2\tS22\t-0.1501448
PSEN2\tS25\t-0.1331081
PSEN2\tS49\t0.3029917
PSEN2\tT18\t-0.10372237
PSIP1\tS106\t0.003602319
PSIP1\tS129\t0.155058295
PSIP1\tS206\t-0.237202
PSIP1\tS273\t-0.04163987
PSIP1\tS275\t-0.01447046
PSMA3\tS243\t-0.07249789
PSMA5\tS16\t0.04488368
PSMA5\tS56\t-0.6370645
PSMA5\tS63\t-0.1644963
PSMA5\tT55\t-0.6640904
PSMC3\tS9\t-0.5509511
PSMC6\tS244\t-0.07099166
PSMD1\tS315\t-0.03276958
PSMD1\tT273\t-0.1257617
PSMD1\tT311\t0.04725923
PSMD11\tS14\t-0.35064527
PSMD12\tS332\t-0.02766022
PSMD2\tS16\t-0.1492805
PSMD3\tS47\t-0.3286373
PSMD4\tS269\t0.1774714
PSMD7\tT186\t-0.083754845
PSME3\tS24\t-0.06360513
PSME3\tT23\t-0.07293796
PSME4\tS1121\t-0.02805736
PSME4\tS1746\t-0.94527925
PSMF1\tS252\t-0.3485372
PSPC1\tS409\t-0.00190205
PSPC1\tS477\t0.01478381
PSPC1\tS481\t0.1423481
PSPHP1\tS14\t-0.1059389
PSPHP1\tS7\t-0.0122381
PSRC1\tS133\t0.2944836
PSRC1\tS175\t0.89702355
PSRC1\tS70\t0.1094274
PTAR1\tT359\t-0.22867726
PTBP1\tS155\t-0.128618815
PTBP3\tS25\t-0.1396331
PTCH1\tS1046\t-0.114883835
PTCH1\tT1044\t-0.02948497
PTDSS1\tS417\t-0.8901714
PTDSS1\tS442\t0.02587931
PTDSS2\tS16\t0.01906128
PTGES3\tS113\t-0.05692631
PTGES3\tS124\t-0.2648938
PTGES3\tS127\t-0.2648938
PTGES3\tS130\t-0.2648938
PTGES3\tS148\t0.153935
PTGES3\tS151\t0.081856101
PTGES3\tS44\t-0.016850962
PTGR2\tS200\t-0.2364525
PTK2\tS568\t0.16450972
PTK2\tS722\t0.1934563
PTK2\tS864\t-0.5907014
PTK2\tT13\t0.2156165
PTK2\tT868\t-0.6641738
PTK2\tY576\t0.004177767
PTK2\tY815\t0.2524157
PTMA\tS10\t0.07888308
PTMA\tS2\t0.01106615
PTMA\tT8\t0.625433375
PTMS\tS2\t0.170352055
PTMS\tS5\t0.12989355
PTOV1\tS73\t-1.782695
PTPDC1\tS446\t0.0292761
PTPDC1\tS490\t-1.446321
PTPDC1\tT465\t-1.146787
PTPLAD1\tS114\t0.1991226
PTPLAD1\tS135\t-0.9760492
PTPLAD1\tS138\t-1.1190255
PTPN1\tS295\t-0.035425195
PTPN1\tS352\t-0.8019333
PTPN1\tS50\t0.4090379
PTPN11\tS562\t-0.03583058
PTPN12\tS19\t-0.3411167
PTPN12\tS332\t-0.1663731
PTPN12\tS342\t0.3589589
PTPN12\tS397\t-0.07905123
PTPN12\tS398\t-0.07905123
PTPN12\tS402\t-0.07905123
PTPN12\tS449\t-0.325901
PTPN12\tS468\t0.1848516
PTPN12\tS571\t0.307953925
PTPN12\tS588\t-0.59848695
PTPN12\tS603\t-0.038167855
PTPN12\tS606\t-0.030168315
PTPN12\tS608\t-0.01337794
PTPN12\tS613\t0.03266509
PTPN12\tS673\t-0.2144243
PTPN12\tS689\t0.2008809
PTPN12\tS719\t-0.1023878
PTPN12\tT454\t0.3125409
PTPN12\tT509\t0.09658986
PTPN12\tT519\t0.24007405
PTPN12\tT569\t0.6547477
PTPN12\tT693\t0.2008809
PTPN13\tS1010\t0.3621052
PTPN13\tS1014\t0.485942
PTPN13\tS1063\t0.00573985
PTPN13\tS1067\t-0.3329708
PTPN13\tS240\t0.1610493
PTPN13\tS301\t0.350969
PTPN13\tS345\t0.21665302
PTPN13\tS512\t0.4054753
PTPN13\tS890\t0.4520766
PTPN13\tS897\t0.324918075
PTPN13\tS908\t0.3958306
PTPN13\tS911\t0.3958306
PTPN13\tS936\t-0.7944573
PTPN13\tS938\t0.05633175
PTPN14\tS314\t0.009633875
PTPN14\tS465\t0.16152487
PTPN14\tS486\t0.2510827
PTPN14\tS512\t0.1190241
PTPN14\tS578\t0.05450115
PTPN14\tS593\t0.262572745
PTPN14\tS594\t0.299096385
PTPN14\tS614\t0.36713715
PTPN14\tS620\t0.3413026
PTPN14\tS642\t0.1409095
PTPN14\tS831\t0.01570045
PTPN2\tS293\t-0.1705076
PTPN2\tS304\t0.153935
PTPN21\tS492\t0.1445685
PTPN21\tS590\t-0.023689
PTPN21\tS616\t0.0923028
PTPN21\tS637\t-0.06727359
PTPN21\tS658\t-1.384395
PTPN21\tS660\t0.7392432
PTPN21\tS673\t-0.19175755
PTPN23\tS1123\t0.018661184
PTPN23\tS1133\t-0.042081985
PTPN3\tS357\t-2.085221
PTPN3\tS359\t1.097139
PTPN3\tS425\t0.4438188
PTPRA\tY654\t-0.1692579
PTPRK\tS836\t0.34555665
PTPRK\tS857\t0.28004995
PTPRK\tT861\t0.28925225
PTPRM\tS577\t-0.02698905
PTPRU\tS843\t0.43711305
PTPRZ1\tT1687\t-0.1026433
PTRF\tS169\t-0.16738908
PTRF\tS36\t-0.2033611
PTRF\tS40\t-0.1091253
PTTG2\tS165\t-0.2056798
PUF60\tT268\t-0.8225797
PUF60\tT31\t0.04809668
PUM1\tS124\t0.08922691
PUM1\tS209\t-0.4340519
PUM1\tS709\t0.1078218
PUM1\tT112\t-0.2838608
PUM1\tT298\t-0.3481148
PUM2\tS136\t0.08528864
PUM2\tS182\t-0.02533851
PUM2\tS587\t-0.7120549
PUM2\tS82\t-0.4859433
PURA\tS182\t0.04278438
PURB\tS23\t0.2402533
PURB\tS298\t-0.01052667
PURB\tS304\t-0.024155415
PURB\tS6\t-0.099757775
PURB\tS8\t0.019618331
PUS10\tS84\t-0.316854
PUS7\tS39\t0.3731749
PUS7\tT610\t0.02062666
PVRL1\tS422\t-0.1272894
PVRL2\tS433\t-0.02866064
PVRL2\tT459\t0.5488312
PVRL3\tS465\t0.36058395
PVRL3\tS469\t0.2397656
PWP1\tS50\t-0.00183368
PWP1\tS57\t-0.02685165
PWP1\tT55\t0.04805675
PWWP2A\tS116\t-0.101643175
PWWP2A\tS119\t-0.101643175
PWWP2A\tS81\t0.07217448
PXK\tS442\t-0.0170243
PXN\tS106\t-1.235008
PXN\tS119\t-0.03452849
PXN\tS126\t-1.3194875
PXN\tS130\t-1.3194875
PXN\tS137\t-0.5545063
PXN\tS303\t0.1078218
PXN\tS4\t-0.6886597
PXN\tS85\t-0.3939258
PXN\tT132\t-0.9116409
PXN\tY118\t0.2035144
PXN\tY88\t-0.28222435
PYCR2\tS303\t0.089289685
PYCR2\tS304\t0.1890338
PYGO1\tS34\t-0.04555055
PYGO2\tS60\t0.3473255
PYGO2\tT265\t0.1518587
Q6ZSR9\tS300\t0.2843957
Q6ZSR9\tS67\t-0.093448
Q6ZSR9\tS93\t-0.04496998
QSER1\tS1211\t-0.02414976
QSER1\tS1213\t-0.01796188
QSER1\tS1348\t-0.3942369
QSER1\tS987\t0.06419311
QSER1\tT1248\t0.1330374
QSER1\tT1341\t-0.166289565
QSER1\tT1346\t-0.14200862
QSOX2\tS579\t-0.3043981
QTRTD1\tS114\t0.02644594
R3HCC1\tS276\t0.2667565
R3HDM1\tS844\t0.2748878
R3HDM2\tS349\t-0.296793
RAB11A\tS42\t-0.21839059
RAB11FIP1\tS156\t0.340961
RAB11FIP1\tS199\t-0.00191056
RAB11FIP1\tS202\t0.03286835
RAB11FIP1\tS357\t-0.07803053
RAB11FIP1\tS435\t-0.4960815
RAB11FIP1\tS496\t0.3270222
RAB11FIP1\tS545\t0.2508404
RAB11FIP2\tS227\t0.4957414
RAB11FIP2\tS277\t-0.3062699
RAB11FIP2\tS388\t-4.19715
RAB11FIP2\tS429\t-0.5784562
RAB11FIP3\tS52\t-2.243113
RAB11FIP4\tS425\t0.2733369
RAB11FIP5\tS174\t0.03139513
RAB11FIP5\tS176\t0.1623389
RAB11FIP5\tS307\t0.2327835
RAB11FIP5\tS538\t0.21540915
RAB11FIP5\tT438\t0.62741735
RAB12\tS21\t0.2281107
RAB12\tS25\t0.113464005
RAB13\tT64\t0.075427795
RAB14\tS180\t-0.2898272
RAB23\tT184\t-0.06644242
RAB23\tT208\t0.102994
RAB27A\tS201\t-0.4135955
RAB28\tS2\t-0.08309814
RAB28\tS4\t-0.08309814
RAB32\tS71\t0.1514692
RAB34\tS13\t0.1944653
RAB34\tT76\t0.17034635
RAB38\tS187\t-0.04510394
RAB3A\tS190\t-0.07233958
RAB3GAP1\tS537\t-5.691373
RAB3GAP1\tS539\t-4.505004
RAB3GAP1\tS664\t-0.394281
RAB3GAP1\tS676\t-1.801632
RAB3GAP1\tT542\t-5.8246835
RAB3GAP2\tS450\t-1.151907
RAB3GAP2\tS916\t-0.9108132
RAB3IL1\tS179\t0.09934012
RAB6A\tS23\t0.2525368
RAB6A\tT3\t0.6909021
RAB7A\tS111\t-0.01955924
RAB7A\tS72\t-0.4566427
RAB7A\tT168\t0.2566484
RAB8A\tS185\t0.46339685
RAB8A\tT164\t0.05366741
RAB8B\tS111\t0.3965267
RAB8B\tS112\t0.216486
RAB8B\tS180\t-0.01941891
RAB8B\tS182\t-0.2177592
RAB8B\tT164\t0.26376585
RAB9A\tS179\t0.06887715
RAB9A\tT175\t-0.01226585
RABEP1\tS162\t-0.5279271
RABEP1\tS374\t-0.2572866
RABEP1\tS407\t0.044608097
RABEP1\tS410\t0.028513852
RABEP2\tS193\t-0.031470983
RABEP2\tS200\t0.05157998
RABEP2\tT194\t0.043118545
RABEPK\tS133\t0.696528
RABGAP1\tS360\t0.1988075
RABGAP1\tS42\t-0.04376486
RABGAP1\tT996\t-0.05054728
RABGAP1L\tS118\t-0.006332865
RABGAP1L\tS119\t-0.1056595
RABGAP1L\tS490\t0.2287264
RABGEF1\tS124\t0.38449835
RABGEF1\tS390\t-0.02373901
RABGEF1\tS400\t0.06681251
RABL6\tS402\t-0.1432135
RABL6\tS492\t-0.01552
RABL6\tS596\t-0.1647388
RABL6\tT599\t-0.1647388
RACGAP1\tS203\t-0.03398309
RACGAP1\tS214\t0.5303705
RACGAP1\tT249\t-0.03331854
RACGAP1\tT342\t0.1924466
RACGAP1\tT579\t0.1818087
RACGAP1\tT580\t0.355684
RAD18\tS103\t0.35395915
RAD18\tS409\t0.000144286
RAD18\tS471\t0.2776278
RAD18\tS99\t0.337308575
RAD23A\tS123\t-0.26465045
RAD23A\tS133\t-0.116958
RAD23A\tS92\t-0.6802196
RAD23B\tS160\t-1.18581925
RAD23B\tT162\t-1.3288175
RAD50\tT690\t0.127176965
RAD51AP1\tS103\t0.4525954
RAD51AP1\tT66\t0.01312788
RAD51C\tS20\t0.2158649
RAD54L2\tS73\t0.1058121
RAD54L2\tT1260\t0.04809668
RAF1\tS289\t0.119280125
RAF1\tS296\t-0.063010315
RAF1\tS301\t-0.7799921
RAF1\tS642\t-3.3538835
RAF1\tT303\t-0.263528248
RAI1\tS1013\t1.585395
RAI1\tS1107\t-0.180936265
RAI1\tS1122\t0.02830873
RAI1\tS1133\t-0.2252255
RAI1\tS1266\t0.0586628
RAI1\tS1352\t-0.071529765
RAI1\tS1358\t-0.4215346
RAI1\tS1362\t-0.17286935
RAI1\tS1374\t-0.03275755
RAI1\tS1431\t0.4369081
RAI1\tS568\t0.1654296
RAI1\tS683\t-0.2287736
RAI1\tS805\t0.02233225
RAI1\tS892\t-0.1348888
RAI1\tS916\t-0.032474357
RAI1\tT1068\t-2.427557
RAI1\tT1297\t0.2842772
RAI1\tT696\t0.3458505
RAI14\tS261\t-1.525496
RAI14\tS285\t-3.195876
RAI14\tS310\t-0.490294
RAI14\tS659\t0.279940855
RAI14\tS787\t0.0033108
RAI14\tT287\t-2.8890285
RAI14\tT289\t-2.910936
RALBP1\tS11\t0.04823624
RALBP1\tS29\t0.1330374
RALBP1\tS461\t0.500802
RALBP1\tS463\t0.351176
RALBP1\tS468\t0.669240525
RALBP1\tS92\t-0.4276924
RALBP1\tS93\t-0.4276924
RALGAPA1\tS1000\t0.03181863
RALGAPA1\tS775\t-0.32338525
RALGAPA1\tS860\t0.02743714
RALGAPA1\tT1002\t0.03181863
RALGAPA1\tT754\t-0.06952757
RALGAPA2\tS190\t-0.2937303
RALGAPA2\tS637\t0.1784973
RALGAPA2\tS638\t-0.009655009
RALGPS2\tS296\t-0.5102516
RALGPS2\tS308\t0.3572705
RALGPS2\tS329\t-0.081127765
RALGPS2\tS343\t0.1654296
RALGPS2\tS382\t0.2379307
RALGPS2\tT326\t-0.07848754
RALY\tS135\t0.0745054
RALY\tS288\t0.04362443
RALY\tS295\t0.06295063
RALY\tT286\t0.05102402
RALY\tT298\t0.04362443
RANBP1\tS188\t0.1035311
RANBP1\tS60\t0.25803865
RANBP10\tS29\t-0.05542082
RANBP10\tS305\t0.04432424
RANBP10\tS309\t0.1829465
RANBP10\tS313\t0.04432424
RANBP10\tS464\t-0.2490163
RANBP2\tS1110\t0.5154593
RANBP2\tS1160\t0.02701252
RANBP2\tS1400\t-0.13330388
RANBP2\tS1509\t0.03463829
RANBP2\tS21\t-0.1205295
RANBP2\tS2270\t0.27370325
RANBP2\tS955\t-0.7294829
RANBP2\tT1396\t-0.0735299
RANBP2\tT2613\t0.7770931
RANBP2\tT2743\t0.1646737
RANBP3\tS143\t-0.058485366
RANBP3\tS151\t-0.24388275
RANBP3\tS151\t-0.1310288
RANBP3\tS153\t1.0014721
RANBP3\tS176\t0.02417773
RANBP3\tS265\t-0.009204835
RANBP3\tS285\t-0.070537428
RANBP3\tS287\t0.03218021
RANBP3\tS289\t0.03218021
RANBP3\tS32\t-0.02874888
RANBP3\tS33\t0.08933725
RANBP3\tS40\t0.076484295
RANBP9\tS477\t-0.3129573
RANBP9\tS483\t-0.1725334
RANBP9\tS485\t-0.161651255
RANBP9\tS487\t-0.10510066
RANGAP1\tS428\t-0.7218445
RANGAP1\tS442\t0.13490331
RAP1B\tS39\t0.3284918
RAP1GAP\tS505\t-0.1593474
RAP1GAP\tS548\t-0.5656306
RAP1GAP\tS563\t-0.2652578
RAP1GAP\tT586\t-0.285739075
RAP1GAP\tT9\t0.33008761
RAPGEF1\tS175\t0.053935765
RAPGEF1\tS254\t0.03998062
RAPGEF2\tS1022\t-1.100187
RAPGEF2\tS1080\t0.2941943
RAPH1\tS1154\t-1.122994
RAPH1\tS17\t-0.1470423
RAPH1\tS5\t-0.1470423
RAPH1\tS894\t-0.02036975
RAPH1\tT830\t-0.054710007
RARA\tS348\t-0.1768539
RARB\tS70\t-0.01147167
RASA3\tS809\t0.07395734
RASAL2\tS1017\t-0.1872307
RASAL2\tS1021\t-0.1872307
RASAL2\tS1084\t-2.029382
RASAL2\tS141\t0.15834102
RASAL2\tS146\t0.075066645
RASAL2\tS165\t0.26635619
RASAL2\tS866\t0.1840899
RASAL2\tS888\t0.696261
RASAL2\tS971\t0.4513299
RASAL2\tT969\t0.4513299
RASSF8\tS385\t0.02193085
RASSF8\tS387\t-0.044767425
RAVER1\tS14\t-0.001039149
RAVER1\tS17\t-0.1639628
RAVER1\tS483\t-1.011501
RAVER1\tS567\t-0.002816039
RAVER1\tS617\t0.06626152
RAVER1\tT463\t-1.278654
RAVER1\tT488\t-1.31581
RB1\tS249\t-0.1159883
RB1\tS360\t-0.04117155
RB1\tS37\t-0.06461568
RB1\tS608\t-0.1205295
RB1\tS612\t-0.1903386
RB1\tS780\t0.04355119
RB1\tS788\t0.005040595
RB1\tS794\t-0.0339978
RB1\tS795\t0.029255005
RB1\tS807\t-0.07851118
RB1\tS811\t0.02913487
RB1\tS816\t0.099314945
RB1\tS855\t-0.4815052
RB1\tT353\t-0.030373348
RB1\tT356\t0.03252402
RB1\tT373\t-0.0997263
RB1\tT821\t0.022495699
RB1\tT823\t0.08786433
RB1\tT826\t0.004896797
RB1\tY606\t0.01747255
RB1CC1\tS222\t-0.3719824
RB1CC1\tS237\t0.08324736
RB1CC1\tS257\t-0.0616163
RB1CC1\tS261\t-0.2277258
RB1CC1\tS266\t-0.32193505
RB1CC1\tS647\t0.35046235
RB1CC1\tS653\t-0.6474674
RB1CC1\tS667\t-0.8724459
RB1CC1\tT238\t0.2239167
RBBP4\tS110\t-0.04760675
RBBP4\tS146\t0.1416253
RBBP4\tT144\t-0.32333565
RBBP6\tS1145\t-0.01884875
RBBP6\tS1243\t0.01406952
RBBP6\tS1294\t0.165301
RBBP6\tS1660\t0.3767671
RBBP6\tS1661\t0.2613201
RBBP6\tS1665\t0.244767
RBBP6\tS516\t0.03337007
RBBP6\tS736\t0.3228512
RBBP6\tS738\t0.3228512
RBBP6\tS911\t-0.200901821
RBBP6\tS926\t-0.106964
RBBP6\tT950\t0.08243007
RBBP7\tS95\t0.4854357
RBBP8\tS327\t0.1285573
RBBP8\tT315\t0.1232689
RBCK1\tS50\t-0.2603075
RBL1\tS1037\t0.1804026
RBL1\tS1041\t0.1407574
RBL1\tS615\t0.01635366
RBL1\tS640\t-0.01597215
RBL1\tS650\t-0.4720279
RBL1\tS964\t-0.134026685
RBL1\tS988\t-0.030283157
RBL1\tT332\t0.1708224
RBL1\tT369\t0.04376442
RBL1\tT385\t-0.001255676
RBL2\tS1068\t-0.4371935
RBL2\tS1112\t0.03477915
RBL2\tS413\t0.1364539
RBL2\tS639\t2.24648045
RBL2\tS662\t-0.1698258
RBL2\tS995\t-0.07225522
RBL2\tT417\t0.1364539
RBL2\tT642\t-0.2333251
RBL2\tT694\t-0.4365489
RBM10\tS60\t0.159269345
RBM10\tS61\t0.159269345
RBM10\tS65\t-0.07510959
RBM10\tS69\t-0.13772275
RBM10\tS717\t0.2342561
RBM10\tS722\t-0.007304073
RBM10\tS735\t0.10313235
RBM10\tS737\t0.3466449
RBM10\tS796\t-0.04357155
RBM10\tS89\t-0.07529195
RBM10\tT91\t-0.07833518
RBM12\tS352\t-0.001648565
RBM12\tS375\t0.171046055
RBM12B\tS278\t0.3149871
RBM12B\tS280\t0.01977311
RBM12B\tS562\t-0.1468028
RBM12B\tS575\t-0.0459079
RBM12B\tS591\t-0.1856547
RBM12B\tS638\t0.04334458
RBM12B\tS710\t0.002306507
RBM12B\tS718\t0.03322923
RBM12B\tS829\t-0.08259113
RBM12B\tS839\t0.03520166
RBM14\tS618\t-0.7705598
RBM14\tS620\t0.418028
RBM14\tS623\t0.1949696
RBM14\tT572\t0.173424
RBM15\tS257\t0.08065767
RBM15\tS259\t0.0724488
RBM15\tS294\t-0.07023927
RBM15\tS622\t-0.3956439
RBM15\tS656\t0.01149566
RBM15\tS659\t0.03294719
RBM15\tS670\t-0.055421545
RBM15\tS674\t0.05713834
RBM15\tS678\t0.006044035
RBM15\tS700\t-0.06989101
RBM15\tS781\t-0.04245678
RBM15\tT265\t0.064243225
RBM15B\tS109\t0.09437123
RBM15B\tS113\t0.01321208
RBM15B\tS147\t0.255238465
RBM15B\tS265\t-0.09052638
RBM15B\tS267\t0.01078666
RBM15B\tS539\t0.1327743
RBM15B\tS552\t0.0416635
RBM15B\tS562\t0.04076872
RBM15B\tS609\t-0.007884207
RBM15B\tT532\t-0.02098439
RBM17\tS155\t-0.03757682
RBM17\tS169\t0.40266935
RBM17\tS222\t-0.01366915
RBM20\tS876\t-0.02986022
RBM23\tS127\t0.02332628
RBM25\tS583\t0.06515872
RBM25\tS677\t0.268400875
RBM25\tS683\t0.5915836
RBM25\tS703\t0.06073913
RBM26\tS127\t-0.03069288
RBM26\tS616\t0.02233225
RBM26\tS616\t0.02233225
RBM26\tT609\t-0.0667404
RBM27\tS566\t0.2668765
RBM27\tS914\t0.17850411
RBM27\tT447\t0.1891604
RBM33\tS205\t-0.356273
RBM33\tS741\t-0.08354735
RBM33\tS765\t0.04404436
RBM33\tS78\t-0.2232558
RBM33\tT946\t0.1027253
RBM34\tS12\t-1.68455
RBM34\tS26\t0.591488
RBM34\tS90\t0.07338358
RBM34\tS97\t-0.02192151
RBM39\tS136\t-0.000692654
RBM4\tS86\t-0.134061735
RBM5\tS59\t0.08460858
RBM5\tS624\t-0.08860756
RBM6\tS228\t0.1527676
RBM6\tS230\t0.083329
RBM6\tS759\t-0.02535321
RBM6\tS893\t0.2152437
RBM7\tS138\t0.2797684
RBM8A\tS42\t0.008343471
RBM8A\tS56\t-0.08508344
RBM8A\tY54\t0.4325151
RBMS1\tS5\t-0.1234388
RBMX\tS189\t0.1448295
RBMX\tS208\t0.006621249
RBMX\tS332\t0.107317495
RBMX\tS352\t-0.2115648
RBMX\tS58\t0.08596853
RBMX\tS88\t-0.08204134
RBMX\tS91\t-0.109384215
RBMX2\tS186\t-0.07058771
RBMX2\tS188\t-0.1408255
RBMXL1\tS88\t-0.06366543
RBPJ\tS18\t-0.04391361
RC3H1\tS535\t0.02233225
RC3H1\tS772\t0.07721405
RC3H2\tS1119\t-1.158913
RC3H2\tS549\t-1.064631
RC3H2\tS803\t2.144577
RC3H2\tT553\t-1.0978565
RCAN1\tS28\t-0.06987584
RCAN1\tS32\t-0.30118342
RCC1\tS11\t-0.05389804
RCC2\tS50\t0.335008575
RCC2\tS51\t0.2784531
RCHY1\tS235\t-0.3016037
RCOR1\tS136\t-0.418229385
RCOR1\tS257\t-0.01576792
RCOR1\tS457\t-0.003857133
RCOR1\tT446\t0.147926235
RCOR2\tS213\t-0.11022355
RCOR3\tS156\t-0.03371775
RCOR3\tS171\t-0.03371775
RECQL\tS634\t0.5462648
RECQL4\tS251\t0.1875144
RECQL5\tS700\t-0.17081014
RECQL5\tS788\t-0.05102542
RECQL5\tT812\t0.21661
REEP3\tS152\t0.2496274
REEP3\tS210\t-0.41167855
REEP3\tT201\t-0.4851432
REEP4\tS152\t0.2263851
RELB\tS37\t-0.3075906
RELL1\tS244\t-0.18182165
RELL1\tT261\t-0.12594899
RELT\tT223\t-0.124047
RENBP\tS416\t0.03379299
REPIN1\tS27\t0.3499314
REPS1\tS162\t0.1733833
REPS1\tS170\t0.21302345
REPS1\tS174\t0.244053575
REPS1\tS272\t-0.41986975
REPS1\tS482\t-1.544224
REPS1\tS561\t0.04432424
REPS1\tS708\t-1.924344
REPS1\tT173\t0.40408125
REPS1\tT481\t-1.447918
REPS1\tT720\t-2.0299585
RER1\tS2\t0.103397
RER1\tS95\t-0.1952856
RERE\tS1266\t0.2542312
RERE\tS142\t-0.1907173
RERE\tS600\t-0.06490241
RERE\tS613\t-0.3099138
RERE\tS641\t-0.16735191
RERE\tS642\t-0.4326298
RERE\tS656\t-0.04495508
RERE\tS675\t0.7253486
RERE\tS679\t0.013489275
RERE\tS692\t0.02616273
REST\tS743\t-0.12287231
REST\tS841\t-0.01996008
REV3L\tS1052\t0.079635815
REV3L\tS1646\t-0.05752675
REV3L\tS2069\t-0.05817256
REV3L\tS2093\t0.06887715
REV3L\tS2105\t-0.2253457
REV3L\tS952\t0.2072682
REXO1\tS287\t0.058846715
REXO1\tS289\t0.058846715
REXO1\tS358\t-0.0721339
REXO1\tS610\t-0.05712151
RFC1\tS108\t0.1526378
RFC1\tS1103\t0.3063232
RFC1\tS190\t0.51017875
RFC1\tS312\t0.1471764
RFC1\tS368\t-0.02691043
RFC1\tS69\t-0.008914516
RFC1\tS71\t-0.008914516
RFC1\tT110\t0.1526378
RFC1\tY67\t-0.011150125
RFFL\tS103\t-0.122608734
RFFL\tS89\t-0.2091279
RFFL\tS92\t-0.2091279
RFTN1\tS163\t0.23206485
RFTN1\tS184\t-0.01196617
RFTN2\tS430\t-0.69783055
RFTN2\tS455\t-0.4397091
RFTN2\tT409\t-0.3100389
RFX1\tS159\t-0.1099814
RFX2\tS28\t0.02219017
RFX3\tS155\t0.01492663
RFX3\tS664\t-0.1363469
RFX3\tS674\t-0.1031779
RFX3\tS678\t-0.1031779
RFX5\tS10\t-0.4114832
RFX5\tS185\t-0.01911189
RFX7\tS1028\t-0.36917155
RFX7\tS202\t-0.109888
RFX7\tS225\t-0.05199724
RFX7\tS282\t0.07011455
RFX7\tS349\t0.14989067
RFX7\tS358\t0.2961034
RFX7\tS424\t-0.31744115
RFX7\tT1025\t-0.36917155
RFX7\tT891\t-0.1734401
RGL2\tS13\t0.06777637
RGL2\tS761\t0.270919345
RGL2\tT12\t0.0446039
RGL2\tT562\t-0.8635724
RGL3\tS511\t-0.17328895
RGL3\tS512\t-0.09978449
RGL3\tS591\t-2.206165
RGPD3\tS1993\t0.2107629
RGPD3\tS2237\t-0.296226
RGPD3\tS2239\t-0.07561138
RGPD3\tS2241\t-0.8091449
RGPD3\tS2242\t-0.8091449
RGPD3\tS2246\t0.1575611
RGPD3\tS2250\t-0.8091449
RGPD3\tS2251\t-0.7146333
RGPD3\tS2297\t-0.2484677
RGPD3\tS2454\t-0.06961845
RGPD3\tS788\t0.1360601
RGPD3\tS809\t0.2715452
RGPD3\tT2293\t0.03773361
RGS12\tS172\t-2.681863
RGS12\tS850\t-0.07264963
RGS14\tS135\t-0.38059595
RHBDF1\tS11\t0.7419199
RHBDF1\tS309\t0.1829465
RHBDF1\tS346\t-4.577319
RHBDF1\tS61\t-0.62054575
RHBDF1\tT180\t-0.758462875
RHBDF1\tT183\t-1.3775345
RHBDF2\tS148\t-0.7956089
RHBDF2\tS61\t-0.8473622
RHOBTB3\tS32\t-0.086428255
RHPN2\tS642\t-0.08065227
RHPN2\tS654\t-0.085016955
RIC8A\tS436\t-0.03658502
RIC8A\tS502\t0.1083358
RIC8A\tT441\t-0.1168328
RIC8A\tT443\t0.1351408
RICTOR\tS1035\t-1.587836
RICTOR\tS1174\t0.0772108
RICTOR\tS1235\t0.6588454
RICTOR\tS1388\t-0.12375035
RICTOR\tS1591\t0.028919235
RICTOR\tS21\t-0.3479495
RICTOR\tT1135\t-0.341921
RICTOR\tT1175\t-0.009882185
RICTOR\tT1592\t0.04881748
RIF1\tS1149\t0.474925
RIF1\tS1162\t0.2111037
RIF1\tS1236\t0.07532719
RIF1\tS1238\t0.09531686
RIF1\tS1422\t-2.491024
RIF1\tS1454\t0.1611782
RIF1\tS1542\t-0.851235
RIF1\tS1552\t-0.3429774
RIF1\tS1554\t-0.12180741
RIF1\tS1579\t0.221847405
RIF1\tS1608\t0.2551986
RIF1\tS1616\t-0.1026202
RIF1\tS1688\t-0.2097284
RIF1\tS1693\t-0.0409967
RIF1\tS1706\t0.56294905
RIF1\tS1873\t0.224671637
RIF1\tS1876\t0.17147711
RIF1\tS2144\t0.154324
RIF1\tS2161\t0.334797
RIF1\tS2172\t0.240164
RIF1\tS2176\t0.3109217
RIF1\tS2196\t0.102994
RIF1\tS2367\t0.1904253
RIF1\tT1806\t-0.1983612
RILPL1\tS346\t-0.276992
RIN1\tS11\t-0.4877023
RIN1\tS16\t-0.300324
RIN1\tS210\t-0.9990384
RIN1\tS258\t-3.2585595
RIN1\tS3\t-0.2690254
RIN1\tS333\t0.3746086
RIN1\tS337\t0.1759396
RIN1\tS349\t-0.4435086
RIN1\tS351\t-0.1704426
RIN1\tS7\t-0.447236
RIN1\tY36\t-0.347619
RIN3\tS270\t-2.036704
RING1\tS188\t0.24154695
RING1\tS229\t-0.047355295
RING1\tS232\t-0.1060631
RING1\tS248\t-0.17776905
RING1\tS38\t-0.18063741
RIOK1\tS21\t0.2335199
RIOK1\tS22\t0.14864946
RIOK2\tS332\t0.01991543
RIOK2\tS337\t-0.004089657
RIOK2\tS350\t0.2599051
RIOK2\tS380\t0.3116193
RIOK2\tS382\t0.3116193
RIOK2\tS385\t0.3116193
RIOK2\tS412\t0.810326
RIOK3\tS109\t0.1413072
RIOK3\tS111\t0.1413072
RIOK3\tS112\t0.1413072
RIPK1\tS320\t-0.4887141
RIPK1\tS330\t-0.365797
RIPK1\tS331\t-0.2239803
RIPK2\tS226\t-2.8337645
RIPK4\tS320\t-0.09668401
RIPK4\tS327\t-0.3109513
RLF\tS632\t-0.2241151
RLIM\tS230\t-0.13856495
RMDN3\tS46\t0.1740229
RMI1\tS284\t-0.068938185
RMI1\tS292\t-0.3527131
RNASEH1\tS76\t0.11740645
RND3\tS14\t-1.166356
RNF10\tS5\t-0.9989504
RNF11\tS14\t0.2639958
RNF11\tS25\t-0.2094949
RNF113A\tS6\t-0.3045941
RNF113A\tS84\t-0.1123343
RNF113A\tS85\t-0.1123343
RNF123\tS675\t0.0197001
RNF126\tS5\t-0.3741872
RNF135\tS184\t-1.0032174
RNF139\tS625\t-0.28228885
RNF139\tS634\t-0.202319375
RNF139\tT635\t-0.202319375
RNF169\tS247\t-0.08295787
RNF169\tS339\t0.1437852
RNF169\tS403\t0.1198209
RNF169\tT554\t0.1563967
RNF182\tT111\t-0.205676655
RNF19A\tS35\t-0.3672664
RNF19A\tS568\t0.3145225
RNF19A\tS600\t-0.7421428
RNF19A\tS603\t-0.7717816
RNF2\tS168\t0.2166554
RNF20\tS136\t-0.089078047
RNF20\tS138\t-0.2298907
RNF213\tS1258\t-0.4076315
RNF213\tS2266\t0.02559582
RNF213\tS2273\t-0.02635203
RNF214\tS176\t-0.01933123
RNF214\tS511\t0.2382977
RNF216\tS419\t0.02115607
RNF216\tS719\t-0.5278856
RNF219\tS553\t0.138763155
RNF219\tS719\t0.2539892
RNF25\tS455\t0.09747601
RNF31\tS284\t-1.652448
RNF31\tS367\t-0.3654253
RNF38\tS60\t-0.3037251
RNF4\tS90\t0.0614788
RNF4\tS94\t0.1154328
RNF4\tS95\t0.25930845
RNF8\tS100\t-1.948363
RNH1\tT82\t-0.31638365
RNPC3\tS108\t0.0311129
RNPEP\tS3\t-0.02763645
RNPEP\tS7\t-0.09941719
ROBO1\tS1403\t0.02048441
ROBO1\tS1453\t-0.4187741
ROBO1\tS901\t0.0265876
ROBO1\tT1201\t0.40892945
ROBO1\tT1402\t0.1277653
ROCK1\tS1105\t-0.27639175
ROCK2\tS1374\t-0.4255206
RP13-360B22.2\tS71\t-0.006274913
RP2\tS28\t1.21014
RPA1\tS135\t0.02899346
RPA1\tS38\t0.1676822
RPAP1\tS1121\t-0.4433163
RPAP1\tS603\t-0.105845885
RPAP1\tS72\t0.02941749
RPAP1\tS80\t-0.4316208
RPAP1\tT321\t-0.03075183
RPAP3\tS481\t-0.29440795
RPGR\tS418\t-0.1052715
RPL12\tS38\t0.1604039
RPL13\tS140\t-0.06453505
RPL13\tS77\t-0.152645545
RPL13\tT107\t-0.2264078
RPL17\tS142\t-0.02482471
RPL24\tS86\t-0.035082765
RPL24\tT83\t0.02715413
RPL27A\tS68\t0.24773305
RPL30\tS10\t0.06722574
RPL31\tS15\t0.1191569
RPL4\tS295\t0.1835818
RPL7\tT17\t0.5189379
RPLP0\tS304\t0.10398013
RPLP0\tS307\t0.10398013
RPLP0\tY24\t0.06722574
RPLP1\tS102\t-0.03458991
RPLP1\tS105\t-0.113682165
RPLP2\tS17\t0.06750099
RPLP2\tS64\t0.1859028
RPLP2\tS74\t-0.2026218
RPLP2\tS79\t-0.3019238
RPLP2\tS86\t-0.1966573
RPN1\tS535\t0.4738724
RPP25\tS162\t0.01435528
RPP30\tS251\t-1.890145
RPP30\tS261\t-0.9101765
RPP38\tS226\t-0.009088701
RPP38\tS235\t0.1610493
RPP38\tT234\t0.26992785
RPRD1A\tS156\t-0.4462267
RPRD1B\tS132\t-0.0810338
RPRD1B\tS134\t-0.03858413
RPRD2\tS1062\t-0.6823949
RPRD2\tS319\t-0.259841
RPRD2\tS337\t-0.02503023
RPRD2\tS401\t0.0311129
RPRD2\tS403\t-0.0481586
RPRD2\tS436\t0.56204885
RPRD2\tS439\t0.5764724
RPRD2\tS442\t0.3253139
RPRD2\tS448\t-0.1458767
RPRD2\tS556\t0.017586008
RPRD2\tS577\t-0.2362655
RPRD2\tS628\t-0.130555
RPRD2\tS721\t-0.4362756
RPRD2\tS759\t0.10865934
RPRD2\tS761\t-0.1197298
RPRD2\tS780\t-0.4247071
RPRD2\tS888\t-0.05661252
RPRD2\tS893\t-0.10957113
RPRD2\tS895\t-0.10453719
RPRD2\tT321\t-0.07841136
RPRD2\tT686\t0.1802752
RPRD2\tT726\t0.5023306
RPS10\tS146\t0.0745054
RPS14\tS139\t0.2977197
RPS17L\tS113\t0.121148
RPS17L\tS115\t0.04236425
RPS2\tS264\t0.07956584
RPS2\tS77\t0.2380531
RPS20\tT9\t-0.1520031
RPS25\tS93\t-0.102181405
RPS27\tS11\t0.1063484
RPS27L\tS11\t-0.01941891
RPS27L\tS27\t-0.2347539
RPS27L\tS78\t-0.4941904
RPS3\tS104\t0.1632449
RPS3\tS224\t-0.075190403
RPS3\tT221\t0.006046604
RPS3A\tS236\t0.04236425
RPS3A\tS237\t0.03618686
RPS3A\tS238\t0.05352838
RPS5\tS142\t0.00302647
RPS5\tT14\t-0.04869572
RPS6\tS148\t0.1861201
RPS6\tS236\t-0.8825118
RPS6\tS240\t-0.85151575
RPS6\tS244\t-0.5031797
RPS6\tS247\t-1.431481
RPS6KA1\tS369\t-4.184818
RPS6KA2\tS377\t-1.618021
RPS6KA2\tS546\t-1.290851
RPS6KA3\tS369\t-1.60052695
RPS6KA3\tS386\t-2.922593
RPS6KA3\tS415\t-0.2769221
RPS6KA3\tS715\t-0.6024379
RPS6KA3\tT577\t-4.445394
RPS6KA4\tS347\t-1.092554
RPS6KA4\tS497\t0.6013071
RPS6KB1\tS374\t-1.046832
RPS6KB1\tS399\t0.215769625
RPS6KC1\tS270\t-0.07010295
RPS6KC1\tS411\t-0.2138551
RPS6KC1\tS415\t-0.1360299
RPS6KC1\tS449\t-0.01447046
RPS6KC1\tS516\t-0.4796129
RPS6KC1\tS571\t-1.617366
RPS6KC1\tS649\t0.29942695
RPS6KC1\tS652\t0.17828098
RPS6KC1\tT272\t0.07354603
RPS8\tS160\t0.1253867
RPS8\tT130\t0.2207014
RPSA\tT104\t0.08515262
RPTOR\tS701\t-0.3258649
RPTOR\tS705\t-0.35369805
RPTOR\tS719\t-0.08263703
RPUSD2\tS68\t-0.03067821
RRAGC\tS15\t-0.09554288
RRAGC\tS95\t0.3160298
RRAGC\tT96\t0.2445218
RRAS2\tS186\t0.03224201
RRBP1\tS1276\t-0.305199568
RRBP1\tS1277\t-0.41304755
RRBP1\tS159\t0.10594225
RRBP1\tS615\t0.3518545
RREB1\tS1122\t0.05032762
RREB1\tS1167\t-0.2102124
RREB1\tS1320\t-0.04806907
RREB1\tS161\t-0.08520586
RRM1\tS780\t-0.117672655
RRM2\tS20\t0.3484591
RRN3\tS140\t-0.01722728
RRN3\tS142\t-0.01722728
RRN3\tS44\t-0.5092657
RRP12\tS1080\t-0.01170433
RRP15\tS11\t0.2492632
RRP15\tS226\t0.6567646
RRP15\tS58\t-0.03509134
RRP15\tS67\t-0.03509134
RRP1B\tS245\t0.05227683
RRP1B\tS392\t0.4323181
RRP1B\tS458\t0.01464098
RRP1B\tS460\t0.1186256
RRP1B\tS513\t0.3359405
RRP1B\tS732\t0.11299074
RRP1B\tS735\t0.03843611
RRP1B\tT728\t1.069702
RRP7A\tS19\t-0.01240263
RRP7A\tS99\t0.1791288
RRP8\tS104\t-0.012295818
RRP8\tS106\t0.07107621
RRP8\tS126\t0.243791
RRP8\tS223\t0.1746621
RRP8\tS62\t-0.0407937
RRP8\tS64\t-0.0407937
RRP9\tS51\t-0.01807427
RSAD1\tS30\t-0.09329405
RSBN1\tS547\t-0.0158992
RSBN1L\tS536\t0.06571014
RSBN1L\tS6\t-0.1315661
RSF1\tS1246\t-0.3252321
RSF1\tS1251\t-0.3361363
RSF1\tS1279\t0.05476098
RSF1\tS1314\t-0.0234017
RSF1\tS1328\t-0.086495465
RSF1\tS1344\t0.15535482
RSF1\tS366\t0.3425547
RSF1\tS573\t-0.06743983
RSF1\tS591\t-0.24831575
RSF1\tT1247\t-0.3252321
RSF1\tT1274\t-0.00839832
RSF1\tY1250\t-0.233862235
RSL1D1\tS361\t0.03238294
RSL1D1\tS400\t0.40642775
RSL1D1\tS427\t0.1129003
RSL1D1\tS469\t0.8139351
RSL1D1\tT358\t-0.02754259
RSL1D1\tT465\t0.5971106
RSRC2\tS104\t-1.46176
RSRC2\tS17\t-0.05712151
RSRC2\tS27\t0.03969989
RSRC2\tS30\t0.9018806
RSRC2\tS32\t0.43214448
RSRC2\tS4\t-0.1501127
RTEL1\tS92\t0.1340894
RTF1\tS674\t-0.34011015
RTF1\tS697\t0.4212637
RTKN\tS219\t0.2189671
RTKN\tS228\t0.7743338
RTKN\tS507\t0.08501676
RTKN\tS93\t-0.9302703
RTN3\tS117\t-0.65170095
RTN3\tS30\t0.1847246
RTN4\tS107\t-0.6328303
RTN4\tS11\t0.00558087
RTN4\tS111\t-0.1617016
RTN4\tS12\t-0.1353325
RTN4\tS121\t-0.73978735
RTN4\tS13\t-0.02901383
RTN4\tS15\t-0.247651632
RTN4\tS181\t-0.10560914
RTN4\tS181\t0.25028735
RTN4\tS184\t-0.1716771
RTN4\tS7\t-1.06466955
RTN4\tT188\t-0.1598954
RUNDC1\tS70\t-0.1288345
RUNDC1\tS74\t-0.1288345
RUNX1\tS17\t0.5207491
RUNX1\tS193\t0.12943315
RUNX1\tS21\t0.4459386
RUNX1\tS212\t0.8705028
RUNX1\tS295\t0.1984942
RUNX1\tT14\t0.3774015
RUNX3\tS14\t0.01306909
RUNX3\tS228\t0.365666865
RUSC2\tS536\t0.216486
RUSC2\tS543\t-0.39699245
RUVBL1\tS29\t0.150838075
RWDD2B\tS275\t-0.1449508
RYBP\tS214\t0.1906428
RYBP\tS99\t0.1979911
RYBP\tT215\t0.1906428
RYK\tT96\t0.06442442
S100A11\tS5\t-1.171108
S100A11\tS6\t-0.1280933
S100A13\tS32\t-0.0327597
SAAL1\tS6\t0.0745054
SACS\tS1779\t-2.767683
SACS\tS4257\t-1.292779
SACS\tS4260\t-1.0990749
SACS\tS4264\t-2.116661
SACS\tT4266\t-2.172734
SAE1\tS201\t-0.2173734
SAFB\tS383\t-0.025338113
SAFB\tS384\t0.142826037
SAFB\tS604\t-0.2924145
SAFB2\tS109\t-0.1049766
SAFB2\tS195\t0.5285713
SAFB2\tS207\t0.42026945
SAFB2\tS235\t0.103909105
SAFB2\tS246\t0.01578305
SAFB2\tS247\t0.081644265
SAFB2\tS288\t0.27427975
SAFB2\tT245\t0.3276874
SALL1\tS1022\t0.1624679
SAMD1\tS161\t-0.1882495
SAMD1\tS427\t-0.4208809
SAMD4A\tS191\t-1.361378
SAMD4A\tS319\t0.04963072
SAMD4A\tS479\t-0.04188776
SAMD4B\tS172\t0.1539389
SAMD4B\tS271\t-1.975226
SAMD4B\tS555\t-0.05054728
SAMD4B\tS557\t-0.007188092
SAMD4B\tS592\t-1.593006
SAMD9\tS858\t0.0135124
SAMHD1\tT522\t-0.01667252
SAP130\tS300\t0.1420866
SAP130\tS442\t0.3280323
SAP130\tS465\t0.6123053
SAP130\tS855\t0.192694575
SAP130\tS875\t-0.02901383
SAP130\tT856\t0.192694575
SAP30BP\tS97\t0.008917032
SAR1A\tS143\t-0.2463735
SAR1A\tT139\t-0.000100957
SARM1\tS54\t-0.2672186
SARM1\tS68\t0.00894693
SART1\tS448\t-1.932141
SART1\tT764\t0.00805652
SART3\tS10\t-0.142448093
SART3\tS250\t0.09922788
SART3\tS8\t-0.303563728
SART3\tT7\t0.01235413
SASH1\tS101\t0.05352838
SASH1\tS1025\t-0.7351153
SASH1\tS1028\t-1.35990625
SASH1\tS1031\t-1.6325795
SASH1\tS1051\t0.0551957
SASH1\tS248\t-0.0375176
SASH1\tS297\t0.1458731
SASH1\tS387\t-0.27129015
SASH1\tS407\t0.1887806
SASH1\tS442\t-0.07650848
SASH1\tS507\t0.170114485
SASH1\tS510\t0.2871176
SASH1\tS721\t-0.01996008
SASH1\tS725\t0.3104565
SASH1\tS730\t0.2702299
SASH1\tS813\t0.07025199
SASH1\tS821\t0.1788739
SASH1\tS90\t-0.2961374
SASH1\tT1030\t-0.7058271
SASH1\tT405\t0.09477648
SATB1\tS38\t0.097075835
SATB2\tS13\t0.08379207
SATB2\tS176\t0.20764145
SATB2\tS185\t-0.23804415
SATB2\tS39\t0.2038903
SATB2\tS475\t-0.01927275
SATB2\tS476\t0.138028
SATB2\tS7\t0.007283605
SBDS\tS2\t0.2249163
SBDS\tT5\t0.5786006
SBF1\tS1120\t-0.1311237
SBF1\tS1141\t-0.05027995
SBF1\tT1033\t-0.09011167
SBF1\tT1137\t0.3427823
SBF1\tT1263\t0.0294594
SBF1\tT1845\t-0.165545814
SBF2\tS1104\t0.08120319
SBF2\tT1105\t-0.009379053
SBNO1\tS814\t-0.136610885
SCAF1\tS239\t-0.06212838
SCAF1\tS30\t-0.1396966
SCAF1\tS498\t-0.215671675
SCAF1\tS500\t-0.02963225
SCAF1\tS548\t0.06983963
SCAF1\tS552\t-0.519098485
SCAF1\tS719\t-0.06517408
SCAF1\tS724\t0.04399136
SCAF1\tS725\t-0.3149239
SCAF1\tS734\t0.053557485
SCAF1\tS738\t-0.00311961
SCAF1\tS874\t0.004033884
SCAF1\tS965\t0.01421241
SCAF1\tT989\t0.1553607
SCAF11\tS23\t0.08188502
SCAF11\tS293\t-0.04360133
SCAF11\tS298\t0.07547108
SCAF11\tS299\t-0.0455952
SCAF11\tS456\t0.07983892
SCAF11\tS459\t0.13803255
SCAF11\tS461\t0.071246935
SCAF11\tS481\t-0.042202625
SCAF11\tS483\t0.07915612
SCAF11\tS487\t0.0917142
SCAF4\tS656\t-0.2305837
SCAF8\tS617\t0.03843611
SCAMP3\tS32\t-0.02503023
SCAMP3\tS76\t-0.1894829
SCAMP4\tT160\t0.3829439
SCAP\tS429\t-0.01214072
SCAP\tS458\t0.05311137
SCARF2\tS546\t0.3143247
SCARF2\tS646\t-0.006036025
SCARF2\tS648\t0.11240599
SCARF2\tS682\t-0.168186
SCARF2\tS688\t0.011989017
SCARF2\tS693\t0.151983275
SCARF2\tS737\t-0.07033019
SCARF2\tS850\t0.6647559
SCD\tS198\t0.4671752
SCD\tT199\t0.386811
SCFD1\tS303\t0.209391
SCLT1\tS656\t-0.8865395
SCML1\tS55\t0.46038905
SCML2\tS106\t-0.1544417
SCNM1\tS183\t0.08488071
SCRIB\tS1220\t0.05380643
SCRIB\tS1223\t-0.086238865
SCRIB\tS1225\t-0.3351259
SCRIB\tS1226\t-0.74666935
SCRIB\tS1232\t-0.04415156
SCRIB\tS1279\t0.7131679
SCRIB\tS1306\t0.4769981
SCRIB\tS1309\t0.47265195
SCRIB\tS1348\t-0.6108862
SCRIB\tS1378\t0.0878702
SCRIB\tS1437\t0.451469
SCRIB\tS1439\t-0.604279
SCRIB\tS1445\t-0.379301
SCRIB\tS1448\t-0.3192342
SCRIB\tS1475\t-0.1257302
SCRIB\tS1486\t0.02431962
SCRIB\tS1508\t-0.01883412
SCRIB\tS1541\t-0.00913461
SCRIB\tS1541\t-0.00913461
SCRIB\tS1547\t-0.14911343
SCRIB\tS1547\t-0.14911343
SCRIB\tS1566\t0.08854871
SCRIB\tS1581\t-0.3833224
SCRIB\tS1613\t0.4410585
SCRIB\tS502\t0.02642595
SCRIB\tS504\t-0.04510394
SCRIB\tS688\t0.1022767
SCRIB\tS835\t-0.5832251
SCRIB\tS853\t-0.2001666
SCRIB\tS939\t-0.06123997
SCRIB\tT1342\t-1.3286025
SCRIB\tT1549\t0.013404705
SCRIB\tT1549\t0.013404705
SCRIB\tT475\t-0.06309867
SCRIB\tT689\t0.0576394
SCRIB\tT941\t-0.2989745
SCRN2\tT52\t0.12426675
SCYL1\tS754\t-0.04170595
SCYL2\tS292\t-0.05514159
SCYL2\tS677\t0.0029624
SCYL3\tS653\t-0.4236555
SDAD1\tS195\t-0.1479053
SDAD1\tS197\t-0.1479053
SDAD1\tS199\t-0.1479053
SDAD1\tS548\t0.1392075
SDCBP\tS131\t-0.13470665
SDCBP\tS6\t0.2051422
SDCCAG3\tS167\t-0.11947298
SDCCAG3\tS170\t-0.3029735
SDCCAG3\tS174\t0.014403475
SDCCAG8\tS92\t0.1461339
SDE2\tS266\t0.1518587
SDE2\tS285\t-0.02754259
SDE2\tT262\t-0.02648427
SEC14L1\tT200\t-0.3466647
SEC16A\tS1069\t-0.07453221
SEC16A\tS1223\t0.1396005
SEC16A\tS1305\t0.02204824
SEC16A\tS1327\t-0.06636697
SEC16A\tS1356\t0.4665791
SEC16A\tS1359\t0.4041402
SEC16A\tS1362\t0.4041402
SEC16A\tS1365\t0.4041402
SEC16A\tS1964\t-1.424959
SEC16A\tS2073\t-0.1535428
SEC16A\tS2083\t-0.1169266
SEC16A\tS2271\t-0.1354117
SEC16A\tS296\t0.3635138
SEC16A\tS314\t0.4083934
SEC16A\tS331\t0.86081685
SEC16A\tS569\t0.004609331
SEC16A\tS589\t-0.35023427
SEC16A\tS595\t0.03841267
SEC16A\tT593\t-0.35023427
SEC22B\tS137\t0.03435652
SEC22B\tS164\t-0.08643077
SEC22B\tT140\t-0.1075802
SEC23IP\tS134\t-0.4150952
SEC23IP\tS926\t0.09180144
SEC24B\tS1189\t0.02133754
SEC24B\tS521\t-0.05087603
SEC24B\tT329\t0.2546093
SEC24B\tT502\t-0.4291873
SEC24D\tS266\t-0.3345526
SEC24D\tS826\t-0.2100955
SEC31A\tS1049\t0.027088835
SEC31A\tS527\t-0.26762475
SEC31A\tS532\t-0.1293394
SEC31A\tS799\t-0.02644013
SEC31A\tT1047\t-0.1072126
SEC61B\tS13\t0.04697992
SEC61B\tS17\t0.3378824
SEC62\tS335\t-0.08109186
SEC62\tS341\t-0.012331995
SEC62\tS345\t0.12564201
SEC62\tS353\t-0.000173111
SEC62\tS356\t-0.05542635
SEC62\tT158\t0.1469159
SEC62\tT343\t-0.06870835
SEC62\tT375\t-0.07972194
SEC63\tS593\t-0.264436095
SEC63\tS597\t-0.264436095
SECISBP2L\tT914\t0.42666335
SEH1L\tS179\t0.02019986
SEH1L\tS190\t-0.300395
SEH1L\tS259\t0.02566619
SEH1L\tS365\t0.07937845
SEMA4C\tS717\t-2.134731
SEMA4C\tS760\t-0.7668236
SEMA4C\tS772\t-0.367344415
SEMA4C\tT774\t-0.8994143
SEMA4G\tS97\t-0.04287289
SEMA5A\tS1010\t-1.1677785
SEMA5A\tS1030\t0.33556405
SEMA5B\tS127\t-2.014616
SEMA6B\tS802\t0.117163
SEMA6B\tT709\t-0.2084276
SEMA6D\tT698\t0.51775735
SEMA6D\tT702\t0.51775735
SENP2\tS32\t-0.3989881
SENP3\tS169\t-0.02989736
SENP3\tS181\t-0.12454168
SENP3\tS212\t0.0353423
SENP3\tS232\t-0.2918392
SENP3\tT353\t0.17577445
SENP6\tS345\t0.09274875
SENP6\tT409\t0.2221863
SEPN1\tS13\t-0.7740834
5-Sep\tS17\t0.3233124
SERBP1\tS152\t0.5465612
SERBP1\tS197\t-0.06733405
SERBP1\tS219\t0.3642362
SERBP1\tS234\t-1.811574
SERBP1\tS237\t0.454864
SERBP1\tS25\t0.3074285
SERBP1\tT352\t0.2732846
SERINC1\tS364\t-0.00222347
SERINC1\tT352\t0.2352368
SERPINB6\tS151\t-0.2007303
SESN2\tS249\t-0.07751287
SET\tS120\t0.09328973
SET\tS15\t0.01192487
SET\tS24\t0.05436236
SET\tS50\t0.07587489
SET\tS7\t0.1840899
SETD1A\tS1103\t-0.09466451
SETD1A\tS1114\t0.1406477
SETD1A\tS1125\t-0.72904185
SETD1A\tS1153\t-0.04361613
SETD1A\tS450\t-0.08621264
SETD1A\tS468\t-0.01591124
SETD1A\tS470\t-0.027603465
SETD1A\tT1088\t-0.74392805
SETD1A\tT540\t-0.108693398
SETD1A\tT562\t0.199536598
SETD1A\tT916\t-0.1058148
SETD1B\tS1031\t-0.165127
SETD1B\tS1240\t-0.1865903
SETD1B\tS1255\t-0.09506509
SETD1B\tS1616\t-0.10798323
SETD1B\tS1620\t-0.089240655
SETD1B\tS1727\t-0.1639951
SETD1B\tS994\t0.6053047
SETD1B\tT450\t-0.10407017
SETD2\tS1084\t0.05824728
SETD2\tS131\t0.09071802
SETD2\tS1988\t-0.047214
SETD2\tS1992\t-0.047214
SETD2\tS1995\t-0.047214
SETD2\tS532\t0.00406462
SETD2\tS624\t0.08624023
SETD2\tS744\t2.281461
SETD2\tS754\t-1.077437
SETD2\tS905\t0.1608672
SETD2\tT1853\t0.07778991
SETD2\tT1872\t-0.07422836
SETD5\tS1198\t-0.01738784
SETD5\tS591\t-0.8551966
SETD5\tS72\t0.04208399
SETD5\tS865\t-0.09824297
SETDB1\tS528\t-0.2462415
SETMAR\tS495\t0.10834465
SETX\tS1017\t-0.3543537
SETX\tS1019\t-0.3543537
SETX\tS1366\t-2.384584
SETX\tS1621\t0.4731144
SETX\tS2612\t-0.116273
SF1\tS112\t0.0247452
SF1\tS80\t-0.01570986
SF1\tS82\t-0.016917325
SF1\tT232\t0.2118725
SF3A1\tS329\t-0.01776754
SF3A1\tS359\t0.0353423
SF3A1\tT383\t-0.010105307
SF3A2\tS153\t0.09477648
SF3B1\tS129\t-0.005622996
SF3B1\tS194\t-0.4121358
SF3B1\tS322\t-0.1516024
SF3B1\tS332\t0.06391706
SF3B1\tS349\t0.1439158
SF3B1\tT142\t0.1068843
SF3B1\tT207\t-0.02809096
SF3B1\tT211\t0.13717929
SF3B1\tT223\t-0.010160825
SF3B1\tT227\t-0.080705175
SF3B1\tT244\t-0.04199625
SF3B1\tT248\t-0.04199625
SF3B1\tT257\t0.21706425
SF3B1\tT261\t-0.0249424
SF3B1\tT267\t0.1208827
SF3B1\tT278\t0.1070183
SF3B1\tT296\t0.1688987
SF3B1\tT303\t-0.18284575
SF3B1\tT313\t0.05609445
SF3B1\tT326\t0.00748015
SF3B1\tT328\t-0.063108545
SF3B1\tT350\t0.008343471
SF3B1\tT354\t0.1845977
SF3B1\tT434\t-0.216663125
SF3B1\tT436\t-0.17414165
SF3B2\tS289\t0.2404974
SF3B2\tS302\t0.1450905
SF3B2\tS307\t-0.13456007
SF3B2\tS309\t-0.073368508
SF3B2\tS431\t-0.1146287
SF3B2\tS435\t-0.1146287
SF3B2\tS436\t-0.1146287
SF3B2\tS778\t-0.1971533
SF3B2\tT780\t-0.04215969
SFPQ\tS273\t-0.2187495
SFPQ\tS33\t0.44016007
SFPQ\tS496\t0.1818022
SFRS2\tS177\t0.1476974
SFRS2\tS179\t0.1351408
SFRS2\tS194\t0.18617412
SFRS2\tS196\t0.1163647
SFRS2\tS2\t0.3253864
SFRS2\tS200\t0.09734114
SFRS2\tS208\t0.07011455
SFSWAP\tS604\t-0.2612408
SFSWAP\tS743\t0.1305355
SFSWAP\tS889\t0.12186353
SFSWAP\tS891\t-0.08771804
SFSWAP\tS893\t0.12186353
SFSWAP\tS897\t-0.08771804
SFT2D3\tS56\t-0.21348845
SGK1\tS169\t-0.63400985
SGK1\tS175\t-1.101676
SGK1\tS492\t0.3568199
SGK1\tS496\t-0.33761315
SGK223\tS694\t-0.0307961
SGK223\tS710\t-0.2958026
SGK223\tS738\t1.177535
SGK223\tS741\t-1.9230405
SGK223\tS743\t-1.925768
SGK223\tS803\t-0.393103
SGK223\tS824\t-0.4321236
SGK223\tS825\t-0.4218051
SGK223\tT708\t-0.006497345
SGK223\tY411\t0.05824728
SGK3\tS129\t0.08082725
SGOL1\tS256\t0.06983963
SGOL1\tS507\t0.182438
SGOL2\tS1085\t-0.8965197
SGOL2\tS1166\t0.4311415
SGOL2\tS1222\t0.50260765
SGOL2\tT845\t0.1304037
SGPP1\tS101\t0.1801479
SGPP1\tS112\t0.03562387
SGPP1\tT114\t-0.1145662
SGTA\tS305\t-2.09945625
SGTA\tS77\t-0.28424419
SGTA\tT303\t-0.724211
SGTA\tT81\t-0.037435847
SGTB\tS295\t0.53514685
SH2B1\tT218\t0.39762455
SH2B2\tS157\t0.3901174
SH2B3\tS103\t-0.04948682
SH2B3\tS120\t-0.1475536
SH2B3\tS13\t-0.4321041
SH2B3\tS150\t-0.2874835
SH2B3\tS330\t-0.1885619
SH2B3\tS334\t-0.1920846
SH2B3\tS337\t-0.22176255
SH2B3\tS343\t-0.3001286
SH2B3\tS511\t-0.3277285
SH2B3\tT159\t-0.3192975
SH3BP1\tS262\t-0.085752835
SH3BP1\tS544\t-0.07234626
SH3BP1\tS550\t-0.02721912
SH3BP1\tS598\t0.911559
SH3BP1\tT15\t0.690283
SH3BP1\tT548\t0.2939327
SH3BP1\tT554\t0.040219405
SH3BP1\tT626\t0.6088092
SH3BP2\tS416\t-0.9682943
SH3BP4\tS131\t-1.1816325
SH3BP4\tS246\t0.1526378
SH3BP4\tS248\t0.1573074
SH3BP4\tS279\t0.3817263
SH3BP4\tS42\t-1.164787
SH3BP4\tS44\t-1.200614
SH3BP5L\tS30\t-1.06976195
SH3BP5L\tS343\t0.05681975
SH3BP5L\tS350\t-0.03011826
SH3BP5L\tS358\t-0.04063042
SH3BP5L\tS362\t-0.03144473
SH3BP5L\tS49\t0.9981484
SH3D19\tS65\t0.4416959
SH3GL1\tS288\t-0.08193439
SH3KBP1\tS146\t0.0393434
SH3KBP1\tS193\t-0.08222458
SH3KBP1\tS550\t0.9797328
SH3PXD2A\tS256\t0.1624679
SH3PXD2A\tS382\t-0.822988
SH3PXD2A\tS486\t-0.3420856
SH3PXD2A\tS559\t0.5443931
SH3PXD2A\tS654\t0.5123786
SH3PXD2A\tS837\t0.08052122
SH3PXD2A\tS873\t-0.8181977
SH3PXD2A\tS878\t1.324407
SH3PXD2A\tS891\t-0.4083493
SH3PXD2A\tT91\t0.160858238
SH3PXD2B\tS291\t-0.1689983
SH3PXD2B\tS811\t0.121407954
SH3RF1\tS735\t1.3899255
SHANK3\tT1220\t0.3873625
SHARPIN\tS129\t-0.193406685
SHARPIN\tS131\t0.49514335
SHARPIN\tS165\t-0.3724492
SHC3\tS22\t0.28107335
SHCBP1\tS42\t0.2886539
SHCBP1\tS54\t-0.06134539
SHKBP1\tS637\t0.2949361
SHPRH\tS93\t-0.26967185
SHROOM2\tS1171\t-0.403928
SHROOM2\tS1173\t-0.403928
SHROOM2\tS1425\t0.47557085
SHROOM2\tS1524\t0.2999336
SHROOM2\tS4\t0.06062756
SHROOM2\tS6\t-0.136483725
SHROOM2\tS8\t-0.03270463
SHROOM2\tT3\t-0.05815752
SHROOM2\tT647\t0.02353814
SHROOM3\tS910\t0.3928669
SHROOM4\tS183\t0.6289135
SHROOM4\tS261\t-0.18510015
SHROOM4\tS295\t0.12343178
SHROOM4\tS548\t-0.0575868
SHROOM4\tS561\t-0.23313722
SHROOM4\tS570\t-0.3448497
SHROOM4\tS613\t-0.04021504
SHROOM4\tS618\t-0.05881857
SHROOM4\tS903\t-0.2349746
SHROOM4\tS943\t-0.4172706
SIGLEC1\tT37\t0.093515346
SIK1\tS435\t-1.3858925
SIK2\tS534\t0.80332995
SIK2\tS587\t0.07778991
SIK3\tS545\t-0.006159014
SIK3\tS668\t0.2358496
SIK3\tS908\t-0.9591215
SIK3\tT215\t0.29291195
SIL1\tS147\t0.1918153
SIN3A\tS1112\t0.04306451
SIN3A\tS832\t0.04865466
SIN3A\tS938\t0.06818932
SIN3A\tS940\t0.1184926
SIPA1\tS55\t-0.252468475
SIPA1\tS67\t0.126582275
SIPA1\tS839\t-1.08198
SIPA1\tS884\t-0.1018458
SIPA1\tS888\t-0.0759575
SIPA1L1\tS1149\t0.455172
SIPA1L1\tS1412\t0.499459485
SIPA1L1\tS1528\t-0.9589252
SIPA1L1\tS1544\t-0.74662785
SIPA1L1\tS1547\t-1.092432
SIPA1L1\tS1564\t0.2161133
SIPA1L1\tS161\t0.1315895
SIPA1L1\tS162\t0.1961033
SIPA1L1\tS1712\t-0.009437132
SIPA1L1\tS208\t0.31171515
SIPA1L1\tS255\t0.4939547
SIPA1L1\tS288\t-1.094742
SIPA1L1\tT1552\t-0.8919494
SIPA1L2\tS1029\t0.124544385
SIPA1L2\tS1081\t1.07432725
SIPA1L2\tS1461\t-2.332789
SIPA1L2\tS1478\t-0.4693698
SIPA1L2\tS148\t-0.2701384
SIPA1L2\tS1488\t0.2281107
SIPA1L2\tS1549\t0.098823775
SIPA1L2\tS1650\t-1.268604275
SIPA1L2\tS1652\t-0.71041255
SIPA1L2\tS194\t0.100574
SIPA1L2\tS379\t0.6429325
SIPA1L3\tS1144\t0.6349703
SIPA1L3\tS1364\t0.000144286
SIPA1L3\tS146\t-0.08632359
SIPA1L3\tS1544\t0.173286
SIPA1L3\tS401\t0.0416635
SIPA1L3\tT1703\t0.06557227
SIPA1L3\tT296\t-0.2278592
SIRT1\tS14\t-0.191788
SIRT1\tS16\t-0.14536495
SIRT1\tS47\t-0.005840297
SIRT2\tS23\t-0.2053804
SIRT2\tS25\t-0.2053804
SIRT2\tS368\t-0.1122564
SIRT6\tS258\t-0.2498738
SKA2\tS101\t-0.3186677
SKA3\tS110\t-0.9708934
SKA3\tS119\t-1.032153
SKA3\tS155\t-0.8118269
SKA3\tT190\t0.2288495
SKAP2\tS6\t-3.5828765
SKIL\tS468\t0.5113026
SKIV2L\tS245\t0.1145003
SKIV2L\tS255\t0.190678
SKIV2L\tS256\t0.01635366
SKIV2L\tS637\t-0.115515555
SKP2\tS64\t0.06460693
SLAIN2\tS179\t0.6005552
SLAIN2\tS433\t0.75832205
SLAIN2\tS435\t0.96980235
SLAIN2\tS456\t0.4434594
SLAIN2\tS48\t0.4582757
SLAIN2\tS63\t0.4768483
SLAIN2\tS87\t-0.2532573
SLBP\tS20\t0.020522635
SLBP\tS23\t0.209068343
SLBP\tT61\t0.09588866
SLC12A2\tS940\t0.04032371
SLC12A2\tT212\t0.3176514
SLC12A2\tT217\t0.3176514
SLC12A2\tT266\t-0.1060942
SLC12A4\tS37\t0.134982495
SLC12A4\tS47\t-0.22652155
SLC12A4\tS51\t-1.215044
SLC12A4\tS56\t-0.02821922
SLC12A4\tS967\t-0.2219428
SLC12A6\tS32\t-0.07005754
SLC12A9\tS6\t-0.0790665
SLC15A4\tS298\t-0.02274209
SLC15A4\tS4\t-0.0301036
SLC16A1\tS461\t-0.2216905
SLC16A1\tS467\t0.1112984
SLC16A1\tT466\t0.2032638
SLC16A3\tS436\t0.001297885
SLC17A5\tS16\t0.4411647
SLC17A5\tT17\t0.33720235
SLC19A1\tS225\t0.8023848
SLC19A1\tS5\t-0.3431102
SLC1A4\tS507\t-0.2119157
SLC1A5\tS503\t0.02531228
SLC1A5\tS535\t0.4544918
SLC1A5\tS539\t0.5555217
SLC1A5\tS9\t0.2894804
SLC1A5\tT494\t0.1982427
SLC20A1\tS265\t-0.02891095
SLC20A1\tS267\t0.08297234
SLC20A1\tS269\t-0.09818013
SLC20A1\tS288\t0.87492435
SLC20A1\tS299\t0.015956895
SLC20A1\tS335\t-0.7144439
SLC20A1\tS417\t0.233060885
SLC20A2\tS256\t0.16857887
SLC20A2\tS259\t0.16857887
SLC20A2\tS268\t-1.239226
SLC20A2\tS324\t-2.0426255
SLC20A2\tS385\t-0.5604088
SLC20A2\tS422\t-0.293412
SLC23A2\tS71\t-0.01732945
SLC23A2\tS81\t-0.300801925
SLC23A2\tT79\t-0.1864753
SLC25A11\tS6\t-0.1268798
SLC25A20\tS9\t-0.1428152
SLC25A32\tT12\t0.2464689
SLC25A32\tT6\t0.2464689
SLC26A6\tS644\t0.0890706
SLC26A6\tS647\t0.4165155
SLC26A8\tS255\t0.2204538
SLC27A1\tS228\t0.1194972
SLC29A1\tS254\t0.3455044
SLC29A2\tS252\t-1.016979
SLC2A3\tS485\t0.6188964
SLC2A6\tS23\t-0.68296345
SLC30A1\tS172\t-0.199454547
SLC30A1\tS468\t0.3348639
SLC30A1\tS506\t0.24065435
SLC30A1\tT462\t0.347296725
SLC30A6\tS185\t-1.263258
SLC30A6\tT194\t0.8892217
SLC35B1\tS29\t-0.1189306
SLC35B2\tS378\t-0.2193372
SLC35C2\tS202\t0.1103632
SLC35C2\tS203\t-0.092574265
SLC35F6\tT365\t0.04628156
SLC38A1\tS49\t0.30931535
SLC38A10\tS802\t-0.06750038
SLC38A7\tS28\t-0.1506412
SLC39A10\tS591\t0.01963077
SLC39A14\tS311\t0.4033768
SLC39A6\tS478\t-0.2062456
SLC39A7\tS185\t-0.14288685
SLC39A7\tS186\t-0.14288685
SLC3A2\tS103\t0.02304246
SLC3A2\tS2\t0.01106615
SLC41A3\tS13\t-0.1323249
SLC41A3\tT49\t-1.527907
SLC46A1\tS6\t0.3444877
SLC4A1AP\tS312\t-0.08739614
SLC4A1AP\tS466\t-0.6539224
SLC4A1AP\tS712\t-0.1395695
SLC4A1AP\tS82\t0.06129241
SLC4A2\tS113\t-0.5943343
SLC4A2\tS132\t0.09504669
SLC4A2\tS144\t-0.6612009
SLC4A2\tS243\t-0.93546575
SLC4A4\tS1025\t-0.38017385
SLC4A4\tS211\t0.3515462
SLC4A4\tS213\t0.195881955
SLC4A7\tS1119\t-0.141637
SLC4A7\tS19\t-0.5098818
SLC4A7\tS251\t0.3164934
SLC4A7\tS264\t0.2481705
SLC4A7\tS267\t0.4431822
SLC4A7\tS285\t0.00828075
SLC4A7\tS288\t0.2036397
SLC4A7\tS292\t0.4103929
SLC4A7\tS93\t-0.0821635
SLC6A15\tS55\t0.001730139
SLC6A15\tS675\t0.3456234
SLC6A15\tS687\t-0.02000393
SLC6A15\tS701\t-0.1055819
SLC6A15\tT674\t0.3084773
SLC6A8\tT42\t-0.60112505
SLC6A8\tT618\t-0.031139056
SLC6A8\tT620\t-0.1661303
SLC7A2\tS454\t1.00490095
SLC7A2\tS455\t1.514575685
SLC7A2\tS464\t0.30378775
SLC7A2\tS647\t-0.0750488
SLC7A5\tS31\t-0.2319385
SLC7A5\tS35\t-0.1011648
SLC7A6OS\tS16\t-0.3602307
SLC7A8\tS21\t-0.09700799
SLC9A1\tS693\t0.1176951
SLC9A1\tS703\t-1.763513
SLC9A1\tS783\t-0.4661975
SLC9A1\tS785\t0.2579761
SLC9A1\tS796\t-2.190009
SLC9A3R1\tS2\t0.008773791
SLC9A3R1\tS280\t-0.2784785
SLC9A3R2\tS254\t-1.304469
SLC9A3R2\tS280\t-0.07565684
SLC9A3R2\tS303\t0.185739705
SLC9B2\tT46\t0.6840068
SLCO4C1\tS16\t-0.3863762
SLIRP\tS100\t0.06460693
SLK\tS189\t0.43831525
SLK\tS340\t-0.1939647
SLK\tS571\t-0.003495565
SLK\tS779\t-0.4596949
SLK\tS818\t-0.0317986
SLMAP\tS148\t-3.386227
SLTM\tS1002\t0.01492663
SLTM\tS1014\t-0.0327478
SLTM\tS144\t-0.3696318
SLTM\tS289\t0.1008431
SLTM\tS550\t-0.037582044
SLTM\tS551\t0.03506084
SLTM\tS553\t-0.06413631
SLTM\tS815\t-0.1571901
SLTM\tS93\t-0.023615438
SLU7\tS215\t0.07148806
SLX4\tS1044\t0.169925
SLX4\tS1329\t-0.008566125
SLX4\tS1469\t0.07888308
SLX4\tS228\t-1.04140775
SLX4\tS287\t0.3066122
SLX4\tS467\t0.009347181
SLX4\tT1315\t-0.008566125
SLX4IP\tS213\t0.001442041
SMAD2\tT8\t0.1774714
SMAD3\tT8\t0.1499097
SMAD5\tS12\t0.6112669
SMAP\tS147\t0.0160683
SMAP\tS15\t-0.12712686
SMAP\tS17\t-0.19075317
SMAP2\tS219\t0.1486088
SMAP2\tS240\t0.12416515
SMAP2\tT234\t0.03825739
SMARCA1\tS119\t0.1315895
SMARCA1\tT118\t0.2084071
SMARCA2\tS1494\t-0.26427503
SMARCA2\tS1498\t-0.26427503
SMARCA2\tS1550\t-0.2698949
SMARCA2\tS1554\t-0.1864744
SMARCA2\tS329\t-0.1157382
SMARCA2\tT274\t-0.04763661
SMARCA4\tS1347\t0.5531639
SMARCA4\tS1384\t-0.009132228
SMARCA4\tS1419\t-0.05090587
SMARCA4\tS1593\t0.1839629
SMARCA4\tS1597\t0.1839629
SMARCA4\tS610\t-0.168328932
SMARCA4\tS613\t-0.009074163
SMARCA4\tS695\t-0.009960023
SMARCA4\tS699\t-0.03593417
SMARCA4\tT1390\t0.001730139
SMARCA4\tT1426\t0.1027253
SMARCA4\tT3\t-0.1360774
SMARCA4\tT609\t0.139560635
SMARCA5\tS66\t0.10987282
SMARCAD1\tS124\t0.112233
SMARCAD1\tS127\t0.112233
SMARCAD1\tS211\t-0.37662
SMARCAD1\tS212\t-0.307555
SMARCAD1\tS213\t0.033302475
SMARCAD1\tS214\t-0.37662
SMARCAD1\tS239\t-0.0264989
SMARCAD1\tS242\t-0.066917881
SMARCAD1\tS247\t-0.04903899
SMARCAD1\tS39\t-0.17123597
SMARCAD1\tS50\t0.20430257
SMARCAD1\tS57\t0.3174425
SMARCAD1\tT54\t-0.038559635
SMARCAD1\tT71\t-0.1837198
SMARCAL1\tS129\t-0.1333056
SMARCC1\tS310\t-0.03889532
SMARCC1\tS328\t0.02105333
SMARCC1\tS330\t0.1125
SMARCC1\tS357\t-0.6410412
SMARCC1\tS395\t0.07777257
SMARCC1\tS573\t-0.1565146
SMARCC1\tS822\t-0.46214405
SMARCC1\tT398\t0.01035019
SMARCC2\tS283\t0.01563255
SMARCC2\tS286\t0.01092296
SMARCC2\tS302\t0.000711515
SMARCC2\tS304\t-0.05219169
SMARCC2\tS306\t-0.1488966
SMARCC2\tS347\t-0.2458479
SMARCC2\tS813\t0.94539635
SMARCC2\tT308\t-0.02620508
SMARCC2\tT548\t-0.49610035
SMARCC2\tT552\t-0.39596285
SMARCD2\tT142\t-0.2194044
SMARCE1\tS244\t0.21262817
SMC1A\tS957\t0.03337007
SMC3\tS1067\t-0.09409458
SMC4\tS22\t-0.3116441
SMC4\tS27\t-0.08968455
SMC4\tS28\t-0.15127795
SMC4\tS41\t0.01264022
SMC5\tS35\t-0.04360133
SMCHD1\tS293\t-2.049248
SMCHD1\tT16\t0.2403946
SMCR7L\tS55\t0.3514022
SMCR7L\tS59\t-0.1733879
SMCR7L\tS94\t0.5279711
SMCR8\tS498\t-0.1671991
SMCR8\tS639\t0.1011122
SMEK1\tS117\t-0.2110972
SMEK1\tS126\t0.06907337
SMEK1\tS127\t0.02431962
SMEK2\tS117\t-0.1312658
SMEK2\tS755\t0.28639295
SMG1\tS34\t-0.0694735
SMG1\tS3556\t0.05341518
SMG1\tS3570\t-0.19330778
SMG1\tS518\t-0.00868695
SMG1\tT3550\t0.027282605
SMG1\tT3573\t0.31576455
SMG5\tS2\t-0.55999905
SMG5\tS523\t0.08997845
SMG6\tS203\t-0.191053025
SMG6\tS484\t-1.2087405
SMG6\tT479\t-1.2087405
SMG7\tS735\t-0.197320625
SMG8\tS469\t-0.5375916
SMG8\tS668\t0.08365592
SMG8\tS894\t-0.011830655
SMG8\tS895\t-0.07490227
SMG8\tT657\t-0.28137965
SMG9\tS2\t-0.04681535
SMG9\tS25\t0.22963328
SMG9\tS32\t0.01521204
SMG9\tS4\t0.104652175
SMG9\tS451\t-0.3052
SMG9\tS7\t-0.08194871
SMG9\tT118\t-0.2273029
SMIM13\tS58\t-0.089033845
SMIM13\tS60\t0.08258539
SMIM13\tT62\t-0.1280775
SMN1\tS28\t0.107370055
SMN1\tS31\t-0.131773195
SMN1\tS4\t0.0615688
SMN1\tT25\t0.09247811
SMNDC1\tS201\t0.4429701
SMPD4\tS690\t0.2073932
SMPD4\tT187\t-0.94572565
SMTN\tS245\t0.2649567
SMTN\tS251\t0.093206635
SMTN\tS277\t0.123931
SMTN\tS341\t0.6199294
SMTN\tS357\t0.67356725
SMTN\tS729\t0.643259
SMTN\tT315\t0.43470625
SMTN\tT360\t0.752616
SMURF1\tS200\t0.07546414
SNAI2\tS107\t1.185867
SNAI2\tS87\t0.9676113
SNAP23\tS110\t-0.05264058
SNAP23\tS20\t0.1086896
SNAP23\tS23\t-0.118209725
SNAP23\tS34\t-0.212835
SNAP23\tS5\t0.312587457
SNAP23\tS6\t0.3951816
SNAP23\tT24\t-1.1066507
SNAP29\tS77\t0.8993304
SNAPC4\tS1224\t0.05829213
SNAPC4\tS599\t-0.23835764
SNAPC4\tS626\t0.4397827
SNAPC4\tS68\t0.1210154
SNAPIN\tS133\t0.002450562
SNAPIN\tT14\t0.08746284
SND1\tS150\t-0.1094366
SND1\tS426\t-0.1355067
SND1\tS645\t-0.4187934
SND1\tS781\t-0.6727955
SND1\tS909\t0.1465249
SND1\tT240\t-0.2587186
SNIP1\tS202\t0.3668149
SNIP1\tS35\t-0.01841033
SNIP1\tS394\t-0.2628844
SNIP1\tS49\t-0.197371855
SNIP1\tS52\t-0.05228949
SNIP1\tS54\t-0.02451654
SNN\tS49\t0.1392075
SNRK\tS518\t0.121148
SNRK\tS569\t-0.4273819
SNRK\tS607\t0.06611722
SNRNP200\tS225\t-0.106529
SNRNP200\tS457\t-0.1184293
SNRNP70\tS226\t0.1200864
SNRNP70\tS410\t-0.1209059
SNRPA1\tS197\t0.06736329
SNRPD2\tT12\t0.03097168
SNRPF\tS2\t0.2101395
SNTB1\tS205\t0.05053325
SNTB1\tS219\t0.290673058
SNTB1\tS225\t-4.782893
SNTB1\tS389\t-0.004580627
SNTB1\tS87\t0.04194384
SNTB1\tT214\t0.355626765
SNTB2\tS110\t-0.004320131
SNTB2\tS222\t-1.675904
SNTB2\tS231\t1.47694335
SNTB2\tS393\t-0.1649167
SNTB2\tS395\t-0.0279397
SNTB2\tS95\t0.02332628
SNW1\tS224\t0.120566855
SNW1\tS232\t0.01521204
SNW1\tS234\t0.02630426
SNW1\tT401\t-0.34288503
SNX1\tS188\t0.2770325
SNX1\tS72\t-0.02616103
SNX11\tS131\t-0.003152625
SNX11\tS133\t-0.07339326
SNX12\tS2\t0.1528972
SNX13\tS523\t-0.97708685
SNX14\tS433\t-0.1408255
SNX15\tS227\t0.03012422
SNX15\tT148\t-0.3065554
SNX16\tS69\t-0.176967305
SNX16\tS70\t-0.3771634
SNX17\tS415\t-0.4069618
SNX17\tS421\t-0.1670209
SNX19\tS733\t-0.8355457
SNX2\tS119\t-0.3637535
SNX2\tS185\t0.03449741
SNX2\tS368\t0.374785705
SNX2\tS97\t-0.47088345
SNX2\tT101\t0.2115106
SNX2\tT104\t-3.041684
SNX24\tS116\t0.01635366
SNX27\tS51\t-0.25975725
SNX27\tT215\t-0.014102625
SNX29\tS372\t-0.1880982
SNX29\tS639\t-0.3114347
SNX29\tT641\t-0.3114347
SNX3\tS72\t0.044464
SNX30\tS40\t-0.72402345
SNX30\tS48\t-0.69126835
SNX30\tS67\t0.01135251
SNX4\tS22\t-0.310021
SNX5\tS193\t-0.37668795
SOAT1\tT36\t0.001297885
SOCS6\tS311\t-1.631913
SOGA1\tS1541\t0.2287264
SOGA1\tS1581\t0.038524605
SOGA1\tS175\t-0.18264315
SOGA2\tS1399\t-0.1151599
SOGA2\tS1791\t-0.4923018
SOGA2\tS1808\t0.263395
SOGA2\tS232\t-0.1607982
SOGA2\tS263\t-0.1127555
SOGA2\tS776\t0.04040144
SOGA2\tS778\t0.28343685
SOGA2\tS901\t-0.3598209
SOGA2\tT1417\t2.661043
SOGA2\tT1831\t0.7114949
SOGA3\tS781\t0.09936258
SOLH\tS296\t-0.1449511
SOLH\tS335\t-0.66940995
SON\tS1036\t0.26216975
SON\tS142\t0.05102402
SON\tS1516\t0.03745244
SON\tS152\t0.19070895
SON\tS1657\t-0.369464
SON\tS1719\t0.3452829
SON\tS1729\t0.06391706
SON\tS1742\t-0.095879595
SON\tS1743\t-0.0466533
SON\tS182\t0.11910045
SON\tS1969\t-0.2199924
SON\tS1973\t-0.1136449
SON\tS283\t-0.1017065
SON\tS94\t-0.29108
SON\tS986\t0.2967804
SON\tT1515\t0.00302647
SON\tT282\t-0.06342424
SORBS1\tS316\t0.7745025
SORBS1\tS319\t0.2877087
SORBS1\tS341\t-0.05344876
SORBS1\tS435\t0.3274574
SORBS1\tS526\t0.09774555
SORBS1\tS635\t-0.14983315
SORBS1\tS89\t-0.75809885
SORBS1\tS915\t0.6541605
SORBS2\tS346\t-0.003784795
SORBS3\tS188\t-0.02538262
SORBS3\tS24\t1.21192095
SORBS3\tS31\t0.630219
SORBS3\tS53\t-0.1880851
SORBS3\tS6\t0.1830736
SORL1\tS198\t0.03054793
SORL1\tY207\t0.03054793
SORT1\tS793\t0.201132
SORT1\tS814\t0.1924466
SOS1\tS1078\t0.08488071
SOS1\tS1082\t0.338327905
SOS1\tS1195\t-0.4601712
SOS1\tS1260\t-0.4614818
SOS1\tT1264\t-0.5295725
SOS2\tS1234\t0.4928274
SOWAHC\tS213\t0.4342412
SOWAHC\tS513\t-2.1045265
SOX10\tS13\t-0.18662437
SOX10\tS17\t0.2424961
SOX10\tS24\t0.14335452
SOX10\tS27\t-0.04315275
SOX10\tS30\t-0.002093429
SOX10\tS346\t-0.35719285
SOX10\tS45\t0.3199269
SOX10\tS451\t0.11258771
SOX10\tS8\t0.087435355
SOX13\tS310\t0.1966071
SOX13\tS335\t0.07395734
SOX13\tS385\t0.10814422
SOX13\tS386\t0.1416943
SOX13\tS5\t-0.00302445
SOX5\tS109\t-0.1007006
SOX5\tS120\t-0.2316505
SOX5\tS138\t-1.005956
SOX5\tS21\t0.04879416
SOX5\tS370\t-0.050953665
SOX5\tS439\t-0.3861478
SOX5\tT131\t0.08283886
SOX5\tT82\t0.2023863
SOX5\tY23\t0.06205746
SOX6\tS171\t0.35719193
SOX6\tS380\t-0.005275485
SOX6\tS387\t0.3534363
SOX6\tS399\t-0.09615961
SOX6\tS8\t0.03787417
SOX6\tT397\t0.3534363
SOX6\tT441\t-0.3627144
SOX8\tS184\t0.2078928
SOX8\tS186\t0.2078928
SOX8\tS188\t0.2078928
SOX8\tS344\t-0.1404916
SP1\tS2\t0.03829577
SP1\tS59\t-0.13742186
SP1\tS7\t-0.1261553
SP100\tS157\t-0.1237954
SP100\tS18\t-0.08341635
SP100\tS362\t-0.2930408
SP100\tS394\t0.3183457
SP100\tS407\t-0.058057675
SP100\tS409\t-0.058057675
SP100\tS410\t-0.058057675
SP100\tS476\t-0.6435569
SP110\tS244\t-0.1408892
SP110\tS248\t-0.2907212
SP110\tS256\t-0.137029
SP110\tS378\t-0.2614829
SP140L\tS180\t0.039718925
SP2\tS71\t0.06212175
SP2\tT56\t0.4392151
SPAG1\tS423\t-0.34870855
SPAG5\tS135\t-1.3885333
SPAG7\tS107\t0.28782295
SPAG9\tS109\t0.008773791
SPAG9\tS183\t0.07737969
SPAG9\tS203\t0.2190911
SPAG9\tS238\t0.4209404
SPAG9\tS251\t-0.05784214
SPAG9\tS283\t-1.133101
SPAG9\tS311\t0.298541
SPAG9\tS329\t0.1071523
SPAG9\tS332\t0.03016035
SPAG9\tS730\t-0.23624016
SPAG9\tS733\t0.1009722
SPAG9\tS815\t-0.50208245
SPAG9\tT1264\t0.1343524
SPAG9\tT217\t-0.9348413
SPAG9\tT226\t-0.3543906
SPAG9\tT292\t-0.3843389
SPAST\tS159\t0.154972
SPATA13\tS254\t-0.25650665
SPATA2L\tS332\t0.1346153
SPATS2L\tS116\t0.1876411
SPATS2L\tS117\t0.1759396
SPATS2L\tS120\t0.1767397
SPATS2L\tS338\t0.03787417
SPATS2L\tS455\t0.48656
SPATS2L\tT498\t0.4269979
SPECC1\tS241\t0.215022965
SPECC1\tS361\t-0.5689012
SPECC1L\tS220\t0.01249718
SPECC1L\tS384\t-0.52842205
SPECC1L\tS385\t-0.640805925
SPECC1L\tS832\t-0.80801995
SPECC1L\tS868\t-2.433814
SPEN\tS1006\t0.05325044
SPEN\tS1222\t0.01378388
SPEN\tS1225\t0.166597715
SPEN\tS1268\t-1.1151415
SPEN\tS1278\t-0.4463791
SPEN\tS1380\t-0.207692875
SPEN\tS1382\t-0.2444458
SPEN\tS2101\t0.02417773
SPEN\tS2120\t0.2225573
SPEN\tS2126\t0.165301
SPEN\tS2452\t-0.2155234
SPEN\tS2481\t-0.029535595
SPEN\tS2493\t-0.06762131
SPEN\tS309\t-0.04619094
SPEN\tS3433\t0.1664584
SPEN\tS736\t-0.04034576
SPEN\tS740\t-0.01492228
SPEN\tS749\t-0.120886375
SPEN\tT1219\t0.59870235
SPEN\tT1633\t0.1782366
SPEN\tT1826\t0.142441405
SPEN\tT1947\t0.2709474
SPEN\tT2421\t0.1051417
SPEN\tT838\t0.05588975
SPG11\tS1955\t-0.30591475
SPG20\tT101\t0.19292845
SPHK2\tS328\t-0.3643478
SPHK2\tS340\t0.011251255
SPHK2\tS428\t-1.831666
SPICE1\tS760\t-0.4425556
SPICE1\tT235\t-0.1950544
SPIN1\tS124\t0.3525446
SPIN1\tS199\t-0.217102265
SPIN3\tS195\t-0.03606721
SPIRE1\tS387\t-0.006144506
SPIRE1\tS450\t-0.0548568
SPIRE1\tS451\t-0.0548568
SPIRE1\tS453\t-0.2897743
SPIRE1\tT400\t-1.060427
SPIRE1\tT457\t-0.164556015
SPIRE1\tT495\t0.03618686
SPIRE2\tS323\t0.1276332
SPIRE2\tS392\t-0.7030438
SPNS1\tT24\t-2.204898
SPP1\tS193\t0.83276205
SPP1\tS197\t0.6674834
SPP1\tS232\t0.494774
SPP1\tS241\t0.4532889
SPP1\tS62\t0.83152875
SPP1\tS63\t0.85335925
SPP1\tT66\t0.735574075
SPPL2B\tS550\t-0.2903564
SPR\tS103\t0.09031146
SPRED1\tS238\t-1.295199
SPRED2\tS206\t-2.136886
SPRTN\tS268\t0.2744107
SPRY1\tS50\t-0.00997407
SPRY2\tS138\t-0.2532229
SPRY2\tS139\t0.073641455
SPRY4\tS125\t-0.2442065
SPRY4\tS15\t-0.9683727
SPRY4\tS98\t-0.4903147
SPRY4\tT12\t-0.6177154
SPRY4\tT77\t0.2351144
SPTAN1\tS1029\t0.3098746
SPTAN1\tS1031\t0.3415304
SPTAN1\tS1217\t-0.03455926
SPTAN1\tS1322\t0.08365592
SPTAN1\tS1323\t0.01301201
SPTAN1\tS1550\t0.05760365
SPTAN1\tS1615\t0.302169275
SPTAN1\tS2009\t0.4152831
SPTBN1\tS2102\t-0.1032554
SPTBN1\tS2106\t-0.05557385
SPTBN1\tS2128\t0.1687703
SPTBN1\tS2138\t0.04711958
SPTBN1\tS2160\t0.1094274
SPTBN1\tS2161\t0.1681285
SPTBN1\tS2164\t0.1716217
SPTBN1\tS2165\t0.02955887
SPTBN1\tS2169\t0.022462715
SPTBN1\tS2316\t0.5863948
SPTBN1\tS2319\t0.754625818
SPTBN1\tS2341\t0.678929125
SPTBN1\tS2358\t0.1443075
SPTBN1\tT1216\t-2.577964
SPTBN1\tT1217\t-2.577964
SPTBN1\tT2159\t0.2127561
SPTBN1\tT2171\t0.014522601
SPTBN1\tT2320\t0.487177621
SPTBN1\tT2328\t0.62528475
SPTBN2\tS2171\t-0.05616116
SQLE\tS559\t3.133492
SQLE\tS567\t3.133492
SQLE\tY566\t3.133492
SQSTM1\tS233\t0.6018866
SQSTM1\tS24\t0.2451305
SQSTM1\tS249\t-0.9610531
SQSTM1\tS272\t-0.23227895
SQSTM1\tS332\t0.04493278
SQSTM1\tT269\t0.01733455
SRA1\tS69\t0.1691554
SRA1\tS87\t-0.5056087
SRBD1\tS964\t0.4247072
SRC\tS17\t-0.1496807
SRC\tS69\t-0.08958612
SRC\tS75\t0.2353594
SRCAP\tS2629\t0.0354831
SRCAP\tS2632\t-0.0764781
SRCAP\tS274\t-0.170329
SRCAP\tS2774\t0.0165172
SRCAP\tS568\t-0.1084979
SRCAP\tT572\t-0.5923166
SRCIN1\tS632\t-0.29760115
SRCIN1\tS775\t-0.2651885
SREBF2\tS469\t-0.9671938
SRF\tS20\t0.04544289
SRFBP1\tS203\t0.006333955
SRFBP1\tS264\t0.08515262
SRFBP1\tT221\t0.48275406
SRGAP1\tS772\t-0.8806837
SRGAP1\tS843\t0.4025039
SRGAP1\tT938\t-0.2135709
SRGAP2\tS1011\t0.5214697
SRGAP2\tS1013\t0.6881356
SRGAP2\tS206\t-0.42499675
SRGAP2\tS427\t-0.1268956
SRGAP2\tS884\t0.1680817
SRGAP2\tS916\t1.070321
SRGAP2\tS990\t-1.4928405
SRGAP2\tS993\t-1.277709
SRGAP2\tT998\t-1.707972
SRP68\tS27\t0.10877848
SRP72\tS610\t0.3533233
SRP72\tS621\t-0.07492861
SRP72\tT571\t0.04490723
SRPK1\tS17\t-0.53733655
SRPK1\tS21\t-0.4088567
SRPK1\tS23\t-0.3235159
SRPK1\tS295\t-0.027032545
SRPK1\tS35\t-0.13384275
SRPK1\tT547\t-0.04024466
SRPK2\tS494\t-0.783545025
SRPK2\tS496\t0.006477609
SRPK2\tS497\t-0.9292809
SRPK2\tT498\t-0.92130335
SRPR\tS296\t-0.01073277
SRPR\tS297\t-0.01073277
SRPR\tS298\t-0.01073277
SRPRB\tS112\t-0.0201649
SRPRB\tS257\t-0.02136503
SRRM1\tS207\t-0.1354276
SRRM1\tS209\t-0.1354276
SRRM1\tS211\t-0.1354276
SRRM1\tS234\t0.03520166
SRRM1\tS242\t0.22893705
SRRM1\tS389\t0.106687045
SRRM1\tS391\t0.074207502
SRRM1\tS393\t0.142117595
SRRM1\tS402\t0.09788039
SRRM1\tS414\t0.1717192
SRRM1\tS448\t-0.079047175
SRRM1\tS450\t-0.000298965
SRRM1\tS461\t-0.004012552
SRRM1\tS463\t0.299854388
SRRM1\tS561\t0.1129003
SRRM1\tS563\t0.1129003
SRRM1\tS572\t-0.28433363
SRRM1\tS574\t0.08202134
SRRM1\tS609\t0.04907312
SRRM1\tS617\t0.04865466
SRRM1\tS619\t0.04865466
SRRM1\tS628\t0.00602991
SRRM1\tS706\t0.07093885
SRRM1\tS707\t0.07093885
SRRM1\tS708\t0.03341735
SRRM1\tS725\t0.038386963
SRRM1\tS727\t0.1954736
SRRM1\tS750\t0.08106696
SRRM1\tS752\t0.057429975
SRRM1\tS755\t0.08106696
SRRM1\tS760\t-0.34122845
SRRM1\tS761\t-0.34122845
SRRM1\tS764\t0.145365105
SRRM1\tS766\t0.20249835
SRRM1\tS768\t-0.1515063
SRRM1\tS781\t-0.02291795
SRRM1\tS785\t-0.006010679
SRRM1\tS787\t-0.02342956
SRRM1\tS789\t0.0174726
SRRM1\tS793\t-0.02291795
SRRM1\tS803\t0.005546605
SRRM1\tS807\t0.005546605
SRRM1\tS809\t0.005546605
SRRM1\tS886\t0.029004084
SRRM1\tT220\t0.001009529
SRRM1\tT406\t0.09788039
SRRM1\tT626\t-0.06395197
SRRM1\tT805\t0.005546605
SRRM1\tT884\t-0.179085052
SRRM2\tS1012\t0.1227
SRRM2\tS1014\t0.060204195
SRRM2\tS1064\t0.132333775
SRRM2\tS1069\t-0.44649205
SRRM2\tS1072\t0.1656869
SRRM2\tS1073\t0.1375035
SRRM2\tS1083\t0.009418687
SRRM2\tS1099\t0.2133784
SRRM2\tS1101\t0.2149951
SRRM2\tS1102\t0.1367164
SRRM2\tS1103\t0.193288645
SRRM2\tS1124\t0.1943392
SRRM2\tS1132\t0.05060612
SRRM2\tS1152\t0.2090997
SRRM2\tS1179\t0.05824728
SRRM2\tS1188\t0.04222413
SRRM2\tS1254\t-0.28943485
SRRM2\tS1270\t-0.04965102
SRRM2\tS1271\t-0.045370765
SRRM2\tS1318\t0.178052168
SRRM2\tS1320\t0.1363226
SRRM2\tS1326\t0.1294132
SRRM2\tS1329\t0.219781735
SRRM2\tS1336\t0.2927818
SRRM2\tS1382\t-0.25424935
SRRM2\tS1387\t-0.089681765
SRRM2\tS1401\t0.15459732
SRRM2\tS1403\t0.114896675
SRRM2\tS1404\t0.0425042
SRRM2\tS1421\t-0.07970667
SRRM2\tS1443\t0.211103745
SRRM2\tS1444\t0.23241459
SRRM2\tS1458\t0.21060205
SRRM2\tS1460\t0.38339908
SRRM2\tS1462\t0.2010088
SRRM2\tS1463\t0.24069045
SRRM2\tS1478\t-0.08621925
SRRM2\tS1482\t0.111148545
SRRM2\tS1483\t0.1514692
SRRM2\tS1497\t0.040186725
SRRM2\tS1499\t0.040661135
SRRM2\tS1501\t0.1043367
SRRM2\tS1502\t0.09707135
SRRM2\tS1537\t0.1919416
SRRM2\tS1539\t0.2837652
SRRM2\tS1541\t0.2163618
SRRM2\tS1542\t0.1681285
SRRM2\tS1550\t0.11552897
SRRM2\tS1552\t0.1784916
SRRM2\tS1577\t0.08321613
SRRM2\tS1579\t0.058260079
SRRM2\tS1581\t0.11857601
SRRM2\tS1582\t0.10184722
SRRM2\tS1587\t0.056713605
SRRM2\tS1616\t0.068260325
SRRM2\tS1618\t0.16793585
SRRM2\tS1620\t0.16793585
SRRM2\tS1648\t-0.2212868
SRRM2\tS1691\t0.00587475
SRRM2\tS1693\t-0.07964569
SRRM2\tS1694\t-0.07964569
SRRM2\tS1727\t0.10883828
SRRM2\tS1729\t0.10883828
SRRM2\tS1731\t0.10883828
SRRM2\tS1732\t0.10883828
SRRM2\tS1972\t0.1323794
SRRM2\tS1975\t0.1323794
SRRM2\tS1984\t0.093342465
SRRM2\tS2044\t0.05658348
SRRM2\tS2046\t0.05658348
SRRM2\tS2067\t0.1386835
SRRM2\tS2071\t0.1386835
SRRM2\tS2118\t0.3811726
SRRM2\tS2121\t0.3811726
SRRM2\tS2123\t0.23966131
SRRM2\tS2132\t0.1264442
SRRM2\tS2272\t0.03984026
SRRM2\tS2382\t0.1264442
SRRM2\tS2398\t0.07737969
SRRM2\tS2407\t0.087133335
SRRM2\tS2412\t0.19994835
SRRM2\tS2449\t-0.06756084
SRRM2\tS2453\t-0.015604515
SRRM2\tS2581\t0.06543438
SRRM2\tS2684\t-1.0295056
SRRM2\tS2688\t-0.376177
SRRM2\tS2692\t0.15738983
SRRM2\tS2694\t0.28447065
SRRM2\tS2702\t-0.05871533
SRRM2\tS2706\t-0.1274943
SRRM2\tS295\t0.07696952
SRRM2\tS297\t0.07696952
SRRM2\tS322\t0.2123825
SRRM2\tS323\t0.10470784
SRRM2\tS333\t0.2459823
SRRM2\tS346\t0.39088235
SRRM2\tS351\t0.20733178
SRRM2\tS353\t0.196133745
SRRM2\tS357\t0.5760514
SRRM2\tS377\t0.04026129
SRRM2\tS387\t-0.005826852
SRRM2\tS395\t0.109750503
SRRM2\tS398\t0.05227683
SRRM2\tS404\t-0.045390005
SRRM2\tS408\t-0.045390005
SRRM2\tS424\t0.10693275
SRRM2\tS435\t0.1226065
SRRM2\tS436\t0.1226065
SRRM2\tS437\t0.1303828
SRRM2\tS440\t0.08486304
SRRM2\tS449\t0.2588203
SRRM2\tS456\t0.1772047
SRRM2\tS536\t0.1315895
SRRM2\tS778\t-0.06146581
SRRM2\tS780\t0.0831889
SRRM2\tS783\t-0.0352473
SRRM2\tS854\t0.197488
SRRM2\tS857\t0.03337007
SRRM2\tS864\t0.10577878
SRRM2\tS871\t0.3331359
SRRM2\tS875\t0.13711
SRRM2\tS876\t0.236217
SRRM2\tS883\t0.7136372
SRRM2\tS895\t0.01621022
SRRM2\tS901\t-0.09660635
SRRM2\tS908\t-0.021903087
SRRM2\tS950\t0.2401311
SRRM2\tS952\t0.25820335
SRRM2\tS954\t0.3731749
SRRM2\tS957\t0.32823055
SRRM2\tS974\t0.014314865
SRRM2\tS994\t0.1082234
SRRM2\tT1003\t0.070031025
SRRM2\tT1043\t-0.011562576
SRRM2\tT1071\t0.1576905
SRRM2\tT1413\t0.3674829
SRRM2\tT1434\t0.1060803
SRRM2\tT1453\t0.06253617
SRRM2\tT2069\t0.1386835
SRRM2\tT2104\t0.2193389
SRRM2\tT2144\t0.38650745
SRRM2\tT2247\t0.62365665
SRRM2\tT2289\t0.08488071
SRRM2\tT2329\t0.3838287
SRRM2\tT2409\t-0.01964186
SRRM2\tT2599\t0.3597461
SRRM2\tT367\t0.1191569
SRRM2\tT383\t-0.05929409
SRRM2\tT400\t0.5222558
SRRM2\tT856\t0.2586204
SRRM2\tT866\t0.09545191
SRRT\tS136\t-1.777838
SRRT\tS4\t-0.02140893
SRRT\tS456\t-0.06547594
SRRT\tS74\t-0.002917193
SRRT\tT507\t-0.05436229
SRSF1\tS199\t0.096411395
SRSF1\tY202\t0.08052122
SRSF10\tS131\t0.09410089
SRSF10\tS133\t0.076520375
SRSF10\tS23\t0.02023818
SRSF10\tS250\t-0.02023806
SRSF10\tS252\t-0.02023806
SRSF10\tT21\t-0.16195352
SRSF11\tS207\t-0.2263243
SRSF11\tS231\t-0.07369686
SRSF11\tS433\t0.06722574
SRSF11\tS448\t-0.008333969
SRSF3\tS5\t0.3190398
SRSF4\tS118\t0.0904378
SRSF4\tS119\t-0.1503529
SRSF4\tS179\t-0.03744355
SRSF4\tS431\t-0.03370244
SRSF4\tS458\t-0.34734385
SRSF5\tS227\t0.02517066
SRSF5\tS229\t-0.012733143
SRSF5\tS231\t0.044533038
SRSF5\tS233\t0.01198375
SRSF6\tS297\t0.09982997
SRSF6\tS299\t0.09982997
SRSF6\tS301\t0.11941301
SRSF6\tS303\t0.09464902
SRSF6\tS314\t0.09261344
SRSF6\tS316\t0.09261344
SRSF6\tS45\t0.02066555
SRSF7\tS192\t0.15470155
SRSF7\tS194\t0.1489992
SRSF7\tS196\t0.1604039
SRSF8\tS2\t0.08922691
SRSF8\tS274\t0.20265085
SRSF8\tS275\t0.20265085
SRSF9\tS189\t0.186722985
SRSF9\tS204\t0.1127669
SRSF9\tS211\t0.06149609
SRSF9\tS216\t0.0647449
SSB\tS225\t-0.2052972
SSB\tS366\t0.01863419
SSB\tS92\t0.2267551
SSB\tS94\t0.1713229
SSFA2\tS1161\t0.105953425
SSFA2\tS441\t0.2465084
SSFA2\tS593\t-0.2641131
SSFA2\tS668\t-0.4085312
SSFA2\tS739\t-0.003162958
SSFA2\tS746\t-0.6390491
SSFA2\tS92\t-0.6609767
SSFA2\tT1156\t0.66884375
SSH1\tS515\t-0.1375685
SSH1\tS576\t0.1329059
SSH1\tS581\t0.4854268
SSH1\tS583\t0.4927248
SSH1\tS889\t-1.748117
SSH1\tS9\t-0.1149411
SSH1\tS937\t-0.1200991
SSH2\tS487\t0.021893765
SSH2\tT795\t0.3538878
SSH3\tS484\t-0.210997
SSH3\tS70\t-0.1871321
SSH3\tS85\t-0.15990905
SSH3\tS87\t-0.1506572
SSH3\tS9\t-0.05916426
SSR1\tS268\t0.2916035
SSR1\tT260\t0.1915626
SSRP1\tS375\t0.01464098
SSRP1\tS444\t-0.01779679
SSRP1\tS659\t0.2255217
SSRP1\tS667\t-0.24691785
SSRP1\tS668\t-0.1774411
SSRP1\tS671\t-0.3438057
SSRP1\tS672\t-0.5558857
SSX2IP\tS308\t-0.13342608
ST13\tS75\t-0.00039723
ST13\tS76\t-0.1122564
ST13\tS79\t-0.04147649
ST5\tS368\t0.02946271
ST5\tS48\t1.291014
ST5\tS515\t-0.10330884
ST5\tS76\t0.08099565
ST5\tS84\t-0.1447916
ST5\tS88\t-0.1297655
ST5\tT364\t0.02946271
ST6GALNAC6\tS301\t-0.05672138
STAG1\tS1062\t-2.9493255
STAG1\tS756\t-0.04540164
STAG1\tT1108\t0.03857661
STAMBPL1\tS25\t-0.05658124
STARD13\tS106\t0.131629895
STARD13\tS136\t0.242572
STARD13\tS279\t0.06736329
STARD13\tS354\t0.06942715
STARD13\tS376\t0.02275842
STARD13\tS537\t0.1793837
STARD13\tS554\t-0.3601936
STARD13\tS98\t0.103934
STARD3NL\tS10\t0.44448435
STARD3NL\tS11\t0.4025239
STARD3NL\tS14\t0.1131439
STARD3NL\tS15\t0.02561259
STARD3NL\tS17\t0.17044205
STARD3NL\tS18\t0.1257833
STARD3NL\tS186\t0.03026536
STARD3NL\tS203\t-0.5838315
STARD3NL\tS21\t-0.068931525
STARD3NL\tS211\t-0.5838315
STARD3NL\tS220\t-0.189391095
STARD3NL\tS32\t0.05852425
STARD3NL\tS8\t-0.1674583
STAT1\tS532\t-0.3490333
STAT3\tS727\t-1.650182
STAT3\tY704\t-0.008203375
STAT3\tY705\t-0.01035232
STAT5A\tS128\t-0.05559368
STAT5A\tS193\t-0.39277815
STAT5A\tS749\t-0.2203453
STAT5B\tS128\t0.01264022
STAT5B\tS193\t-0.6888224
STAU1\tS197\t-0.32437265
STAU1\tS309\t0.18222215
STAU2\tS16\t-0.3236965
STAU2\tS22\t-0.18032705
STAU2\tS268\t-1.9227405
STAU2\tS314\t-0.1756688
STAU2\tS320\t-1.4511595
STAU2\tT236\t0.485262
STAU2\tT316\t-1.0032045
STIL\tS348\t0.162834545
STIM1\tS257\t0.6141915
STIM1\tS512\t0.4863777
STIM1\tS519\t0.3582838
STIM1\tS521\t0.3043227
STIM1\tS575\t0.4598512
STIM1\tS608\t0.6642097
STIM1\tS618\t0.1219437
STIM1\tS620\t0.16503662
STIM1\tS660\t0.6397878
STIM1\tS668\t0.3633393
STIM1\tT517\t0.2548359
STIM2\tS518\t0.3667401
STIM2\tS523\t0.2513344
STIM2\tS631\t0.1194226
STIP1\tS481\t-0.1208746
STK10\tS191\t0.215368
STK10\tS417\t0.158854
STK10\tS438\t0.08202134
STK10\tS448\t0.234336145
STK10\tS450\t-0.003260305
STK10\tS454\t0.01174457
STK10\tS514\t-0.8643864
STK10\tT14\t0.1820566
STK10\tT459\t0.00235733
STK10\tT952\t-2.304719
STK11\tS31\t-0.01702287
STK11IP\tS387\t-0.05371828
STK11IP\tS389\t0.113397863
STK11IP\tS392\t0.0716639
STK11IP\tS470\t-0.3725239
STK11IP\tS599\t-0.7621427
STK11IP\tS777\t-0.25230315
STK17A\tS12\t0.1503163
STK17A\tS20\t0.6171231
STK17A\tS28\t-0.1970541
STK17A\tS9\t0.1489992
STK17B\tS10\t-3.344473
STK24\tS4\t-0.2815967
STK24\tT153\t0.2747686
STK3\tS15\t0.1206174
STK3\tS316\t0.1488691
STK3\tT177\t0.4507022
STK32C\tS18\t0.06942715
STK32C\tS29\t-0.125384
STK39\tS371\t-0.1207177
STK4\tS320\t0.03829577
STK4\tS410\t-0.1397125
STK4\tT340\t0.1107641
STMN1\tS16\t0.2599811
STMN1\tS25\t-0.6917622
STMN1\tS38\t-0.172051
STMN1\tS46\t-0.1837034
STMN1\tS63\t0.3146386
STOM\tS161\t-0.19524545
STOML2\tT327\t0.03492
STON1\tS244\t-0.22945
STON2\tS296\t0.68131
STOX2\tS387\t0.15703184
STRADA\tS297\t-0.2571832
STRAP\tS312\t-0.05293984
STRIP1\tS335\t0.007913023
STRIP2\tS318\t-0.0882701
STRN\tS245\t-0.09315554
STRN\tS259\t0.3399355
STRN\tT265\t0.5629409
STRN3\tS168\t-0.17009405
STRN3\tS202\t0.1119661
STRN3\tS229\t-0.4016538
STRN3\tT171\t-0.116344111
STRN4\tS342\t0.01049345
STRN4\tT338\t-0.08926005
STT3B\tS498\t-0.04420009
STT3B\tS499\t-0.04998911
STUB1\tS19\t-0.033890495
STUB1\tS23\t-0.06000013
STUB1\tS273\t-0.03092684
STX12\tS142\t0.48096945
STX12\tS94\t-0.07164862
STX17\tS288\t0.5512945
STX17\tS289\t0.6868814
STX4\tS117\t0.021764
STX6\tS129\t-0.03271267
STX6\tS2\t-0.19235601
STX7\tS126\t0.3399355
STX7\tS129\t0.287996
STX7\tS131\t-0.001298968
STX7\tS2\t-0.11332947
STX7\tS45\t0.3538878
STX7\tS75\t0.08065767
STX7\tS81\t0.0426443
STX7\tT79\t-0.2883641
STXBP2\tT91\t-0.1221458
STXBP5\tS193\t0.2684706
STXBP5\tS692\t-0.9935511
STXBP5\tS759\t-0.06585339
STXBP5\tS782\t0.4529117
SUB1\tS118\t0.06887715
SUDS3\tS234\t-0.043863885
SUDS3\tS236\t-0.089642285
SUDS3\tS237\t-0.028590455
SUDS3\tS45\t-0.07561126
SUDS3\tS53\t-0.07561126
SUDS3\tT244\t0.03791772
SUDS3\tT49\t-0.07561126
SUFU\tS346\t-0.1199023
SUGP1\tS409\t0.06460693
SUGP1\tS411\t-0.08650737
SUGP1\tS485\t0.145768825
SUGP2\tS224\t-0.1156912
SUGP2\tS315\t-0.2837872
SUGP2\tS573\t-0.02666059
SUGP2\tS603\t0.2387868
SUGP2\tS745\t-0.22706775
SUGP2\tS773\t-0.1952194
SUGT1\tT233\t-1.514037
SUMO1\tS2\t0.03153631
SUMO1\tS32\t-0.1487047
SUMO4\tS28\t0.138373315
SUN2\tS110\t0.3379965
SUN2\tS113\t0.3379965
SUN2\tS116\t0.2808376
SUN2\tS12\t-1.357048
SUN2\tS38\t0.2185952
SUN2\tT107\t0.131326
SUPT16H\tS1013\t-0.2854775
SUPT16H\tS188\t-0.16801865
SUPT3H\tS7\t0.02814484
SUPT5H\tS32\t-0.2634384
SUPT5H\tS36\t-0.2634384
SUPT5H\tS666\t-0.1063582
SUPT5H\tT1034\t0.04362443
SUPT5H\tT784\t-0.03255102
SUPT5H\tT791\t0.1045996
SUPT5H\tT799\t0.04096256
SUPT5H\tT806\t0.04096256
SUPT5H\tT814\t0.1063484
SUPT5H\tT828\t0.3499314
SUPT6H\tS12\t-0.08220929
SUPT6H\tS1535\t-0.023835333
SUPT6H\tS7\t-0.07524173
SUPT6H\tS73\t0.14118905
SUPT6H\tS75\t0.14118905
SUPT6H\tS78\t0.14118905
SUPT6H\tS91\t-0.8605304
SUPT6H\tT1523\t-0.00607247
SUPT6H\tT1530\t-0.094477961
SUPT6H\tT1532\t-0.031209487
SUPT6H\tT1539\t-0.055383865
SUPT7L\tS106\t-0.0906873
SUPT7L\tS332\t-0.07290677
SUPV3L1\tS725\t0.20657745
SURF2\tT195\t0.2173952
SURF6\tS138\t0.1616942
SURF6\tS206\t-0.1587676
SUV39H1\tS391\t0.04921259
SUV39H2\tS148\t0.2823805
SUZ12\tS523\t0.006621249
SUZ12\tS703\t-0.030945055
SV2A\tS127\t0.96460435
SVIL\tS1120\t0.7131679
SVIL\tS18\t0.7131679
SVIL\tS221\t-0.805207
SVIL\tS245\t-0.1196358
SVIL\tS261\t0.02180965
SVIL\tS270\t0.005737
SVIL\tS547\t-1.183638
SVIL\tS549\t0.17563836
SVIL\tS673\t-0.08018048
SVIL\tS707\t-0.1148943
SVIL\tS920\t0.8042188
SVIL\tT672\t0.22618435
SVIL\tT852\t0.21114475
SVIL\tT856\t0.4371686
SVIP\tS46\t-0.005956171
SWAP70\tS3\t-0.111140972
SYAP1\tS313\t0.22456163
SYDE1\tS575\t0.06073913
SYDE1\tS60\t-0.2088945
SYDE1\tS645\t0.2497487
SYDE1\tS683\t0.2880631
SYDE2\tS1082\t1.023906
SYMPK\tS1171\t-0.07618906
SYMPK\tS1173\t0.07368314
SYMPK\tS1175\t-0.02236109
SYMPK\tS1243\t0.012735515
SYMPK\tS1259\t0.01963077
SYMPK\tS494\t-1.452728
SYMPK\tS501\t-1.49844
SYMPK\tS870\t0.091209955
SYMPK\tT1246\t-0.0246925
SYMPK\tT1257\t-0.086985465
SYN3\tS475\t0.1634987
SYNE1\tS5918\t0.09013362
SYNE1\tS8152\t0.03167748
SYNE1\tS8234\t-0.1053491
SYNE1\tS8277\t0.4101945
SYNE1\tS8678\t-0.029598856
SYNE1\tT8312\t-0.09144841
SYNE1\tT8314\t0.04234648
SYNE2\tS1772\t-0.1384734
SYNE2\tS2781\t-0.01996008
SYNE2\tS3145\t-0.4824945
SYNE2\tS6303\t-0.109943715
SYNE2\tS6361\t-0.04020019
SYNE2\tS6388\t-1.619188
SYNGR2\tS3\t0.2180992
SYNJ1\tS1048\t-0.2538936
SYNJ1\tS1298\t-0.159557
SYNJ1\tS1345\t0.389787
SYNJ1\tS1504\t-0.0102651
SYNJ1\tS1518\t-0.5075418
SYNM\tS1044\t-0.2190424
SYNM\tS1049\t-0.2736047
SYNM\tS1181\t-2.129544
SYNM\tS1432\t-0.3887193
SYNM\tS1435\t0.6102857
SYNM\tS429\t0.38407665
SYNM\tS653\t-0.2775721
SYNM\tS777\t-1.983875
SYNM\tS913\t-0.28487683
SYNPO\tS235\t-0.2764677
SYNPO\tS441\t-0.03883605
SYNPO\tS575\t0.1790014
SYNPO\tS589\t0.393363435
SYNPO\tS804\t-0.05262468
SYNPO\tS854\t0.09502138
SYNRG\tS419\t-1.533493
SYNRG\tS559\t-0.7435448
SYNRG\tS591\t-0.4539131
SYNRG\tS651\t0.103934
SYNRG\tS726\t-0.015952185
SYNRG\tS729\t0.1724875
SYNRG\tS869\t-0.2785136
SYNRG\tS881\t0.2210259
SYNRG\tS892\t0.2143735
SYTL2\tS274\t-0.1960456
SYTL2\tS296\t-0.5345375
SYTL4\tS274\t0.01077991
SYTL4\tS289\t0.3087104
SZRD1\tS106\t-0.09598994
SZRD1\tS38\t-0.0500393
SZT2\tS1585\t-1.102001
SZT2\tS1762\t-0.07594515
SZT2\tS2079\t-3.688767
SZT2\tS2842\t0.109681
SZT2\tT2377\t-1.866173
TAB1\tS378\t-1.4974865
TACC1\tS218\t0.227125
TACC1\tS27\t-0.2613619
TACC1\tS276\t-2.936773
TACC1\tS29\t-0.0029107
TACC1\tS361\t-1.677435
TACC1\tS44\t-0.05547139
TACC2\tS2027\t-0.57808765
TACC2\tS2272\t0.3198445
TACC2\tS2276\t-1.768371
TACC2\tS2314\t-2.334894
TACC2\tS2398\t-0.24678945
TACC2\tS2467\t-0.38314055
TACC3\tS177\t0.4168398
TACC3\tS250\t-0.002902718
TACC3\tS317\t0.09882372
TACC3\tS434\t0.2102636
TACC3\tS570\t0.47143
TACC3\tS71\t-0.4860646
TACC3\tT315\t0.415975
TADA3\tS298\t0.01072136
TAF1\tS1152\t0.15555007
TAF1\tS1155\t0.05755419
TAF10\tS44\t0.04488368
TAF11\tS7\t0.127105
TAF12\tS21\t0.02573757
TAF15\tS372\t-0.1787142
TAF1D\tS138\t0.1352544
TAF1D\tS234\t0.2949
TAF2\tS1185\t-0.112208175
TAF2\tS190\t-0.9068184
TAF3\tS183\t-0.03797669
TAF3\tS667\t-0.27315353
TAF3\tT364\t-0.13121106
TAF3\tT433\t-0.090624594
TAF4\tS543\t-0.1151286
TAF4\tT1046\t0.5418122
TAF6\tS532\t-1.1235817
TAF6\tS653\t0.004752986
TAF6L\tS501\t0.05311137
TAF7\tS171\t-1.339455
TAF7\tS200\t-0.075452
TAF7\tS201\t-0.03853962
TAF7\tS205\t-0.02941982
TAF9\tT161\t0.703125
TAF9B\tS153\t0.2018848
TAF9B\tT156\t0.1959021
TAGLN2\tS163\t-0.2461388
TALDO1\tS237\t-0.005608579
TALDO1\tS256\t-0.042441285
TALDO1\tS4\t0.005204645
TANC1\tS132\t-0.4753947
TANC1\tS1497\t0.7419455
TANC1\tS1564\t0.673285
TANC1\tS1668\t0.3190398
TANC1\tS1687\t-0.04196659
TANC1\tS1855\t-0.1233396
TANC1\tS207\t-0.01952132
TANC1\tS214\t-0.072201255
TANC1\tS243\t0.103238115
TANC1\tS270\t0.04781753
TANC1\tS313\t-1.068665
TANC1\tS444\t-0.26836375
TANC1\tS447\t-0.33024505
TANC1\tS448\t-0.1638355
TANC1\tS61\t0.200894
TANC1\tS63\t0.4101965
TANC1\tS66\t0.33225382
TANC1\tS67\t0.4519297
TANC1\tT1713\t0.70970745
TANC1\tT284\t-0.321680185
TANC1\tT687\t-0.12955525
TANC2\tS1442\t-1.050891
TANC2\tS1445\t-1.052386
TANC2\tS1458\t-1.257264
TANC2\tS1530\t0.4201766
TANC2\tS1534\t-0.4998098
TANC2\tS1545\t-0.3504673
TANC2\tS169\t-0.4445372
TANC2\tS1827\t-1.546807
TANC2\tS235\t0.2520522
TANC2\tS238\t0.2715452
TANC2\tS254\t0.3138294
TANC2\tS268\t0.3720605
TANC2\tS400\t-0.027700235
TANC2\tS404\t-0.027700235
TANC2\tS61\t-0.23784305
TANC2\tS65\t0.103934
TANC2\tT236\t0.30752755
TANC2\tT434\t-0.03759164
TANK\tS129\t0.2293591
TANK\tS228\t0.3922765
TANK\tS257\t-2.2498695
TAOK1\tS421\t0.06350289
TAOK1\tS9\t-0.02208269
TAOK2\tS1011\t-0.1299652
TAOK2\tS827\t-0.4269164
TAOK2\tS9\t0.1007085
TAOK3\tS324\t0.4299177
TAOK3\tS331\t-0.1584616
TARDBP\tS92\t0.65739985
TARSL2\tS358\t-0.46408045
TAX1BP1\tS624\t1.287868
TAX1BP3\tS61\t-0.05688132
TBC1D10A\tS18\t-0.7956671
TBC1D10A\tS20\t-0.3809522
TBC1D10A\tS407\t0.284751
TBC1D10A\tT22\t-0.3426343
TBC1D10B\tS132\t0.04684024
TBC1D10B\tS141\t0.3473498
TBC1D10B\tS22\t0.08065767
TBC1D10B\tS678\t-0.04745771
TBC1D10B\tS687\t-0.1462598
TBC1D10B\tT148\t0.2468274
TBC1D10B\tT150\t0.3001349
TBC1D10B\tT152\t0.1750454
TBC1D13\tS183\t0.39061585
TBC1D14\tS688\t-0.1164261
TBC1D14\tS91\t-0.7506639
TBC1D15\tS658\t0.1656869
TBC1D15\tS70\t-0.3621394
TBC1D15\tT672\t-0.4455781
TBC1D16\tS103\t-0.44866395
TBC1D16\tS155\t-0.6570812
TBC1D16\tS260\t-0.1897296
TBC1D16\tS383\t-2.121298
TBC1D17\tS602\t0.8365165
TBC1D22A\tS85\t-0.2680869
TBC1D22A\tS88\t-0.2628324
TBC1D23\tS474\t0.29242025
TBC1D23\tT514\t-0.4350658
TBC1D24\tS474\t-0.06264055
TBC1D25\tS252\t-0.1367435
TBC1D2B\tS155\t0.067500075
TBC1D2B\tS317\t-0.5273044
TBC1D2B\tS473\t-1.603507
TBC1D2B\tS957\t-0.09652972
TBC1D30\tS114\t0.2413522
TBC1D4\tS106\t-0.4357147
TBC1D4\tS318\t0.8368501
TBC1D4\tS341\t0.006190286
TBC1D4\tS370\t0.05699965
TBC1D4\tS4\t-0.01702287
TBC1D4\tS566\t-0.2847927
TBC1D4\tS569\t0.18097165
TBC1D4\tS570\t0.197488
TBC1D4\tS588\t-0.18659625
TBC1D4\tS591\t1.26742375
TBC1D4\tS754\t-0.26631208
TBC1D4\tS757\t-0.01893649
TBC1D4\tS782\t0.3634827
TBC1D4\tS787\t0.256178106
TBC1D4\tS789\t0.081038665
TBC1D4\tT568\t-0.4894595
TBC1D4\tT642\t0.2851063
TBC1D5\tS4\t0.485942
TBC1D5\tS44\t-0.7459865
TBC1D5\tS522\t-0.8676137
TBC1D5\tS537\t-0.1973352
TBC1D5\tS539\t-0.1844901
TBC1D5\tS541\t-0.6824232
TBC1D5\tS544\t-0.47960601
TBC1D5\tS554\t-0.188529
TBC1D5\tS730\t0.5642122
TBC1D9B\tS1121\t-0.03416033
TBC1D9B\tS411\t-0.5939056
TBC1D9B\tS435\t-0.41439435
TBCEL\tS41\t0.08406419
TBCK\tS827\t-0.3232452
TBL1XR1\tS119\t0.4374408
TBL3\tS257\t0.06342352
TBRG1\tS10\t0.196733
TBRG4\tT65\t0.07929271
TBX2\tS320\t0.0425042
TBX2\tS323\t0.114343675
TBX2\tS324\t0.18618315
TBX2\tS336\t-0.22488133
TBX2\tS342\t0.19685742
TBX2\tS360\t-0.08681373
TBX2\tS379\t-0.08084595
TBX2\tS386\t0.122474
TBX2\tS653\t-0.00749095
TBX2\tS657\t0.107865665
TBX2\tS705\t-0.082293945
TBX2\tS710\t-0.082293945
TCEA1\tS100\t-0.03636313
TCEA1\tS81\t-4.602964
TCEA1\tS97\t-0.04869572
TCEAL1\tS28\t-0.01136983
TCEAL3\tS121\t-0.0867678
TCEAL3\tS125\t0.125136215
TCEAL3\tS135\t-0.2132698
TCEAL3\tS65\t-0.305931
TCEAL4\tS102\t0
TCEAL4\tS13\t0.2494554
TCEB3\tS222\t0.1950955
TCEB3\tS542\t0.09643383
TCF12\tS142\t0.09125975
TCF12\tS385\t-0.6399168
TCF12\tT62\t-0.7095048
TCF20\tS1335\t-0.12463891
TCF20\tS1522\t0.1719754
TCF20\tS559\t-0.07465022
TCF20\tS640\t0.05769283
TCF20\tS871\t0.1674864
TCF20\tS966\t0.1415635
TCF20\tT1518\t0.029300915
TCF20\tT1671\t0.133126365
TCF25\tS602\t-0.7740342
TCF25\tS605\t-0.80036145
TCF25\tT106\t-0.4646636
TCF3\tS379\t-0.1251951
TCF3\tS530\t-1.32348
TCOF1\tS1073\t0.121148
TCOF1\tS110\t0.374956
TCOF1\tS111\t0.012289195
TCOF1\tS1111\t-0.008261406
TCOF1\tS1191\t0.06598585
TCOF1\tS1193\t0.37689755
TCOF1\tS1220\t0.2609891
TCOF1\tS1313\t-0.3236965
TCOF1\tS1341\t0.08038475
TCOF1\tS160\t-0.28725035
TCOF1\tS171\t0.41117515
TCOF1\tS381\t-0.0700427
TCOF1\tS446\t0.08379207
TCOF1\tS583\t0.9963088
TCOF1\tS674\t-0.101335
TCOF1\tS679\t0.37053765
TCOF1\tS906\t0.06239799
TCOF1\tS967\t0.13121415
TCOF1\tT1233\t0.1575611
TCOF1\tT249\t0.47101675
TCOF1\tT533\t0.2565276
TCOF1\tT983\t0.10750253
TDRD3\tS255\t-1.907522
TDRD3\tS486\t0.9192257
TDRD7\tS319\t-0.5999649
TDRD7\tS859\t0.2579622
TEAD1\tS11\t0.08980525
TEAD1\tS7\t-0.014381447
TEAD3\tS148\t-0.5520506
TECPR2\tT726\t-1.12404095
TEKT3\tS465\t-0.03249201
TENC1\tS120\t-0.09386367
TENC1\tS921\t-0.1205138
TENC1\tS931\t-0.2634557
TENC1\tS993\t-1.515398
TENM3\tS116\t-0.27973945
TENM3\tS27\t0.2859696
TEP1\tS397\t-0.4229072
TERF1\tS11\t0.116573425
TERF2\tS323\t-0.1599598
TERF2IP\tS111\t0.09855437
TERF2IP\tS203\t-0.01297024
TERF2IP\tS36\t0.259457745
TERF2IP\tS43\t-0.23115005
TET2\tS1107\t-0.017183065
TET2\tS75\t0.03969989
TET2\tT1122\t0.1450905
TET3\tS369\t0.04187775
TET3\tS666\t0.10916
TEX2\tS295\t-0.9583085
TEX264\tS244\t-0.95721695
TEX264\tS249\t-0.08230096
TEX264\tT242\t-1.1247625
TFAP2A\tS235\t0.061326315
TFAP2A\tS252\t0.04278438
TFAP2C\tS434\t-0.09717778
TFAP4\tS124\t-1.040319
TFAP4\tS139\t0.7891033
TFAP4\tT37\t0.4536493
TFDP1\tS23\t0.04642113
TFDP2\tS117\t0.3645725
TFDP2\tS119\t0.23059995
TFDP2\tS24\t-0.039071876
TFE3\tS548\t-0.1202786
TFE3\tS556\t-0.09799805
TFE3\tS560\t-0.08493425
TFG\tS164\t-0.041046
TFG\tS197\t-0.128322525
TFG\tS50\t-0.2291456
TFIP11\tS210\t0.01959267
TFIP11\tS59\t0.1285573
TFIP11\tS98\t-0.011588
TFPI\tT219\t-0.1866067
TFPT\tS171\t-0.3304652
TFPT\tS179\t-1.1358872
TFPT\tT198\t0.05644473
TGFB1I1\tS192\t0.1792563
TGFB1I1\tS194\t0.041593115
TGFB1I1\tS68\t-0.2495822
TGFB1I1\tT33\t-0.262520985
TGIF1\tS286\t-0.27027175
TGIF1\tS291\t0.74696065
TGIF1\tS95\t-0.15355505
TGOLN2\tS224\t-0.2146755
TGOLN2\tS71\t-0.009393595
TGOLN2\tT296\t-0.1844082
TGS1\tS89\t-0.04051173
THAP7\tS162\t-0.3975621
THOC1\tS2\t-0.02373901
THOC1\tS560\t0.1198209
THOC1\tT4\t0.08283826
THOC1\tT542\t-0.1322933
THOC2\tS1417\t0.008773791
THOC2\tS1419\t0.011852415
THOC2\tS1514\t0.08746284
THOC2\tS1516\t0.06653696
THOC2\tT1289\t0.07364105
THOC5\tS307\t-0.1798741
THOC5\tS312\t-0.133849715
THOC5\tS314\t-0.133849715
THOC5\tT328\t-3.306573
THOC6\tS156\t-0.078402615
THOP1\tS16\t-0.2121163
THRAP3\tS207\t0.060738955
THRAP3\tS232\t0.124853375
THRAP3\tS243\t0.04753833
THRAP3\tS248\t-0.0341424
THRAP3\tS253\t-0.0920941
THRAP3\tS315\t-0.07555045
THRAP3\tS320\t-0.020654192
THRAP3\tS377\t-0.4811627
THRAP3\tS379\t0.1234014
THRAP3\tS575\t-0.22945
THRAP3\tS622\t-0.3300742
THRAP3\tS624\t0.06170257
THRAP3\tS682\t0.1090262
THRAP3\tS698\t-0.1465952
THRAP3\tS928\t-0.07689211
THRAP3\tS939\t-0.11097708
THRAP3\tT487\t-0.0661706
THRAP3\tT874\t0.2757223
THRAP3\tT941\t-0.3802551
THUMPD1\tS86\t-0.0369106
THUMPD1\tS88\t-0.0369106
TIAM1\tS1406\t-0.3054674
TIAM1\tS1446\t-0.2244697
TIAM1\tS231\t0.04823624
TIAM1\tS358\t0.4413773
TIAM1\tS695\t-0.1113054
TIAM2\tS1569\t-0.2193707
TIAM2\tS201\t-0.04507414
TIAM2\tS389\t-0.128230795
TICAM1\tS212\t0.52938645
TICRR\tS1000\t0.168106095
TICRR\tS1056\t0.2097652
TICRR\tS1077\t0.07176267
TICRR\tS1161\t0.022936895
TICRR\tS1313\t0.07724293
TICRR\tS1333\t-0.04686145
TICRR\tS1412\t-0.08408909
TICRR\tS1429\t0.674551
TICRR\tS1432\t0.33716635
TICRR\tS1849\t0.2834926
TICRR\tS440\t-0.1032864
TICRR\tS598\t0.08133958
TICRR\tS837\t0.67105072
TICRR\tS864\t-0.51452965
TICRR\tS922\t-0.03768053
TICRR\tS937\t-0.24228482
TICRR\tT1104\t0.09234277
TIMELESS\tS1120\t0.009203812
TIMELESS\tS1148\t0.01335505
TIMELESS\tS1172\t-0.1520512
TIMM44\tS180\t-0.023878995
TIMMDC1\tS253\t-0.2554083
TIPIN\tT132\t0.3630029
TJAP1\tS225\t-0.1248963
TJAP1\tS470\t-0.1581235
TJAP1\tT347\t-0.9336248
TJP1\tS125\t-0.1858516
TJP1\tS131\t-0.3065376
TJP1\tS1617\t-1.5347415
TJP1\tS175\t0.165664925
TJP1\tS178\t0.165664925
TJP1\tS179\t0.165664925
TJP1\tS275\t-0.4466985
TJP1\tS277\t0.077600775
TJP1\tS280\t-0.1136792
TJP1\tS284\t0.163787235
TJP1\tS294\t0.13497411
TJP1\tS297\t-0.06208313
TJP1\tS300\t0.13497411
TJP1\tS329\t0.009203812
TJP1\tS617\t-0.05943476
TJP1\tS912\t-0.152154875
TJP1\tS968\t-0.235501
TJP2\tS107\t-0.1672639
TJP2\tS1136\t0.3271692
TJP2\tS145\t0.08955045
TJP2\tS151\t0.37222395
TJP2\tS221\t0.05130255
TJP2\tS243\t0.09261344
TJP2\tS438\t-0.13787
TJP2\tS955\t0.09761087
TJP2\tS963\t-0.009291985
TK1\tS13\t0.2928995
TK1\tS15\t0.1749178
TK1\tS231\t0.5586369
TKT\tS295\t-0.1643992
TKT\tS345\t0.04292445
TKT\tT287\t0.06166643
TLE3\tS203\t0.07107621
TLE3\tS240\t0.3860384
TLE3\tS245\t0.3860384
TLE3\tS263\t0.590944955
TLE3\tS267\t-0.03146323
TLE3\tS286\t0.0182068
TLE3\tT259\t0.3860384
TLE3\tT328\t0.46597075
TLE3\tT334\t0.448266475
TLE4\tS181\t0.081105705
TLE4\tS183\t-0.16838102
TLE4\tS225\t0.1923205
TLE4\tS240\t0.2156148
TLE4\tS267\t-0.2026051
TLE4\tY218\t0.02630426
TLK1\tS111\t-0.09629841
TLK1\tS140\t0.1947517
TLK1\tS34\t-0.85045035
TLK1\tS46\t0.08678382
TLK2\tS134\t-0.1279395
TLK2\tS35\t-0.2442793
TLK2\tS99\t0.09653179
TLN1\tS1164\t0.04586229
TLN1\tS1225\t-0.3092701
TLN1\tS1227\t-0.4611769
TLN1\tS2040\t0.143271885
TLN1\tS2127\t-0.1611531
TLN1\tS2162\t-0.07254346
TLN1\tS425\t0.1326427
TLN1\tS620\t-0.154522
TLN1\tS729\t-0.025414325
TLN1\tS981\t-0.1747026
TLN1\tT144\t0.07628538
TLN2\tT1843\t0.09247811
TM7SF3\tT566\t0.08256635
TMBIM1\tS2\t0.0839273
TMBIM1\tS81\t0.2802438
TMBIM1\tS83\t0.2597846
TMC8\tS435\t-0.2172895
TMCC1\tS382\t0.04488368
TMCC1\tS414\t0.04320455
TMCC2\tS198\t-0.1284875
TMCC3\tS216\t-0.35486965
TMCO1\tS60\t0.7810043
TMED8\tS21\t0.09639683
TMED8\tS39\t0.01306909
TMED8\tS62\t-0.28343525
TMEM104\tS120\t-0.05838279
TMEM104\tS90\t0.060349713
TMEM104\tS94\t0.1722355
TMEM104\tT92\t0.060349713
TMEM106B\tS33\t0.06060078
TMEM106B\tS58\t0.162669875
TMEM115\tS320\t-2.379845
TMEM115\tT329\t0.01349801
TMEM131\tS1155\t0.0451634
TMEM131\tS1375\t0.03167748
TMEM131\tS1871\t-0.2296192
TMEM131\tT1490\t0.6133431
TMEM132A\tS121\t0.2185952
TMEM160\tS48\t-0.0752616
TMEM163\tS38\t-0.38350327
TMEM163\tS55\t-1.9911025
TMEM163\tS57\t-0.7233962
TMEM169\tT107\t0.3955016
TMEM179B\tS205\t0.08161233
TMEM179B\tS206\t0.05644473
TMEM184C\tS344\t-0.1645125
TMEM192\tS226\t-0.0970697
TMEM201\tS454\t-0.02827807
TMEM201\tS477\t0.6777724
TMEM201\tS480\t0.6777724
TMEM209\tS264\t-0.7935569
TMEM209\tS97\t-0.1064048
TMEM237\tS39\t0.1004395
TMEM237\tS41\t-0.1289765
TMEM237\tS54\t-0.8485048
TMEM237\tT48\t0.47777555
TMEM245\tS327\t-0.9660379
TMEM245\tS332\t-0.1598319
TMEM245\tT36\t0.7396753
TMEM259\tT29\t-0.4842068
TMEM38B\tS262\t0.00195092
TMEM44\tS18\t0.2333973
TMEM47\tS6\t0.662541425
TMEM48\tS330\t-0.70280145
TMEM48\tS359\t0.3823906
TMEM48\tT299\t0.2062681
TMEM5\tS63\t0.3529404
TMEM51\tS182\t0.5698799
TMEM51\tT234\t-1.645435
TMEM55A\tS47\t-0.1506091
TMEM55A\tT22\t0.1480882
TMEM55B\tS169\t-1.563198
TMEM57\tS305\t0.4594316
TMEM57\tS332\t0.57305995
TMEM57\tT306\t0.4624712
TMEM61\tS10\t0.1142337
TMEM63B\tS114\t-0.26936655
TMEM63B\tS115\t0.1209151
TMEM66\tT9\t-0.485221
TMEM66\tY4\t-0.485221
TMEM87A\tS479\t-0.15246878
TMF1\tS344\t0.1553607
TMF1\tS77\t-1.696966
TMOD3\tS25\t0.2753647
TMPO\tS156\t0.68030005
TMPO\tS158\t0.2052674
TMPO\tS159\t0.1729995
TMPO\tS168\t0.2348042
TMPO\tS180\t0.05241581
TMPO\tS184\t0.00870363
TMPO\tS184\t-0.06996664
TMPO\tS265\t-0.228704
TMPO\tS306\t0.3203114
TMPO\tS315\t-0.21683785
TMPO\tS351\t0.3437175
TMPO\tS354\t0.4414835
TMPO\tS378\t0.2261386
TMPO\tS385\t0.07286042
TMPO\tS387\t0.132008665
TMPO\tS424\t0.3802861
TMPO\tS66\t0.01106615
TMPO\tS67\t0.01106615
TMPO\tS79\t-0.2093948
TMPO\tT154\t0.2895985
TMPO\tT160\t0.178761715
TMPO\tT208\t0.03449741
TMPO\tT355\t0.3872522
TMPO\tT74\t0.007769512
TMPO\tY183\t0.12684906
TMSB10\tS12\t-0.2390892
TMUB1\tS98\t-0.292595
TMUB1\tT71\t0.421156
TMX1\tS247\t-0.1590575
TMX1\tS270\t-0.2868674
TMX2\tS250\t-0.1791226
TMX2\tT245\t-1.211915
TMX3\tS437\t-0.03600805
TMX4\tS294\t0.0889556
TNC\tS72\t-0.4837226
TNFRSF10D\tS369\t0.196872975
TNFRSF19\tS241\t-0.023163925
TNFRSF19\tS261\t-1.34055
TNFRSF19\tT244\t0.01049345
TNFRSF21\tS521\t-0.2516762
TNFRSF21\tS525\t-0.2516762
TNIK\tS541\t0.7521491
TNIK\tS543\t0.9751899
TNIK\tS611\t-0.2199755
TNIK\tS649\t-0.1407142
TNIK\tS651\t-0.069564094
TNIK\tS678\t0.04368595
TNIK\tS691\t0.05283319
TNIK\tS735\t-0.198690985
TNIK\tS737\t0.075267505
TNIK\tS740\t0.04665865
TNIK\tS935\t-0.2026549
TNIK\tT552\t0.09288389
TNIK\tT614\t-0.17374435
TNIP1\tS403\t-0.1462279
TNIP1\tS563\t-1.457474
TNK1\tS497\t-0.1790573
TNK1\tS514\t2.46694835
TNK2\tS724\t0.3284918
TNK2\tY827\t-1.749038
TNKS1BP1\tS1024\t0.2158649
TNKS1BP1\tS1029\t-0.57190635
TNKS1BP1\tS1103\t-0.3281088
TNKS1BP1\tS1297\t-0.4962849
TNKS1BP1\tS1385\t-0.457415
TNKS1BP1\tS14\t1.03069705
TNKS1BP1\tS1533\t0.0359054
TNKS1BP1\tS1620\t-0.09594115
TNKS1BP1\tS1621\t0.044033535
TNKS1BP1\tS1652\t0.2974849
TNKS1BP1\tS1666\t-1.155566
TNKS1BP1\tS1715\t0.20167775
TNKS1BP1\tS178\t-0.1357286
TNKS1BP1\tS228\t-2.727835
TNKS1BP1\tS353\t0.44757305
TNKS1BP1\tS368\t0.67026355
TNKS1BP1\tS429\t1.126973
TNKS1BP1\tS435\t-0.003206307
TNKS1BP1\tS456\t1.276318
TNKS1BP1\tS494\t-1.234262
TNKS1BP1\tS498\t-1.334498
TNKS1BP1\tS504\t-1.3098
TNKS1BP1\tS592\t0.108491
TNKS1BP1\tS601\t-0.2349915
TNKS1BP1\tS672\t0.04026129
TNKS1BP1\tS691\t-0.21861535
TNKS1BP1\tS712\t-0.7124244
TNKS1BP1\tS836\t-0.325469
TNKS1BP1\tS872\t0.4380799
TNKS1BP1\tS893\t0.2715452
TNKS1BP1\tS920\t-0.9635708
TNKS1BP1\tS984\t-0.14220556
TNKS1BP1\tT1282\t0.7736588
TNKS1BP1\tT131\t-3.048591
TNKS1BP1\tT501\t-1.279952
TNKS1BP1\tT710\t-0.61492775
TNPO1\tT28\t-0.3485188
TNRC18\tS1127\t0.204836975
TNRC18\tS1138\t0.127862785
TNRC18\tS1359\t-0.1308821
TNRC18\tS1857\t0.09882372
TNRC18\tS1878\t-0.5342658
TNRC18\tS1957\t0.1231364
TNRC18\tS1989\t-0.03196089
TNRC18\tS2538\t-0.0392558
TNRC18\tS2543\t0.1007085
TNRC18\tS263\t0.5130146
TNRC18\tS333\t0.1655583
TNRC18\tS660\t0.8277876
TNRC6A\tS943\t-0.8714691
TNRC6A\tS991\t-0.129655
TNRC6B\tS1322\t0.351984145
TNRC6B\tS1351\t-0.2929701
TNRC6B\tS384\t-1.25168295
TNRC6B\tS385\t-2.4790165
TNRC6B\tS879\t0.1050075
TNRC6B\tT29\t0.8796344
TNRC6C\tS465\t0.103409555
TNRC6C\tS714\t0.003170453
TNS3\tS1149\t-0.8742695
TNS3\tS1154\t-0.4805387
TNS3\tS660\t-0.04614627
TNS3\tS776\t-0.8406034
TNS3\tS811\t-1.71506
TNS3\tS850\t-0.4297509
TNS3\tS874\t0.3909978
TNS3\tS88\t0.1314818
TNS3\tS969\t0.02998291
TNS3\tT967\t0.58208885
TNS3\tY855\t-0.1931728
TNXB\tS2787\t-0.3066625
TOE1\tS428\t-0.2063621
TOE1\tS5\t0.005040595
TOM1\tS355\t-0.089197455
TOM1\tS359\t-0.058616405
TOM1\tS462\t-1.034692
TOM1\tS464\t-1.683854
TOM1\tS473\t-0.8602162
TOM1L1\tS244\t-0.322397
TOM1L1\tS246\t0.07601179
TOMM22\tS15\t-1.471729
TOMM34\tS186\t-0.3025108
TOMM40\tS142\t-0.3694081
TOMM6\tS13\t-0.52523185
TOMM70A\tS110\t-0.2929216
TOMM70A\tS91\t-0.09167438
TOMM70A\tS96\t0.0367041
TONSL\tS719\t0.07477944
TONSL\tS905\t0.0987957
TOP1\tS10\t0.1986199
TOP1\tS111\t-0.1989157
TOP1\tS112\t-0.038109745
TOP2A\tS1106\t0.1521185
TOP2A\tS1213\t0.2807188
TOP2A\tS1247\t0.2434253
TOP2A\tS1374\t0.414785
TOP2A\tS1377\t0.3229665
TOP2A\tS1393\t0.134089965
TOP2A\tS1469\t-0.106666177
TOP2A\tS1471\t0.113400747
TOP2A\tS1474\t0.113400747
TOP2A\tS4\t0.355129
TOP2A\tT1112\t0.21723915
TOP2A\tT1470\t0.119365411
TOP2B\tS1231\t0.657928
TOP2B\tS1395\t-0.1514742
TOP2B\tS1408\t-0.10861852
TOP2B\tS1419\t-0.07207324
TOP2B\tS1456\t0.1135672
TOP2B\tS1461\t-0.0757121
TOP2B\tS1466\t-0.1645286
TOP2B\tS1468\t0.354539475
TOP2B\tS1471\t-0.36576735
TOP2B\tS1517\t-0.13993916
TOP2B\tS1519\t-0.07310485
TOP2B\tS1521\t0.120376905
TOP2B\tS1545\t-1.8704825
TOP2B\tS1547\t-0.7259447
TOPBP1\tT848\t0.5803725
TOPORS\tS9\t0.03646811
TOR1AIP1\tS154\t-0.023120695
TOR1AIP1\tS156\t-0.0057507
TOR1AIP1\tS157\t-0.0057507
TOR1AIP1\tS164\t-0.09058782
TOR1AIP1\tS215\t-0.1293078
TOR1AIP1\tS305\t0.1110314
TOR1AIP1\tS315\t0.4156505
TOR1AIP1\tT220\t0.0888201
TOR1AIP1\tT286\t0.2756031
TOR1AIP2\tS120\t-0.51860905
TOX4\tS155\t-0.08314123
TOX4\tS159\t-0.062947497
TP53\tS183\t0.3720693
TP53BP1\tS1028\t-0.02020876
TP53BP1\tS1068\t0.06529664
TP53BP1\tS1094\t-0.000591656
TP53BP1\tS1101\t0.055780617
TP53BP1\tS1113\t-0.05114498
TP53BP1\tS1114\t-0.02435518
TP53BP1\tS1362\t-0.15199524
TP53BP1\tS1426\t0.14139234
TP53BP1\tS1430\t0.128605515
TP53BP1\tS1462\t0.0359054
TP53BP1\tS1618\t0.49087445
TP53BP1\tS1673\t-0.374007245
TP53BP1\tS1678\t0.008773791
TP53BP1\tS208\t-0.06818078
TP53BP1\tS265\t-0.08522119
TP53BP1\tS294\t-0.001660071
TP53BP1\tS366\t-1.481665
TP53BP1\tS380\t-0.07672148
TP53BP1\tS395\t0.1750454
TP53BP1\tS398\t-0.1685443
TP53BP1\tS500\t-0.05862323
TP53BP1\tS523\t0.043053065
TP53BP1\tS525\t0.03726935
TP53BP1\tS552\t-0.1067931
TP53BP1\tS580\t0.1717192
TP53BP1\tS63\t-0.04149136
TP53BP1\tS771\t0.2580967
TP53BP1\tS78\t0.1330374
TP53BP1\tS809\t0.05672221
TP53BP1\tS831\t-0.06367634
TP53BP1\tT1056\t-0.6598594
TP53BP1\tT1609\t0.0197807
TP53BP1\tT1648\t-0.1332898
TP53BP1\tT321\t-0.01547628
TP53BP1\tT922\t0.2128806
TP53BP2\tS173\t-0.2904094
TP53BP2\tS335\t0.4766409
TP53BP2\tS357\t0.1979911
TP53BP2\tS358\t0.25738285
TP53BP2\tS433\t-1.380371
TP53BP2\tS435\t-1.191363
TP53BP2\tS446\t-0.7530691
TP53BP2\tS453\t-0.2258485
TP53BP2\tS550\t-0.2347708
TP53BP2\tS614\t0.2848694
TP53BP2\tT577\t0.08827728
TP53BP2\tT616\t0.122378735
TP53INP1\tS156\t0.083721645
TP53RK\tT8\t0.1036654
TPCN1\tS867\t-0.35335335
TPD52\tS131\t-1.6562235
TPD52L2\tS12\t0.2076431
TPD52L2\tS166\t0.7590706
TPD52L2\tS21\t-0.2896881
TPI1\tS21\t0.01006364
TPI1\tS80\t-0.08897574
TPM1\tS216\t0.6762674
TPM1\tS6\t0.1179609
TPM3\tS51\t0.0610158
TPM3\tT6\t0.09369545
TPM4\tS6\t-0.02366567
TPMT\tS14\t-0.1039374
TPR\tS1185\t0.03913844
TPR\tS2037\t-0.05514159
TPR\tS2048\t0.3252713
TPR\tS2155\t-3.270626
TPR\tS371\t-0.0535084
TPR\tS379\t0.02715413
TPR\tS632\t-0.29978175
TPR\tT641\t0.4482667
TPRN\tS264\t-2.339922
TPRN\tS274\t-1.37891055
TPRN\tS362\t-0.62667825
TPRN\tS417\t-0.05431738
TPRN\tS418\t0.03026536
TPX2\tS738\t-0.06018668
TPX2\tT147\t0.1512094
TPX2\tT369\t0.544782
TRA2A\tS14\t-0.021789855
TRA2A\tS16\t0.01621099
TRA2A\tS18\t0.01621099
TRA2A\tS2\t0.02272126
TRA2A\tS20\t-0.1798741
TRA2A\tS84\t0.008200003
TRA2A\tS86\t0.008200003
TRA2A\tT202\t0.03759303
TRA2A\tT204\t0.08243007
TRA2A\tT24\t0.0984196
TRA2A\tT88\t0.008200003
TRA2B\tS14\t0.0353423
TRA2B\tS2\t0.07231157
TRA2B\tS260\t-0.148781875
TRA2B\tS262\t0.07203723
TRA2B\tS266\t-0.3240898
TRA2B\tS4\t0.03830558
TRA2B\tS95\t-0.07607685
TRA2B\tS97\t-0.07607685
TRA2B\tS99\t-0.07607685
TRA2B\tT201\t0.03463829
TRA2B\tT203\t0.003746074
TRAF1\tS66\t-0.2972893
TRAF1\tS8\t-0.6355396
TRAF2\tT7\t0.14235078
TRAF3\tS9\t-0.4896058
TRAF3IP1\tS410\t-0.2449586
TRAF4\tS426\t-0.1355067
TRAFD1\tS327\t-0.1702641
TRAFD1\tS415\t0.08038475
TRAK2\tS775\t0.3236583
TRAK2\tS780\t0.291682175
TRAK2\tS784\t0.3236583
TRAK2\tS84\t-2.926098
TRAK2\tT776\t0.266103
TRAM1\tS279\t0.549817
TRAPPC12\tS109\t-0.44360505
TRAPPC12\tS182\t-2.500789
TRAPPC12\tS184\t-0.85591215
TRAPPC12\tS276\t-1.245027
TRAPPC12\tT107\t-0.44360505
TRAPPC8\tS311\t0.33295368
TRAPPC9\tS944\t-0.01132231
TREX1\tS122\t0.2967804
TRIM11\tS85\t0.04306451
TRIM2\tS10\t-1.061722
TRIM2\tS424\t0.1028596
TRIM2\tS428\t0.12221155
TRIM2\tT430\t0.1986199
TRIM24\tS991\t0.0278618
TRIM24\tS994\t0.0278618
TRIM25\tS100\t0.006764703
TRIM28\tS14\t-0.211131045
TRIM28\tS17\t0.09234277
TRIM28\tS19\t-0.224197935
TRIM28\tS26\t0.2335199
TRIM28\tS471\t-0.37574
TRIM28\tS473\t-0.3168515
TRIM28\tS50\t-0.1300813
TRIM28\tS594\t0.158749137
TRIM28\tS681\t0.2669964
TRIM28\tS683\t-0.1610402
TRIM28\tS752\t0.004465491
TRIM28\tS756\t-0.14286236
TRIM28\tS757\t0.1047392
TRIM28\tT541\t-0.4451656
TRIM3\tS416\t-0.1456532
TRIM3\tS7\t0.1674864
TRIM32\tS335\t0.2988929
TRIM33\tS1102\t-3.116536
TRIM35\tS4\t-0.11951087
TRIM35\tS65\t0.1386835
TRIM36\tS75\t-0.1094833
TRIM47\tS350\t-3.232294
TRIM5\tS86\t-0.131487
TRIM56\tS469\t-0.4442008
TRIM56\tS471\t-0.7657134
TRIM56\tS475\t0.079646787
TRIM56\tT418\t-0.1102461
TRIM56\tT442\t0.3173041
TRIM9\tS44\t-0.67016565
TRIM9\tS46\t-0.1822622
TRIO\tS2429\t0.11787321
TRIO\tS2455\t-0.9346759
TRIO\tS2477\t-3.00613
TRIO\tS2508\t0.668693
TRIOBP\tS1777\t0.01706665
TRIOBP\tS1783\t0.6452405
TRIOBP\tS1881\t0.0247452
TRIOBP\tS2190\t-0.8440694
TRIP10\tS296\t-0.019773872
TRIP10\tS298\t0.107750776
TRIP10\tS299\t0.16356617
TRIP10\tS351\t0.292075
TRIP11\tS1842\t-0.453191225
TRIP11\tS1882\t0.032133162
TRIP11\tS1891\t0.1054098
TRIP11\tT1846\t-0.01613085
TRIP12\tS1020\t0.1377659
TRIP12\tS1024\t0.1397313
TRIP12\tS1049\t-0.01930195
TRIP12\tS1063\t-0.5035669
TRIP12\tS1069\t-0.1355185
TRIP12\tS1087\t0.5747444
TRIP12\tS12\t0.4446948
TRIP12\tS1409\t0.034198877
TRIP12\tS161\t-0.23486141
TRIP12\tS1610\t-0.3589905
TRIP12\tS310\t-0.13018852
TRIP12\tS312\t-0.007086551
TRIP12\tS975\t-0.01633686
TRIP12\tT1410\t-0.032556201
TRIP12\tT754\t0.0729976
TRIP6\tS92\t-0.065301275
TRIT1\tS300\t0.03885755
TRIT1\tS312\t0.05880134
TRMT10A\tS318\t-0.02472201
TRMT10C\tT168\t0.5065004
TRMT13\tS7\t-0.08118634
TRMT44\tS78\t0.20568273
TROVE2\tS19\t0.08324736
TRPM7\tS1287\t0.1195554
TRPM7\tS1387\t0.3222744
TRPM7\tS1463\t0.1899194
TRPM7\tS1468\t0.2446586
TRPM7\tS1477\t0.2287264
TRPM7\tS1503\t-0.48337875
TRPM7\tS1512\t-0.5601109
TRPM7\tS1850\t-0.1318506
TRPS1\tS373\t0.1001703
TRPT1\tS191\t0.1236661
TRPV2\tS3\t-0.03668205
TRPV2\tS6\t0.2115692
TRPV2\tS7\t-0.04380954
TRRAP\tS2058\t0.102994
TRUB1\tS11\t0.1583371
TSC1\tS1029\t-0.3052356
TSC1\tS1049\t-0.625912
TSC1\tS454\t0.2691529
TSC1\tS533\t-0.06621589
TSC2\tS1132\t-0.1638335
TSC2\tS1155\t-0.5138521
TSC2\tS1395\t0.27659605
TSC2\tS1397\t0.1382902
TSC2\tS1426\t-0.110877925
TSC2\tT1439\t0.7035437
TSC22D4\tS104\t0.42702035
TSC22D4\tS165\t0.8958455
TSC22D4\tS264\t-0.4077846
TSC22D4\tS279\t-2.53952
TSC22D4\tS49\t-0.6018248
TSC22D4\tS62\t-0.04094214
TSC22D4\tT57\t0.60939025
TSEN2\tS215\t-0.031924915
TSEN54\tS230\t-0.18064305
TSEN54\tS267\t0.07956584
TSG101\tT220\t0.04404436
TSHZ1\tS444\t-0.03621516
TSNAX\tS32\t-0.13615359
TSNAX\tS33\t-0.08972783
TSR3\tS282\t-0.073340835
TSSC4\tS29\t-0.7927068
TSSC4\tS68\t0.2075181
TSTD2\tS43\t0.2928995
TTBK2\tS359\t0.72014325
TTBK2\tT41\t-0.1134109
TTC28\tS2104\t0.247297155
TTC28\tS2108\t0.247297155
TTC28\tS2398\t0.2900705
TTC28\tS28\t-0.2865329
TTC28\tS32\t-0.2218082
TTC28\tS47\t-0.3024753
TTC3\tS119\t-0.3122585
TTC3\tS1509\t-0.077589
TTC33\tS197\t-0.1011493
TTC7A\tS51\t0.1800205
TTC7A\tS53\t-0.02789699
TTC7A\tS647\t-0.06581225
TTC7A\tS690\t0.1845977
TTC7B\tS160\t0.173895
TTC7B\tS202\t0.1289532
TTC7B\tS673\t-0.149788663
TTC7B\tS677\t-0.05530643
TTC7B\tS678\t0.1547128
TTF1\tS15\t0.42751995
TTF1\tS472\t0.2052674
TTF1\tS487\t-0.310021
TTF1\tS65\t-0.1300655
TTF1\tT12\t0.2185952
TTF2\tS368\t-0.23793455
TTK\tS281\t0.05269407
TTK\tS820\t0.1509495
TTLL12\tS16\t-0.16389194
TTYH2\tS483\t0.12618
TTYH3\tS464\t-0.062039895
TTYH3\tS490\t-0.0559062
TUBB\tS30\t0.6165459
TUBG1\tS284\t0.03576464
TUSC1\tS153\t0.1267086
TUT1\tS6\t0.2003789
TUT1\tT329\t0.578441265
TVP23B\tS14\t0.9712963
TVP23B\tS6\t-0.2344992
TWF1\tS143\t-0.795033
TWIST1\tS68\t-0.2586323
TWISTNB\tS304\t0.01464098
TWISTNB\tS316\t-1.50200175
TWISTNB\tS328\t0.97094485
TWISTNB\tT322\t1.652501
TXLNA\tS19\t0.07395734
TXLNA\tS515\t-1.390699
TXLNG\tS517\t-0.682418
TXLNG\tS97\t-0.6463154
TXNL1\tS113\t0.09599187
TXNL4B\tS132\t-0.11734225
TXNRD3\tS4\t0.85384175
TYK2\tY292\t-0.06703179
TYW1\tS483\t0.004768056
U2AF2\tS2\t0.1060803
U2AF2\tS79\t0.1624679
U2AF2\tT133\t-0.243624121
U2SURP\tS484\t0.2628979
U2SURP\tS67\t0.2645965
U2SURP\tT486\t-0.007246082
U2SURP\tT918\t-5.7803824
UACA\tT237\t0.01464098
UBA1\tS21\t0.1315895
UBA1\tS46\t-0.4662772
UBA1\tS810\t-0.007666597
UBA1\tS816\t-0.9225109
UBA1\tS835\t0.07121356
UBA2\tS207\t-0.03612646
UBA52\tS57\t0.09058251
UBAP2\tS277\t-1.092081
UBAP2\tS432\t-1.319694
UBAP2\tS473\t0.9967612
UBAP2L\tS116\t0.41879375
UBAP2L\tS349\t0.4218023
UBAP2L\tS409\t-0.51692855
UBAP2L\tS432\t-0.37672445
UBAP2L\tS446\t-0.141682733
UBAP2L\tS447\t-0.015338275
UBAP2L\tS460\t0.14221032
UBAP2L\tS470\t0.360637825
UBAP2L\tS598\t0.2324152
UBAP2L\tS601\t0.21676405
UBAP2L\tS602\t0.34254234
UBAP2L\tT418\t0.4887207
UBE2C\tS3\t0.38122545
UBE2E3\tS8\t0.1123665
UBE2J1\tS266\t0.2533843
UBE2O\tS401\t0.5314688
UBE2O\tS411\t0.3351059
UBE2O\tS836\t0.3646845
UBE2O\tS839\t-1.845028
UBE2O\tS87\t-0.01566586
UBE2O\tS89\t-0.01566586
UBE2O\tS896\t-0.1981792
UBE2O\tT838\t-1.6869415
UBE2O\tT841\t-1.4285845
UBE2Z\tS337\t0.07537274
UBE2Z\tS340\t0.043428255
UBE3A\tS195\t0.1234014
UBE3B\tS677\t-0.12253519
UBE4B\tS105\t-0.4654403
UBE4B\tS31\t-0.8771261
UBE4B\tS674\t0.2914856
UBE4B\tS87\t-0.03910285
UBE4B\tS88\t-0.170180325
UBL4A\tS90\t0.3728406
UBN1\tS173\t0.035628155
UBN1\tS175\t0.01578305
UBN1\tS493\t0.01264022
UBN1\tS660\t0.071601455
UBN2\tS13\t0.007339063
UBN2\tS250\t-0.1808877
UBN2\tT252\t-0.1808877
UBR1\tS1593\t-0.03577143
UBR1\tT21\t-0.5740896
UBR2\tS1009\t-0.3983795
UBR4\tS1760\t-2.9742765
UBR4\tS178\t-0.2533949
UBR4\tS181\t-0.1247704
UBR4\tS2729\t0.1088924
UBR4\tS2730\t0.1123665
UBR4\tS620\t-0.03297898
UBR4\tT2735\t0.212598858
UBR5\tS1308\t-0.31385435
UBR5\tS2011\t-0.19398615
UBR5\tS2241\t0.044464
UBR5\tS2485\t-0.3987409
UBR5\tT1306\t-0.05047256
UBTD1\tS164\t0.2997136
UBXN1\tS199\t-0.8554575
UBXN1\tT229\t0.7518064
UBXN2B\tS235\t-1.01217
UBXN6\tS43\t-0.00669885
UBXN7\tS288\t0.22296135
UCHL3\tS64\t0.2736949
UCK1\tS11\t-0.27748985
UCKL1\tS16\t-0.1460522
UCKL1\tS56\t0.05762345
UFD1L\tS129\t-0.3710119
UFD1L\tS247\t0.2458607
UFD1L\tS299\t-0.04201112
UGDH\tS476\t-1.43170855
UGDH\tT91\t0.0615688
UGP2\tS2\t0.1553607
UHRF1\tS287\t0.1915626
UHRF1\tS639\t0.2257685
UHRF1\tS91\t0.2324152
UHRF1\tT93\t0.09545959
UHRF2\tS667\t-0.1029145
UIMC1\tS23\t-0.06089378
UIMC1\tS575\t0.05852425
UIMC1\tS599\t0.08447251
ULK1\tS450\t-0.3744303
ULK1\tS469\t0.140777755
ULK1\tS477\t-0.3422685
ULK1\tS479\t-0.3422685
ULK1\tS556\t0.1871343
ULK1\tS623\t-0.5339524
ULK1\tS638\t0.266360465
ULK1\tT636\t0.16045685
ULK3\tS462\t-0.05415265
UMPS\tS214\t-0.1670856
UNC13B\tS176\t-0.210969955
UNC13B\tS367\t0.1669301
UNC45A\tT15\t-0.05509656
UNC45A\tT8\t0.3125361
UNC45B\tS150\t0.36904065
UNC5A\tT52\t0.04306451
UNC5A\tT61\t0.04306451
UNC84A\tS138\t0.2618317
UNC84A\tS48\t0.389016
UNC93B1\tS547\t-0.1852117
UNC93B1\tS550\t-0.205763
UNG\tS23\t0.168642
UNG\tS63\t-0.19752514
UNG\tS64\t-0.432963275
UNG\tT60\t0.07809211
UNK\tS378\t-0.1981626
UNK\tS385\t-0.07148345
UPF1\tS1096\t-0.1238426
UPF2\tT1088\t0.1897929
UPF3B\tS297\t0.4504855
UPF3B\tT169\t0.3710091
UPP1\tS61\t0.01920368
UPP1\tS63\t0.111165
URGCP\tS3\t-0.06923993
URGCP\tS3\t-0.2558734
URI1\tS13\t-0.3471969
URI1\tS372\t-1.994716
URI1\tT492\t-1.219304
UROD\tS61\t-0.044672205
UROS\tS245\t-0.15867389
USO1\tS851\t-0.0124172
USO1\tS942\t-0.021381725
USO1\tS952\t0.09566215
USP1\tS313\t0.03026536
USP1\tS327\t0.09730322
USP1\tS398\t0.1386835
USP1\tS42\t0.4317833
USP1\tS475\t0.01149566
USP1\tS67\t-0.05593624
USP10\tS365\t0.01578305
USP10\tS370\t-0.9182801
USP10\tS547\t-0.0180451
USP10\tS576\t-0.01969679
USP14\tS108\t-0.1131611
USP14\tT200\t-0.65004485
USP15\tS229\t-0.53813945
USP15\tT226\t-0.3768448
USP16\tS400\t-0.3646264
USP16\tS537\t0.019216148
USP19\tS215\t-1.275437
USP19\tS335\t-0.1311552
USP19\tS565\t-0.57676565
USP20\tS112\t-0.5375078
USP20\tS132\t0.03884609
USP20\tS134\t0.07527413
USP20\tT377\t-0.0228886
USP22\tT147\t0.2403754
USP24\tS1285\t-0.4675933
USP24\tS1612\t-0.24896705
USP24\tS1943\t-0.05936251
USP24\tS2047\t0.07313477
USP24\tS2077\t-1.4877365
USP24\tS2561\t-0.6092663
USP24\tS2604\t0.3762904
USP24\tS88\t-1.94892
USP24\tT1289\t0.2378085
USP28\tS1021\t-0.33733785
USP28\tS279\t0.10095284
USP31\tS1323\t0.08995794
USP31\tS54\t0.05658348
USP31\tS887\t0.58982885
USP32\tS1350\t-0.5510145
USP32\tS1422\t-0.1105576
USP32\tT1326\t-0.7564284
USP34\tS3358\t-0.6961199
USP34\tS3359\t-0.1084564
USP34\tS3367\t-0.61914195
USP34\tS3406\t0.019002325
USP34\tT3350\t-0.11355246
USP34\tT3381\t-0.2060292
USP36\tS582\t0.2514464
USP36\tS667\t0.2813699
USP36\tS682\t0.147076575
USP36\tS742\t0.1348781
USP36\tS952\t0.099386625
USP37\tS210\t-2.186327
USP39\tS82\t0.004609331
USP4\tS628\t-0.1336222
USP4\tS633\t-0.1221458
USP42\tS1181\t-0.009742186
USP42\tS1219\t0.6027452
USP42\tS1222\t0.6027452
USP42\tS1226\t0.6027452
USP42\tS754\t-0.01035232
USP42\tS856\t-0.02595536
USP47\tS812\t0.01321208
USP47\tS890\t-0.5554601
USP47\tS913\t-0.1849
USP5\tS760\t-0.013327763
USP5\tS762\t-0.2110638
USP5\tT148\t-0.3312091
USP54\tS1270\t-0.4854383
USP54\tS331\t-0.01270823
USP54\tS886\t-0.07416762
USP6\tS1416\t0.3370831
USP6\tT330\t0.22037871
USP6NL\tS716\t-0.05126464
USP6NL\tS784\t0.5685101
USP7\tS18\t-0.0716638
USP7\tS963\t-0.146964205
USP8\tS153\t0.1478277
USP8\tS389\t-0.2499293
USP8\tS392\t-0.2894569
USP8\tS452\t-1.467813
USP8\tS718\t-0.01016343
USP8\tT577\t0.1677432
USP9X\tS1600\t-0.09441807
USP9X\tS1609\t0.01572225
USPL1\tS200\t-0.02924942
UTP11L\tS241\t0.1318529
UTP14A\tS14\t0.18727612
UTP14A\tS29\t-0.01276644
UTP14A\tS31\t-0.01276644
UTP14A\tS445\t0.1891604
UTP14A\tS453\t0.102994
UTP14A\tS52\t0.524164
UTP14A\tS569\t0.3264224
UTP18\tS121\t-0.225029757
UTP18\tS124\t0.000576887
UTP18\tS205\t-0.034990521
UTP18\tS206\t0.005998095
UTP18\tS210\t-0.01238904
UTP18\tT204\t-0.003824146
UTP20\tS2601\t0.0871912
UTP20\tS843\t-0.38296115
UTP20\tT1741\t0.05533457
UTP3\tS365\t0.06350289
UTP3\tS368\t0.06350289
UTRN\tS1405\t0.1466552
UTRN\tS2482\t0.3174198
UTRN\tS295\t-0.1451745
UTRN\tS784\t-0.09327245
UTRN\tS881\t-0.03577143
UVRAG\tS448\t-0.28026384
UVRAG\tS470\t-0.35340875
UVSSA\tS281\t0.01321208
UVSSA\tS287\t0.01321208
UVSSA\tS478\t0.125651
UVSSA\tS480\t0.2087669
VAMP1\tS44\t-2.052955
VAMP2\tS58\t0.6836515
VAMP2\tS63\t0.4620524
VAMP2\tT4\t0.36815215
VAMP3\tT3\t0.5550308
VAMP3\tT9\t0.3631055
VAMP4\tS30\t-0.2233233
VAMP4\tS88\t-0.2259531
VAMP4\tS90\t-0.1723761
VAMP7\tS167\t0.2318028
VAMP7\tS168\t0.7634116
VANGL1\tS45\t-0.1879701
VANGL1\tT296\t0.2735755
VANGL2\tT59\t0.14250315
VAPA\tS209\t-0.08369153
VAPA\tS3\t0.27258215
VAPB\tS156\t-0.35086635
VAPB\tS158\t-0.6352483
VARS\tS301\t-0.2187326
VARS\tS525\t-0.2795814
VAT1\tS18\t-0.3260275
VAT1\tS35\t-0.2960286
VAT1\tS44\t-0.7535068
VAV2\tS566\t0.0451634
VAX2\tS53\t0.0392528
VAX2\tT44\t0.522678955
VCAN\tS1129\t0.6669384
VCAN\tS362\t0.2012575
VCAN\tS364\t0.22102395
VCL\tS288\t0.10437107
VCL\tS290\t-0.04363102
VCL\tS346\t0.1590773
VCL\tS434\t-0.090747835
VCL\tS721\t0.1463945
VCL\tS795\t0.003889986
VCL\tT1055\t-0.03945861
VCL\tT604\t0.219669495
VCP\tS13\t-0.12963495
VCP\tS702\t-0.1007625
VCPIP1\tS994\t0.4878979
VCPIP1\tS997\t0.5086315
VCPIP1\tT761\t-0.1491206
VDAC1\tS104\t-0.02274209
VDAC1\tS57\t-0.07771584
VDAC2\tS115\t0.1329059
VDAC3\tT4\t-0.086057905
VEZT\tS21\t-0.02073557
VEZT\tS26\t-0.02073557
VGF\tS420\t0.4027634
VGLL4\tS118\t-0.3806527
VGLL4\tS231\t-0.05226649
VGLL4\tS243\t-0.082640325
VGLL4\tS250\t-0.240674567
VIM\tS205\t0.1861201
VIM\tS214\t0.3669237
VIM\tS22\t0.68904845
VIM\tS226\t0.001009529
VIM\tS26\t0.9385493
VIM\tS278\t-0.5865359
VIM\tS299\t0.1920679
VIM\tS325\t0.0615688
VIM\tS339\t0.0167015
VIM\tS39\t0.01963077
VIM\tS412\t0.1770886
VIM\tS419\t0.06722574
VIM\tS420\t-0.06934594
VIM\tS430\t0.07833651
VIM\tS438\t-0.05014391
VIM\tS56\t0.2408638
VIM\tT336\t0.03754075
VIM\tT426\t0.20596728
VIM\tT436\t-0.03231489
VIMP\tS140\t0.6983073
VPRBP\tS254\t-0.3698741
VPRBP\tS894\t0.2146222
VPRBP\tS999\t-0.09836651
VPS11\tS923\t0.11703
VPS13B\tS1263\t-0.4911455
VPS13C\tS3473\t0.44331925
VPS13D\tS1038\t0.1431322
VPS13D\tS1042\t-0.07790872
VPS13D\tS1138\t-0.1549235
VPS13D\tS1724\t-0.07371206
VPS13D\tS1765\t-0.5564994
VPS13D\tS2038\t0.9687192
VPS13D\tS2039\t0.9687192
VPS13D\tS2079\t-0.6469252
VPS13D\tS2435\t-0.25413505
VPS13D\tS2692\t-0.05277526
VPS13D\tS2958\t0.3126652
VPS13D\tT1761\t-0.5564994
VPS18\tS11\t-0.43662624
VPS26B\tT325\t-0.1727663
VPS35\tS7\t-0.34070965
VPS4A\tS90\t0.097868385
VPS4A\tS95\t0.266267113
VPS4A\tS97\t-0.006691341
VPS4A\tS99\t0.2683145
VPS4B\tS102\t-0.04826298
VPS4B\tS5\t0.1507527
VPS4B\tS93\t-0.1147068
VPS51\tS13\t-0.08075912
VPS51\tS18\t-0.04991983
VPS51\tS667\t-0.987417
VPS53\tS377\t-0.7040655
VPS54\tS8\t-2.183835
VRK3\tS59\t-0.0178634
VRK3\tS82\t-0.0930899
VTA1\tY278\t-0.3298305
VTI1B\tS138\t0.2851063
VTI1B\tS185\t-0.00641768
WAC\tS8\t0.03125411
WAPAL\tS221\t-0.026390575
WAPAL\tS226\t0.09234277
WAPAL\tS459\t-0.09648224
WAPAL\tS461\t-0.09648224
WAPAL\tS77\t-0.02020876
WARS\tS351\t-0.04629518
WARS\tS467\t0.0278618
WASF1\tS310\t0.6658175
WASF2\tS293\t0.7008166
WASF2\tS296\t0.33590925
WASF2\tS308\t0.2301364
WASH3P\tS215\t-0.0493635
WASH3P\tS366\t0.1858666
WASH6P\tS327\t0.4299641
WBP11\tS237\t-0.01993078
WBP11\tS566\t-1.811659
WBP11\tT252\t-0.07453221
WBP1L\tS173\t-1.04763475
WBP7\tS1092\t-0.03513566
WBP7\tS1095\t-0.03513566
WBP7\tS2270\t-0.1177248
WBP7\tS2348\t-0.0576761
WBP7\tS493\t-0.06882819
WBP7\tS582\t-0.120003703
WBP7\tS632\t-0.1823112
WBP7\tS821\t-0.4476623
WBP7\tS844\t-0.03512085
WBP7\tS857\t-0.04177352
WBP7\tS861\t-0.06102923
WBP7\tS936\t0.3001823
WBP7\tT588\t-0.06023178
WBP7\tT948\t0.3302142
WDHD1\tS383\t0.28900505
WDHD1\tS407\t0.07532719
WDR13\tS70\t-0.8526412
WDR13\tS74\t-1.122428
WDR13\tS79\t-0.1797761
WDR20\tS373\t-0.0659264
WDR20\tT402\t0.08338356
WDR24\tT581\t-0.18369663
WDR26\tS121\t-0.139649
WDR26\tS123\t-0.05523147
WDR3\tS211\t-0.341267
WDR33\tS1210\t-0.002989488
WDR33\tS7\t0.0766959
WDR4\tS390\t-0.04999452
WDR4\tS410\t0.29209385
WDR43\tS431\t0.3862592
WDR43\tS658\t-0.1249615
WDR43\tT656\t-0.1249615
WDR44\tS199\t-0.1671829
WDR44\tS262\t-0.4897267
WDR44\tS27\t-0.2620018
WDR44\tS403\t0.04656085
WDR44\tS470\t-0.15272744
WDR44\tS471\t-0.15272744
WDR44\tS472\t-0.15272744
WDR44\tS50\t0.07464243
WDR44\tS561\t0.3448285
WDR44\tS96\t0.1385524
WDR44\tT163\t0.195435395
WDR44\tT219\t0.5545398
WDR46\tS41\t0.2663968
WDR47\tS312\t-2.026499
WDR47\tS578\t-0.21875335
WDR55\tS14\t-0.4550399
WDR59\tS156\t-0.02557351
WDR59\tS413\t-0.07090052
WDR59\tS414\t-0.1646417
WDR59\tS422\t-0.510457
WDR62\tS1149\t0.3695953
WDR62\tS1233\t-0.3693733
WDR62\tS1353\t-1.460528
WDR62\tT50\t-1.3646078
WDR67\tS752\t0.4161008
WDR70\tS638\t-0.03432279
WDR75\tS779\t0.0618453
WDR75\tS782\t0.0618453
WDR75\tS796\t0.1624679
WDR77\tT5\t0.05102402
WDR81\tS1113\t-0.5093126
WDR81\tS1135\t0.1212807
WDR90\tT347\t-0.05610117
WDR91\tS221\t-0.01705202
WDTC1\tS510\t-0.3044338
WEE1\tS150\t0.2856981
WEE1\tS67\t-0.6241988
WFS1\tS32\t0.9689085
WHSC1\tS121\t0.019036075
WHSC1\tS407\t-3.152773
WHSC1\tS614\t0.8031443
WHSC1\tT110\t0.64373795
WHSC1\tT115\t0.64373795
WHSC1\tT544\t0.03913844
WHSC1L1\tS561\t-0.2636635
WHSC1L1\tS659\t-0.04236769
WIBG\tS6\t-0.03696989
WIPF1\tS214\t0.2372388
WIPF1\tS340\t-1.20841
WIPF1\tS350\t-0.7550886
WIPF2\tS267\t-2.1764775
WIPI1\tS392\t-0.2771751
WIZ\tS1006\t-0.2916627
WIZ\tS1012\t0.295467458
WIZ\tS1017\t-0.1022484
WIZ\tS1106\t0.1849785
WIZ\tS1127\t0.5313448
WIZ\tS1134\t0.4719678
WIZ\tS1146\t-0.3282175
WIZ\tS1309\t-0.282668665
WIZ\tS1314\t-0.4883103
WIZ\tS982\t-0.4514252
WIZ\tS996\t-1.33982
WIZ\tT1337\t0.3271125
WNK1\tS1009\t-2.622732
WNK1\tS1035\t-1.8606155
WNK1\tS1513\t0.2408638
WNK1\tS167\t-0.15779777
WNK1\tS2230\t-0.5528334
WNK1\tS2257\t-0.162751
WNK1\tS2264\t-0.05267046
WNK1\tS2279\t-0.2604457
WNK1\tS2281\t0.500802
WNK1\tS2284\t-0.2604457
WNK1\tS382\t0.73626075
WRAP53\tS26\t0.3267674
WRAP53\tS30\t0.3267674
WRAP53\tS491\t-0.08825473
WRAP53\tS54\t-0.01547628
WRAP53\tT489\t-0.004870074
WRN\tS1133\t0.230449
WRN\tS478\t0.0893058
WRNIP1\tS153\t-0.07885314
WRNIP1\tS75\t-1.173645278
WRNIP1\tS78\t-0.897994555
WRNIP1\tS91\t0.6218995
WRNIP1\tS92\t0.6218995
WRNIP1\tT116\t-0.4404788
WTAP\tS306\t0.01256406
WTIP\tS171\t-0.09427945
WTIP\tS88\t0.7952682
WWC2\tT686\t0.3339925
WWC3\tS479\t0.08024827
WWC3\tS809\t-0.09555832
WWC3\tS927\t0.05380643
WWC3\tS956\t-0.1398715
WWC3\tS957\t-0.05443721
WWP2\tS95\t0.1263122
WWTR1\tS89\t0.04376442
XBP1\tS47\t0.1073169
XPC\tS347\t0.0564792
XPC\tS397\t0.056559775
XPC\tS398\t0.056559775
XPC\tS399\t0.056559775
XPC\tS883\t-0.05120486
XPC\tS884\t-0.05120486
XPC\tS94\t0.09936258
XPC\tT876\t-0.02869002
XPO1\tS391\t-0.3011415
XPO4\tS521\t-0.09364811
XPO5\tS416\t-0.1833921
XPO6\tT204\t0.40564325
XRCC1\tS226\t0.140801695
XRCC1\tS241\t0.05311137
XRCC1\tT453\t0.03139513
XRCC4\tS232\t-0.1629287
XRCC4\tS256\t-0.1418964
XRCC4\tS318\t0.08664794
XRCC4\tT233\t-0.1629287
XRCC5\tS145\t-0.21797575
XRCC6\tS180\t-0.09597459
XRCC6\tS237\t0.33145975
XRCC6\tS520\t-0.08800939
XRCC6\tT455\t0.07272322
XRN2\tS448\t0.3069621
XRN2\tS473\t-0.04957654
XRN2\tS475\t0.25629305
XRN2\tS485\t0.17159395
XRN2\tS487\t-0.08105015
XRN2\tS499\t-0.062368915
XRN2\tS501\t0.04575384
XRN2\tS678\t0.04110281
YAP1\tS109\t0.24421203
YAP1\tS127\t0.116298185
YAP1\tS138\t0.045811545
YAP1\tS251\t-0.150417
YAP1\tS306\t0.0187308
YAP1\tS333\t-1.246943
YAP1\tS363\t0.3832757
YAP1\tS61\t0.07025199
YAP1\tT119\t0.4576468
YAP1\tT143\t0.080520375
YAP1\tT145\t0.1519769
YAP1\tT63\t-0.1441059
YBX1\tS165\t0.3216309
YBX1\tS167\t0.349705
YBX1\tS174\t0.2532051
YBX1\tS176\t0.3087882
YBX1\tS209\t-0.03472177
YBX3\tS102\t-1.8397985
YBX3\tS201\t-0.09700799
YBX3\tS203\t0.2354592
YBX3\tS204\t-0.05502161
YBX3\tS324\t0.166587
YEATS2\tS118\t0.05352838
YEATS2\tS447\t-0.05686224
YEATS2\tS463\t0.2520522
YEATS2\tS465\t0.3865902
YEATS2\tS536\t0.00697915
YEATS2\tT132\t0.06915226
YEATS2\tT514\t0.13583876
YEATS2\tT517\t0.105678
YES1\tS111\t0.1631499
YES1\tY426\t0.2578555
YIF1B\tT13\t0.8893956
YIPF6\tS15\t-0.420704
YIPF6\tS7\t-0.226088
YKT6\tS172\t0.06805168
YKT6\tS174\t0.231801
YLPM1\tS1303\t0.08678382
YLPM1\tS829\t0.24386975
YRDC\tS37\t-0.007420064
YRDC\tS60\t-0.1935027
YTHDC1\tS146\t-0.19973465
YTHDC1\tS152\t-0.077505025
YTHDC1\tS308\t0.03407487
YTHDC1\tS406\t0.04376442
YTHDC1\tT148\t-0.04883003
YTHDC2\tS1090\t0.03167748
YTHDC2\tS1183\t-1.2311616
YTHDC2\tS1202\t-3.217903
YTHDC2\tS1221\t0.6876884
YTHDF2\tS2\t0.17407082
YTHDF2\tS39\t-0.9636163
YTHDF2\tS5\t0.1020534
YTHDF3\tT176\t0.03345995
YWHAB\tS4\t0.6191782
YWHAE\tS210\t-0.08063699
YWHAQ\tT218\t0.1633699
YWHAZ\tS110\t-0.59511602
YWHAZ\tS207\t-0.036802815
YWHAZ\tS64\t-0.069750245
YY1\tS118\t-0.06252003
YY1\tS187\t-0.6956837
YY1AP1\tS1255\t-0.08802466
YY1AP1\tS395\t0.209391
ZBED4\tS1053\t0.19079685
ZBED4\tS624\t0.072379795
ZBED6\tS14\t0.1357976
ZBED6\tS381\t0.05477901
ZBTB1\tS301\t-1.3766852
ZBTB1\tS305\t-3.0445725
ZBTB1\tS355\t0.01920368
ZBTB1\tT356\t0.01920368
ZBTB10\tS210\t0.005759195
ZBTB11\tS511\t-2.324022
ZBTB14\tT235\t-0.047462795
ZBTB17\tS120\t0.02998291
ZBTB2\tS483\t-0.05658124
ZBTB20\tS359\t-0.2300591
ZBTB20\tT138\t0.11905479
ZBTB21\tS1003\t-0.08439493
ZBTB21\tS345\t-0.07366654
ZBTB21\tS411\t-0.01795742
ZBTB21\tS422\t-0.373402
ZBTB21\tS434\t0.3758458
ZBTB21\tS435\t-0.156193
ZBTB21\tS605\t-0.01519921
ZBTB21\tS714\t-0.5872943
ZBTB21\tS983\t-0.03498781
ZBTB21\tT431\t0.3758458
ZBTB25\tS220\t-0.1928371
ZBTB3\tS362\t0.071290595
ZBTB3\tS549\t0.1204847
ZBTB33\tT251\t0.1108978
ZBTB37\tS310\t0.004321636
ZBTB38\tS130\t-0.1112587
ZBTB40\tS190\t-0.1236697
ZBTB40\tS214\t-0.004493761
ZBTB41\tS57\t-0.4712086
ZBTB44\tS161\t0.04628156
ZBTB44\tS164\t-0.2243004
ZBTB44\tS194\t-0.158680485
ZBTB47\tT14\t-0.09243245
ZBTB5\tS208\t-0.767728
ZBTB5\tS371\t0.2185952
ZBTB6\tS202\t0.07107621
ZBTB7A\tS337\t-0.01845414
ZBTB7A\tS525\t-0.20707988
ZBTB7A\tS526\t-0.19288748
ZBTB7A\tS549\t-0.1984108
ZC3H10\tS126\t0.07696952
ZC3H11A\tS108\t0.073123875
ZC3H11A\tS290\t-2.93049
ZC3H11A\tS495\t0.4410585
ZC3H11A\tS758\t-1.72609
ZC3H11A\tS759\t-0.9754533
ZC3H11A\tS761\t-0.9668092
ZC3H11A\tT321\t0.3028747
ZC3H12A\tS99\t0.081139076
ZC3H12C\tS620\t-0.18980435
ZC3H12C\tS721\t-0.3192076
ZC3H12C\tS729\t0.6895336
ZC3H13\tS1010\t-0.4864284
ZC3H13\tS1014\t-0.4864284
ZC3H13\tS1017\t-0.4864284
ZC3H13\tS1065\t0.3078948
ZC3H13\tS1068\t0.017363
ZC3H13\tS109\t-0.01464531
ZC3H13\tS110\t-0.010832765
ZC3H13\tS1240\t-0.6827886
ZC3H13\tS1364\t-2.983589
ZC3H13\tS1366\t-0.3110767
ZC3H13\tS137\t-0.159789155
ZC3H13\tS1433\t0.05880134
ZC3H13\tS1438\t-0.1301601
ZC3H13\tS198\t0.01706665
ZC3H13\tS207\t0.138355215
ZC3H13\tS209\t0.138355215
ZC3H13\tS242\t0.1902988
ZC3H13\tS265\t-0.127579835
ZC3H13\tS318\t-0.0524728
ZC3H13\tS370\t0.08243007
ZC3H13\tS372\t0.08243007
ZC3H13\tS381\t0.03885755
ZC3H13\tS831\t-0.6984996
ZC3H13\tS845\t0.106886335
ZC3H13\tS848\t0.106886335
ZC3H13\tS853\t0.166483235
ZC3H13\tS877\t-0.05015878
ZC3H13\tS943\t-0.1561287
ZC3H13\tS986\t-0.003681904
ZC3H13\tS993\t-0.003444105
ZC3H13\tT134\t-0.155520555
ZC3H13\tT1430\t-0.2832812
ZC3H13\tT263\t-0.124987535
ZC3H13\tT317\t-0.0524728
ZC3H14\tS409\t-0.01042498
ZC3H14\tS515\t0.1106305
ZC3H15\tS231\t-0.1600292
ZC3H15\tS351\t-0.01920593
ZC3H15\tS360\t0.1083571
ZC3H15\tS381\t0.001730139
ZC3H18\tS110\t-0.079045755
ZC3H18\tS117\t0.1642714
ZC3H18\tS118\t0.04388908
ZC3H18\tS13\t-0.25608609
ZC3H18\tS24\t-0.095976045
ZC3H18\tS32\t-0.2539969
ZC3H18\tS34\t-0.09435647
ZC3H18\tS46\t0.021675
ZC3H18\tS53\t0.1558403
ZC3H18\tS532\t0.0984196
ZC3H18\tS534\t0.062291165
ZC3H18\tS6\t-0.0139896
ZC3H18\tS67\t-0.065533465
ZC3H18\tS74\t-0.03401259
ZC3H18\tS842\t0.08202134
ZC3H18\tS89\t-0.63332855
ZC3H18\tS94\t-0.001457859
ZC3H18\tS95\t-0.259271
ZC3H18\tT109\t-0.089505746
ZC3H18\tT162\t-0.03256571
ZC3H4\tS1104\t-0.1146443
ZC3H4\tS1108\t-0.1587901
ZC3H4\tS1114\t-0.1349364
ZC3H4\tS1269\t0.294312
ZC3H4\tS1275\t0.300768
ZC3H4\tS807\t0.012279115
ZC3H4\tS808\t0.012279115
ZC3H4\tS908\t0.05903025
ZC3H4\tT1106\t-0.1254627
ZC3H4\tT1118\t-0.09940171
ZC3H4\tT40\t-0.033652675
ZC3H7A\tS316\t-1.190977
ZC3H7A\tT210\t-0.2820352
ZC3H7B\tS399\t-0.07201258
ZC3H8\tT32\t-0.06827157
ZC3HAV1\tS257\t0.02524393
ZC3HAV1\tS271\t0.2875905
ZC3HAV1\tS275\t0.140860639
ZC3HAV1\tS284\t-0.2075943
ZC3HAV1\tS302\t-0.2747737
ZC3HAV1\tS335\t0.27605745
ZC3HAV1\tS378\t-0.2411851
ZC3HAV1\tS572\t-1.564948
ZC3HAV1\tT273\t0.0263275
ZC3HAV1\tT393\t0.40523
ZC3HAV1L\tS256\t0.16665353
ZC3HAV1L\tS257\t0.1696685
ZC3HC1\tS321\t-0.1580108
ZC3HC1\tS329\t-0.08938185
ZC3HC1\tS335\t-0.06348453
ZC3HC1\tS338\t-0.4714287
ZC3HC1\tS344\t-0.4714287
ZC3HC1\tS350\t-0.4589796
ZC3HC1\tS354\t-1.08633685
ZC3HC1\tS359\t0.48334405
ZC3HC1\tS370\t-0.22727815
ZC3HC1\tS394\t-0.1644963
ZC3HC1\tS395\t-0.1423215
ZC3HC1\tS407\t-1.863756
ZC3HC1\tS409\t-1.599985
ZC3HC1\tS410\t-1.699466
ZC3HC1\tS411\t-1.7772085
ZC3HC1\tS58\t0.222576
ZC3HC1\tS62\t0.139661825
ZC3HC1\tT333\t0.018759545
ZCCHC11\tS49\t0.6001746
ZCCHC17\tS146\t-0.03200511
ZCCHC17\tS90\t0.2331518
ZCCHC2\tS172\t-0.09669945
ZCCHC24\tS65\t-0.6275382
ZCCHC6\tS132\t-1.260014
ZCCHC6\tS172\t0.2509616
ZCCHC6\tT1376\t0.72434845
ZCCHC8\tS500\t-0.3049683
ZCCHC8\tS598\t-0.1197612
ZCCHC8\tS649\t0.3148993
ZCCHC8\tT479\t0.1744064
ZCCHC8\tT492\t0.256526025
ZCRB1\tS114\t-0.0477669
ZDBF2\tS1574\t0.29788905
ZDHHC14\tS440\t0.05394543
ZDHHC18\tS19\t-0.1101527
ZDHHC18\tS360\t-0.50341295
ZDHHC18\tS366\t0.6298462
ZDHHC20\tS305\t0.367371
ZDHHC5\tS243\t-0.1434524
ZDHHC5\tS246\t0
ZDHHC5\tS327\t0.03632757
ZDHHC5\tS345\t0.3614315
ZDHHC5\tS372\t0.13138069
ZDHHC5\tS379\t-0.03884315
ZDHHC5\tS501\t-0.03162166
ZDHHC5\tS524\t0.6548937
ZDHHC5\tS568\t-0.08315653
ZDHHC5\tS641\t-0.4324884
ZDHHC5\tT295\t0.06212175
ZDHHC5\tT606\t-0.6631636
ZDHHC8\tS245\t-0.3926354
ZDHHC8\tS434\t0.13074025
ZDHHC8\tS514\t-0.1939331
ZDHHC8\tS651\t-0.21973815
ZEB1\tS612\t-0.4387961
ZEB2\tS1098\t-0.0366319
ZEB2\tS1100\t-0.3245093
ZEB2\tS1105\t-0.3245093
ZEB2\tS160\t0.587653
ZEB2\tS332\t0.1146774
ZEB2\tS336\t-0.18138505
ZEB2\tS481\t-0.1360457
ZEB2\tS617\t0.09963177
ZEB2\tS623\t0.5359534
ZEB2\tS677\t0.399004
ZEB2\tS707\t-0.082408055
ZEB2\tS754\t0.380397
ZEB2\tS756\t0.149329085
ZEB2\tS760\t0.115943835
ZEB2\tT758\t0.149088995
ZFAND3\tS101\t-0.1311079
ZFAND3\tS106\t-0.1311079
ZFAND3\tS86\t-0.08962952
ZFAND3\tS99\t-0.1311079
ZFAND3\tT89\t-0.1047129
ZFAND5\tS48\t0.1953476
ZFC3H1\tS1303\t0.055018933
ZFC3H1\tS1304\t0.03292239
ZFC3H1\tS15\t-0.01119537
ZFC3H1\tS28\t-0.174173045
ZFC3H1\tS34\t-0.19257099
ZFC3H1\tS352\t-2.435761
ZFC3H1\tS655\t-0.03470545
ZFC3H1\tS949\t-0.0735168
ZFC3H1\tS953\t-0.1470104
ZFC3H1\tT766\t-0.06041236
ZFHX2\tT946\t-0.18283905
ZFHX3\tS1204\t0.1989969
ZFHX3\tS1347\t-0.09725495
ZFHX3\tS1590\t0.01168745
ZFHX3\tS2230\t-0.2091612
ZFHX3\tS2786\t-0.3005905
ZFHX3\tS3409\t-0.05464944
ZFHX3\tS3432\t0.03674946
ZFHX3\tS425\t0.0362106
ZFHX3\tS430\t0.1597583
ZFHX4\tS1552\t0.01106615
ZFHX4\tS2844\t-0.003235265
ZFHX4\tS508\t0.07052668
ZFHX4\tT1148\t0.1719754
ZFHX4\tT2827\t-0.07233107
ZFP106\tS1025\t0.09707135
ZFP106\tS1026\t0.08228617
ZFP106\tS1249\t0.2999479
ZFP106\tS1279\t0.1071523
ZFP106\tS1302\t-0.02400304
ZFP106\tS1315\t-0.172934785
ZFP106\tS1328\t0.05561211
ZFP106\tS1370\t0.120352
ZFP106\tS861\t-0.2846112
ZFP106\tS864\t-0.2196193
ZFP106\tS872\t0.1418251
ZFP106\tS875\t0.4576457
ZFP106\tS878\t-0.3384692
ZFP106\tS893\t0.008486926
ZFP106\tS937\t-0.3784568
ZFP106\tT1298\t0.04697992
ZFP36L1\tS70\t-0.8691218
ZFP36L2\tS125\t-0.5293434
ZFP36L2\tS426\t-0.52743295
ZFP36L2\tS438\t-0.3076264
ZFP36L2\tS440\t-0.05731664
ZFP36L2\tS57\t-0.7373263
ZFP62\tS64\t-0.2958894
ZFP91\tS83\t0.01221106
ZFP91\tS85\t-0.01067203
ZFPM1\tS487\t0.02772026
ZFPM1\tS491\t0.02772026
ZFPM1\tS668\t-0.1406983
ZFPM1\tS786\t0.08188502
ZFPM1\tS901\t0.06391706
ZFPM1\tS909\t-0.1860649
ZFPM1\tT489\t0.02772026
ZFPM1\tT60\t-0.146629784
ZFR\tS1054\t-0.7981905
ZFYVE16\tS330\t-0.02566208
ZFYVE16\tS939\t-0.4279834
ZFYVE16\tS946\t-1.794557
ZFYVE19\tS179\t-0.1623635
ZFYVE20\tS217\t-0.67266905
ZFYVE26\tS1759\t-0.7462285
ZFYVE26\tS272\t0.05347308
ZFYVE26\tS276\t-0.05957008
ZFYVE26\tT1781\t-0.6569421
ZFYVE9\tS668\t-0.3500443
ZHX1\tS202\t-1.08925
ZHX1\tS648\t-0.065989805
ZHX2\tS628\t-0.02792669
ZHX2\tT37\t-0.8109155
ZHX3\tS417\t-0.3141585
ZHX3\tS608\t-0.078951605
ZHX3\tS655\t-0.08662991
ZKSCAN1\tS13\t-0.07964569
ZKSCAN1\tS208\t-0.05523147
ZKSCAN1\tS551\t0.13526975
ZKSCAN2\tS591\t-0.0887609
ZKSCAN8\tS12\t-0.04853154
ZKSCAN8\tS193\t0.0586628
ZMYM2\tS305\t-0.1822949
ZMYM2\tS4\t-0.1514101
ZMYM2\tS838\t-0.3400207
ZMYM2\tT840\t-0.34215905
ZMYM3\tS466\t-0.3434213
ZMYM3\tS776\t-0.2039671
ZMYM3\tT819\t0.17502865
ZMYM3\tT828\t0.222472525
ZMYM4\tS1152\t0.05630613
ZMYM4\tS1155\t-0.3895142
ZMYM4\tS122\t0.005328146
ZMYM4\tS941\t-0.2108133
ZMYM4\tS975\t-0.2349233
ZMYM4\tS982\t0.08416131
ZMYND8\tS426\t-0.07054228
ZMYND8\tS445\t-2.847985
ZMYND8\tS452\t0.137627455
ZMYND8\tS464\t0.477766275
ZMYND8\tS506\t-0.1005769
ZMYND8\tS510\t-0.13949
ZMYND8\tS515\t-0.1396873
ZMYND8\tS567\t-0.1852609
ZMYND8\tS688\t-0.0906032
ZMYND8\tS776\t-0.166236815
ZMYND8\tT766\t-0.06047253
ZMYND8\tT771\t-0.052251287
ZNF106\tS11\t-0.2020242
ZNF106\tS641\t0.00031783
ZNF106\tS661\t0.3069621
ZNF148\tS306\t0.01735182
ZNF148\tS412\t-1.382213
ZNF174\tS195\t0.1212807
ZNF174\tS287\t0.2363395
ZNF185\tS157\t-0.096591161
ZNF185\tS170\t-0.3279458
ZNF185\tT152\t-0.04481785
ZNF2\tS5\t-0.02670465
ZNF205\tS181\t-0.5689441
ZNF217\tS407\t-0.1090008
ZNF217\tS421\t-0.01538875
ZNF217\tS441\t-0.41340075
ZNF217\tS445\t-0.07956945
ZNF217\tS848\t-0.1143787
ZNF217\tT648\t-0.09300172
ZNF259\tS19\t0.1606621
ZNF263\tS178\t0.1220763
ZNF264\tS177\t0.28509595
ZNF275\tS76\t0.1068843
ZNF275\tS91\t0.3996634
ZNF276\tS282\t0.093086135
ZNF276\tS285\t0.093086135
ZNF276\tS291\t0.093086135
ZNF276\tS526\t-0.2986727
ZNF280D\tS532\t-0.03954761
ZNF281\tS165\t-2.698436
ZNF281\tS584\t0.6008952
ZNF281\tT618\t0.4289999
ZNF316\tS10\t-0.05707642
ZNF316\tS112\t0.08420031
ZNF316\tS540\t-0.39734365
ZNF316\tT565\t-0.1822458
ZNF318\tS1238\t0.3215818
ZNF318\tS1243\t0.17231213
ZNF318\tS136\t0.07203723
ZNF318\tS141\t-0.06026043
ZNF318\tS1420\t-0.1243929
ZNF318\tS173\t-0.01198073
ZNF318\tS1896\t0.3784007
ZNF318\tS2101\t0.06032421
ZNF318\tS2189\t-0.1214865
ZNF318\tS501\t-0.33635565
ZNF318\tS527\t-1.391683
ZNF318\tS69\t0.05949366
ZNF318\tS71\t0.05949366
ZNF318\tS79\t0.07148806
ZNF318\tS81\t0.07148806
ZNF318\tT161\t0.08338356
ZNF318\tT1847\t0.177599
ZNF318\tT1968\t0.067988225
ZNF32\tS69\t0.43499505
ZNF326\tS478\t-0.24083595
ZNF329\tS496\t-1.382852
ZNF330\tS236\t0.00434428
ZNF335\tS821\t0.06143053
ZNF358\tS487\t-0.0019634
ZNF362\tS160\t0.007913023
ZNF362\tS401\t0.07983892
ZNF362\tS404\t0.1801479
ZNF362\tS410\t0.5649147
ZNF362\tT162\t0.052388745
ZNF362\tT394\t0.02493937
ZNF385A\tS133\t-0.04647402
ZNF385A\tS140\t-0.3073943
ZNF395\tS449\t-0.01042498
ZNF397\tS142\t-0.08702827
ZNF407\tS952\t0.04697992
ZNF407\tS993\t0.095515725
ZNF407\tS994\t0.063860575
ZNF408\tS338\t-0.0801184
ZNF408\tT322\t-0.20107295
ZNF428\tS99\t0.0451634
ZNF428\tT108\t0.2021475
ZNF444\tS231\t-0.03405687
ZNF445\tS150\t-0.1090475
ZNF446\tS137\t-0.106978998
ZNF446\tS146\t-0.1577572
ZNF446\tS3\t0.3719492
ZNF446\tT308\t-0.0673945
ZNF451\tS1027\t-0.22027676
ZNF462\tS1090\t-0.4672343
ZNF462\tS1356\t-0.0781981
ZNF462\tS1747\t0.002162436
ZNF462\tS1753\t0.061342355
ZNF462\tS2172\t-0.1306971
ZNF462\tS2402\t0.04977013
ZNF462\tS350\t-0.01733715
ZNF462\tS688\t0.00302647
ZNF473\tS145\t0.17864765
ZNF496\tS23\t-0.12454413
ZNF507\tS884\t-0.2020526
ZNF507\tS95\t-0.06117976
ZNF512B\tS409\t-0.1073215
ZNF512B\tS63\t-0.1055663
ZNF512B\tS665\t-0.1372669
ZNF513\tS191\t-0.1390769
ZNF513\tS23\t0.108491
ZNF516\tS116\t-0.2930585
ZNF521\tS273\t-0.1293394
ZNF521\tS605\t0.4905701
ZNF521\tS608\t0.6266728
ZNF526\tS187\t0.05241581
ZNF532\tS294\t0.2732175
ZNF532\tS314\t-0.03364338
ZNF532\tS418\t-0.1060321
ZNF532\tS434\t-0.1922824
ZNF532\tS602\t-0.08280504
ZNF536\tS1141\t-0.2006805
ZNF551\tS126\t-1.391834
ZNF571\tS40\t0.03200885
ZNF571\tY39\t0.03200885
ZNF574\tS113\t0.41608025
ZNF574\tS164\t0.39267035
ZNF574\tS298\t-0.4014252
ZNF574\tS728\t0.188021
ZNF579\tS194\t0.06818932
ZNF579\tS483\t-0.234041
ZNF579\tT482\t-0.2068449
ZNF580\tS15\t0.07135073
ZNF592\tS1089\t0.16075711
ZNF592\tS460\t0.212341425
ZNF592\tS573\t0.09274875
ZNF592\tS691\t-0.126738
ZNF598\tS428\t-2.63424
ZNF598\tS437\t-1.903619
ZNF608\tS421\t0.04711958
ZNF608\tS627\t-0.05754484
ZNF608\tS895\t0.02814484
ZNF608\tS964\t0.1267086
ZNF608\tT481\t-0.01328635
ZNF608\tT636\t-0.01905342
ZNF609\tS1055\t-0.1182728
ZNF609\tS358\t0.217078998
ZNF609\tS379\t0.07560106
ZNF609\tS452\t0.5247111
ZNF609\tS467\t-0.01346525
ZNF609\tS491\t-0.04989001
ZNF609\tS576\t0.1182268
ZNF609\tS578\t-0.002093429
ZNF609\tS743\t0.021764
ZNF609\tS758\t0.2980718
ZNF609\tS804\t0.190678
ZNF609\tS842\t-0.05523076
ZNF609\tS846\t-0.05523076
ZNF609\tS849\t-0.05523076
ZNF609\tT360\t0.4269625
ZNF609\tT381\t0.1281614
ZNF609\tT722\t0.1737671
ZNF609\tT746\t0.004752986
ZNF609\tT823\t0.23775375
ZNF618\tS184\t0.2095017
ZNF618\tS336\t-0.013664085
ZNF628\tS340\t0.0566737
ZNF629\tS28\t0.325962
ZNF638\tS128\t0.1853591
ZNF638\tS383\t0.100012815
ZNF638\tS650\t0.2065182
ZNF639\tS60\t-0.03637794
ZNF639\tS88\t-0.023480429
ZNF644\tS1000\t0.094825975
ZNF644\tT165\t0.29665905
ZNF646\tS1496\t-0.15613534
ZNF646\tS612\t0.0322696
ZNF646\tS930\t-0.06760617
ZNF652\tS204\t0.02614456
ZNF652\tS55\t0.1840054
ZNF652\tS57\t0.2572926
ZNF652\tT203\t0.28768612
ZNF655\tS12\t0.1587248
ZNF655\tS60\t0.2101395
ZNF667\tS90\t0.0413831
ZNF687\tS1057\t-0.01448496
ZNF687\tS1191\t-0.07327185
ZNF687\tS129\t-0.27352117
ZNF687\tS140\t-0.17533737
ZNF687\tS183\t-0.1198239
ZNF687\tS227\t-0.000764838
ZNF687\tS253\t-0.1724411
ZNF687\tS374\t-0.04152109
ZNF687\tS433\t0.1640813
ZNF687\tT191\t0.07403181
ZNF691\tS39\t0.03083044
ZNF697\tS123\t-0.0892366
ZNF697\tS22\t-0.372692
ZNF697\tT75\t-0.1735633
ZNF703\tS252\t0.2343786
ZNF704\tS97\t0.0934656
ZNF740\tS44\t0.112233
ZNF747\tS141\t-0.06913401
ZNF768\tS108\t0.2564068
ZNF768\tS129\t0.1645289
ZNF768\tS52\t-0.02420843
ZNF768\tS59\t0.008343471
ZNF768\tS66\t0.159167236
ZNF768\tS94\t0.1075539
ZNF775\tS71\t-0.04529746
ZNF777\tS47\t-0.541408
ZNF8\tS187\t-0.07904275
ZNF800\tS336\t0.175166956
ZNF800\tS422\t0.0059149
ZNF800\tS426\t-0.046960808
ZNF800\tS462\t0.60979325
ZNF804B\tS877\t-0.1677014
ZNF827\tS146\t1.0779913
ZNF827\tS157\t-0.4366604
ZNF827\tS207\t0.2213203
ZNF827\tS689\t-0.06860439
ZNF827\tS760\t0.03632757
ZNF827\tT506\t0.33583806
ZNHIT2\tT189\t-0.2302282
ZNHIT3\tS80\t-0.1492966
ZNRF1\tS123\t-0.3831342
ZNRF2\tS135\t-0.1359981
ZNRF2\tS145\t-0.175059745
ZNRF2\tS151\t-0.361472
ZNRF2\tS19\t-0.03722152
ZNRF2\tS82\t-0.1808877
ZRANB1\tS115\t0.061912845
ZRANB2\tS120\t-0.04085306
ZRANB2\tS153\t-0.1941793
ZRANB2\tS181\t-0.20500959
ZRANB2\tS188\t-0.05899889
ZRANB2\tS305\t-0.00889481
ZRANB2\tS307\t-0.020187464
ZRANB2\tS310\t0.172099705
ZRSR2\tS349\t0.1515991
ZSCAN2\tS191\t-0.04312555
ZSCAN2\tT11\t0.3396867
ZSCAN21\tS208\t-0.03776933
ZSCAN25\tS84\t-1.231447
ZSCAN29\tS153\t0.0542234
ZSCAN5A\tS150\t-0.118398
ZSWIM8\tS1154\t-0.02181902
ZSWIM8\tS48\t-0.42503145
ZSWIM8\tS53\t-0.3976762
ZSWIM8\tT55\t-0.400606
ZW10\tS3\t0.2067682
ZXDA\tS714\t0.39428582
ZYX\tS142\t-2.530239
ZYX\tS259\t0.21661
ZYX\tS281\t0.002162436
ZYX\tS308\t0.469886
ZYX\tS344\t-1.484792
ZZEF1\tS1518\t-1.71652675
ZZEF1\tS2443\t-0.1806098
ZZEF1\tS2444\t-0.2442408
ZZEF1\tT2074\t-0.089362255
ZZZ3\tS113\t-0.05259563
stx1c\tS14\t0.1717192`,
    3: `O15440\tY10\t1.415816194
Q6PCB6\tY224\t1.5196147
Q8IZP0\tY198\t2.499737738
Q8IZP0\tY213\t1.896027379
Q8IZP0\tY23\t2.423529784
P42684-10\tY668\t2.99635672
P42684-6\tY59\t1.036949953
O14639-5\tY199\t1.661833951
O14639\tS367\t2.29713052
O14639\tY357\t2.249188896
O14639\tY638\t1.169203927
P45954\tY198\t6.57098415
Q15057\tY298\t1.225680865
Q9H3P7\tY492\t3.007303827
Q9BYF1\tY781\t1.076358798
P53396\tY682\t3.508799463
Q9ULC5\tY96\t1.922439282
P68133\tY190\t3.038172544
P68133\tY242\t1.54670175
P68133\tY71\t1.296500756
P68133\tY93\t1.149545001
P62736\tY93\t1.844138219
P60709\tY166\t1.892050338
P60709\tY294\t2.234928551
P12814\tY246\t1.194178004
O43707\tY212\t1.575296267
O43707\tY693\t1.371123156
P61158\tY16\t1.899485306
P61158\tY231\t3.59890831
Q13443\tS758\t1.622226545
Q13443\tY778\t2.539482512
Q13443\tY815\t1.420955277
O60266\tY1061\t1.309072765
P35611\tY24\t2.977644721
P25098\tY356\t9.936892545
P30520\tY236\t2.394454458
Q8N556\tY353\t1.420105763
Q8N4X5\tY413\t1.339606911
Q53H12\tY224\t2.691044564
P35573\tY504\t1.285817671
O00116\tY645\t3.325921941
Q6RW13\tY133\t1.264816279
P23526\tY193\t1.933124485
Q09666\tS5841\t5.536682316
Q09666\tY1469\t3.126392034
Q09666\tY715\t6.621297976
Q09666\tY836\t9.924012797
Q9UIJ7\tY186\t2.741019647
Q9UKA4\tY485\t2.419091078
P42330\tY110\t5.295841417
P00352\tY426\t1.175632427
P00352\tY481\t1.089049457
P30837\tY373\t4.228006574
P04075\tY223\t3.054339407
P04075\tY3\t3.133726499
P09917\tY95\t4.279550322
Q12955\tY533\t3.360662896
Q12955\tY575\t8.980973738
Q12955\tY731\t38.18543296
Q53RE8\tY65\t6.952497159
Q92625\tY455\t1.226653368
P50995\tY279\t1.163009427
P50995\tY482\t2.029006355
P04083\tY39\t1.250875933
P07355\tS26\t116.9118578
P07355\tY238\t3.617016649
P07355\tY30\t3.002346335
P07355\tY316\t2.183799096
P12429\tY15\t1.940231961
P12429\tY300\t2.034754305
P09525\tY296\t1.236454923
P08758\tY297\t1.394777434
P08758\tY94\t1.100479127
Q10567\tY277\t1.092064929
Q96GX9\tY26\t9.980760287
Q96P48\tY737\t1.362188934
Q8WZ64\tY473\t1.310483147
Q8WZ64\tY77\t1.104830368
Q8IWW6\tS240\t2.2966633
Q8IWW6\tY63\t9.229013626
A7KAX9\tY1557\t1.423905097
A7KAX9\tY2023\t6.019921541
Q9NRY4\tY1087\t1.967237428
Q9NRY4\tY1105\t1.276976448
Q9C0H5\tY418\t2.213572633
Q9C0H5\tY448\t6.154433119
A6NI28\tY376\t1.645383457
A6NI28\tY792\t1.13237143
P52565\tY156\t2.169549493
Q12774\tS652\t3.110223481
Q12774\tY656\t3.354694471
O15143\tY172\t1.063107771
O15143\tY35\t1.434655961
O15145\tY47\t2.342792103
P56211\tY36\t4.65525743
P56211\tY59\t11.66615901
P07306\tY5\t1.911621638
P00966\tY133\t1.58987254
P00966\tY322\t3.56340837
P00966\tY87\t2.188844769
Q9BSB4\tY164\t4.50323021
P31939\tY104\t3.075167913
P31939\tY290\t1.445072792
P31939\tY464\t3.636296234
P98196\tY532\t1.422796443
Q9H7F0\tY371\t2.809914201
P25705\tY337\t1.037798091
O75947\tY150\t8.907493922
P48047\tY35\t1.093789746
Q9UI12\tY388\t2.182045206
O95817\tY205\t1.247144072
O95817\tY233\t1.55294062
Q9UHR4\tY156\t1.40733834
Q9UHR4\tY293\t1.519314453
Q9UHR4\tY380\t1.215854462
P56945\tY249\t1.459888313
P56945\tY306\t2.088227047
P56945\tY387\t1.021860854
Q9NYF8\tY466\t2.146719001
P11274\tY177\t2.318385058
Q9Y276\tY181\t1.035800011
P07738\tY92\t1.220910408
Q06187\tY551\t5.260146938
Q6UX41\tY368\t3.997685175
Q96A22\tY103\t1.505308389
Q96A22\tY78\t1.591731442
Q5T0Z8\tY1067\t1.193644092
Q5T0Z8\tY1142\t3.224918693
Q5T0Z8\tY1158\t1.699984226
Q5T0Z8\tY477\t1.803873262
Q5JTZ5\tY215\t2.506589707
P62158\tY100\t2.639346228
P27824\tS583\t2.383061391
P47756\tY232\t2.186409905
P49589\tY32\t2.57047578
Q8WXE0\tY336\t1.836857924
P31415\tY64\t2.071798138
P04040\tY84\t1.640420045
Q03135\tY14\t2.097916978
P22681\tY674\t1.21744997
P22681\tY700\t1.112185886
Q13191\tY889\t1.658871728
Q96CT7\tY38\t5.825870712
P50990\tY426\t1.053774279
P86791\tY380\t6.449807681
Q9Y5S2\tY1638\t3.21486079
Q15131\tY50\t3.650210531
Q00536\tY176\t1.176342695
O76039\tY171\t2.419391288
Q9UKY7\tY190\t2.580931877
Q53EZ4\tY237\t1.36987872
P23528\tY140\t1.420399425
P52757\tY153\t1.017691089
P12277\tY269\t5.28098844
P12277\tY39\t1.462919173
P06732\tY125\t2.507524111
P06732\tY140\t2.01884463
P17540\tY208\t1.617759968
P33552\tY17\t1.886048863
P57739\tS192\t9.823979581
P57739\tY224\t8.084929688
Q00610\tY1206\t1.063830416
Q00610\tY1487\t1.407264839
Q00610\tY430\t1.04036255
Q00610\tY634\t1.212243088
Q96KP4\tY311\t1.33638482
Q99439\tY12\t2.274602577
Q6P4Q7\tY611\t7.946457332
Q53SF7\tY318\t2.082006018
Q9H9E3\tY456\t3.734446993
P53621\tY249\t1.841079776
P53621\tY634\t1.714689579
Q9ULV4\tY301\t2.089999967
Q5RI15\tY101\t3.566770204
O75976\tY1376\t1.313871731
Q99829\tY386\t1.445915033
Q96FN4\tY408\t1.396850429
O75131\tY203\t1.714122625
O75131\tY392\t1.258147102
Q86YQ8\tY410\t1.42853565
Q9NZV1\tY1019\t1.07079753
P46108\tY108\t1.952925253
P46108\tY251\t1.285913437
P46109\tY132\t1.576408409
P46109\tY92\t1.537236435
P41240\tY18\t1.302040132
P48729\tY294\t2.921471604
P68400\tY239\t1.762971808
P21291\tY18\t3.178127545
P21291\tY73\t1.149949885
P04080\tY97\t2.007653816
G3XAM7\tY222\t4.983656702
G3XAM7\tY280\t1.242698346
G3XAM7\tY419\t1.735025202
P26232\tY417\t1.553789359
P35222\tY30\t2.045704378
P35222\tY654\t1.707749014
C9JZR2\tS230\t1.483950925
C9JZR2\tS252\t1.80084079
C9JZR2\tY174\t1.517689123
C9JZR2\tY193\t1.905169534
C9JZR2\tY213\t2.171760603
C9JZR2\tY395\t2.186209672
C9JZR2\tY96\t2.20524498
Q14247\tY141\t1.022066167
Q14247\tY265\t1.07875086
Q14247\tY334\t1.113698418
Q14247\tY421\t1.565756262
P00387\tY80\t1.457358691
P99999\tY98\t1.955018635
Q7L576\tY1054\t1.163832098
Q7L576\tY108\t1.455318345
A8MQ03\tY12\t1.116412423
A8MQ03\tY91\t1.851601554
Q9H1C7\tY64\t1.055692521
P98082\tY170\t1.091684859
Q9UN19\tY139\t2.273592881
Q8N8Z6\tS616\t2.975461836
Q8N8Z6\tY589\t6.487086828
A0A0A0MSX3\tY646\t1.787997688
Q16832\tY481\t1.783295207
Q92499\tY628\t19.27291735
O00148\tY38\t1.071680328
O00571\tY301\t1.085252198
O00571\tY462\t1.941381507
O43143\tY13\t1.065974155
Q6P158\tY1261\t6.016126169
Q9NR28\tY108\t4.76483599
O60610\tY374\t1.110632463
Q5HYI5\tY3\t1.292925538
Q12959\tY399\t4.855818065
Q12959\tY760\t5.961856652
Q12959\tY784\t2.290163157
Q92796\tY673\t3.387707354
P31689\tY119\t1.025594251
P25685\tY176\t1.357379953
Q9UDY4\tY172\t1.615019634
Q99543\tY145\t1.351981194
Q9H3Z4\tS10\t6.877749133
O75937\tY129\t2.232879873
Q6XZF7\tY1339\t1.774810374
Q99704\tY337\t1.948382764
Q8TEW6\tY165\t1.916725478
Q02487\tY821\t1.289085259
Q02487\tY853\t9.562660164
Q14126\tY1013\t1.056151268
Q03001\tY7456\t1.720116877
Q86UW9\tY156\t3.820187645
Q8TDB6\tY248\t25.01317162
O75319\tY313\t1.820483349
Q14204\tY3379\t9.770987587
Q14204\tY3447\t1.212196303
P63167\tY65\t3.461941376
Q13627\tY145\t3.116843873
O75521\tY285\t1.623807374
P68104\tY141\t1.201574499
P68104\tY177\t1.294102653
P68104\tY85\t1.259177059
O43324\tY59\t1.553182059
Q96C19\tY83\t1.490663051
P52799\tY304\t2.194052789
P00533\tY727\t3.206311723
Q9H223\tY456\t1.264404156
Q9H223\tY518\t1.262835637
P41567\tY79\t2.882817113
P05198\tY150\t1.280970196
P20042\tY298\t2.443160238
O15371\tY318\t1.918190554
O15371\tY50\t1.66729571
Q9Y262\tY89\t1.227151425
P60842\tY197\t1.706459091
P60842\tY48\t1.817109414
P60842\tY70\t2.687593599
Q14240\tY71\t1.20127173
P38919\tY155\t1.015347007
P38919\tY202\t1.041256862
P63241\tY69\t2.055808492
Q15717\tY200\t1.02589835
Q9H9T3\tY202\t1.211616349
Q92979\tY61\t3.010729133
Q9HC35\tY226\t1.789401003
P06733\tY287\t2.084482927
P06733\tY44\t1.376471199
P11171-4\tY418\t1.815208957
Q9H4G0-4\tY37\t9.703586956
Q9H4G0\tY343\t1.875989455
Q9H4G0\tY68\t20.45760331
Q9HCM4-2\tY476\t1.487887432
P21709\tY599\t1.134853105
P29317\tS579\t1.076444305
P29317\tT587\t1.207904615
P29317\tT771\t1.452156765
P29320\tY779\t2.158485834
P54764\tY602\t5.438031692
P54762\tY768\t1.02408181
P54760\tY574\t1.083145854
P54760\tY581\t1.076112815
P54760\tY774\t1.06585564
P58107\tY1766\t1.702366732
Q9UBC2\tY74\t1.853542805
Q8TE68-4\tY228\t1.563358371
Q8TE68\tY526\t4.815251801
Q9H6S3\tY501\t1.341783003
P04626\tY1005\t22.10273018
P04626\tY735\t4.030666572
P04626\tY877\t6.95994881
Q96RT1\tY1104\t2.444937655
Q96RT1\tY1270\t1.690712909
Q96RT1\tY884\t1.449523357
P21860\tS1315\t6.751024766
P21860\tY1159\t22.18187011
P21860\tY1307\t8.996288767
P30040\tY66\t2.11062377
Q9UJM3\tY394\t1.456629957
Q9BSJ8\tT824\t2.349840699
Q9BSJ8\tY1009\t6.89183476
Q92817\tY1700\t1.746660601
P15311\tT425\t1.212201479
P15311\tY270\t1.149355697
Q96CS3\tY79\t1.530770358
O75063\tY138\t1.679523442
Q5T0W9\tY343\t1.852497383
Q9NSD9\tY192\t3.854099426
O00757\tY216\t2.243880287
Q96M96\tY36\t9.119856859
P09769\tY180\t1.452534318
Q02790\tY220\t2.0945778
Q02790\tY411\t3.48411679
P21333\tY2216\t1.368644078
P21333\tY2388\t1.498696553
P21333\tY373\t1.591041675
P21333\tY506\t1.235874323
O75369\tY2171\t2.506602302
O75369\tY871\t1.389325762
O75955\tY203\t12.55805651
Q5T0N5\tY291\t1.418068496
P42685\tY132\t1.083765842
P42685\tY368\t1.091012719
Q8WU20\tY306\t3.004295682
P51114\tY477\t1.155228782
Q9UN86\tY56\t1.31661683
P11413\tY503\t2.14107783
Q13480\tT638\t2.587450222
Q13480\tY242\t3.384018987
Q13480\tY259\t1.308912104
Q13480\tY307\t1.53575789
Q13480\tY627\t1.095336596
Q13480\tY659\t1.012058616
Q9UQC2\tY293\t1.534265356
O14976\tY1149\t2.216706346
Q9NY12\tY149\t1.169408612
Q9NY12\tY97\t1.154657246
Q9H706\tY453\t1.016278967
Q8WXI9\tY317\t1.153463599
O75323\tY106\t11.08123659
O75323\tY205\t1.702242037
P50395\tY203\t2.005797507
Q9Y2X7\tY545\t1.613208733
Q04760\tY136\t1.60217468
P35754\tY25\t3.090490301
O60547\tY324\t1.32974616
O60547\tY84\t2.129468498
P08754\tY69\t4.389308164
P62873\tY59\t4.66895667
P63244\tY140\t1.589322043
O00461\tY111\t2.804748509
O00461\tY176\t1.3747744
Q9HD26\tY457\t4.23811093
P00505\tY75\t1.165919296
P00505\tY96\t4.585805708
Q9NZH0\tT389\t3.368175503
Q9NQ84\tS359\t1.89725949
Q9NQ84\tT326\t1.173712245
Q9NQ84\tY312\t1.41472088
Q9NQ84\tY387\t1.549551774
Q9NQ84\tY438\t2.359678562
P07203\tY98\t9.046474
P18283\tY88\t3.959203158
Q7Z6J2\tY237\t1.388468003
P62993\tY52\t3.391946711
Q14451\tY107\t3.407625445
Q14451\tY188\t13.03543237
Q14451\tY274\t3.023596702
Q14451\tY293\t4.610969136
Q14451\tY343\t9.284504867
P57764\tY158\t3.845193995
P09211\tY109\t1.40839014
P09211\tY199\t3.494159818
P09211\tY50\t4.525492743
P09211\tY8\t2.932682632
P30711\tY83\t3.080696394
P25092\tY681\t2.288379085
Q16774\tY53\t18.79161331
P13807\tY212\t2.140199549
P57053\tY38\t3.270605149
P69905\tY25\t1.324875694
O14964\tY132\t2.427344815
P49773\tY109\t3.644589544
P16401\tS18\t9.128549814
P33778\tY41\t10.45490702
P62805\tT55\t1.515465182
P09429\tY144\t2.663550724
P22626\tY331\t1.059676656
P51991\tY149\t1.42586655
P31943\tY266\t1.295725389
P52272\tY681\t2.043511413
O43390\tY376\t1.097146908
O43390\tY431\t2.220497905
Q00839\tS271\t3.117211434
Q00839\tS817\t1.054127587
Q00839\tY257\t1.216718079
P35367\tY301\t3.563247172
P52758\tY21\t4.851780439
P07900\tY492\t1.466021803
P07900\tY61\t1.373935883
P08238\tY56\t1.659096823
Q58FF8\tY138\t2.801926503
Q58FF8\tY56\t1.555629373
Q58FF6\tY32\t1.589519874
P14625\tY94\t3.051035875
P0DMV8\tY41\t1.800183174
P34932\tY336\t1.253180075
P11021\tY570\t1.570280464
P04792\tY23\t4.271110596
P10809\tY223\t1.023177832
P10809\tY243\t2.24480577
P61604\tY88\t41.87676511
O75874\tY208\t3.292839013
P13164\tY78\t8.35421042
P15260\tY304\t1.383015587
P31785\tY303\t1.122939798
Q8NI35\tY396\t1.011215544
Q92835\tY1022\t3.280912737
Q92835\tY1161\t2.023261135
Q92835\tY865\t2.097408632
O15357\tY1162\t4.023160561
P46940\tY654\t4.13253953
Q13576\tY770\t60.5860945
Q86VI3\tS190\t1.07811262
P35568\tY612\t5.487445469
Q9Y4H2\tY542\t1.317751224
Q9Y4H2\tY598\t1.045788626
Q9Y4H2\tY625\t1.427144209
Q9Y4H2\tY653\t1.944596001
Q9Y4H2\tY823\t1.242271493
Q96CN7\tY160\t2.623966226
P23229\tY1110\t1.008704424
P05556\tY783\t1.005919872
P05556\tY795\t1.076093414
P16144\tS1208\t1.222595978
P16144\tY1187\t2.627378924
P16144\tY1492\t2.734939873
P16144\tY1510\t1.170228681
P16144\tY920\t2.68741273
Q9NZM3\tY39\t1.794939276
Q9NZM3\tY553\t1.469031077
P23458\tY1034\t2.224162325
O60674\tY570\t2.10172962
P14923\tY480\t1.049711572
P14923\tY644\t1.070885523
Q8IYT4\tY293\t1.191253894
Q9Y6H6\tY95\t1.100793656
Q8NC54\tY243\t4.4879857
O15037\tY456\t1.496885276
Q5T5P2\tY244\t4.070522338
Q5T5P2\tY393\t1.377943241
Q5T5P2\tY520\t2.227556082
Q9P206\tY241\t2.001620957
Q9BY89\tY1032\t1.661419129
Q9ULH0\tY1572\t1.080429115
Q15058\tY1023\t1.028238208
Q96J84\tY572\t1.156072618
Q96J84\tY605\t4.576285597
Q96J84\tY622\t1.471860512
Q96J84\tY647\t1.697509686
Q96J84\tY701\t1.497422112
Q96J84\tY721\t1.860068281
Q96J84\tY745\t1.105057719
Q9H0B6\tY345\t1.05954364
Q9NSK0\tY446\t1.143943263
Q2TBA0\tY57\t1.555932756
P05783\tS34\t1.164625221
P05783\tY129\t3.212566588
Q6IAA8\tY138\t1.331097181
        `
};

export const statisticdata={
    "source_count": {
        "TextMining": {
            "internal_id_count": 40699,
                "gene_id_count": 7485
        },
        "FigureMining": {
            "internal_id_count": 2431,
                "gene_id_count": 836
        },
        "Network": {
            "internal_id_count": 26246,
                "gene_id_count": 5590
        },
        "PTMAtlas": {
            "internal_id_count": 194296,
                "gene_id_count": 13415
        },
        "CPTAC Cohort": {
            "internal_id_count": 91976,
                "gene_id_count": 10396
        }
    },
    "feature_count": {
        "HallmarkProcess": {
            "signature": 10,
                "site_seq_count": 753
        },
        "Figure": {
            "signature": 282,
                "site_seq_count": 1921
        },
        "CoGene": {
            "signature": 1063,
                "site_seq_count": 4928
        },
        "CoDisease": {
            "signature": 531,
                "site_seq_count": 2921
        },
        "CoChemical": {
            "signature": 421,
                "site_seq_count": 1505
        }
    }
}

export const related_database= [
    { name: "idppub", link: "https://idppub.ptmax.org/" },
    { name: "PhosphoSitePlus", link: "https://www.phosphosite.org/homeAction" },
    { name: "PhosCancer", link: "https://lilab.life.sjtu.edu.cn/PhosCancer/" },
    { name: "Pathway Figure OCR (pfocr)", link: "https://pfocr.wikipathways.org/" },
    { name: "PTMsigDB", link: "https://www.gsea-msigdb.org/gsea/msigdb/ptmsig_genesets.jsp" },
    { name: "WebGestalt", link: "https://www.webgestalt.org/option.php" }
]
export const news= [
    { date: "[2026/02/13]", text: "PTMax version1 is released" }
]